/* eslint-disable */
/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from '../../schema';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client/react';
import * as ApolloReactHooks from '@apollo/client/react';
export * from './schema'
const defaultOptions = {"fetchPolicy":"network-only"} as const;
export type AccountAdvertiserPartsFragment = { id: unknown, slug: string, name: string, agencyId: unknown, campaigns: Array<{ id: unknown, name: string, adGroups: Array<{ id: unknown, name: string, dailyBudget: number | null, dailyBudgetType: Types.DailyBudgetType, budgetCapping: number | null, budgetCappingType: Types.BudgetCapping, startDate: unknown, endDate: unknown, status: Types.AdGroupStatus, updatedAt: unknown, assistant: { recommendations: Array<{ isHidden: boolean }> }, budget: { date: unknown, budgetMeasures: { dayBudget: number | null, daySpent: number, monthBudget: number | null, monthSpent: number, periodBudget: number | null, periodSpent: number, overallBudget: number | null, overallSpent: number }, budgetStatus: { dayOverspent: boolean, monthOverspent: boolean, overallOverspent: boolean } } | null, targeting: { targetingCount: unknown } | null, performanceStats: { stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number } } }> }> };

export type AccountTimeseriesQueryVariables = Exact<{
  endDate: unknown;
  startDate: unknown;
  accountId: unknown;
  granularity: Types.GraphGranularity;
}>;


export type AccountTimeseriesQuery = { account: { id: unknown, timeseries: { timeseries: Array<{ date: unknown, stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number } }>, stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number } } } };

export type AdGroupsFromAccountQueryVariables = Exact<{
  id: unknown;
  endDate: unknown;
  startDate: unknown;
}>;


export type AdGroupsFromAccountQuery = { account: { id: unknown, reseller: { id: unknown, advertiserPerformanceStats: { stats: { cpm: number } } }, advertisers: Array<{ id: unknown, slug: string, name: string, agencyId: unknown, campaigns: Array<{ id: unknown, name: string, adGroups: Array<{ id: unknown, name: string, dailyBudget: number | null, dailyBudgetType: Types.DailyBudgetType, budgetCapping: number | null, budgetCappingType: Types.BudgetCapping, startDate: unknown, endDate: unknown, status: Types.AdGroupStatus, updatedAt: unknown, assistant: { recommendations: Array<{ isHidden: boolean }> }, budget: { date: unknown, budgetMeasures: { dayBudget: number | null, daySpent: number, monthBudget: number | null, monthSpent: number, periodBudget: number | null, periodSpent: number, overallBudget: number | null, overallSpent: number }, budgetStatus: { dayOverspent: boolean, monthOverspent: boolean, overallOverspent: boolean } } | null, targeting: { targetingCount: unknown } | null, performanceStats: { stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number } } }> }> }> } };

export type PartialCompanyPartsFragment = { id: unknown, name: string, slug: string, type: Types.CompanyType };

type ActivityFeedEntityParts_AdCopy_Fragment = { __typename: 'AdCopy', id: unknown, name: string, adGroup: { id: unknown, campaign: { advertiser: { slug: string } } } };

type ActivityFeedEntityParts_AdGroup_Fragment = { __typename: 'AdGroup', id: unknown, name: string, campaign: { advertiser: { slug: string } } };

type ActivityFeedEntityParts_AdGroupBudgetPlan_Fragment = { __typename: 'AdGroupBudgetPlan', id: unknown, adGroupId: unknown, plannedDate: unknown };

type ActivityFeedEntityParts_AdGroupDirectoryPreset_Fragment = { __typename: 'AdGroupDirectoryPreset', id: unknown, name: string };

type ActivityFeedEntityParts_AdTemplateBanner_Fragment = { __typename: 'AdTemplateBanner', id: unknown, name: string, position: { id: unknown, website: { publisher: { slug: string } } } };

type ActivityFeedEntityParts_AdTemplateNative_Fragment = { __typename: 'AdTemplateNative', id: unknown, name: string, position: { id: unknown, website: { publisher: { slug: string } } } };

type ActivityFeedEntityParts_AdTemplateWeb_Fragment = { __typename: 'AdTemplateWeb', id: unknown, name: string, position: { id: unknown, website: { publisher: { slug: string } } } };

type ActivityFeedEntityParts_Advertiser_Fragment = { __typename: 'Advertiser', id: unknown, name: string, slug: string, type: Types.CompanyType };

type ActivityFeedEntityParts_Agency_Fragment = { __typename: 'Agency', id: unknown, name: string, slug: string, type: Types.CompanyType };

type ActivityFeedEntityParts_BillingContact_Fragment = { __typename: 'BillingContact', id: unknown, firstName: string, lastName: string, companyId: unknown };

type ActivityFeedEntityParts_Campaign_Fragment = { __typename: 'Campaign', id: unknown, name: string, advertiser: { slug: string } };

type ActivityFeedEntityParts_CampaignProgrammatic_Fragment = { __typename: 'CampaignProgrammatic', id: unknown, name: string, tradingDesk: { slug: string } };

type ActivityFeedEntityParts_CompanyApiToken_Fragment = { __typename: 'CompanyApiToken', token: string };

type ActivityFeedEntityParts_CompanyArchiver_Fragment = { __typename: 'CompanyArchiver' };

type ActivityFeedEntityParts_CompanyWebhook_Fragment = { __typename: 'CompanyWebhook' };

type ActivityFeedEntityParts_Position_Fragment = { __typename: 'Position', id: unknown, name: string, website: { publisher: { slug: string } } };

type ActivityFeedEntityParts_Publisher_Fragment = { __typename: 'Publisher', id: unknown, name: string, slug: string, type: Types.CompanyType };

type ActivityFeedEntityParts_PublisherExclusionPreset_Fragment = { __typename: 'PublisherExclusionPreset', id: unknown, name: string };

type ActivityFeedEntityParts_Reseller_Fragment = { __typename: 'Reseller', id: unknown, name: string, slug: string, type: Types.CompanyType };

type ActivityFeedEntityParts_SegmentBehavioural_Fragment = { __typename: 'SegmentBehavioural', id: unknown, name: string };

type ActivityFeedEntityParts_SegmentCrm_Fragment = { __typename: 'SegmentCrm', id: unknown, name: string };

type ActivityFeedEntityParts_TradingDesk_Fragment = { __typename: 'TradingDesk', id: unknown, name: string, slug: string, type: Types.CompanyType };

type ActivityFeedEntityParts_User_Fragment = { __typename: 'User', id: unknown, firstName: string, lastName: string };

type ActivityFeedEntityParts_Website_Fragment = { __typename: 'Website', id: unknown, name: string, publisher: { slug: string } };

export type ActivityFeedEntityPartsFragment =
  | ActivityFeedEntityParts_AdCopy_Fragment
  | ActivityFeedEntityParts_AdGroup_Fragment
  | ActivityFeedEntityParts_AdGroupBudgetPlan_Fragment
  | ActivityFeedEntityParts_AdGroupDirectoryPreset_Fragment
  | ActivityFeedEntityParts_AdTemplateBanner_Fragment
  | ActivityFeedEntityParts_AdTemplateNative_Fragment
  | ActivityFeedEntityParts_AdTemplateWeb_Fragment
  | ActivityFeedEntityParts_Advertiser_Fragment
  | ActivityFeedEntityParts_Agency_Fragment
  | ActivityFeedEntityParts_BillingContact_Fragment
  | ActivityFeedEntityParts_Campaign_Fragment
  | ActivityFeedEntityParts_CampaignProgrammatic_Fragment
  | ActivityFeedEntityParts_CompanyApiToken_Fragment
  | ActivityFeedEntityParts_CompanyArchiver_Fragment
  | ActivityFeedEntityParts_CompanyWebhook_Fragment
  | ActivityFeedEntityParts_Position_Fragment
  | ActivityFeedEntityParts_Publisher_Fragment
  | ActivityFeedEntityParts_PublisherExclusionPreset_Fragment
  | ActivityFeedEntityParts_Reseller_Fragment
  | ActivityFeedEntityParts_SegmentBehavioural_Fragment
  | ActivityFeedEntityParts_SegmentCrm_Fragment
  | ActivityFeedEntityParts_TradingDesk_Fragment
  | ActivityFeedEntityParts_User_Fragment
  | ActivityFeedEntityParts_Website_Fragment
;

export type ActivityFeedPartsFragment = { createdAt: unknown, entityType: Types.EntityType, entityId: unknown, property: string | null, oldValue: string | null, newValue: string | null, activityType: Types.ActivityType, origin: Types.ActivityFeedOrigin, user: { id: unknown, firstName: string, lastName: string, company: { id: unknown, name: string, slug: string, type: Types.CompanyType } } | null, company: { id: unknown, name: string, slug: string, type: Types.CompanyType }, oldValueEntity:
    | { __typename: 'AdCopy', id: unknown, name: string, adGroup: { id: unknown, campaign: { advertiser: { slug: string } } } }
    | { __typename: 'AdGroup', id: unknown, name: string, campaign: { advertiser: { slug: string } } }
    | { __typename: 'AdGroupBudgetPlan', id: unknown, adGroupId: unknown, plannedDate: unknown }
    | { __typename: 'AdGroupDirectoryPreset', id: unknown, name: string }
    | { __typename: 'AdTemplateBanner', id: unknown, name: string, position: { id: unknown, website: { publisher: { slug: string } } } }
    | { __typename: 'AdTemplateNative', id: unknown, name: string, position: { id: unknown, website: { publisher: { slug: string } } } }
    | { __typename: 'AdTemplateWeb', id: unknown, name: string, position: { id: unknown, website: { publisher: { slug: string } } } }
    | { __typename: 'Advertiser', id: unknown, name: string, slug: string, type: Types.CompanyType }
    | { __typename: 'Agency', id: unknown, name: string, slug: string, type: Types.CompanyType }
    | { __typename: 'BillingContact', id: unknown, firstName: string, lastName: string, companyId: unknown }
    | { __typename: 'Campaign', id: unknown, name: string, advertiser: { slug: string } }
    | { __typename: 'CampaignProgrammatic', id: unknown, name: string, tradingDesk: { slug: string } }
    | { __typename: 'CompanyApiToken', token: string }
    | { __typename: 'CompanyArchiver' }
    | { __typename: 'CompanyWebhook' }
    | { __typename: 'Position', id: unknown, name: string, website: { publisher: { slug: string } } }
    | { __typename: 'Publisher', id: unknown, name: string, slug: string, type: Types.CompanyType }
    | { __typename: 'PublisherExclusionPreset', id: unknown, name: string }
    | { __typename: 'Reseller', id: unknown, name: string, slug: string, type: Types.CompanyType }
    | { __typename: 'SegmentBehavioural', id: unknown, name: string }
    | { __typename: 'SegmentCrm', id: unknown, name: string }
    | { __typename: 'TradingDesk', id: unknown, name: string, slug: string, type: Types.CompanyType }
    | { __typename: 'User', id: unknown, firstName: string, lastName: string }
    | { __typename: 'Website', id: unknown, name: string, publisher: { slug: string } }
   | null, newValueEntity:
    | { __typename: 'AdCopy', id: unknown, name: string, adGroup: { id: unknown, campaign: { advertiser: { slug: string } } } }
    | { __typename: 'AdGroup', id: unknown, name: string, campaign: { advertiser: { slug: string } } }
    | { __typename: 'AdGroupBudgetPlan', id: unknown, adGroupId: unknown, plannedDate: unknown }
    | { __typename: 'AdGroupDirectoryPreset', id: unknown, name: string }
    | { __typename: 'AdTemplateBanner', id: unknown, name: string, position: { id: unknown, website: { publisher: { slug: string } } } }
    | { __typename: 'AdTemplateNative', id: unknown, name: string, position: { id: unknown, website: { publisher: { slug: string } } } }
    | { __typename: 'AdTemplateWeb', id: unknown, name: string, position: { id: unknown, website: { publisher: { slug: string } } } }
    | { __typename: 'Advertiser', id: unknown, name: string, slug: string, type: Types.CompanyType }
    | { __typename: 'Agency', id: unknown, name: string, slug: string, type: Types.CompanyType }
    | { __typename: 'BillingContact', id: unknown, firstName: string, lastName: string, companyId: unknown }
    | { __typename: 'Campaign', id: unknown, name: string, advertiser: { slug: string } }
    | { __typename: 'CampaignProgrammatic', id: unknown, name: string, tradingDesk: { slug: string } }
    | { __typename: 'CompanyApiToken', token: string }
    | { __typename: 'CompanyArchiver' }
    | { __typename: 'CompanyWebhook' }
    | { __typename: 'Position', id: unknown, name: string, website: { publisher: { slug: string } } }
    | { __typename: 'Publisher', id: unknown, name: string, slug: string, type: Types.CompanyType }
    | { __typename: 'PublisherExclusionPreset', id: unknown, name: string }
    | { __typename: 'Reseller', id: unknown, name: string, slug: string, type: Types.CompanyType }
    | { __typename: 'SegmentBehavioural', id: unknown, name: string }
    | { __typename: 'SegmentCrm', id: unknown, name: string }
    | { __typename: 'TradingDesk', id: unknown, name: string, slug: string, type: Types.CompanyType }
    | { __typename: 'User', id: unknown, firstName: string, lastName: string }
    | { __typename: 'Website', id: unknown, name: string, publisher: { slug: string } }
   | null, entity:
    | { __typename: 'AdCopy', id: unknown, name: string, adGroup: { id: unknown, campaign: { advertiser: { slug: string } } } }
    | { __typename: 'AdGroup', id: unknown, name: string, campaign: { advertiser: { slug: string } } }
    | { __typename: 'AdGroupBudgetPlan', id: unknown, adGroupId: unknown, plannedDate: unknown }
    | { __typename: 'AdGroupDirectoryPreset', id: unknown, name: string }
    | { __typename: 'AdTemplateBanner', id: unknown, name: string, position: { id: unknown, website: { publisher: { slug: string } } } }
    | { __typename: 'AdTemplateNative', id: unknown, name: string, position: { id: unknown, website: { publisher: { slug: string } } } }
    | { __typename: 'AdTemplateWeb', id: unknown, name: string, position: { id: unknown, website: { publisher: { slug: string } } } }
    | { __typename: 'Advertiser', id: unknown, name: string, slug: string, type: Types.CompanyType }
    | { __typename: 'Agency', id: unknown, name: string, slug: string, type: Types.CompanyType }
    | { __typename: 'BillingContact', id: unknown, firstName: string, lastName: string, companyId: unknown }
    | { __typename: 'Campaign', id: unknown, name: string, advertiser: { slug: string } }
    | { __typename: 'CampaignProgrammatic', id: unknown, name: string, tradingDesk: { slug: string } }
    | { __typename: 'CompanyApiToken', token: string }
    | { __typename: 'CompanyArchiver' }
    | { __typename: 'CompanyWebhook' }
    | { __typename: 'Position', id: unknown, name: string, website: { publisher: { slug: string } } }
    | { __typename: 'Publisher', id: unknown, name: string, slug: string, type: Types.CompanyType }
    | { __typename: 'PublisherExclusionPreset', id: unknown, name: string }
    | { __typename: 'Reseller', id: unknown, name: string, slug: string, type: Types.CompanyType }
    | { __typename: 'SegmentBehavioural', id: unknown, name: string }
    | { __typename: 'SegmentCrm', id: unknown, name: string }
    | { __typename: 'TradingDesk', id: unknown, name: string, slug: string, type: Types.CompanyType }
    | { __typename: 'User', id: unknown, firstName: string, lastName: string }
    | { __typename: 'Website', id: unknown, name: string, publisher: { slug: string } }
   | null };

export type ActivityFeedGroupItemPartsFragment = { property: string | null, oldValue: string | null, newValue: string | null, activityType: Types.ActivityType, oldValueEntity:
    | { __typename: 'AdCopy', id: unknown, name: string, adGroup: { id: unknown, campaign: { advertiser: { slug: string } } } }
    | { __typename: 'AdGroup', id: unknown, name: string, campaign: { advertiser: { slug: string } } }
    | { __typename: 'AdGroupBudgetPlan', id: unknown, adGroupId: unknown, plannedDate: unknown }
    | { __typename: 'AdGroupDirectoryPreset', id: unknown, name: string }
    | { __typename: 'AdTemplateBanner', id: unknown, name: string, position: { id: unknown, website: { publisher: { slug: string } } } }
    | { __typename: 'AdTemplateNative', id: unknown, name: string, position: { id: unknown, website: { publisher: { slug: string } } } }
    | { __typename: 'AdTemplateWeb', id: unknown, name: string, position: { id: unknown, website: { publisher: { slug: string } } } }
    | { __typename: 'Advertiser', id: unknown, name: string, slug: string, type: Types.CompanyType }
    | { __typename: 'Agency', id: unknown, name: string, slug: string, type: Types.CompanyType }
    | { __typename: 'BillingContact', id: unknown, firstName: string, lastName: string, companyId: unknown }
    | { __typename: 'Campaign', id: unknown, name: string, advertiser: { slug: string } }
    | { __typename: 'CampaignProgrammatic', id: unknown, name: string, tradingDesk: { slug: string } }
    | { __typename: 'CompanyApiToken', token: string }
    | { __typename: 'CompanyArchiver' }
    | { __typename: 'CompanyWebhook' }
    | { __typename: 'Position', id: unknown, name: string, website: { publisher: { slug: string } } }
    | { __typename: 'Publisher', id: unknown, name: string, slug: string, type: Types.CompanyType }
    | { __typename: 'PublisherExclusionPreset', id: unknown, name: string }
    | { __typename: 'Reseller', id: unknown, name: string, slug: string, type: Types.CompanyType }
    | { __typename: 'SegmentBehavioural', id: unknown, name: string }
    | { __typename: 'SegmentCrm', id: unknown, name: string }
    | { __typename: 'TradingDesk', id: unknown, name: string, slug: string, type: Types.CompanyType }
    | { __typename: 'User', id: unknown, firstName: string, lastName: string }
    | { __typename: 'Website', id: unknown, name: string, publisher: { slug: string } }
   | null, newValueEntity:
    | { __typename: 'AdCopy', id: unknown, name: string, adGroup: { id: unknown, campaign: { advertiser: { slug: string } } } }
    | { __typename: 'AdGroup', id: unknown, name: string, campaign: { advertiser: { slug: string } } }
    | { __typename: 'AdGroupBudgetPlan', id: unknown, adGroupId: unknown, plannedDate: unknown }
    | { __typename: 'AdGroupDirectoryPreset', id: unknown, name: string }
    | { __typename: 'AdTemplateBanner', id: unknown, name: string, position: { id: unknown, website: { publisher: { slug: string } } } }
    | { __typename: 'AdTemplateNative', id: unknown, name: string, position: { id: unknown, website: { publisher: { slug: string } } } }
    | { __typename: 'AdTemplateWeb', id: unknown, name: string, position: { id: unknown, website: { publisher: { slug: string } } } }
    | { __typename: 'Advertiser', id: unknown, name: string, slug: string, type: Types.CompanyType }
    | { __typename: 'Agency', id: unknown, name: string, slug: string, type: Types.CompanyType }
    | { __typename: 'BillingContact', id: unknown, firstName: string, lastName: string, companyId: unknown }
    | { __typename: 'Campaign', id: unknown, name: string, advertiser: { slug: string } }
    | { __typename: 'CampaignProgrammatic', id: unknown, name: string, tradingDesk: { slug: string } }
    | { __typename: 'CompanyApiToken', token: string }
    | { __typename: 'CompanyArchiver' }
    | { __typename: 'CompanyWebhook' }
    | { __typename: 'Position', id: unknown, name: string, website: { publisher: { slug: string } } }
    | { __typename: 'Publisher', id: unknown, name: string, slug: string, type: Types.CompanyType }
    | { __typename: 'PublisherExclusionPreset', id: unknown, name: string }
    | { __typename: 'Reseller', id: unknown, name: string, slug: string, type: Types.CompanyType }
    | { __typename: 'SegmentBehavioural', id: unknown, name: string }
    | { __typename: 'SegmentCrm', id: unknown, name: string }
    | { __typename: 'TradingDesk', id: unknown, name: string, slug: string, type: Types.CompanyType }
    | { __typename: 'User', id: unknown, firstName: string, lastName: string }
    | { __typename: 'Website', id: unknown, name: string, publisher: { slug: string } }
   | null };

export type ActivityFeedGroupPartsFragment = { groupId: string, activityType: Types.ActivityType, createdAt: unknown, origin: Types.ActivityFeedOrigin, user: { id: unknown, firstName: string, lastName: string, company: { id: unknown, name: string, slug: string, type: Types.CompanyType } } | null, company: { id: unknown, name: string, slug: string, type: Types.CompanyType }, entity:
    | { __typename: 'AdCopy', id: unknown, name: string, adGroup: { id: unknown, campaign: { advertiser: { slug: string } } } }
    | { __typename: 'AdGroup', id: unknown, name: string, campaign: { advertiser: { slug: string } } }
    | { __typename: 'AdGroupBudgetPlan', id: unknown, adGroupId: unknown, plannedDate: unknown }
    | { __typename: 'AdGroupDirectoryPreset', id: unknown, name: string }
    | { __typename: 'AdTemplateBanner', id: unknown, name: string, position: { id: unknown, website: { publisher: { slug: string } } } }
    | { __typename: 'AdTemplateNative', id: unknown, name: string, position: { id: unknown, website: { publisher: { slug: string } } } }
    | { __typename: 'AdTemplateWeb', id: unknown, name: string, position: { id: unknown, website: { publisher: { slug: string } } } }
    | { __typename: 'Advertiser', id: unknown, name: string, slug: string, type: Types.CompanyType }
    | { __typename: 'Agency', id: unknown, name: string, slug: string, type: Types.CompanyType }
    | { __typename: 'BillingContact', id: unknown, firstName: string, lastName: string, companyId: unknown }
    | { __typename: 'Campaign', id: unknown, name: string, advertiser: { slug: string } }
    | { __typename: 'CampaignProgrammatic', id: unknown, name: string, tradingDesk: { slug: string } }
    | { __typename: 'CompanyApiToken', token: string }
    | { __typename: 'CompanyArchiver' }
    | { __typename: 'CompanyWebhook' }
    | { __typename: 'Position', id: unknown, name: string, website: { publisher: { slug: string } } }
    | { __typename: 'Publisher', id: unknown, name: string, slug: string, type: Types.CompanyType }
    | { __typename: 'PublisherExclusionPreset', id: unknown, name: string }
    | { __typename: 'Reseller', id: unknown, name: string, slug: string, type: Types.CompanyType }
    | { __typename: 'SegmentBehavioural', id: unknown, name: string }
    | { __typename: 'SegmentCrm', id: unknown, name: string }
    | { __typename: 'TradingDesk', id: unknown, name: string, slug: string, type: Types.CompanyType }
    | { __typename: 'User', id: unknown, firstName: string, lastName: string }
    | { __typename: 'Website', id: unknown, name: string, publisher: { slug: string } }
   | null, items: Array<{ property: string | null, oldValue: string | null, newValue: string | null, activityType: Types.ActivityType, oldValueEntity:
      | { __typename: 'AdCopy', id: unknown, name: string, adGroup: { id: unknown, campaign: { advertiser: { slug: string } } } }
      | { __typename: 'AdGroup', id: unknown, name: string, campaign: { advertiser: { slug: string } } }
      | { __typename: 'AdGroupBudgetPlan', id: unknown, adGroupId: unknown, plannedDate: unknown }
      | { __typename: 'AdGroupDirectoryPreset', id: unknown, name: string }
      | { __typename: 'AdTemplateBanner', id: unknown, name: string, position: { id: unknown, website: { publisher: { slug: string } } } }
      | { __typename: 'AdTemplateNative', id: unknown, name: string, position: { id: unknown, website: { publisher: { slug: string } } } }
      | { __typename: 'AdTemplateWeb', id: unknown, name: string, position: { id: unknown, website: { publisher: { slug: string } } } }
      | { __typename: 'Advertiser', id: unknown, name: string, slug: string, type: Types.CompanyType }
      | { __typename: 'Agency', id: unknown, name: string, slug: string, type: Types.CompanyType }
      | { __typename: 'BillingContact', id: unknown, firstName: string, lastName: string, companyId: unknown }
      | { __typename: 'Campaign', id: unknown, name: string, advertiser: { slug: string } }
      | { __typename: 'CampaignProgrammatic', id: unknown, name: string, tradingDesk: { slug: string } }
      | { __typename: 'CompanyApiToken', token: string }
      | { __typename: 'CompanyArchiver' }
      | { __typename: 'CompanyWebhook' }
      | { __typename: 'Position', id: unknown, name: string, website: { publisher: { slug: string } } }
      | { __typename: 'Publisher', id: unknown, name: string, slug: string, type: Types.CompanyType }
      | { __typename: 'PublisherExclusionPreset', id: unknown, name: string }
      | { __typename: 'Reseller', id: unknown, name: string, slug: string, type: Types.CompanyType }
      | { __typename: 'SegmentBehavioural', id: unknown, name: string }
      | { __typename: 'SegmentCrm', id: unknown, name: string }
      | { __typename: 'TradingDesk', id: unknown, name: string, slug: string, type: Types.CompanyType }
      | { __typename: 'User', id: unknown, firstName: string, lastName: string }
      | { __typename: 'Website', id: unknown, name: string, publisher: { slug: string } }
     | null, newValueEntity:
      | { __typename: 'AdCopy', id: unknown, name: string, adGroup: { id: unknown, campaign: { advertiser: { slug: string } } } }
      | { __typename: 'AdGroup', id: unknown, name: string, campaign: { advertiser: { slug: string } } }
      | { __typename: 'AdGroupBudgetPlan', id: unknown, adGroupId: unknown, plannedDate: unknown }
      | { __typename: 'AdGroupDirectoryPreset', id: unknown, name: string }
      | { __typename: 'AdTemplateBanner', id: unknown, name: string, position: { id: unknown, website: { publisher: { slug: string } } } }
      | { __typename: 'AdTemplateNative', id: unknown, name: string, position: { id: unknown, website: { publisher: { slug: string } } } }
      | { __typename: 'AdTemplateWeb', id: unknown, name: string, position: { id: unknown, website: { publisher: { slug: string } } } }
      | { __typename: 'Advertiser', id: unknown, name: string, slug: string, type: Types.CompanyType }
      | { __typename: 'Agency', id: unknown, name: string, slug: string, type: Types.CompanyType }
      | { __typename: 'BillingContact', id: unknown, firstName: string, lastName: string, companyId: unknown }
      | { __typename: 'Campaign', id: unknown, name: string, advertiser: { slug: string } }
      | { __typename: 'CampaignProgrammatic', id: unknown, name: string, tradingDesk: { slug: string } }
      | { __typename: 'CompanyApiToken', token: string }
      | { __typename: 'CompanyArchiver' }
      | { __typename: 'CompanyWebhook' }
      | { __typename: 'Position', id: unknown, name: string, website: { publisher: { slug: string } } }
      | { __typename: 'Publisher', id: unknown, name: string, slug: string, type: Types.CompanyType }
      | { __typename: 'PublisherExclusionPreset', id: unknown, name: string }
      | { __typename: 'Reseller', id: unknown, name: string, slug: string, type: Types.CompanyType }
      | { __typename: 'SegmentBehavioural', id: unknown, name: string }
      | { __typename: 'SegmentCrm', id: unknown, name: string }
      | { __typename: 'TradingDesk', id: unknown, name: string, slug: string, type: Types.CompanyType }
      | { __typename: 'User', id: unknown, firstName: string, lastName: string }
      | { __typename: 'Website', id: unknown, name: string, publisher: { slug: string } }
     | null }> };

export type ActivityFeedQueryVariables = Exact<{
  companyId?: unknown;
  pagination?: Types.Pagination | null | undefined;
  userId?: unknown;
  entityType?: Types.EntityType | null | undefined;
  origin?: Array<Types.ActivityFeedOrigin> | Types.ActivityFeedOrigin | null | undefined;
}>;


export type ActivityFeedQuery = { searchActivityFeedGrouped: Array<{ groupId: string, activityType: Types.ActivityType, createdAt: unknown, origin: Types.ActivityFeedOrigin, user: { id: unknown, firstName: string, lastName: string, company: { id: unknown, name: string, slug: string, type: Types.CompanyType } } | null, company: { id: unknown, name: string, slug: string, type: Types.CompanyType }, entity:
      | { __typename: 'AdCopy', id: unknown, name: string, adGroup: { id: unknown, campaign: { advertiser: { slug: string } } } }
      | { __typename: 'AdGroup', id: unknown, name: string, campaign: { advertiser: { slug: string } } }
      | { __typename: 'AdGroupBudgetPlan', id: unknown, adGroupId: unknown, plannedDate: unknown }
      | { __typename: 'AdGroupDirectoryPreset', id: unknown, name: string }
      | { __typename: 'AdTemplateBanner', id: unknown, name: string, position: { id: unknown, website: { publisher: { slug: string } } } }
      | { __typename: 'AdTemplateNative', id: unknown, name: string, position: { id: unknown, website: { publisher: { slug: string } } } }
      | { __typename: 'AdTemplateWeb', id: unknown, name: string, position: { id: unknown, website: { publisher: { slug: string } } } }
      | { __typename: 'Advertiser', id: unknown, name: string, slug: string, type: Types.CompanyType }
      | { __typename: 'Agency', id: unknown, name: string, slug: string, type: Types.CompanyType }
      | { __typename: 'BillingContact', id: unknown, firstName: string, lastName: string, companyId: unknown }
      | { __typename: 'Campaign', id: unknown, name: string, advertiser: { slug: string } }
      | { __typename: 'CampaignProgrammatic', id: unknown, name: string, tradingDesk: { slug: string } }
      | { __typename: 'CompanyApiToken', token: string }
      | { __typename: 'CompanyArchiver' }
      | { __typename: 'CompanyWebhook' }
      | { __typename: 'Position', id: unknown, name: string, website: { publisher: { slug: string } } }
      | { __typename: 'Publisher', id: unknown, name: string, slug: string, type: Types.CompanyType }
      | { __typename: 'PublisherExclusionPreset', id: unknown, name: string }
      | { __typename: 'Reseller', id: unknown, name: string, slug: string, type: Types.CompanyType }
      | { __typename: 'SegmentBehavioural', id: unknown, name: string }
      | { __typename: 'SegmentCrm', id: unknown, name: string }
      | { __typename: 'TradingDesk', id: unknown, name: string, slug: string, type: Types.CompanyType }
      | { __typename: 'User', id: unknown, firstName: string, lastName: string }
      | { __typename: 'Website', id: unknown, name: string, publisher: { slug: string } }
     | null, items: Array<{ property: string | null, oldValue: string | null, newValue: string | null, activityType: Types.ActivityType, oldValueEntity:
        | { __typename: 'AdCopy', id: unknown, name: string, adGroup: { id: unknown, campaign: { advertiser: { slug: string } } } }
        | { __typename: 'AdGroup', id: unknown, name: string, campaign: { advertiser: { slug: string } } }
        | { __typename: 'AdGroupBudgetPlan', id: unknown, adGroupId: unknown, plannedDate: unknown }
        | { __typename: 'AdGroupDirectoryPreset', id: unknown, name: string }
        | { __typename: 'AdTemplateBanner', id: unknown, name: string, position: { id: unknown, website: { publisher: { slug: string } } } }
        | { __typename: 'AdTemplateNative', id: unknown, name: string, position: { id: unknown, website: { publisher: { slug: string } } } }
        | { __typename: 'AdTemplateWeb', id: unknown, name: string, position: { id: unknown, website: { publisher: { slug: string } } } }
        | { __typename: 'Advertiser', id: unknown, name: string, slug: string, type: Types.CompanyType }
        | { __typename: 'Agency', id: unknown, name: string, slug: string, type: Types.CompanyType }
        | { __typename: 'BillingContact', id: unknown, firstName: string, lastName: string, companyId: unknown }
        | { __typename: 'Campaign', id: unknown, name: string, advertiser: { slug: string } }
        | { __typename: 'CampaignProgrammatic', id: unknown, name: string, tradingDesk: { slug: string } }
        | { __typename: 'CompanyApiToken', token: string }
        | { __typename: 'CompanyArchiver' }
        | { __typename: 'CompanyWebhook' }
        | { __typename: 'Position', id: unknown, name: string, website: { publisher: { slug: string } } }
        | { __typename: 'Publisher', id: unknown, name: string, slug: string, type: Types.CompanyType }
        | { __typename: 'PublisherExclusionPreset', id: unknown, name: string }
        | { __typename: 'Reseller', id: unknown, name: string, slug: string, type: Types.CompanyType }
        | { __typename: 'SegmentBehavioural', id: unknown, name: string }
        | { __typename: 'SegmentCrm', id: unknown, name: string }
        | { __typename: 'TradingDesk', id: unknown, name: string, slug: string, type: Types.CompanyType }
        | { __typename: 'User', id: unknown, firstName: string, lastName: string }
        | { __typename: 'Website', id: unknown, name: string, publisher: { slug: string } }
       | null, newValueEntity:
        | { __typename: 'AdCopy', id: unknown, name: string, adGroup: { id: unknown, campaign: { advertiser: { slug: string } } } }
        | { __typename: 'AdGroup', id: unknown, name: string, campaign: { advertiser: { slug: string } } }
        | { __typename: 'AdGroupBudgetPlan', id: unknown, adGroupId: unknown, plannedDate: unknown }
        | { __typename: 'AdGroupDirectoryPreset', id: unknown, name: string }
        | { __typename: 'AdTemplateBanner', id: unknown, name: string, position: { id: unknown, website: { publisher: { slug: string } } } }
        | { __typename: 'AdTemplateNative', id: unknown, name: string, position: { id: unknown, website: { publisher: { slug: string } } } }
        | { __typename: 'AdTemplateWeb', id: unknown, name: string, position: { id: unknown, website: { publisher: { slug: string } } } }
        | { __typename: 'Advertiser', id: unknown, name: string, slug: string, type: Types.CompanyType }
        | { __typename: 'Agency', id: unknown, name: string, slug: string, type: Types.CompanyType }
        | { __typename: 'BillingContact', id: unknown, firstName: string, lastName: string, companyId: unknown }
        | { __typename: 'Campaign', id: unknown, name: string, advertiser: { slug: string } }
        | { __typename: 'CampaignProgrammatic', id: unknown, name: string, tradingDesk: { slug: string } }
        | { __typename: 'CompanyApiToken', token: string }
        | { __typename: 'CompanyArchiver' }
        | { __typename: 'CompanyWebhook' }
        | { __typename: 'Position', id: unknown, name: string, website: { publisher: { slug: string } } }
        | { __typename: 'Publisher', id: unknown, name: string, slug: string, type: Types.CompanyType }
        | { __typename: 'PublisherExclusionPreset', id: unknown, name: string }
        | { __typename: 'Reseller', id: unknown, name: string, slug: string, type: Types.CompanyType }
        | { __typename: 'SegmentBehavioural', id: unknown, name: string }
        | { __typename: 'SegmentCrm', id: unknown, name: string }
        | { __typename: 'TradingDesk', id: unknown, name: string, slug: string, type: Types.CompanyType }
        | { __typename: 'User', id: unknown, firstName: string, lastName: string }
        | { __typename: 'Website', id: unknown, name: string, publisher: { slug: string } }
       | null }> }> };

export type AdCopyMinSizeQueryVariables = Exact<{
  reseller: unknown;
}>;


export type AdCopyMinSizeQuery = { adCopyMinSize: { width: number, height: number } };

export type AdTestQueryVariables = Exact<{
  pagination: Types.Pagination;
  searchQuery: Types.PositionSearchQuery;
}>;


export type AdTestQuery = { searchPositions: Array<{ id: unknown, name: string, shortCode: string, nbZone: number, channelType: Types.ChannelType, status: Types.Status, website: { name: string, publisher: { name: string, slug: string } } }> };

export type AdcopyPartsFragment = { id: unknown, name: string, title: unknown, description: unknown, callToAction: unknown, advertiserName: unknown, image: string, forceRedirectUrl: string | null, comments: string | null, status: Types.AdCopyStatus, rejectedReason: string | null, lastValidatedDate: unknown, weight: number, width: number, height: number, impressionPixels: Array<string>, createdAt: unknown, updatedAt: unknown, statusUpdatedAt: unknown, visualUpdatedAt: unknown, startDate: unknown, endDate: unknown, imageCheck: { hasText: boolean } | null, adCopyTags: Array<{ keyword: string, adCopyId: unknown }> };

export type SearchAdCopiesQueryVariables = Exact<{
  pagination: Types.Pagination;
  searchQuery: Types.AdCopySearchQuery;
}>;


export type SearchAdCopiesQuery = { searchAdCopies: Array<{ id: unknown, name: string, title: unknown, description: unknown, callToAction: unknown, advertiserName: unknown, image: string, forceRedirectUrl: string | null, comments: string | null, status: Types.AdCopyStatus, rejectedReason: string | null, lastValidatedDate: unknown, weight: number, width: number, height: number, impressionPixels: Array<string>, createdAt: unknown, updatedAt: unknown, statusUpdatedAt: unknown, visualUpdatedAt: unknown, startDate: unknown, endDate: unknown, adGroup: { id: unknown, name: string, network: Types.Network, campaign: { id: unknown, name: string, advertiser: { slug: string, genericName: string } } }, imageCheck: { hasText: boolean } | null, adCopyTags: Array<{ keyword: string, adCopyId: unknown }> }> };

export type AdgroupAdCopiesQueryVariables = Exact<{
  adGroupId: unknown;
  pagination: Types.Pagination;
  status?: Array<Types.AdCopyStatus> | Types.AdCopyStatus | null | undefined;
}>;


export type AdgroupAdCopiesQuery = { adGroup: { adCopies: Array<{ id: unknown, name: string, title: unknown, description: unknown, callToAction: unknown, advertiserName: unknown, image: string, forceRedirectUrl: string | null, comments: string | null, status: Types.AdCopyStatus, rejectedReason: string | null, lastValidatedDate: unknown, weight: number, width: number, height: number, impressionPixels: Array<string>, createdAt: unknown, updatedAt: unknown, statusUpdatedAt: unknown, visualUpdatedAt: unknown, startDate: unknown, endDate: unknown, imageCheck: { hasText: boolean } | null, adCopyTags: Array<{ keyword: string, adCopyId: unknown }> }> } };

export type AdCopyQueryVariables = Exact<{
  id: unknown;
}>;


export type AdCopyQuery = { adCopy: { id: unknown, name: string, title: unknown, description: unknown, callToAction: unknown, advertiserName: unknown, image: string, forceRedirectUrl: string | null, comments: string | null, status: Types.AdCopyStatus, rejectedReason: string | null, lastValidatedDate: unknown, weight: number, width: number, height: number, impressionPixels: Array<string>, createdAt: unknown, updatedAt: unknown, statusUpdatedAt: unknown, visualUpdatedAt: unknown, startDate: unknown, endDate: unknown, imageCheck: { hasText: boolean } | null, adCopyTags: Array<{ keyword: string, adCopyId: unknown }> } };

export type UpdateAdCopyMutationVariables = Exact<{
  adCopy: Types.AdCopyInput;
  file?: unknown;
}>;


export type UpdateAdCopyMutation = { updateAdCopy: { id: unknown, name: string, title: unknown, description: unknown, callToAction: unknown, advertiserName: unknown, image: string, forceRedirectUrl: string | null, comments: string | null, status: Types.AdCopyStatus, rejectedReason: string | null, lastValidatedDate: unknown, weight: number, width: number, height: number, impressionPixels: Array<string>, createdAt: unknown, updatedAt: unknown, statusUpdatedAt: unknown, visualUpdatedAt: unknown, startDate: unknown, endDate: unknown, imageCheck: { hasText: boolean } | null, adCopyTags: Array<{ keyword: string, adCopyId: unknown }> } };

export type UpdateAdCopyStatusMutationVariables = Exact<{
  adCopyId: unknown;
  status: Types.AdCopyStatus;
  rejectedReason?: string | null | undefined;
}>;


export type UpdateAdCopyStatusMutation = { updateAdCopyStatus: { id: unknown, name: string, title: unknown, description: unknown, callToAction: unknown, advertiserName: unknown, image: string, forceRedirectUrl: string | null, comments: string | null, status: Types.AdCopyStatus, rejectedReason: string | null, lastValidatedDate: unknown, weight: number, width: number, height: number, impressionPixels: Array<string>, createdAt: unknown, updatedAt: unknown, statusUpdatedAt: unknown, visualUpdatedAt: unknown, startDate: unknown, endDate: unknown, imageCheck: { hasText: boolean } | null, adCopyTags: Array<{ keyword: string, adCopyId: unknown }> } };

export type DuplicateAdCopyMutationVariables = Exact<{
  id: unknown;
  override: Types.AdCopyDuplicateInput;
  file?: unknown;
}>;


export type DuplicateAdCopyMutation = { duplicateAdCopy: { id: unknown, name: string, title: unknown, description: unknown, callToAction: unknown, advertiserName: unknown, image: string, forceRedirectUrl: string | null, comments: string | null, status: Types.AdCopyStatus, rejectedReason: string | null, lastValidatedDate: unknown, weight: number, width: number, height: number, impressionPixels: Array<string>, createdAt: unknown, updatedAt: unknown, statusUpdatedAt: unknown, visualUpdatedAt: unknown, startDate: unknown, endDate: unknown, imageCheck: { hasText: boolean } | null, adCopyTags: Array<{ keyword: string, adCopyId: unknown }> } };

export type CreateAdCopiesMutationVariables = Exact<{
  newAdCopies: Array<Types.AdCopyCreateInput> | Types.AdCopyCreateInput;
  images?: Array<unknown> | unknown | null | undefined;
  adGroupId: unknown;
}>;


export type CreateAdCopiesMutation = { createAdCopies: { errors: Array<string>, success: Array<{ id: unknown, name: string, title: unknown, description: unknown, callToAction: unknown, advertiserName: unknown, image: string, forceRedirectUrl: string | null, comments: string | null, status: Types.AdCopyStatus, rejectedReason: string | null, lastValidatedDate: unknown, weight: number, width: number, height: number, impressionPixels: Array<string>, createdAt: unknown, updatedAt: unknown, statusUpdatedAt: unknown, visualUpdatedAt: unknown, startDate: unknown, endDate: unknown, imageCheck: { hasText: boolean } | null, adCopyTags: Array<{ keyword: string, adCopyId: unknown }> }> } };

export type AdGroupPartsFragment = { id: unknown, name: string, status: Types.AdGroupStatus, impressionPixels: Array<string>, clickPixels: Array<string>, format: Types.AdFormat, dailyBudget: number | null, dailyBudgetType: Types.DailyBudgetType, redirectUrl: string, network: Types.Network, contentStrategy: Types.ContentStrategy, channelWeb: boolean, channelEmail: boolean, startDate: unknown, endDate: unknown, budgetCapping: number | null, budgetCappingType: Types.BudgetCapping, dspId: number | null, dealId: string | null, userCappingType: Types.UserCapping | null, userCappingValue: number | null, userCappingTimeframe: string | null, costType: Types.CostType, costValue: number, countryBlacklistRedirectUrl: string | null, authorizedCountries: Array<{ code: string, label: string }>, campaign: { id: unknown, name: string, status: Types.Status }, targeting: { gender: Array<Types.Gender>, age: { range: Array<Types.AgeRange>, unknown: boolean }, device: { type: Array<Types.DeviceType>, exclusive: boolean }, geoTargeting: { geoExclusive: boolean, countries: Array<string>, cities: Array<{ name: string, radius: number, location: { latitude: number, longitude: number } }>, regions: Array<{ name: string, geometry: { southwest: { latitude: number, longitude: number }, northeast: { latitude: number, longitude: number } } }>, departements: Array<{ name: string, geometry: { southwest: { latitude: number, longitude: number }, northeast: { latitude: number, longitude: number } } }> }, os: { type: Array<Types.OsType>, exclusive: boolean }, time: { days: Array<Types.Day>, hours: Array<number> }, segments: Array<{ isExcluded: boolean, segment:
        | { id: unknown, name: string, errorReason: string | null, nbProfiles: number | null, existingProfiles: number | null, reach: number | null, archived: boolean, status: Types.SegmentStatus, updatedAt: unknown, createdAt: unknown, duration: number | null, rules: Array<{ type: Types.RuleType, urls: Array<string> }> }
        | { id: unknown, name: string, errorReason: string | null, nbProfiles: number | null, existingProfiles: number | null, reach: number | null, archived: boolean, status: Types.SegmentStatus, originalFilename: string, updatedAt: unknown, createdAt: unknown }
       }>, autoSegments: Array<{ type: Types.AutoSegmentType, dimension: Types.AutoSegmentFor, id: string, isExcluded: boolean }>, tags: Array<{ id: string, origin: string, name: string, description: string | null, profileCount: number | null, isExcluded: boolean }> } | null, budget: { date: unknown, budgetMeasures: { dayBudget: number | null, daySpent: number, monthBudget: number | null, monthSpent: number, periodBudget: number | null, periodSpent: number, overallBudget: number | null, overallSpent: number }, budgetStatus: { monthOverspent: boolean, overallOverspent: boolean } } | null };

export type AdGroupNameQueryVariables = Exact<{
  id: unknown;
}>;


export type AdGroupNameQuery = { adGroup: { id: unknown, name: string } };

export type AdGroupAdvertiserSlugQueryVariables = Exact<{
  id: unknown;
}>;


export type AdGroupAdvertiserSlugQuery = { adGroup: { id: unknown, campaign: { advertiser: { slug: string } } } };

export type AdgroupsQueryVariables = Exact<{
  pagination: Types.Pagination;
  searchQuery: Types.AdGroupSearchQuery;
}>;


export type AdgroupsQuery = { searchAdGroups: Array<{ id: unknown, name: string, status: Types.AdGroupStatus, network: Types.Network, costType: Types.CostType, costValue: number, dailyBudget: number | null, dailyBudgetType: Types.DailyBudgetType, startDate: unknown, endDate: unknown, budgetCapping: number | null, budgetCappingType: Types.BudgetCapping, campaign: { id: unknown, name: string, advertiser: { slug: string, genericName: string, currency: Types.Currency | null, reseller: { genericName: string } }, market: { language: { code: string }, country: { code: string } } }, budget: { date: unknown, budgetMeasures: { dayBudget: number | null, daySpent: number, monthBudget: number | null, monthSpent: number, periodBudget: number | null, periodSpent: number, overallBudget: number | null, overallSpent: number }, budgetStatus: { monthOverspent: boolean, overallOverspent: boolean } } | null }> };

export type AdgroupSettingsQueryVariables = Exact<{
  id: unknown;
}>;


export type AdgroupSettingsQuery = { adGroup: { priorityId: unknown, id: unknown, name: string, status: Types.AdGroupStatus, impressionPixels: Array<string>, clickPixels: Array<string>, format: Types.AdFormat, dailyBudget: number | null, dailyBudgetType: Types.DailyBudgetType, redirectUrl: string, network: Types.Network, contentStrategy: Types.ContentStrategy, channelWeb: boolean, channelEmail: boolean, startDate: unknown, endDate: unknown, budgetCapping: number | null, budgetCappingType: Types.BudgetCapping, dspId: number | null, dealId: string | null, userCappingType: Types.UserCapping | null, userCappingValue: number | null, userCappingTimeframe: string | null, costType: Types.CostType, costValue: number, countryBlacklistRedirectUrl: string | null, authorizedCountries: Array<{ code: string, label: string }>, campaign: { id: unknown, name: string, status: Types.Status }, targeting: { gender: Array<Types.Gender>, age: { range: Array<Types.AgeRange>, unknown: boolean }, device: { type: Array<Types.DeviceType>, exclusive: boolean }, geoTargeting: { geoExclusive: boolean, countries: Array<string>, cities: Array<{ name: string, radius: number, location: { latitude: number, longitude: number } }>, regions: Array<{ name: string, geometry: { southwest: { latitude: number, longitude: number }, northeast: { latitude: number, longitude: number } } }>, departements: Array<{ name: string, geometry: { southwest: { latitude: number, longitude: number }, northeast: { latitude: number, longitude: number } } }> }, os: { type: Array<Types.OsType>, exclusive: boolean }, time: { days: Array<Types.Day>, hours: Array<number> }, segments: Array<{ isExcluded: boolean, segment:
          | { id: unknown, name: string, errorReason: string | null, nbProfiles: number | null, existingProfiles: number | null, reach: number | null, archived: boolean, status: Types.SegmentStatus, updatedAt: unknown, createdAt: unknown, duration: number | null, rules: Array<{ type: Types.RuleType, urls: Array<string> }> }
          | { id: unknown, name: string, errorReason: string | null, nbProfiles: number | null, existingProfiles: number | null, reach: number | null, archived: boolean, status: Types.SegmentStatus, originalFilename: string, updatedAt: unknown, createdAt: unknown }
         }>, autoSegments: Array<{ type: Types.AutoSegmentType, dimension: Types.AutoSegmentFor, id: string, isExcluded: boolean }>, tags: Array<{ id: string, origin: string, name: string, description: string | null, profileCount: number | null, isExcluded: boolean }> } | null, budget: { date: unknown, budgetMeasures: { dayBudget: number | null, daySpent: number, monthBudget: number | null, monthSpent: number, periodBudget: number | null, periodSpent: number, overallBudget: number | null, overallSpent: number }, budgetStatus: { monthOverspent: boolean, overallOverspent: boolean } } | null } };

export type AdgroupDirectoryQueryVariables = Exact<{
  id: unknown;
}>;


export type AdgroupDirectoryQuery = { adGroup: { id: unknown, directoryWithPreset: { directory: { type: Types.DirectoryType, websites: Array<{ id: unknown, name: string, url: string, iabCategory: Types.Iab | null, reseller: { name: string, id: unknown }, positions: Array<{ id: unknown, name: string, channelType: Types.ChannelType, iabCategory: Types.Iab | null, isEnabled: boolean, impressions: number, adTemplateSizes: Array<{ zone: number, width: number, height: number }> | null }> }> }, presets: Array<{ id: unknown, name: string, description: string | null, company: { name: string }, websites: Array<{ id: unknown, name: string, url: string, iabCategory: Types.Iab | null, reseller: { name: string, id: unknown }, positions: Array<{ id: unknown, name: string, channelType: Types.ChannelType, iabCategory: Types.Iab | null, isEnabled: boolean, impressions: number }> }> }> } } };

export type DeviceAdjustmentByAdGroupQueryVariables = Exact<{
  adGroupId: unknown;
}>;


export type DeviceAdjustmentByAdGroupQuery = { adGroup: { id: unknown, deviceAdjustments: Array<{ realAdjustment: unknown, wantedAdjustment: unknown, deviceType: Types.DeviceType }> } };

export type WebsiteAdjustmentByAdGroupQueryVariables = Exact<{
  adGroupId: unknown;
}>;


export type WebsiteAdjustmentByAdGroupQuery = { adGroup: { id: unknown, websiteAdjustments: Array<{ id: unknown, name: string, url: string, iabCategory: Types.Iab | null, realAdjustment: unknown, wantedAdjustment: unknown, reseller: { id: unknown, name: string }, positions: Array<{ id: unknown, name: string, realAdjustment: unknown, wantedAdjustment: unknown, channelType: Types.ChannelType, iabCategory: Types.Iab | null }> }> } };

export type SearchOutsideDirectoryQueryVariables = Exact<{
  pagination?: Types.Pagination | null | undefined;
  searchQuery: Types.DirectorySearchQuery;
  adGroupId: unknown;
}>;


export type SearchOutsideDirectoryQuery = { searchOutsideDirectory: Array<{ id: unknown, name: string, url: string, iabCategory: Types.Iab | null, reseller: { name: string, id: unknown }, positions: Array<{ id: unknown, name: string, channelType: Types.ChannelType, impressions: number, iabCategory: Types.Iab | null, isEnabled: boolean }> }> };

export type SearchInDirectoryQueryVariables = Exact<{
  pagination?: Types.Pagination | null | undefined;
  searchQuery: Types.DirectorySearchQuery;
  adGroupId: unknown;
}>;


export type SearchInDirectoryQuery = { searchInDirectory: Array<{ id: unknown, name: string, url: string, iabCategory: Types.Iab | null, reseller: { name: string, id: unknown }, positions: Array<{ id: unknown, name: string, channelType: Types.ChannelType, iabCategory: Types.Iab | null, adTemplateSizes: Array<{ zone: number, width: number, height: number }> | null }> }> };

export type AdGroupPerformanceStatsQueryVariables = Exact<{
  endDate: unknown;
  startDate: unknown;
  adGroupId: unknown;
  filters?: Array<Types.CostDetailsFilter> | Types.CostDetailsFilter | null | undefined;
}>;


export type AdGroupPerformanceStatsQuery = { adGroup: { id: unknown, performanceStats: { stats: { pageViews: number, sessions: number, engagedSessions: number, totalUsers: number, newUsers: number, bounceRate: number, engagementRate: number, sessionTimeSeconds: number, cpv: number, impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number }, devices: Array<{ name: string, stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number } }>, publisherResellers: Array<{ name: string, stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number }, publishers: Array<{ name: string, stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number }, websites: Array<{ name: string, stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number }, positions: Array<{ name: string, stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number } }> }> }> }>, adCopies: Array<{ id: unknown, name: string, title: unknown, description: unknown, callToAction: unknown, advertiserName: unknown, image: string, status: Types.AdCopyStatus, statusUpdatedAt: unknown, stats: { pageViews: number, sessions: number, engagedSessions: number, totalUsers: number, newUsers: number, bounceRate: number, engagementRate: number, sessionTimeSeconds: number, cpv: number, impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number } }> } } };

export type AdGroupTimeseriesQueryVariables = Exact<{
  endDate: unknown;
  startDate: unknown;
  adGroupId: unknown;
  granularity: Types.GraphGranularity;
  filters?: Array<Types.CostDetailsFilter> | Types.CostDetailsFilter | null | undefined;
}>;


export type AdGroupTimeseriesQuery = { adGroup: { id: unknown, timeseries: { timeseries: Array<{ date: unknown, stats: { pageViews: number, sessions: number, engagedSessions: number, totalUsers: number, newUsers: number, bounceRate: number, engagementRate: number, sessionTimeSeconds: number, cpv: number, impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number } }>, stats: { pageViews: number, sessions: number, engagedSessions: number, totalUsers: number, newUsers: number, bounceRate: number, engagementRate: number, sessionTimeSeconds: number, cpv: number, impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number } } } };

export type AdGroupPreviewQueryVariables = Exact<{
  adGroupId: unknown;
  positionId: unknown;
}>;


export type AdGroupPreviewQuery = { adGroupPreview: Array<{ id: string, name: string, image: string }> };

export type CreateAdgroupMutationVariables = Exact<{
  adgroup: Types.AdGroupCreateInput;
}>;


export type CreateAdgroupMutation = { createAdGroup: { id: unknown, name: string, status: Types.AdGroupStatus, impressionPixels: Array<string>, clickPixels: Array<string>, format: Types.AdFormat, dailyBudget: number | null, dailyBudgetType: Types.DailyBudgetType, redirectUrl: string, network: Types.Network, contentStrategy: Types.ContentStrategy, channelWeb: boolean, channelEmail: boolean, startDate: unknown, endDate: unknown, budgetCapping: number | null, budgetCappingType: Types.BudgetCapping, dspId: number | null, dealId: string | null, userCappingType: Types.UserCapping | null, userCappingValue: number | null, userCappingTimeframe: string | null, costType: Types.CostType, costValue: number, countryBlacklistRedirectUrl: string | null, authorizedCountries: Array<{ code: string, label: string }>, campaign: { id: unknown, name: string, status: Types.Status }, targeting: { gender: Array<Types.Gender>, age: { range: Array<Types.AgeRange>, unknown: boolean }, device: { type: Array<Types.DeviceType>, exclusive: boolean }, geoTargeting: { geoExclusive: boolean, countries: Array<string>, cities: Array<{ name: string, radius: number, location: { latitude: number, longitude: number } }>, regions: Array<{ name: string, geometry: { southwest: { latitude: number, longitude: number }, northeast: { latitude: number, longitude: number } } }>, departements: Array<{ name: string, geometry: { southwest: { latitude: number, longitude: number }, northeast: { latitude: number, longitude: number } } }> }, os: { type: Array<Types.OsType>, exclusive: boolean }, time: { days: Array<Types.Day>, hours: Array<number> }, segments: Array<{ isExcluded: boolean, segment:
          | { id: unknown, name: string, errorReason: string | null, nbProfiles: number | null, existingProfiles: number | null, reach: number | null, archived: boolean, status: Types.SegmentStatus, updatedAt: unknown, createdAt: unknown, duration: number | null, rules: Array<{ type: Types.RuleType, urls: Array<string> }> }
          | { id: unknown, name: string, errorReason: string | null, nbProfiles: number | null, existingProfiles: number | null, reach: number | null, archived: boolean, status: Types.SegmentStatus, originalFilename: string, updatedAt: unknown, createdAt: unknown }
         }>, autoSegments: Array<{ type: Types.AutoSegmentType, dimension: Types.AutoSegmentFor, id: string, isExcluded: boolean }>, tags: Array<{ id: string, origin: string, name: string, description: string | null, profileCount: number | null, isExcluded: boolean }> } | null, budget: { date: unknown, budgetMeasures: { dayBudget: number | null, daySpent: number, monthBudget: number | null, monthSpent: number, periodBudget: number | null, periodSpent: number, overallBudget: number | null, overallSpent: number }, budgetStatus: { monthOverspent: boolean, overallOverspent: boolean } } | null } | null };

export type UpdateAdgroupMutationVariables = Exact<{
  adgroup: Types.AdGroupInput;
}>;


export type UpdateAdgroupMutation = { updateAdGroup: { id: unknown, name: string, status: Types.AdGroupStatus, impressionPixels: Array<string>, clickPixels: Array<string>, format: Types.AdFormat, dailyBudget: number | null, dailyBudgetType: Types.DailyBudgetType, redirectUrl: string, network: Types.Network, contentStrategy: Types.ContentStrategy, channelWeb: boolean, channelEmail: boolean, startDate: unknown, endDate: unknown, budgetCapping: number | null, budgetCappingType: Types.BudgetCapping, dspId: number | null, dealId: string | null, userCappingType: Types.UserCapping | null, userCappingValue: number | null, userCappingTimeframe: string | null, costType: Types.CostType, costValue: number, countryBlacklistRedirectUrl: string | null, authorizedCountries: Array<{ code: string, label: string }>, campaign: { id: unknown, name: string, status: Types.Status }, targeting: { gender: Array<Types.Gender>, age: { range: Array<Types.AgeRange>, unknown: boolean }, device: { type: Array<Types.DeviceType>, exclusive: boolean }, geoTargeting: { geoExclusive: boolean, countries: Array<string>, cities: Array<{ name: string, radius: number, location: { latitude: number, longitude: number } }>, regions: Array<{ name: string, geometry: { southwest: { latitude: number, longitude: number }, northeast: { latitude: number, longitude: number } } }>, departements: Array<{ name: string, geometry: { southwest: { latitude: number, longitude: number }, northeast: { latitude: number, longitude: number } } }> }, os: { type: Array<Types.OsType>, exclusive: boolean }, time: { days: Array<Types.Day>, hours: Array<number> }, segments: Array<{ isExcluded: boolean, segment:
          | { id: unknown, name: string, errorReason: string | null, nbProfiles: number | null, existingProfiles: number | null, reach: number | null, archived: boolean, status: Types.SegmentStatus, updatedAt: unknown, createdAt: unknown, duration: number | null, rules: Array<{ type: Types.RuleType, urls: Array<string> }> }
          | { id: unknown, name: string, errorReason: string | null, nbProfiles: number | null, existingProfiles: number | null, reach: number | null, archived: boolean, status: Types.SegmentStatus, originalFilename: string, updatedAt: unknown, createdAt: unknown }
         }>, autoSegments: Array<{ type: Types.AutoSegmentType, dimension: Types.AutoSegmentFor, id: string, isExcluded: boolean }>, tags: Array<{ id: string, origin: string, name: string, description: string | null, profileCount: number | null, isExcluded: boolean }> } | null, budget: { date: unknown, budgetMeasures: { dayBudget: number | null, daySpent: number, monthBudget: number | null, monthSpent: number, periodBudget: number | null, periodSpent: number, overallBudget: number | null, overallSpent: number }, budgetStatus: { monthOverspent: boolean, overallOverspent: boolean } } | null } };

export type CopyAdGroupMutationVariables = Exact<{
  name: string;
  adGroupId: unknown;
  isActive: boolean;
}>;


export type CopyAdGroupMutation = { copyAdGroup: unknown };

export type UpdateDeviceAdjustmentsMutationVariables = Exact<{
  adjustments: Array<Types.AdGroupDeviceAdjustmentInput> | Types.AdGroupDeviceAdjustmentInput;
  adGroupId: unknown;
}>;


export type UpdateDeviceAdjustmentsMutation = { updateDeviceAdjustments: boolean };

export type UpdateWebsiteAdjustmentsMutationVariables = Exact<{
  adjustments: Array<Types.WebsiteAdjustmentInput> | Types.WebsiteAdjustmentInput;
  adGroupId: unknown;
}>;


export type UpdateWebsiteAdjustmentsMutation = { updateWebsiteAdjustments: boolean };

export type UpdateAdgroupTargetingMutationVariables = Exact<{
  targeting: Types.AdGroupTargetingInput;
  adgroupId: unknown;
}>;


export type UpdateAdgroupTargetingMutation = { updateAdgroupTargeting: boolean | null };

export type AddAdGroupTargetingAdressesMutationVariables = Exact<{
  adGroupId: unknown;
  clearPrevious?: boolean | null | undefined;
  radius?: number | null | undefined;
  addresses: Array<string> | string;
}>;


export type AddAdGroupTargetingAdressesMutation = { addAdGroupTargetingAdresses: Array<{ address: string, invalidReason: string }> | null };

export type AddToDirectoryMutationVariables = Exact<{
  toAdd: Array<Types.WebsiteDirectoryInput> | Types.WebsiteDirectoryInput;
  adGroupId: unknown;
}>;


export type AddToDirectoryMutation = { addToDirectory: boolean };

export type AddToWebsiteAdjustmentsMutationVariables = Exact<{
  toAdd: Array<Types.WebsiteAdjustmentInput> | Types.WebsiteAdjustmentInput;
  adGroupId: unknown;
}>;


export type AddToWebsiteAdjustmentsMutation = { addToWebsiteAdjustments: boolean };

export type UpdateDirectoryMutationVariables = Exact<{
  directory: Array<Types.WebsiteDirectoryInput> | Types.WebsiteDirectoryInput;
  adGroupId: unknown;
  type: Types.DirectoryType;
}>;


export type UpdateDirectoryMutation = { updateDirectory: boolean };

export type AnalyticsDataQueryVariables = Exact<{
  advertiserId: unknown;
  startDate: unknown;
  endDate: unknown;
}>;


export type AnalyticsDataQuery = { analyticsImportParameters: unknown, adCopiesForAnalyticsImport: Array<{ id: unknown, adGroupId: unknown, name: string, forceRedirectUrl: string | null, startDate: unknown, endDate: unknown, analyticsStats: { pageViews: number, sessions: number, engagedSessions: number, totalUsers: number, newUsers: number, revenue: number, bounceRate: number, engagementRate: number, sessionTimeSeconds: number, leads: number, orders: number, lastAt: unknown } }> };

export type ImportAnalyticsDataMutationVariables = Exact<{
  analyticsData: Array<Types.AnalayticsStatInput> | Types.AnalayticsStatInput;
  analyticsImportParameters?: unknown;
}>;


export type ImportAnalyticsDataMutation = { importAnalyticsData: Array<{ adGroupId: unknown, adCopyId: unknown, at: unknown, pageViews: number, sessions: number, engagedSessions: number, totalUsers: number, newUsers: number, revenue: number, bounceRate: number, engagementRate: number, sessionTimeSeconds: number, leads: number, orders: number }> };

export type TargetingReachQueryVariables = Exact<{
  adGroupId: unknown;
  targeting: Types.AdGroupTargetingInput;
}>;


export type TargetingReachQuery = { targetingReach: { impressions: unknown, cpc: unknown } };

export type SimulateReachQueryVariables = Exact<{
  market: unknown;
  targeting: Types.AdGroupTargetingInput;
  network?: Types.Network | null | undefined;
  adFormat?: Types.AdFormat | null | undefined;
  directory?: Types.AdGroupDirectoryInput | null | undefined;
}>;


export type SimulateReachQuery = { simulateReach: { impressions: unknown, cpc: unknown } };

export type ProfileTagOriginsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProfileTagOriginsQuery = { profileTagOrigins: Array<string> };

export type SearchTagsQueryVariables = Exact<{
  pagination: Types.Pagination;
  origin?: string | null | undefined;
  query: string;
}>;


export type SearchTagsQuery = { searchTags: Array<{ id: string, origin: string, name: string, description: string | null, profileCount: number }> };

export type AdgroupBlacklistQueryVariables = Exact<{
  id: unknown;
}>;


export type AdgroupBlacklistQuery = { adGroup: { id: unknown, blacklistedOn: { maximumTraffic: unknown, websites: Array<{ traffic: unknown, reasons: Array<Types.BlacklistReason>, website: { id: unknown, name: string, publisher: { id: unknown, name: string, reseller: { id: unknown, name: string } } } }> } } };

export type AdGroupBudgetHistoryQueryVariables = Exact<{
  adGroupId: unknown;
  days: number;
}>;


export type AdGroupBudgetHistoryQuery = { adGroupBudgetHistory: Array<{ at: unknown, changeType: Types.AdGroupBudgetChangeType, dailyBudget: number | null, dailyBudgetType: Types.DailyBudgetType | null, budgetCapping: number | null, budgetCappingType: Types.BudgetCapping | null, costValue: number | null, costType: Types.CostType | null, user: { id: unknown, firstName: string, lastName: string, company: { id: unknown, name: string, slug: string, type: Types.CompanyType } } | null }> };

export type AdGroupBudgetPlanPartsFragment = { id: unknown, adGroupId: unknown, plannedDate: unknown, dailyBudget: number | null, dailyBudgetType: Types.DailyBudgetType | null, budgetCapping: number | null, budgetCappingType: Types.BudgetCapping | null, costValue: number | null, costType: Types.CostType | null, changeDailyBudget: boolean, changeBudgetCapping: boolean, changeCost: boolean, changeDates: boolean, processed: boolean, startDate: unknown, endDate: unknown };

export type AdGroupBudgetPlansQueryVariables = Exact<{
  id: unknown;
}>;


export type AdGroupBudgetPlansQuery = { adGroup: { id: unknown, budgetPlans: Array<{ id: unknown, adGroupId: unknown, plannedDate: unknown, dailyBudget: number | null, dailyBudgetType: Types.DailyBudgetType | null, budgetCapping: number | null, budgetCappingType: Types.BudgetCapping | null, costValue: number | null, costType: Types.CostType | null, changeDailyBudget: boolean, changeBudgetCapping: boolean, changeCost: boolean, changeDates: boolean, processed: boolean, startDate: unknown, endDate: unknown }> } };

export type CreateAdGroupBudgetPlanMutationVariables = Exact<{
  plan: Types.AdGroupBudgetPlanCreateInput;
}>;


export type CreateAdGroupBudgetPlanMutation = { createAdGroupBudgetPlan: { id: unknown, adGroupId: unknown, plannedDate: unknown, dailyBudget: number | null, dailyBudgetType: Types.DailyBudgetType | null, budgetCapping: number | null, budgetCappingType: Types.BudgetCapping | null, costValue: number | null, costType: Types.CostType | null, changeDailyBudget: boolean, changeBudgetCapping: boolean, changeCost: boolean, changeDates: boolean, processed: boolean, startDate: unknown, endDate: unknown } | null };

export type UpdateAdGroupBudgetPlanMutationVariables = Exact<{
  plan: Types.AdGroupBudgetPlanUpdateInput;
}>;


export type UpdateAdGroupBudgetPlanMutation = { updateAdGroupBudgetPlan: { id: unknown, adGroupId: unknown, plannedDate: unknown, dailyBudget: number | null, dailyBudgetType: Types.DailyBudgetType | null, budgetCapping: number | null, budgetCappingType: Types.BudgetCapping | null, costValue: number | null, costType: Types.CostType | null, changeDailyBudget: boolean, changeBudgetCapping: boolean, changeCost: boolean, changeDates: boolean, processed: boolean, startDate: unknown, endDate: unknown } | null };

export type DeleteAdGroupBudgetPlanMutationVariables = Exact<{
  id: unknown;
}>;


export type DeleteAdGroupBudgetPlanMutation = { deleteAdGroupBudgetPlan: boolean | null };

export type DirectoryPresetWebsitePartsFragment = { id: unknown, name: string, url: string, iabCategory: Types.Iab | null, reseller: { id: unknown, name: string }, positions: Array<{ id: unknown, name: string, channelType: Types.ChannelType, iabCategory: Types.Iab | null, isEnabled: boolean }> };

export type AdGroupDirectoryPresetPartsFragment = { id: unknown, name: string, description: string | null, websites: Array<{ id: unknown, name: string, url: string, iabCategory: Types.Iab | null, reseller: { id: unknown, name: string }, positions: Array<{ id: unknown, name: string, channelType: Types.ChannelType, iabCategory: Types.Iab | null, isEnabled: boolean }> }> };

export type AdGroupDirectoryPresetsQueryVariables = Exact<{
  companyId: unknown;
}>;


export type AdGroupDirectoryPresetsQuery = { adGroupDirectoryPresets: Array<{ id: unknown, name: string, description: string | null, websites: Array<{ id: unknown, name: string, url: string, iabCategory: Types.Iab | null, reseller: { id: unknown, name: string }, positions: Array<{ id: unknown, name: string, channelType: Types.ChannelType, iabCategory: Types.Iab | null, isEnabled: boolean }> }> }> };

export type SearchWebsitesForDirectoryPresetQueryVariables = Exact<{
  pagination: Types.Pagination;
  searchQuery: Types.WebsiteSearchQuery;
}>;


export type SearchWebsitesForDirectoryPresetQuery = { searchWebsites: Array<{ id: unknown, name: string, url: string, iabCategory: Types.Iab, positions: Array<{ id: unknown, name: string, channelType: Types.ChannelType, iabCategory: Types.Iab | null }> }> };

export type CreateAdGroupDirectoryPresetMutationVariables = Exact<{
  name: string;
  companyId: unknown;
  description?: string | null | undefined;
}>;


export type CreateAdGroupDirectoryPresetMutation = { createAdGroupDirectoryPreset: { id: unknown, name: string, description: string | null } };

export type UpdateAdGroupDirectoryPresetMutationVariables = Exact<{
  preset: Types.AdGroupDirectoryPresetInput;
}>;


export type UpdateAdGroupDirectoryPresetMutation = { updateAdGroupDirectoryPreset: boolean };

export type DeleteAdGroupDirectoryPresetMutationVariables = Exact<{
  id: unknown;
}>;


export type DeleteAdGroupDirectoryPresetMutation = { deleteAdGroupDirectoryPreset: boolean };

export type SelectAdGroupDirectoryPresetsMutationVariables = Exact<{
  adGroupId: unknown;
  presetIds: Array<unknown> | unknown;
}>;


export type SelectAdGroupDirectoryPresetsMutation = { selectAdGroupDirectoryPresets: boolean };

export type AdTemplateBannerPartsFragment = { id: unknown, name: string, status: Types.Status, width: number, height: number, format: Types.AdFormat };

export type AdTemplateNativePartsFragment = { id: unknown, name: string, status: Types.Status, isDefault: boolean, format: Types.AdFormat };

export type AdTemplateWebPartsFragment = { id: unknown, name: string, status: Types.Status, masterTemplate: string | null, zoneTemplate: string | null, css: string | null, js: string | null, cssSelector: string | null, cssSelectorPosition: Types.CssSelectorPosition, format: Types.AdFormat };

export type AdTemplateNativeImageDescriptorPartsFragment = { id: unknown, template: { canvas: { width: number, height: number, backgroundColor: string, backgroundImageUrl: string | null }, elements: Array<
      | { type: Types.Element, top: number, left: number, radius: number, backgroundColor: unknown, border: { width: number, color: unknown } }
      | { type: Types.Element, top: number, left: number, backgroundColor: unknown, border: { width: number, color: unknown } }
      | { type: Types.Element, top: number, left: number, width: number, height: number }
      | { type: Types.Element, top: number, left: number, color: unknown }
      | { type: Types.Element, top: number, left: number, backgroundColor: unknown, width: number, height: number, border: { width: number, color: unknown, radius: number | null } }
      | { type: Types.Element, top: number, left: number, text: string, backgroundColor: unknown, horizontalAlign: Types.HorizontalAlign, verticalAlign: Types.VerticalAlign, width: number, height: number, font: { family: string, size: number, color: unknown, backgroundColor: unknown, italic: boolean, bold: boolean, underline: boolean, uppercase: boolean }, border: { width: number, color: unknown }, overrides: Array<{ characterIndex: number, family: string | null, size: number | null, color: unknown, backgroundColor: unknown, italic: boolean | null, bold: boolean | null, underline: boolean | null, uppercase: boolean | null }> }
      | { type: Types.Element, top: number, left: number, backgroundColor: unknown, width: number, height: number, border: { width: number, color: unknown } }
    > }, mobileTemplate: { canvas: { width: number, height: number, backgroundColor: string, backgroundImageUrl: string | null }, elements: Array<
      | { type: Types.Element, top: number, left: number, radius: number, backgroundColor: unknown, border: { width: number, color: unknown } }
      | { type: Types.Element, top: number, left: number, backgroundColor: unknown, border: { width: number, color: unknown } }
      | { type: Types.Element, top: number, left: number, width: number, height: number }
      | { type: Types.Element, top: number, left: number, color: unknown }
      | { type: Types.Element, top: number, left: number, backgroundColor: unknown, width: number, height: number, border: { width: number, color: unknown, radius: number | null } }
      | { type: Types.Element, top: number, left: number, text: string, backgroundColor: unknown, horizontalAlign: Types.HorizontalAlign, verticalAlign: Types.VerticalAlign, width: number, height: number, font: { family: string, size: number, color: unknown, backgroundColor: unknown, italic: boolean, bold: boolean, underline: boolean, uppercase: boolean }, border: { width: number, color: unknown }, overrides: Array<{ characterIndex: number, family: string | null, size: number | null, color: unknown, backgroundColor: unknown, italic: boolean | null, bold: boolean | null, underline: boolean | null, uppercase: boolean | null }> }
      | { type: Types.Element, top: number, left: number, backgroundColor: unknown, width: number, height: number, border: { width: number, color: unknown } }
    > } | null };

export type PositionTemplatesQueryVariables = Exact<{
  id: unknown;
  pagination?: Types.Pagination | null | undefined;
  searchQuery: Types.AdTemplateSearchQuery;
}>;


export type PositionTemplatesQuery = { position: { id: unknown, adTemplates: Array<
      | { id: unknown, name: string, status: Types.Status, width: number, height: number, format: Types.AdFormat }
      | { id: unknown, name: string, status: Types.Status, isDefault: boolean, format: Types.AdFormat, template: { canvas: { width: number, height: number, backgroundColor: string, backgroundImageUrl: string | null }, elements: Array<
            | { type: Types.Element, top: number, left: number, radius: number, backgroundColor: unknown, border: { width: number, color: unknown } }
            | { type: Types.Element, top: number, left: number, backgroundColor: unknown, border: { width: number, color: unknown } }
            | { type: Types.Element, top: number, left: number, width: number, height: number }
            | { type: Types.Element, top: number, left: number, color: unknown }
            | { type: Types.Element, top: number, left: number, backgroundColor: unknown, width: number, height: number, border: { width: number, color: unknown, radius: number | null } }
            | { type: Types.Element, top: number, left: number, text: string, backgroundColor: unknown, horizontalAlign: Types.HorizontalAlign, verticalAlign: Types.VerticalAlign, width: number, height: number, font: { family: string, size: number, color: unknown, backgroundColor: unknown, italic: boolean, bold: boolean, underline: boolean, uppercase: boolean }, border: { width: number, color: unknown }, overrides: Array<{ characterIndex: number, family: string | null, size: number | null, color: unknown, backgroundColor: unknown, italic: boolean | null, bold: boolean | null, underline: boolean | null, uppercase: boolean | null }> }
            | { type: Types.Element, top: number, left: number, backgroundColor: unknown, width: number, height: number, border: { width: number, color: unknown } }
          > }, mobileTemplate: { canvas: { width: number, height: number, backgroundColor: string, backgroundImageUrl: string | null }, elements: Array<
            | { type: Types.Element, top: number, left: number, radius: number, backgroundColor: unknown, border: { width: number, color: unknown } }
            | { type: Types.Element, top: number, left: number, backgroundColor: unknown, border: { width: number, color: unknown } }
            | { type: Types.Element, top: number, left: number, width: number, height: number }
            | { type: Types.Element, top: number, left: number, color: unknown }
            | { type: Types.Element, top: number, left: number, backgroundColor: unknown, width: number, height: number, border: { width: number, color: unknown, radius: number | null } }
            | { type: Types.Element, top: number, left: number, text: string, backgroundColor: unknown, horizontalAlign: Types.HorizontalAlign, verticalAlign: Types.VerticalAlign, width: number, height: number, font: { family: string, size: number, color: unknown, backgroundColor: unknown, italic: boolean, bold: boolean, underline: boolean, uppercase: boolean }, border: { width: number, color: unknown }, overrides: Array<{ characterIndex: number, family: string | null, size: number | null, color: unknown, backgroundColor: unknown, italic: boolean | null, bold: boolean | null, underline: boolean | null, uppercase: boolean | null }> }
            | { type: Types.Element, top: number, left: number, backgroundColor: unknown, width: number, height: number, border: { width: number, color: unknown } }
          > } | null }
      | { id: unknown, name: string, status: Types.Status, masterTemplate: string | null, zoneTemplate: string | null, css: string | null, js: string | null, cssSelector: string | null, cssSelectorPosition: Types.CssSelectorPosition, format: Types.AdFormat }
    > } };

export type LoadTemplateQueryVariables = Exact<{
  positionId: unknown;
  id: unknown;
}>;


export type LoadTemplateQuery = { adTemplate:
    | { id: unknown, name: string, status: Types.Status, width: number, height: number, format: Types.AdFormat }
    | { id: unknown, name: string, status: Types.Status, isDefault: boolean, format: Types.AdFormat, template: { canvas: { width: number, height: number, backgroundColor: string, backgroundImageUrl: string | null }, elements: Array<
          | { type: Types.Element, top: number, left: number, radius: number, backgroundColor: unknown, border: { width: number, color: unknown } }
          | { type: Types.Element, top: number, left: number, backgroundColor: unknown, border: { width: number, color: unknown } }
          | { type: Types.Element, top: number, left: number, width: number, height: number }
          | { type: Types.Element, top: number, left: number, color: unknown }
          | { type: Types.Element, top: number, left: number, backgroundColor: unknown, width: number, height: number, border: { width: number, color: unknown, radius: number | null } }
          | { type: Types.Element, top: number, left: number, text: string, backgroundColor: unknown, horizontalAlign: Types.HorizontalAlign, verticalAlign: Types.VerticalAlign, width: number, height: number, font: { family: string, size: number, color: unknown, backgroundColor: unknown, italic: boolean, bold: boolean, underline: boolean, uppercase: boolean }, border: { width: number, color: unknown }, overrides: Array<{ characterIndex: number, family: string | null, size: number | null, color: unknown, backgroundColor: unknown, italic: boolean | null, bold: boolean | null, underline: boolean | null, uppercase: boolean | null }> }
          | { type: Types.Element, top: number, left: number, backgroundColor: unknown, width: number, height: number, border: { width: number, color: unknown } }
        > }, mobileTemplate: { canvas: { width: number, height: number, backgroundColor: string, backgroundImageUrl: string | null }, elements: Array<
          | { type: Types.Element, top: number, left: number, radius: number, backgroundColor: unknown, border: { width: number, color: unknown } }
          | { type: Types.Element, top: number, left: number, backgroundColor: unknown, border: { width: number, color: unknown } }
          | { type: Types.Element, top: number, left: number, width: number, height: number }
          | { type: Types.Element, top: number, left: number, color: unknown }
          | { type: Types.Element, top: number, left: number, backgroundColor: unknown, width: number, height: number, border: { width: number, color: unknown, radius: number | null } }
          | { type: Types.Element, top: number, left: number, text: string, backgroundColor: unknown, horizontalAlign: Types.HorizontalAlign, verticalAlign: Types.VerticalAlign, width: number, height: number, font: { family: string, size: number, color: unknown, backgroundColor: unknown, italic: boolean, bold: boolean, underline: boolean, uppercase: boolean }, border: { width: number, color: unknown }, overrides: Array<{ characterIndex: number, family: string | null, size: number | null, color: unknown, backgroundColor: unknown, italic: boolean | null, bold: boolean | null, underline: boolean | null, uppercase: boolean | null }> }
          | { type: Types.Element, top: number, left: number, backgroundColor: unknown, width: number, height: number, border: { width: number, color: unknown } }
        > } | null }
    | { id: unknown, name: string, status: Types.Status, masterTemplate: string | null, zoneTemplate: string | null, css: string | null, js: string | null, cssSelector: string | null, cssSelectorPosition: Types.CssSelectorPosition, format: Types.AdFormat }
   };

export type AdTemplateNativeImageDescriptorQueryVariables = Exact<{
  positionId: unknown;
  id: unknown;
}>;


export type AdTemplateNativeImageDescriptorQuery = { adTemplate:
    | { id: unknown, template: { canvas: { width: number, height: number, backgroundColor: string, backgroundImageUrl: string | null }, elements: Array<
          | { type: Types.Element, top: number, left: number, radius: number, backgroundColor: unknown, border: { width: number, color: unknown } }
          | { type: Types.Element, top: number, left: number, backgroundColor: unknown, border: { width: number, color: unknown } }
          | { type: Types.Element, top: number, left: number, width: number, height: number }
          | { type: Types.Element, top: number, left: number, color: unknown }
          | { type: Types.Element, top: number, left: number, backgroundColor: unknown, width: number, height: number, border: { width: number, color: unknown, radius: number | null } }
          | { type: Types.Element, top: number, left: number, text: string, backgroundColor: unknown, horizontalAlign: Types.HorizontalAlign, verticalAlign: Types.VerticalAlign, width: number, height: number, font: { family: string, size: number, color: unknown, backgroundColor: unknown, italic: boolean, bold: boolean, underline: boolean, uppercase: boolean }, border: { width: number, color: unknown }, overrides: Array<{ characterIndex: number, family: string | null, size: number | null, color: unknown, backgroundColor: unknown, italic: boolean | null, bold: boolean | null, underline: boolean | null, uppercase: boolean | null }> }
          | { type: Types.Element, top: number, left: number, backgroundColor: unknown, width: number, height: number, border: { width: number, color: unknown } }
        > }, mobileTemplate: { canvas: { width: number, height: number, backgroundColor: string, backgroundImageUrl: string | null }, elements: Array<
          | { type: Types.Element, top: number, left: number, radius: number, backgroundColor: unknown, border: { width: number, color: unknown } }
          | { type: Types.Element, top: number, left: number, backgroundColor: unknown, border: { width: number, color: unknown } }
          | { type: Types.Element, top: number, left: number, width: number, height: number }
          | { type: Types.Element, top: number, left: number, color: unknown }
          | { type: Types.Element, top: number, left: number, backgroundColor: unknown, width: number, height: number, border: { width: number, color: unknown, radius: number | null } }
          | { type: Types.Element, top: number, left: number, text: string, backgroundColor: unknown, horizontalAlign: Types.HorizontalAlign, verticalAlign: Types.VerticalAlign, width: number, height: number, font: { family: string, size: number, color: unknown, backgroundColor: unknown, italic: boolean, bold: boolean, underline: boolean, uppercase: boolean }, border: { width: number, color: unknown }, overrides: Array<{ characterIndex: number, family: string | null, size: number | null, color: unknown, backgroundColor: unknown, italic: boolean | null, bold: boolean | null, underline: boolean | null, uppercase: boolean | null }> }
          | { type: Types.Element, top: number, left: number, backgroundColor: unknown, width: number, height: number, border: { width: number, color: unknown } }
        > } | null }
    | Record<PropertyKey, never>
   };

export type AdTemplateNativePreviewQueryVariables = Exact<{
  template: Types.ImageTemplateDescriptorInput;
}>;


export type AdTemplateNativePreviewQuery = { template1: string | null, template2: string | null, template3: string | null };

export type AdTemplateImageMaxSizeQueryVariables = Exact<{
  reseller: unknown;
}>;


export type AdTemplateImageMaxSizeQuery = { adTemplateImageMaxSize: { width: number, height: number } };

export type CreateAdTemplateNativeMutationVariables = Exact<{
  newAdTemplate: Types.AdTemplateNativeCreateInput;
}>;


export type CreateAdTemplateNativeMutation = { createAdTemplateNative: { id: unknown, name: string, status: Types.Status, isDefault: boolean, format: Types.AdFormat } };

export type CreateAdTemplateBannerMutationVariables = Exact<{
  newAdTemplate: Types.AdTemplateBannerCreateInput;
}>;


export type CreateAdTemplateBannerMutation = { createAdTemplateBanner: { id: unknown, name: string, status: Types.Status, width: number, height: number, format: Types.AdFormat } };

export type CreateAdTemplateWebMutationVariables = Exact<{
  newAdTemplate: Types.AdTemplateWebCreateInput;
}>;


export type CreateAdTemplateWebMutation = { createAdTemplateWeb: { id: unknown, name: string, status: Types.Status, masterTemplate: string | null, zoneTemplate: string | null, css: string | null, js: string | null, cssSelector: string | null, cssSelectorPosition: Types.CssSelectorPosition, format: Types.AdFormat } };

export type DuplicateAdTemplateMutationVariables = Exact<{
  adTemplateId: unknown;
  positionId: unknown;
  newName: string;
}>;


export type DuplicateAdTemplateMutation = { duplicateAdTemplate:
    | { id: unknown, name: string, status: Types.Status, width: number, height: number, format: Types.AdFormat }
    | { id: unknown, name: string, status: Types.Status, isDefault: boolean, format: Types.AdFormat }
    | { id: unknown, name: string, status: Types.Status, masterTemplate: string | null, zoneTemplate: string | null, css: string | null, js: string | null, cssSelector: string | null, cssSelectorPosition: Types.CssSelectorPosition, format: Types.AdFormat }
   };

export type UpdateAdTemplateNativeMutationVariables = Exact<{
  adTemplate: Types.AdTemplateNativeInput;
  mobileBackground?: unknown;
  normalBackground?: unknown;
}>;


export type UpdateAdTemplateNativeMutation = { updateAdTemplateNative: { id: unknown, name: string, status: Types.Status, isDefault: boolean, format: Types.AdFormat, template: { canvas: { width: number, height: number, backgroundColor: string, backgroundImageUrl: string | null }, elements: Array<
        | { type: Types.Element, top: number, left: number, radius: number, backgroundColor: unknown, border: { width: number, color: unknown } }
        | { type: Types.Element, top: number, left: number, backgroundColor: unknown, border: { width: number, color: unknown } }
        | { type: Types.Element, top: number, left: number, width: number, height: number }
        | { type: Types.Element, top: number, left: number, color: unknown }
        | { type: Types.Element, top: number, left: number, backgroundColor: unknown, width: number, height: number, border: { width: number, color: unknown, radius: number | null } }
        | { type: Types.Element, top: number, left: number, text: string, backgroundColor: unknown, horizontalAlign: Types.HorizontalAlign, verticalAlign: Types.VerticalAlign, width: number, height: number, font: { family: string, size: number, color: unknown, backgroundColor: unknown, italic: boolean, bold: boolean, underline: boolean, uppercase: boolean }, border: { width: number, color: unknown }, overrides: Array<{ characterIndex: number, family: string | null, size: number | null, color: unknown, backgroundColor: unknown, italic: boolean | null, bold: boolean | null, underline: boolean | null, uppercase: boolean | null }> }
        | { type: Types.Element, top: number, left: number, backgroundColor: unknown, width: number, height: number, border: { width: number, color: unknown } }
      > }, mobileTemplate: { canvas: { width: number, height: number, backgroundColor: string, backgroundImageUrl: string | null }, elements: Array<
        | { type: Types.Element, top: number, left: number, radius: number, backgroundColor: unknown, border: { width: number, color: unknown } }
        | { type: Types.Element, top: number, left: number, backgroundColor: unknown, border: { width: number, color: unknown } }
        | { type: Types.Element, top: number, left: number, width: number, height: number }
        | { type: Types.Element, top: number, left: number, color: unknown }
        | { type: Types.Element, top: number, left: number, backgroundColor: unknown, width: number, height: number, border: { width: number, color: unknown, radius: number | null } }
        | { type: Types.Element, top: number, left: number, text: string, backgroundColor: unknown, horizontalAlign: Types.HorizontalAlign, verticalAlign: Types.VerticalAlign, width: number, height: number, font: { family: string, size: number, color: unknown, backgroundColor: unknown, italic: boolean, bold: boolean, underline: boolean, uppercase: boolean }, border: { width: number, color: unknown }, overrides: Array<{ characterIndex: number, family: string | null, size: number | null, color: unknown, backgroundColor: unknown, italic: boolean | null, bold: boolean | null, underline: boolean | null, uppercase: boolean | null }> }
        | { type: Types.Element, top: number, left: number, backgroundColor: unknown, width: number, height: number, border: { width: number, color: unknown } }
      > } | null } };

export type UpdateAdTemplateBannerMutationVariables = Exact<{
  adTemplate: Types.AdTemplateBannerInput;
}>;


export type UpdateAdTemplateBannerMutation = { updateAdTemplateBanner: { id: unknown, name: string, status: Types.Status, width: number, height: number, format: Types.AdFormat } };

export type UpdateAdTemplateWebMutationVariables = Exact<{
  adTemplate: Types.AdTemplateWebInput;
}>;


export type UpdateAdTemplateWebMutation = { updateAdTemplateWeb: { id: unknown, name: string, status: Types.Status, masterTemplate: string | null, zoneTemplate: string | null, css: string | null, js: string | null, cssSelector: string | null, cssSelectorPosition: Types.CssSelectorPosition, format: Types.AdFormat } };

export type DeleteAdTemplateMutationVariables = Exact<{
  positionId: unknown;
  adTemplateId: unknown;
}>;


export type DeleteAdTemplateMutation = { deleteAdTemplate: boolean | null };

export type GetFontListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFontListQuery = { getFontList: Array<string> };

export type AdvertiserInvoicePartsFragment = { reference: unknown, date: unknown, period: unknown, status: Types.InvoiceStatus, advertiserName: string, advertiserId: unknown, agencyName: string | null, agencyId: unknown, resellerName: string, resellerId: unknown, amount: number, comment: string | null, total: number, createdAt: unknown, updatedAt: unknown, tax: { amount: number, percentage: unknown }, items: Array<
    | { description: string, total: number, createdAt: unknown, updatedAt: unknown }
    | { campaignName: string, campaignId: unknown, adGroupName: string, adGroupId: unknown, total: number, impressions: number, clicks: number, leads: number, orders: number, network: Types.Network, createdAt: unknown, updatedAt: unknown, market: { language: { code: string }, country: { code: string } } }
  >, advertiser: { slug: string } };

export type AdvertiserNameQueryVariables = Exact<{
  id: unknown;
}>;


export type AdvertiserNameQuery = { advertiser: { id: unknown, name: string } };

export type AdvertiserSettingsQueryVariables = Exact<{
  id: unknown;
}>;


export type AdvertiserSettingsQuery = { advertiser: { id: unknown, agency: { id: unknown, name: string } | null, settings: { gestion: Types.AdvertiserGestion | null, subType: Types.AdvertiserType | null, unknownTrafficRate: number | null, copperId: string | null, accountManagerId: unknown, salesManagerId: unknown } } };

export type AdvertiserTimeseriesQueryVariables = Exact<{
  endDate: unknown;
  startDate: unknown;
  advertiserId?: unknown;
  slug?: string | null | undefined;
  granularity: Types.GraphGranularity;
  filters?: Array<Types.CostDetailsFilter> | Types.CostDetailsFilter | null | undefined;
}>;


export type AdvertiserTimeseriesQuery = { advertiser: { id: unknown, timeseries: { timeseries: Array<{ date: unknown, stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number } }>, stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number } } } };

export type AdvertiserPerformanceStatsQueryVariables = Exact<{
  endDate: unknown;
  startDate: unknown;
  slug?: string | null | undefined;
  filters?: Array<Types.CostDetailsFilter> | Types.CostDetailsFilter | null | undefined;
}>;


export type AdvertiserPerformanceStatsQuery = { advertiser: { id: unknown, performanceStats: { stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number }, publisherResellers: Array<{ name: string, stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number }, publishers: Array<{ name: string, stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number }, websites: Array<{ name: string, stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number }, positions: Array<{ name: string, stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number } }> }> }> }>, campaigns: Array<{ id: unknown, name: string, status: Types.Status, stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number } }> } } };

export type AdvertiserConfigQueryVariables = Exact<{
  id: unknown;
}>;


export type AdvertiserConfigQuery = { advertiser: { id: unknown, config: { global: { network: Types.Network, formats: Array<{ height: number, width: number }> }, adGroup: { min: { cpc: number, cpl: number, cpo: number, cpm: number, dailyBudget: number, budgetCapping: number }, max: { cpc: number, cpl: number, cpo: number, cpm: number, dailyBudget: number, budgetCapping: number } }, adCopy: { min: { title: number, description: number, callToAction: number, advertiserName: number }, max: { title: number, description: number, callToAction: number, advertiserName: number } } } } };

export type SearchAdvertiserInvoicesQueryVariables = Exact<{
  pagination?: Types.Pagination | null | undefined;
  searchQuery: Types.InvoiceAdvertiserSearchQuery;
}>;


export type SearchAdvertiserInvoicesQuery = { searchAdvertiserInvoices: Array<{ reference: unknown, date: unknown, period: unknown, status: Types.InvoiceStatus, advertiserName: string, advertiserId: unknown, agencyName: string | null, agencyId: unknown, resellerName: string, resellerId: unknown, amount: number, comment: string | null, total: number, createdAt: unknown, updatedAt: unknown, tax: { amount: number, percentage: unknown }, items: Array<
      | { description: string, total: number, createdAt: unknown, updatedAt: unknown }
      | { campaignName: string, campaignId: unknown, adGroupName: string, adGroupId: unknown, total: number, impressions: number, clicks: number, leads: number, orders: number, network: Types.Network, createdAt: unknown, updatedAt: unknown, market: { language: { code: string }, country: { code: string } } }
    >, advertiser: { slug: string } }> };

export type AdvertiserInvoiceQueryVariables = Exact<{
  reference: string;
}>;


export type AdvertiserInvoiceQuery = { advertiserInvoice: { reference: unknown, date: unknown, period: unknown, status: Types.InvoiceStatus, advertiserName: string, advertiserId: unknown, agencyName: string | null, agencyId: unknown, resellerName: string, resellerId: unknown, amount: number, comment: string | null, total: number, createdAt: unknown, updatedAt: unknown, tax: { amount: number, percentage: unknown }, items: Array<
      | { description: string, total: number, createdAt: unknown, updatedAt: unknown }
      | { campaignName: string, campaignId: unknown, adGroupName: string, adGroupId: unknown, total: number, impressions: number, clicks: number, leads: number, orders: number, network: Types.Network, createdAt: unknown, updatedAt: unknown, market: { language: { code: string }, country: { code: string } } }
    >, advertiser: { slug: string } } };

export type CreateAdvertiserInvoicesMutationVariables = Exact<{
  year: number;
  month: number;
}>;


export type CreateAdvertiserInvoicesMutation = { createAdvertiserInvoices: boolean | null };

export type UpdateAdvertiserSettingsMutationVariables = Exact<{
  advertiserId: unknown;
  settings: Types.AdvertiserSettingsInput;
}>;


export type UpdateAdvertiserSettingsMutation = { updateAdvertiserSettings: { agencyId: unknown, gestion: Types.AdvertiserGestion | null, subType: Types.AdvertiserType | null, unknownTrafficRate: number | null, copperId: string | null, accountManagerId: unknown, salesManagerId: unknown } };

export type AgencyTimeseriesQueryVariables = Exact<{
  endDate: unknown;
  startDate: unknown;
  agencyId?: unknown;
  slug?: string | null | undefined;
  granularity: Types.GraphGranularity;
}>;


export type AgencyTimeseriesQuery = { agency: { id: unknown, timeseries: { timeseries: Array<{ date: unknown, stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number } }>, stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number } } } };

export type AgencyPerformanceStatsQueryVariables = Exact<{
  endDate: unknown;
  startDate: unknown;
  agencyId?: unknown;
  slug?: string | null | undefined;
}>;


export type AgencyPerformanceStatsQuery = { agency: { id: unknown, performanceStats: { stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number }, publisherResellers: Array<{ name: string, stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number }, publishers: Array<{ name: string, stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number } }> }>, advertisers: Array<{ name: string, stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number } }> } } };

export type AgencyNameQueryVariables = Exact<{
  agencyId: unknown;
}>;


export type AgencyNameQuery = { agency: { id: unknown, name: string } };

export type AgencySettingsQueryVariables = Exact<{
  id: unknown;
}>;


export type AgencySettingsQuery = { agency: { id: unknown, settings: { copperId: string | null, accountManagerId: unknown, salesManagerId: unknown } } };

export type UpdateAgencySettingsMutationVariables = Exact<{
  agencyId: unknown;
  settings: Types.AgencySettingsInput;
}>;


export type UpdateAgencySettingsMutation = { updateAgencySettings: { copperId: string | null, accountManagerId: unknown, salesManagerId: unknown } };

export type AssistantRuleSystemFieldsFragment = { id: unknown, key: string, name: string, description: string | null, entity: Types.AssistantRuleEntity, isActive: boolean, executionOrder: unknown, importance: Types.AssistantRuleImportance, config: unknown };

export type AssistantRuleUserFieldsFragment = { id: unknown, name: string, description: string | null, entity: Types.AssistantRuleEntity, isActive: boolean, executionOrder: unknown, importance: Types.AssistantRuleImportance, createdAt: unknown, updatedAt: unknown, conditions: { all: Array<{ scope: string, field: string, operator: Types.AssistantRuleConditionOperator, value: unknown, params: unknown, compareField: { scope: string, field: string, params: unknown } | null }> | null, any: Array<{ scope: string, field: string, operator: Types.AssistantRuleConditionOperator, value: unknown, params: unknown, compareField: { scope: string, field: string, params: unknown } | null }> | null } | null, recommendedChanges: { message: string | null, all: Array<{ scope: string | null, field: string | null, action: Types.AssistantRuleRecommendationAction | null, value: unknown, message: string | null }> | null, any: Array<{ scope: string | null, field: string | null, action: Types.AssistantRuleRecommendationAction | null, value: unknown, message: string | null }> | null } | null };

export type AdGroupAssistantQueryVariables = Exact<{
  adGroupId: unknown;
}>;


export type AdGroupAssistantQuery = { adGroup: { campaign: { advertiser: { slug: string } }, assistant: { recommendations: Array<{ message: string, isHidden: boolean, ruleId: unknown, recommendedChanges: unknown, rule:
          | { id: unknown, key: string, name: string, description: string | null, entity: Types.AssistantRuleEntity, isActive: boolean, executionOrder: unknown, importance: Types.AssistantRuleImportance, config: unknown }
          | { id: unknown, name: string, description: string | null, entity: Types.AssistantRuleEntity, isActive: boolean, executionOrder: unknown, importance: Types.AssistantRuleImportance, createdAt: unknown, updatedAt: unknown, conditions: { all: Array<{ scope: string, field: string, operator: Types.AssistantRuleConditionOperator, value: unknown, params: unknown, compareField: { scope: string, field: string, params: unknown } | null }> | null, any: Array<{ scope: string, field: string, operator: Types.AssistantRuleConditionOperator, value: unknown, params: unknown, compareField: { scope: string, field: string, params: unknown } | null }> | null } | null, recommendedChanges: { message: string | null, all: Array<{ scope: string | null, field: string | null, action: Types.AssistantRuleRecommendationAction | null, value: unknown, message: string | null }> | null, any: Array<{ scope: string | null, field: string | null, action: Types.AssistantRuleRecommendationAction | null, value: unknown, message: string | null }> | null } | null }
         | null }>, adCopies: Array<{ message: string, adCopy: { id: unknown, name: string, advertiserName: unknown, title: unknown, description: unknown, callToAction: unknown, image: string, status: Types.AdCopyStatus, statusUpdatedAt: unknown }, stats: { impressions: number, clicks: number, leads: number, orders: number, costs: number, ctr: number, lr: number, cpl: number, or: number, cpo: number, roi: number, startedAt: unknown, abTestImpressions: number, abTestClicks: number, abTestLeads: number, abTestOrders: number, abTestCosts: number, abTestCtr: number, abTestLr: number, abTestCpl: number, abTestOr: number, abTestCpo: number, abTestRoi: number, abTestStartDate: unknown } | null }> } } };

export type AskAdgroupSuggestionsQueryVariables = Exact<{
  adGroupId: unknown;
  languageOutput: string;
  userInstructions: string;
}>;


export type AskAdgroupSuggestionsQuery = { askAdgroupSuggestions: { keywords: Array<string>, description: Array<string>, titles: Array<string>, actions: Array<string> } };

export type AdGroupMarketLanguageQueryVariables = Exact<{
  id: unknown;
}>;


export type AdGroupMarketLanguageQuery = { adGroup: { id: unknown, campaign: { market: { language: { code: string } } } } };

export type AssistantRulesQueryVariables = Exact<{
  resellerId: unknown;
}>;


export type AssistantRulesQuery = { assistantRules: Array<
    | { id: unknown, key: string, name: string, description: string | null, entity: Types.AssistantRuleEntity, isActive: boolean, executionOrder: unknown, importance: Types.AssistantRuleImportance, config: unknown }
    | { id: unknown, name: string, description: string | null, entity: Types.AssistantRuleEntity, isActive: boolean, executionOrder: unknown, importance: Types.AssistantRuleImportance, createdAt: unknown, updatedAt: unknown, conditions: { all: Array<{ scope: string, field: string, operator: Types.AssistantRuleConditionOperator, value: unknown, params: unknown, compareField: { scope: string, field: string, params: unknown } | null }> | null, any: Array<{ scope: string, field: string, operator: Types.AssistantRuleConditionOperator, value: unknown, params: unknown, compareField: { scope: string, field: string, params: unknown } | null }> | null } | null, recommendedChanges: { message: string | null, all: Array<{ scope: string | null, field: string | null, action: Types.AssistantRuleRecommendationAction | null, value: unknown, message: string | null }> | null, any: Array<{ scope: string | null, field: string | null, action: Types.AssistantRuleRecommendationAction | null, value: unknown, message: string | null }> | null } | null }
  > };

export type AssistantRuleConditionPropertiesQueryVariables = Exact<{ [key: string]: never; }>;


export type AssistantRuleConditionPropertiesQuery = { assistantRuleConditionProperties: Array<{ scope: string, field: string, valueType: Types.AssistantRuleConditionValueType, allowedOperators: Array<Types.AssistantRuleConditionOperator>, possibleValues: Array<string> | null, unit: Types.AssistantAdgroupFieldUnit | null, paramsJsonSchema: unknown }> };

export type UpdateAssistantRuleMutationVariables = Exact<{
  input: Types.UpdateAssistantRuleInput;
}>;


export type UpdateAssistantRuleMutation = { updateAssistantRule:
    | { id: unknown, key: string, name: string, description: string | null, entity: Types.AssistantRuleEntity, isActive: boolean, executionOrder: unknown, importance: Types.AssistantRuleImportance, config: unknown }
    | { id: unknown, name: string, description: string | null, entity: Types.AssistantRuleEntity, isActive: boolean, executionOrder: unknown, importance: Types.AssistantRuleImportance, createdAt: unknown, updatedAt: unknown, conditions: { all: Array<{ scope: string, field: string, operator: Types.AssistantRuleConditionOperator, value: unknown, params: unknown, compareField: { scope: string, field: string, params: unknown } | null }> | null, any: Array<{ scope: string, field: string, operator: Types.AssistantRuleConditionOperator, value: unknown, params: unknown, compareField: { scope: string, field: string, params: unknown } | null }> | null } | null, recommendedChanges: { message: string | null, all: Array<{ scope: string | null, field: string | null, action: Types.AssistantRuleRecommendationAction | null, value: unknown, message: string | null }> | null, any: Array<{ scope: string | null, field: string | null, action: Types.AssistantRuleRecommendationAction | null, value: unknown, message: string | null }> | null } | null }
   };

export type CreateAssistantUserRuleMutationVariables = Exact<{
  input: Types.CreateAssistantUserRuleInput;
}>;


export type CreateAssistantUserRuleMutation = { createAssistantUserRule: { id: unknown, name: string, description: string | null, entity: Types.AssistantRuleEntity, isActive: boolean, executionOrder: unknown, importance: Types.AssistantRuleImportance, createdAt: unknown, updatedAt: unknown, conditions: { all: Array<{ scope: string, field: string, operator: Types.AssistantRuleConditionOperator, value: unknown, params: unknown, compareField: { scope: string, field: string, params: unknown } | null }> | null, any: Array<{ scope: string, field: string, operator: Types.AssistantRuleConditionOperator, value: unknown, params: unknown, compareField: { scope: string, field: string, params: unknown } | null }> | null } | null, recommendedChanges: { message: string | null, all: Array<{ scope: string | null, field: string | null, action: Types.AssistantRuleRecommendationAction | null, value: unknown, message: string | null }> | null, any: Array<{ scope: string | null, field: string | null, action: Types.AssistantRuleRecommendationAction | null, value: unknown, message: string | null }> | null } | null } };

export type DeleteAssistantUserRuleMutationVariables = Exact<{
  ruleId: unknown;
}>;


export type DeleteAssistantUserRuleMutation = { deleteAssistantUserRule: boolean };

export type DisableAssistantRuleMutationVariables = Exact<{
  adGroupId: unknown;
  ruleId: unknown;
}>;


export type DisableAssistantRuleMutation = { disableAssistantRule: boolean };

export type EnableAssistantRuleMutationVariables = Exact<{
  adGroupId: unknown;
  ruleId: unknown;
}>;


export type EnableAssistantRuleMutation = { enableAssistantRule: boolean };

export type BannerSizesQueryVariables = Exact<{
  resellerId: unknown;
}>;


export type BannerSizesQuery = { bannerSizes: Array<{ width: number, height: number }> };

export type SegmentBehaviouralPartsFragment = { id: unknown, name: string, errorReason: string | null, nbProfiles: number | null, existingProfiles: number | null, reach: number | null, archived: boolean, status: Types.SegmentStatus, updatedAt: unknown, createdAt: unknown, duration: number | null, rules: Array<{ type: Types.RuleType, urls: Array<string> }> };

export type SegmentCrmPartsFragment = { id: unknown, name: string, errorReason: string | null, nbProfiles: number | null, existingProfiles: number | null, reach: number | null, archived: boolean, status: Types.SegmentStatus, originalFilename: string, updatedAt: unknown, createdAt: unknown };

export type CampaignPartsFragment = { id: unknown, leadEvent: string, orderEvent: string, name: string, iabCategory: Types.Iab, shortCode: string, status: Types.Status, advertiserDomainName: string | null, conversionClickAge: Types.ClickAge, segments: Array<
    | { id: unknown, name: string, errorReason: string | null, nbProfiles: number | null, existingProfiles: number | null, reach: number | null, archived: boolean, status: Types.SegmentStatus, updatedAt: unknown, createdAt: unknown, duration: number | null, rules: Array<{ type: Types.RuleType, urls: Array<string> }> }
    | { id: unknown, name: string, errorReason: string | null, nbProfiles: number | null, existingProfiles: number | null, reach: number | null, archived: boolean, status: Types.SegmentStatus, originalFilename: string, updatedAt: unknown, createdAt: unknown }
  >, market: { id: unknown, country: { code: string, label: string } } };

export type CampaignNameQueryVariables = Exact<{
  id: unknown;
}>;


export type CampaignNameQuery = { campaign: { id: unknown, name: string } };

export type CampaignQueryVariables = Exact<{
  campaignId: unknown;
}>;


export type CampaignQuery = { campaign: { id: unknown, leadEvent: string, orderEvent: string, name: string, iabCategory: Types.Iab, shortCode: string, status: Types.Status, advertiserDomainName: string | null, conversionClickAge: Types.ClickAge, recommendedIabCategory: { iabCategory: Types.Iab, adGroupIabCategories: Array<{ iabCategory: Types.Iab, adGroup: { id: unknown, name: string }, iabTiers: { iabId: string, type: Types.IabTaxonomyType, tier1Name: string | null, tier2Name: string | null, tier3Name: string | null } }> } | null, adGroups: Array<{ id: unknown, name: string, status: Types.AdGroupStatus, endDate: unknown, budgetCapping: number | null, budgetCappingType: Types.BudgetCapping, budget: { budgetMeasures: { monthBudget: number | null, monthSpent: number, periodBudget: number | null, periodSpent: number, overallBudget: number | null, overallSpent: number } } | null }>, segments: Array<
      | { id: unknown, name: string, errorReason: string | null, nbProfiles: number | null, existingProfiles: number | null, reach: number | null, archived: boolean, status: Types.SegmentStatus, updatedAt: unknown, createdAt: unknown, duration: number | null, rules: Array<{ type: Types.RuleType, urls: Array<string> }> }
      | { id: unknown, name: string, errorReason: string | null, nbProfiles: number | null, existingProfiles: number | null, reach: number | null, archived: boolean, status: Types.SegmentStatus, originalFilename: string, updatedAt: unknown, createdAt: unknown }
    >, market: { id: unknown, country: { code: string, label: string } } } };

export type AdvertiserCampaignsQueryVariables = Exact<{
  advertiserId: unknown;
  status?: Array<Types.Status> | Types.Status | null | undefined;
}>;


export type AdvertiserCampaignsQuery = { advertiserCampaigns: Array<{ id: unknown, name: string, status: Types.Status, adGroups: Array<{ id: unknown, name: string, status: Types.AdGroupStatus, dailyBudget: number | null }> }> };

export type ResellerCampaignsQueryVariables = Exact<{
  resellerId: unknown;
}>;


export type ResellerCampaignsQuery = { searchCampaigns: Array<{ id: unknown, name: string }> };

export type SearchCampaignsQueryVariables = Exact<{
  pagination: Types.Pagination;
  searchQuery: Types.CampaignSearchQuery;
}>;


export type SearchCampaignsQuery = { searchCampaigns: Array<{ id: unknown, name: string, advertiserDomainName: string | null, iabCategory: Types.Iab, status: Types.Status, market: { language: { code: string }, country: { code: string } }, advertiser: { slug: string, genericName: string, reseller: { genericName: string } }, adGroups: Array<{ name: string }> }> };

export type CampaignTimeseriesQueryVariables = Exact<{
  endDate: unknown;
  startDate: unknown;
  campaignId: unknown;
  granularity: Types.GraphGranularity;
  filters?: Array<Types.CostDetailsFilter> | Types.CostDetailsFilter | null | undefined;
}>;


export type CampaignTimeseriesQuery = { campaign: { id: unknown, timeseries: { timeseries: Array<{ date: unknown, stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number } }>, stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number } } } };

export type CampaignPerformanceStatsQueryVariables = Exact<{
  endDate: unknown;
  startDate: unknown;
  campaignId: unknown;
  filters?: Array<Types.CostDetailsFilter> | Types.CostDetailsFilter | null | undefined;
}>;


export type CampaignPerformanceStatsQuery = { campaign: { id: unknown, performanceStats: { stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number }, publisherResellers: Array<{ name: string, stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number }, publishers: Array<{ name: string, stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number }, websites: Array<{ name: string, stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number }, positions: Array<{ name: string, stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number } }> }> }> }>, adGroups: Array<{ id: unknown, name: string, status: Types.AdGroupStatus, dailyBudget: number | null, stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number } }> } } };

export type UpdateCampaignMutationVariables = Exact<{
  campaign: Types.CampaignInput;
}>;


export type UpdateCampaignMutation = { updateCampaign: { id: unknown, leadEvent: string, orderEvent: string, name: string, iabCategory: Types.Iab, shortCode: string, status: Types.Status, advertiserDomainName: string | null, conversionClickAge: Types.ClickAge, segments: Array<
      | { id: unknown, name: string, errorReason: string | null, nbProfiles: number | null, existingProfiles: number | null, reach: number | null, archived: boolean, status: Types.SegmentStatus, updatedAt: unknown, createdAt: unknown, duration: number | null, rules: Array<{ type: Types.RuleType, urls: Array<string> }> }
      | { id: unknown, name: string, errorReason: string | null, nbProfiles: number | null, existingProfiles: number | null, reach: number | null, archived: boolean, status: Types.SegmentStatus, originalFilename: string, updatedAt: unknown, createdAt: unknown }
    >, market: { id: unknown, country: { code: string, label: string } } } };

export type ArchiveCampaignMutationVariables = Exact<{
  campaignId: unknown;
}>;


export type ArchiveCampaignMutation = { archiveCampaign: boolean };

export type CampaignHasAdGroupsQueryVariables = Exact<{
  campaignId: unknown;
  pagination: Types.Pagination;
}>;


export type CampaignHasAdGroupsQuery = { campaign: { id: unknown, adGroups: Array<{ id: unknown }> } };

export type CreateCampaignMutationVariables = Exact<{
  campaign: Types.CampaignCreateInput;
}>;


export type CreateCampaignMutation = { createCampaign: { id: unknown, leadEvent: string, orderEvent: string, name: string, iabCategory: Types.Iab, shortCode: string, status: Types.Status, advertiserDomainName: string | null, conversionClickAge: Types.ClickAge, segments: Array<
      | { id: unknown, name: string, errorReason: string | null, nbProfiles: number | null, existingProfiles: number | null, reach: number | null, archived: boolean, status: Types.SegmentStatus, updatedAt: unknown, createdAt: unknown, duration: number | null, rules: Array<{ type: Types.RuleType, urls: Array<string> }> }
      | { id: unknown, name: string, errorReason: string | null, nbProfiles: number | null, existingProfiles: number | null, reach: number | null, archived: boolean, status: Types.SegmentStatus, originalFilename: string, updatedAt: unknown, createdAt: unknown }
    >, market: { id: unknown, country: { code: string, label: string } } } };

export type DeleteSegmentCrmMutationVariables = Exact<{
  id: unknown;
}>;


export type DeleteSegmentCrmMutation = { deleteSegmentCrm: boolean | null };

export type CreateSegmentCrmMutationVariables = Exact<{
  campaignId: unknown;
  name: string;
  file: unknown;
}>;


export type CreateSegmentCrmMutation = { createSegmentCrm: { id: unknown, name: string, errorReason: string | null, nbProfiles: number | null, existingProfiles: number | null, reach: number | null, archived: boolean, status: Types.SegmentStatus, originalFilename: string, updatedAt: unknown, createdAt: unknown } };

export type UpdateSegmentCrmMutationVariables = Exact<{
  segment: Types.SegmentCrmInput;
}>;


export type UpdateSegmentCrmMutation = { updateSegmentCrm: { id: unknown, name: string, errorReason: string | null, nbProfiles: number | null, existingProfiles: number | null, reach: number | null, archived: boolean, status: Types.SegmentStatus, originalFilename: string, updatedAt: unknown, createdAt: unknown } };

export type DeleteSegmentBehaviouralMutationVariables = Exact<{
  id: unknown;
}>;


export type DeleteSegmentBehaviouralMutation = { deleteSegmentBehavioural: boolean | null };

export type CreateSegmentBehaviouralMutationVariables = Exact<{
  campaignId: unknown;
  name: string;
  rules: Array<Types.SegmentBehaviouralRuleInput> | Types.SegmentBehaviouralRuleInput;
}>;


export type CreateSegmentBehaviouralMutation = { createSegmentBehavioural: { id: unknown, name: string, errorReason: string | null, nbProfiles: number | null, existingProfiles: number | null, reach: number | null, archived: boolean, status: Types.SegmentStatus, updatedAt: unknown, createdAt: unknown, duration: number | null, rules: Array<{ type: Types.RuleType, urls: Array<string> }> } };

export type UpdateSegmentBehaviouralMutationVariables = Exact<{
  rules: Array<Types.SegmentBehaviouralRuleInput> | Types.SegmentBehaviouralRuleInput;
  segment: Types.SegmentBehaviouralInput;
}>;


export type UpdateSegmentBehaviouralMutation = { updateSegmentBehavioural: { id: unknown, name: string, errorReason: string | null, nbProfiles: number | null, existingProfiles: number | null, reach: number | null, archived: boolean, status: Types.SegmentStatus, updatedAt: unknown, createdAt: unknown, duration: number | null, rules: Array<{ type: Types.RuleType, urls: Array<string> }> } };

export type PriorityListQueryVariables = Exact<{
  campaignId: unknown;
}>;


export type PriorityListQuery = { campaign: { advertiser: { reseller: { priorities: Array<{ id: unknown, name: string, value: number, isDefault: boolean }> } } } };

export type CreateTermsAndConditionMutationVariables = Exact<{
  newTermsAndCondition: Types.TermsAndConditionApprovalCreateInput;
}>;


export type CreateTermsAndConditionMutation = { createTermsAndCondition: { version: string } | null };

export type CompanyPartsFragment = { id: unknown, resellerId: unknown, agencyId: unknown, accountManagerId: unknown, salesManagerId: unknown, slug: string, type: Types.CompanyType, name: string, genericName: string, addressLine1: string | null, zipCode: string | null, city: string | null, phone: string | null, fax: string | null, website: string | null, vatId: string | null, accountingId: string | null, bankName: string | null, iban: string | null, swift: string | null, taxId: string | null, registrationId: string | null, paymentTerm: Types.PaymentTerm | null, contactEmail: string | null, currency: Types.Currency | null, invoiceLanguage: Types.InvoiceLanguage | null, invoicingCompany: Types.InvoicingCompany | null, status: Types.Status, rootDomain: string | null, kpis: string | null, country: { code: string, label: string }, userPermissions: { companyType: Types.CompanyType, read: boolean, edit: boolean, admin: boolean, superAdmin: boolean, api: boolean, adgroupCpm: boolean, adgroupCpl: boolean, adgroupExclusions: boolean, adgroupCustomcpcs: boolean, adgroupReportwebsites: boolean, adgroupUsertargeting: boolean, adgroupGeotargeting: boolean, adgroupDevicetargeting: boolean, adgroupTimetargeting: boolean, adgroupSegments: boolean, adgroupAutoSegments: boolean, adgroupPriority: boolean, adgroupBudgetCapping: boolean, adgroupMonthlyBudgetCapping: boolean, adgroupOverallBudgetCapping: boolean, adgroupOpenBudgetCapping: boolean, adgroupOpenDailyBudget: boolean, adgroupDatesRequired: boolean, adCopyValidation: boolean, adCopyDates: boolean, assistant: boolean, aiAssistant: boolean, costHistory: boolean, costRecommendation: boolean, advertiserDirectoryPresets: boolean, publisherBlacklistPresets: boolean, positionAdvancedsettings: boolean, websiteExclusions: boolean, web: boolean, banner: boolean } };

export type CompanyPermissionsFragment = { id: unknown, permissions: { api: boolean, adgroupCpm: boolean, adgroupCpl: boolean, adgroupExclusions: boolean, adgroupCustomcpcs: boolean, adgroupReportwebsites: boolean, adgroupUsertargeting: boolean, adgroupGeotargeting: boolean, adgroupDevicetargeting: boolean, adgroupTimetargeting: boolean, adgroupSegments: boolean, adgroupAutoSegments: boolean, adgroupPriority: boolean, adgroupBudgetCapping: boolean, adgroupMonthlyBudgetCapping: boolean, adgroupOverallBudgetCapping: boolean, adgroupOpenBudgetCapping: boolean, adgroupOpenDailyBudget: boolean, adgroupDatesRequired: boolean, adCopyDates: boolean, positionAdvancedsettings: boolean, websiteExclusions: boolean, banner: boolean, web: boolean, editable: boolean } };

export type GetCompanyQueryVariables = Exact<{
  slug?: string | null | undefined;
  id?: unknown;
}>;


export type GetCompanyQuery = { company: { id: unknown, resellerId: unknown, agencyId: unknown, accountManagerId: unknown, salesManagerId: unknown, slug: string, type: Types.CompanyType, name: string, genericName: string, addressLine1: string | null, zipCode: string | null, city: string | null, phone: string | null, fax: string | null, website: string | null, vatId: string | null, accountingId: string | null, bankName: string | null, iban: string | null, swift: string | null, taxId: string | null, registrationId: string | null, paymentTerm: Types.PaymentTerm | null, contactEmail: string | null, currency: Types.Currency | null, invoiceLanguage: Types.InvoiceLanguage | null, invoicingCompany: Types.InvoicingCompany | null, status: Types.Status, rootDomain: string | null, kpis: string | null, country: { code: string, label: string }, userPermissions: { companyType: Types.CompanyType, read: boolean, edit: boolean, admin: boolean, superAdmin: boolean, api: boolean, adgroupCpm: boolean, adgroupCpl: boolean, adgroupExclusions: boolean, adgroupCustomcpcs: boolean, adgroupReportwebsites: boolean, adgroupUsertargeting: boolean, adgroupGeotargeting: boolean, adgroupDevicetargeting: boolean, adgroupTimetargeting: boolean, adgroupSegments: boolean, adgroupAutoSegments: boolean, adgroupPriority: boolean, adgroupBudgetCapping: boolean, adgroupMonthlyBudgetCapping: boolean, adgroupOverallBudgetCapping: boolean, adgroupOpenBudgetCapping: boolean, adgroupOpenDailyBudget: boolean, adgroupDatesRequired: boolean, adCopyValidation: boolean, adCopyDates: boolean, assistant: boolean, aiAssistant: boolean, costHistory: boolean, costRecommendation: boolean, advertiserDirectoryPresets: boolean, publisherBlacklistPresets: boolean, positionAdvancedsettings: boolean, websiteExclusions: boolean, web: boolean, banner: boolean } } };

export type CompanyExistsQueryVariables = Exact<{
  name: string;
  resellerId: unknown;
  agencyId?: unknown;
}>;


export type CompanyExistsQuery = { companyExists: boolean };

export type CompaniesForAutoCompleteQueryVariables = Exact<{
  pagination: Types.Pagination;
  searchQuery: Types.CompanySearchQuery;
}>;


export type CompaniesForAutoCompleteQuery = { searchCompanies: Array<{ id: unknown, name: string }> };

export type GetCompanyDetailsQueryVariables = Exact<{
  slug?: string | null | undefined;
  id?: unknown;
}>;


export type GetCompanyDetailsQuery = { company: { id: unknown, resellerId: unknown, agencyId: unknown, accountManagerId: unknown, salesManagerId: unknown, slug: string, type: Types.CompanyType, name: string, genericName: string, addressLine1: string | null, zipCode: string | null, city: string | null, phone: string | null, fax: string | null, website: string | null, vatId: string | null, accountingId: string | null, bankName: string | null, iban: string | null, swift: string | null, taxId: string | null, registrationId: string | null, paymentTerm: Types.PaymentTerm | null, contactEmail: string | null, currency: Types.Currency | null, invoiceLanguage: Types.InvoiceLanguage | null, invoicingCompany: Types.InvoicingCompany | null, status: Types.Status, rootDomain: string | null, kpis: string | null, country: { label: string, code: string }, reseller: { name: string, id: unknown, slug: string }, agency: { name: string, id: unknown, slug: string } | null, approvedTerms: { acceptedAt: unknown, version: string, user: { firstName: string, lastName: string } } | null, userPermissions: { companyType: Types.CompanyType, read: boolean, edit: boolean, admin: boolean, superAdmin: boolean, api: boolean, adgroupCpm: boolean, adgroupCpl: boolean, adgroupExclusions: boolean, adgroupCustomcpcs: boolean, adgroupReportwebsites: boolean, adgroupUsertargeting: boolean, adgroupGeotargeting: boolean, adgroupDevicetargeting: boolean, adgroupTimetargeting: boolean, adgroupSegments: boolean, adgroupAutoSegments: boolean, adgroupPriority: boolean, adgroupBudgetCapping: boolean, adgroupMonthlyBudgetCapping: boolean, adgroupOverallBudgetCapping: boolean, adgroupOpenBudgetCapping: boolean, adgroupOpenDailyBudget: boolean, adgroupDatesRequired: boolean, adCopyValidation: boolean, adCopyDates: boolean, assistant: boolean, aiAssistant: boolean, costHistory: boolean, costRecommendation: boolean, advertiserDirectoryPresets: boolean, publisherBlacklistPresets: boolean, positionAdvancedsettings: boolean, websiteExclusions: boolean, web: boolean, banner: boolean } }, getCountries: Array<{ code: string, label: string }>, getLanguages: Array<{ id: unknown, code: string, label: string }> };

export type BillingContactQueryVariables = Exact<{
  slug?: string | null | undefined;
  id?: unknown;
}>;


export type BillingContactQuery = { company: { id: unknown, billingContacts: Array<{ id: unknown, firstName: string, lastName: string, email: unknown, phone: string | null }> } };

export type CompanyInvoiceInfoQueryVariables = Exact<{
  slug?: string | null | undefined;
  id?: unknown;
}>;


export type CompanyInvoiceInfoQuery = { company: { id: unknown, name: string, addressLine1: string | null, zipCode: string | null, city: string | null, vatId: string | null, paymentTerm: Types.PaymentTerm | null, country: { label: string } } };

export type CompanyPermissionsQueryVariables = Exact<{
  slug?: string | null | undefined;
  id?: unknown;
}>;


export type CompanyPermissionsQuery = { company: { type: Types.CompanyType, agencyId: unknown, resellerId: unknown, id: unknown, permissions: { api: boolean, adgroupCpm: boolean, adgroupCpl: boolean, adgroupExclusions: boolean, adgroupCustomcpcs: boolean, adgroupReportwebsites: boolean, adgroupUsertargeting: boolean, adgroupGeotargeting: boolean, adgroupDevicetargeting: boolean, adgroupTimetargeting: boolean, adgroupSegments: boolean, adgroupAutoSegments: boolean, adgroupPriority: boolean, adgroupBudgetCapping: boolean, adgroupMonthlyBudgetCapping: boolean, adgroupOverallBudgetCapping: boolean, adgroupOpenBudgetCapping: boolean, adgroupOpenDailyBudget: boolean, adgroupDatesRequired: boolean, adCopyDates: boolean, positionAdvancedsettings: boolean, websiteExclusions: boolean, banner: boolean, web: boolean, editable: boolean } } };

export type CompaniesQueryVariables = Exact<{
  pagination: Types.Pagination;
  searchQuery: Types.CompanySearchQuery;
}>;


export type CompaniesQuery = { searchCompanies: Array<{ id: unknown, slug: string, name: string, genericName: string, type: Types.CompanyType, status: Types.Status, agency: { id: unknown, name: string } | null, reseller: { id: unknown, name: string } }> };

export type CreateCompanyMutationVariables = Exact<{
  newCompany: Types.CompanyCreateInput;
}>;


export type CreateCompanyMutation = { createCompany: { id: unknown, resellerId: unknown, agencyId: unknown, accountManagerId: unknown, salesManagerId: unknown, slug: string, type: Types.CompanyType, name: string, genericName: string, addressLine1: string | null, zipCode: string | null, city: string | null, phone: string | null, fax: string | null, website: string | null, vatId: string | null, accountingId: string | null, bankName: string | null, iban: string | null, swift: string | null, taxId: string | null, registrationId: string | null, paymentTerm: Types.PaymentTerm | null, contactEmail: string | null, currency: Types.Currency | null, invoiceLanguage: Types.InvoiceLanguage | null, invoicingCompany: Types.InvoicingCompany | null, status: Types.Status, rootDomain: string | null, kpis: string | null, country: { code: string, label: string }, userPermissions: { companyType: Types.CompanyType, read: boolean, edit: boolean, admin: boolean, superAdmin: boolean, api: boolean, adgroupCpm: boolean, adgroupCpl: boolean, adgroupExclusions: boolean, adgroupCustomcpcs: boolean, adgroupReportwebsites: boolean, adgroupUsertargeting: boolean, adgroupGeotargeting: boolean, adgroupDevicetargeting: boolean, adgroupTimetargeting: boolean, adgroupSegments: boolean, adgroupAutoSegments: boolean, adgroupPriority: boolean, adgroupBudgetCapping: boolean, adgroupMonthlyBudgetCapping: boolean, adgroupOverallBudgetCapping: boolean, adgroupOpenBudgetCapping: boolean, adgroupOpenDailyBudget: boolean, adgroupDatesRequired: boolean, adCopyValidation: boolean, adCopyDates: boolean, assistant: boolean, aiAssistant: boolean, costHistory: boolean, costRecommendation: boolean, advertiserDirectoryPresets: boolean, publisherBlacklistPresets: boolean, positionAdvancedsettings: boolean, websiteExclusions: boolean, web: boolean, banner: boolean } } | null };

export type UpdateCompanyMutationVariables = Exact<{
  company: Types.CompanyInput;
}>;


export type UpdateCompanyMutation = { updateCompany: { id: unknown, resellerId: unknown, agencyId: unknown, accountManagerId: unknown, salesManagerId: unknown, slug: string, type: Types.CompanyType, name: string, genericName: string, addressLine1: string | null, zipCode: string | null, city: string | null, phone: string | null, fax: string | null, website: string | null, vatId: string | null, accountingId: string | null, bankName: string | null, iban: string | null, swift: string | null, taxId: string | null, registrationId: string | null, paymentTerm: Types.PaymentTerm | null, contactEmail: string | null, currency: Types.Currency | null, invoiceLanguage: Types.InvoiceLanguage | null, invoicingCompany: Types.InvoicingCompany | null, status: Types.Status, rootDomain: string | null, kpis: string | null, country: { code: string, label: string }, userPermissions: { companyType: Types.CompanyType, read: boolean, edit: boolean, admin: boolean, superAdmin: boolean, api: boolean, adgroupCpm: boolean, adgroupCpl: boolean, adgroupExclusions: boolean, adgroupCustomcpcs: boolean, adgroupReportwebsites: boolean, adgroupUsertargeting: boolean, adgroupGeotargeting: boolean, adgroupDevicetargeting: boolean, adgroupTimetargeting: boolean, adgroupSegments: boolean, adgroupAutoSegments: boolean, adgroupPriority: boolean, adgroupBudgetCapping: boolean, adgroupMonthlyBudgetCapping: boolean, adgroupOverallBudgetCapping: boolean, adgroupOpenBudgetCapping: boolean, adgroupOpenDailyBudget: boolean, adgroupDatesRequired: boolean, adCopyValidation: boolean, adCopyDates: boolean, assistant: boolean, aiAssistant: boolean, costHistory: boolean, costRecommendation: boolean, advertiserDirectoryPresets: boolean, publisherBlacklistPresets: boolean, positionAdvancedsettings: boolean, websiteExclusions: boolean, web: boolean, banner: boolean } } };

export type CompanyUsersQueryVariables = Exact<{
  pagination?: Types.Pagination | null | undefined;
  searchQuery: Types.UserSearchQuery;
}>;


export type CompanyUsersQuery = { users: Array<{ id: unknown, firstName: string, lastName: string, email: unknown, accessType: Types.AccessType, status: Types.UserStatus, isPrimaryContact: boolean | null }> };

export type AgencyCompaniesQueryVariables = Exact<{
  resellerIds: Array<string> | string;
}>;


export type AgencyCompaniesQuery = { searchCompanies: Array<{ id: unknown, name: string, genericName: string }> };

export type ResellerCompaniesQueryVariables = Exact<{ [key: string]: never; }>;


export type ResellerCompaniesQuery = { searchCompanies: Array<{ id: unknown, name: string, status: Types.Status }> };

export type ActivePublisherNamesQueryVariables = Exact<{ [key: string]: never; }>;


export type ActivePublisherNamesQuery = { searchCompanies: Array<{ id: unknown, genericName: string }> };

export type ActiveCompaniesNamesQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveCompaniesNamesQuery = { searchCompanies: Array<{ id: unknown, genericName: string }> };

export type CreateBillingContactMutationVariables = Exact<{
  newBillingContact: Types.BillingContactCreateInput;
}>;


export type CreateBillingContactMutation = { createBillingContact: { id: unknown, firstName: string, lastName: string, email: unknown, phone: string | null } | null };

export type DeleteBillingContactMutationVariables = Exact<{
  id: unknown;
}>;


export type DeleteBillingContactMutation = { deleteBillingContact: boolean | null };

export type UpdateCompanyPermissionsMutationVariables = Exact<{
  permissions: Types.CompanyPermissionInput;
  companyId: unknown;
}>;


export type UpdateCompanyPermissionsMutation = { updateCompanyPermissions: { id: unknown, permissions: { api: boolean, adgroupCpm: boolean, adgroupCpl: boolean, adgroupExclusions: boolean, adgroupCustomcpcs: boolean, adgroupReportwebsites: boolean, adgroupUsertargeting: boolean, adgroupGeotargeting: boolean, adgroupDevicetargeting: boolean, adgroupTimetargeting: boolean, adgroupSegments: boolean, adgroupAutoSegments: boolean, adgroupPriority: boolean, adgroupBudgetCapping: boolean, adgroupMonthlyBudgetCapping: boolean, adgroupOverallBudgetCapping: boolean, adgroupOpenBudgetCapping: boolean, adgroupOpenDailyBudget: boolean, adgroupDatesRequired: boolean, adCopyDates: boolean, positionAdvancedsettings: boolean, websiteExclusions: boolean, banner: boolean, web: boolean, editable: boolean } } };

export type CompanyApiTokensQueryVariables = Exact<{
  companyId: unknown;
}>;


export type CompanyApiTokensQuery = { company: { apiTokens: Array<{ status: Types.ApiTokenStatus, token: string, createdAt: unknown }> } };

export type CreateCompanyApiTokenMutationVariables = Exact<{
  companyId: unknown;
}>;


export type CreateCompanyApiTokenMutation = { createApiToken: { status: Types.ApiTokenStatus, token: string, createdAt: unknown } };

export type CompanyWebhookPartsFragment = { id: unknown, companyId: unknown, types: Array<Types.CompanyWebhookType>, url: string };

export type CompanyWebhooksQueryVariables = Exact<{
  companyId: unknown;
}>;


export type CompanyWebhooksQuery = { company: { webhooks: Array<{ id: unknown, companyId: unknown, types: Array<Types.CompanyWebhookType>, url: string }> } };

export type UpdateCompanyWebhookMutationVariables = Exact<{
  companyId: unknown;
  types: Array<Types.CompanyWebhookType> | Types.CompanyWebhookType;
  url: string;
}>;


export type UpdateCompanyWebhookMutation = { updateCompanyWebhook: { id: unknown, companyId: unknown, types: Array<Types.CompanyWebhookType>, url: string } };

export type DeleteCompanyWebhookMutationVariables = Exact<{
  id: unknown;
}>;


export type DeleteCompanyWebhookMutation = { deleteCompanyWebhook: boolean };

export type WebhookExampleQueryVariables = Exact<{ [key: string]: never; }>;


export type WebhookExampleQuery = { webhookExample: Array<{ type: Types.CompanyWebhookType, version: number, payload: unknown }> };

export type ArchiverConfigPartsFragment = { adcopyMonths: number | null, adgroupMonths: number | null, adtemplateMonths: number | null, positionMonths: number | null };

export type CompanyArchiverConfigQueryVariables = Exact<{
  companyId: unknown;
  isAdvertiser: boolean;
  isPublisher: boolean;
  isAgency: boolean;
  isReseller: boolean;
}>;


export type CompanyArchiverConfigQuery = { advertiser?: { id: unknown, archiverConfig: { adcopyMonths: number | null, adgroupMonths: number | null, adtemplateMonths: number | null, positionMonths: number | null }, agency: { id: unknown, archiverConfig: { adcopyMonths: number | null, adgroupMonths: number | null, adtemplateMonths: number | null, positionMonths: number | null } } | null, reseller: { id: unknown, archiverConfig: { adcopyMonths: number | null, adgroupMonths: number | null, adtemplateMonths: number | null, positionMonths: number | null } } }, publisher?: { id: unknown, archiverConfig: { adcopyMonths: number | null, adgroupMonths: number | null, adtemplateMonths: number | null, positionMonths: number | null }, reseller: { id: unknown, archiverConfig: { adcopyMonths: number | null, adgroupMonths: number | null, adtemplateMonths: number | null, positionMonths: number | null } } }, agency?: { id: unknown, reseller: { id: unknown, archiverConfig: { adcopyMonths: number | null, adgroupMonths: number | null, adtemplateMonths: number | null, positionMonths: number | null } } }, reseller?: { id: unknown, archiverConfig: { adcopyMonths: number | null, adgroupMonths: number | null, adtemplateMonths: number | null, positionMonths: number | null } } };

export type UpdateArchiverConfigMutationVariables = Exact<{
  companyId: unknown;
  config: Types.ArchiverConfigInput;
}>;


export type UpdateArchiverConfigMutation = { updateArchiverConfig: { adcopyMonths: number | null, adgroupMonths: number | null, adtemplateMonths: number | null, positionMonths: number | null } };

export type ArchiveAdvertiserMutationVariables = Exact<{
  advertiserId: unknown;
}>;


export type ArchiveAdvertiserMutation = { archiveAdvertiser: boolean };

export type ArchivePublisherMutationVariables = Exact<{
  publisherId: unknown;
}>;


export type ArchivePublisherMutation = { archivePublisher: boolean };

export type ArchiveAgencyMutationVariables = Exact<{
  agencyId: unknown;
}>;


export type ArchiveAgencyMutation = { archiveAgency: boolean };

export type ArchiveResellerMutationVariables = Exact<{
  resellerId: unknown;
}>;


export type ArchiveResellerMutation = { archiveReseller: boolean };

export type ArchiveTradingDeskMutationVariables = Exact<{
  tradingDeskId: unknown;
}>;


export type ArchiveTradingDeskMutation = { archiveTradingDesk: boolean };

export type CompanyHasCampaignsQueryVariables = Exact<{
  companyId: unknown;
  pagination: Types.Pagination;
}>;


export type CompanyHasCampaignsQuery = { searchCampaigns: Array<{ id: unknown }> };

export type CompanyHasWebsitesQueryVariables = Exact<{
  companyId: unknown;
  pagination: Types.Pagination;
}>;


export type CompanyHasWebsitesQuery = { searchWebsites: Array<{ id: unknown }> };

export type CompanyHasProgrammaticCampaignsQueryVariables = Exact<{
  tradingDeskId: unknown;
  pagination: Types.Pagination;
}>;


export type CompanyHasProgrammaticCampaignsQuery = { searchProgrammaticCampaigns: Array<{ id: unknown }> };

export type CompanyHasAgencyAdvertisersQueryVariables = Exact<{
  agencyId: string;
  pagination: Types.Pagination;
}>;


export type CompanyHasAgencyAdvertisersQuery = { searchCompanies: Array<{ id: unknown }> };

export type CompanyHasResellerChildrenQueryVariables = Exact<{
  resellerId: string;
  pagination: Types.Pagination;
}>;


export type CompanyHasResellerChildrenQuery = { searchCompanies: Array<{ id: unknown }> };

export type SearchCopperOpportunitiesByCompanyQueryVariables = Exact<{
  params?: Types.CopperOpportunitySearchParams | null | undefined;
}>;


export type SearchCopperOpportunitiesByCompanyQuery = { searchCopperOpportunities: Array<{ id: string, name: string, stage: string | null, monetaryValue: number | null }> };

export type SearchCopperOpportunitiesQueryVariables = Exact<{
  params?: Types.CopperOpportunitySearchParams | null | undefined;
  pagination: Types.Pagination;
}>;


export type SearchCopperOpportunitiesQuery = { searchCopperOpportunities: Array<{ id: string, name: string, stage: string | null, company: { name: string, customFields: Array<{ name: string, value: string | null }>, address: { street: string | null, city: string | null, postalCode: string | null, country: string | null } | null, phoneNumbers: Array<{ number: string }>, websites: Array<{ url: string }>, primaryContact: { name: string, firstName: string | null, lastName: string | null, title: string | null, emails: Array<{ email: string }>, phoneNumbers: Array<{ number: string }> } | null } | null, assignee: { email: string | null } | null }> };

export type SearchCopperCompaniesQueryVariables = Exact<{
  params?: Types.CopperCompanySearchParams | null | undefined;
}>;


export type SearchCopperCompaniesQuery = { searchCopperCompanies: Array<{ id: string, name: string }> };

export type CopperCompanyQueryVariables = Exact<{
  id: string;
}>;


export type CopperCompanyQuery = { copperCompany: { id: string, name: string } };

export type GetCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCountriesQuery = { getCountries: Array<{ code: string, label: string }> };

export type InvalidFlatrecordStatsQueryVariables = Exact<{
  start: unknown;
  end: unknown;
  timezone: string;
  adGroupId: unknown;
}>;


export type InvalidFlatrecordStatsQuery = { getInvalidFlatrecordStats: Array<{ invalidReason: string, leads: number, orders: number }> };

export type InventoryPartsFragment = { id: unknown, name: string, format: Types.AdFormat, status: Types.AdGroupStatus, network: Types.Network, contentStrategy: Types.ContentStrategy, channelWeb: boolean, channelEmail: boolean, startDate: unknown, endDate: unknown, dspId: number | null, dealId: string | null, campaign: { id: unknown, name: string, status: Types.Status } };

export type InventoryTimeseriesQueryVariables = Exact<{
  endDate: unknown;
  startDate: unknown;
  id: unknown;
  granularity: Types.GraphGranularity;
}>;


export type InventoryTimeseriesQuery = { inventory: { id: unknown, timeseries: { timeseries: Array<{ date: unknown, stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number } }>, stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number } } } };

export type InventoryPerformanceStatsQueryVariables = Exact<{
  endDate: unknown;
  startDate: unknown;
  id: unknown;
}>;


export type InventoryPerformanceStatsQuery = { inventory: { id: unknown, performanceStats: { stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number }, publisherResellers: Array<{ name: string, stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number }, publishers: Array<{ name: string, stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number }, websites: Array<{ name: string, stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number }, positions: Array<{ name: string, stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number } }> }> }> }> } } };

export type InventoryQueryVariables = Exact<{
  id: unknown;
}>;


export type InventoryQuery = { inventory: { id: unknown, name: string, format: Types.AdFormat, status: Types.AdGroupStatus, network: Types.Network, contentStrategy: Types.ContentStrategy, channelWeb: boolean, channelEmail: boolean, startDate: unknown, endDate: unknown, dspId: number | null, dealId: string | null, campaign: { id: unknown, name: string, status: Types.Status } } };

export type GetLanguagesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLanguagesQuery = { getLanguages: Array<{ id: unknown, code: string, label: string }> };

export type MarketsQueryVariables = Exact<{ [key: string]: never; }>;


export type MarketsQuery = { searchMarkets: Array<{ id: unknown, language: { code: string }, country: { code: string } }> };

export type AdvertiserPerformanceStatsPartsFragment = { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number };

export type AdvertiserPerformanceStatsFullPartsFragment = { pageViews: number, sessions: number, engagedSessions: number, totalUsers: number, newUsers: number, bounceRate: number, engagementRate: number, sessionTimeSeconds: number, cpv: number, impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number };

export type PublisherPerformanceStatsPartsFragment = { displays: unknown, impressions: unknown, clicks: unknown, commissions: number, ctr: number, cpc: number, cpm: number, rpm: number, leads: unknown };

export type PositionCustomDomainPartsFragment = { domain: string, sslStatus: Types.SslStatus, failureReason: string | null, createdAt: unknown, updatedAt: unknown };

export type PositionPartsFragment = { acceptEditorial: boolean, acceptPromotional: boolean, channelType: Types.ChannelType, cpmFloor: number | null, dealId: string | null, iabCategory: Types.Iab | null, id: unknown, name: string, nbZone: number, network: Types.Network, passbackImage: string | null, passbackJs: string | null, passbackLink: string | null, positionType: Types.PositionType | null, revenueShare: number, shortCode: string, sspId: number | null, status: Types.Status, subchannelType: Types.SubChannelType, demandSources: Array<{ name: string, seat: string, dsp: string, isEnabled: boolean }>, customDomain: { domain: string, sslStatus: Types.SslStatus, failureReason: string | null, createdAt: unknown, updatedAt: unknown } | null, website: { id: unknown } };

export type ZoneFragmentFragment = { zone: number, templates: { banners: Array<{ id: unknown, name: string, status: Types.Status, format: Types.AdFormat, height: number, width: number }> | null, natives: Array<{ format: Types.AdFormat, height: number, id: unknown, status: Types.Status, isDefault: boolean, name: string, width: number }> | null } };

export type PositionsQueryVariables = Exact<{
  pagination: Types.Pagination;
  searchQuery: Types.PositionSearchQuery;
}>;


export type PositionsQuery = { searchPositions: Array<{ id: unknown, name: string, iabCategory: Types.Iab | null, network: Types.Network, channelType: Types.ChannelType, subchannelType: Types.SubChannelType, status: Types.Status, website: { name: string, publisher: { name: string, slug: string, reseller: { name: string } }, market: { language: { code: string }, country: { code: string } } } }> };

export type PositionQueryVariables = Exact<{
  id: unknown;
}>;


export type PositionQuery = { position: { acceptEditorial: boolean, acceptPromotional: boolean, channelType: Types.ChannelType, cpmFloor: number | null, dealId: string | null, iabCategory: Types.Iab | null, id: unknown, name: string, nbZone: number, network: Types.Network, passbackImage: string | null, passbackJs: string | null, passbackLink: string | null, positionType: Types.PositionType | null, revenueShare: number, shortCode: string, sspId: number | null, status: Types.Status, subchannelType: Types.SubChannelType, demandSources: Array<{ name: string, seat: string, dsp: string, isEnabled: boolean }>, customDomain: { domain: string, sslStatus: Types.SslStatus, failureReason: string | null, createdAt: unknown, updatedAt: unknown } | null, website: { id: unknown } } };

export type PositionZoneQueryVariables = Exact<{
  id: unknown;
}>;


export type PositionZoneQuery = { position: { id: unknown, zones: Array<{ zone: number, templates: { banners: Array<{ id: unknown, name: string, status: Types.Status, format: Types.AdFormat, height: number, width: number }> | null, natives: Array<{ format: Types.AdFormat, height: number, id: unknown, status: Types.Status, isDefault: boolean, name: string, width: number }> | null } }> } };

export type PositionTimeseriesQueryVariables = Exact<{
  endDate: unknown;
  startDate: unknown;
  positionId: unknown;
  granularity: Types.GraphGranularity;
  filters?: Array<Types.CostDetailsFilter> | Types.CostDetailsFilter | null | undefined;
}>;


export type PositionTimeseriesQuery = { position: { id: unknown, timeseries: { timeseries: Array<{ date: unknown, stats: { displays: unknown, impressions: unknown, clicks: unknown, commissions: number, ctr: number, cpc: number, cpm: number, rpm: number, leads: unknown } }>, stats: { displays: unknown, impressions: unknown, clicks: unknown, commissions: number, ctr: number, cpc: number, cpm: number, rpm: number, leads: unknown } } } };

export type PositionPerformanceStatsQueryVariables = Exact<{
  endDate: unknown;
  startDate: unknown;
  positionId: unknown;
  filters?: Array<Types.CostDetailsFilter> | Types.CostDetailsFilter | null | undefined;
}>;


export type PositionPerformanceStatsQuery = { position: { id: unknown, performanceStats: { stats: { displays: unknown, impressions: unknown, clicks: unknown, commissions: number, ctr: number, cpc: number, cpm: number, rpm: number, leads: unknown }, devices: Array<{ name: string, stats: { displays: unknown, impressions: unknown, clicks: unknown, commissions: number, ctr: number, cpc: number, cpm: number, rpm: number, leads: unknown } }>, zones: Array<{ name: string, stats: { displays: unknown, impressions: unknown, clicks: unknown, commissions: number, ctr: number, cpc: number, cpm: number, rpm: number, leads: unknown } }>, advertiserResellers: Array<{ name: string, stats: { displays: unknown, impressions: unknown, clicks: unknown, commissions: number, ctr: number, cpc: number, cpm: number, rpm: number, leads: unknown }, advertisers: Array<{ slug: string | null, campaigns: Array<{ name: string, stats: { displays: unknown, impressions: unknown, clicks: unknown, commissions: number, ctr: number, cpc: number, cpm: number, rpm: number, leads: unknown } }> }> }>, adTemplates: Array<
        | { id: unknown, name: string, stats: { displays: unknown, impressions: unknown, clicks: unknown, commissions: number, ctr: number, cpc: number, cpm: number, rpm: number, leads: unknown }, zones: Array<{ name: string, stats: { displays: unknown, impressions: unknown, clicks: unknown, commissions: number, ctr: number, cpc: number, cpm: number, rpm: number, leads: unknown } }> }
        | { id: unknown, name: string, stats: { displays: unknown, impressions: unknown, clicks: unknown, commissions: number, ctr: number, cpc: number, cpm: number, rpm: number, leads: unknown }, zones: Array<{ name: string, stats: { displays: unknown, impressions: unknown, clicks: unknown, commissions: number, ctr: number, cpc: number, cpm: number, rpm: number, leads: unknown } }> }
        | { id: unknown, name: string, stats: { displays: unknown, impressions: unknown, clicks: unknown, commissions: number, ctr: number, cpc: number, cpm: number, rpm: number, leads: unknown }, zones: Array<{ name: string, stats: { displays: unknown, impressions: unknown, clicks: unknown, commissions: number, ctr: number, cpc: number, cpm: number, rpm: number, leads: unknown } }> }
      > } } };

export type PositionPopulationStatsQueryVariables = Exact<{
  id: unknown;
}>;


export type PositionPopulationStatsQuery = { position: { population: { os: Array<{ label: string, impressions: number, clicks: number, conversions: number, revenues: number }>, deviceType: Array<{ label: string, impressions: number, clicks: number, conversions: number, revenues: number }>, ageRange: Array<{ label: string, impressions: number, clicks: number, conversions: number, revenues: number }>, gender: Array<{ label: string, impressions: number, clicks: number, conversions: number, revenues: number }> } } };

export type CreatePositionMutationVariables = Exact<{
  newPosition: Types.PositionCreateInput;
}>;


export type CreatePositionMutation = { createPosition: { id: unknown, name: string, website: { publisher: { slug: string } } } };

export type UpdatePositionMutationVariables = Exact<{
  position: Types.PositionInput;
}>;


export type UpdatePositionMutation = { updatePosition: { acceptEditorial: boolean, acceptPromotional: boolean, channelType: Types.ChannelType, cpmFloor: number | null, dealId: string | null, iabCategory: Types.Iab | null, id: unknown, name: string, nbZone: number, network: Types.Network, passbackImage: string | null, passbackJs: string | null, passbackLink: string | null, positionType: Types.PositionType | null, revenueShare: number, shortCode: string, sspId: number | null, status: Types.Status, subchannelType: Types.SubChannelType, demandSources: Array<{ name: string, seat: string, dsp: string, isEnabled: boolean }>, customDomain: { domain: string, sslStatus: Types.SslStatus, failureReason: string | null, createdAt: unknown, updatedAt: unknown } | null, website: { id: unknown } } };

export type CopyPositionMutationVariables = Exact<{
  name: string;
  positionId: unknown;
}>;


export type CopyPositionMutation = { copyPosition: unknown };

export type UpdateDemandSourcesMutationVariables = Exact<{
  positionId: unknown;
  demandSources: Array<Types.DemandSourceInput> | Types.DemandSourceInput;
}>;


export type UpdateDemandSourcesMutation = { updateDemandSources: boolean | null };

export type UpdatePositionZonesMutationVariables = Exact<{
  positionId: unknown;
  zones: Array<Types.PositionZoneInput> | Types.PositionZoneInput;
}>;


export type UpdatePositionZonesMutation = { updatePositionZones: Array<{ zone: number, templates: { banners: Array<{ id: unknown, name: string, status: Types.Status, format: Types.AdFormat, height: number, width: number }> | null, natives: Array<{ format: Types.AdFormat, height: number, id: unknown, status: Types.Status, isDefault: boolean, name: string, width: number }> | null } }> };

export type UpdatePositionCustomDomainMutationVariables = Exact<{
  positionId: unknown;
  customDomain?: string | null | undefined;
}>;


export type UpdatePositionCustomDomainMutation = { updatePositionCustomDomain: { domain: string, sslStatus: Types.SslStatus, failureReason: string | null, createdAt: unknown, updatedAt: unknown } | null };

export type AdGroupAdProductTierAdGroupPartsFragment = { id: unknown, name: string, campaign: { name: string, advertiser: { slug: string, name: string } } };

export type AdGroupAdProductTierBreakdownPartsFragment = { name: string, stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number } };

export type AdGroupAdProductTierAgeRangeBreakdownPartsFragment = { name: string, stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number }, genders: Array<{ name: string, stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number } }> };

export type AdGroupAdProductTierWebsiteBreakdownPartsFragment = { website: { id: unknown, name: string, url: string, iabCategory: Types.Iab }, stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number } };

export type PowerspacePopulationStatsQueryVariables = Exact<{
  endDate: unknown;
  startDate: unknown;
  filters?: Array<Types.CostDetailsFilter> | Types.CostDetailsFilter | null | undefined;
}>;


export type PowerspacePopulationStatsQuery = { powerspace: { population: { os: Array<{ label: string, impressions: number, clicks: number, conversions: number, revenues: number }>, deviceType: Array<{ label: string, impressions: number, clicks: number, conversions: number, revenues: number }>, ageRange: Array<{ label: string, impressions: number, clicks: number, conversions: number, revenues: number }>, gender: Array<{ label: string, impressions: number, clicks: number, conversions: number, revenues: number }> }, adGroupIABStatsAnalysis: Array<{ iabCategory: string, adGroupId: unknown, campaignId: unknown, impressions: unknown, clicks: unknown, revenues: number, conversions: unknown }> } };

export type PowerspaceAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type PowerspaceAccountsQuery = { powerspace: { accounts: Array<{ id: unknown, firstName: string, lastName: string }> } };

export type PowerspaceSalesQueryVariables = Exact<{ [key: string]: never; }>;


export type PowerspaceSalesQuery = { powerspace: { sales: Array<{ id: unknown, firstName: string, lastName: string }> } };

export type PowerspaceBudgetsQueryVariables = Exact<{
  endDate: unknown;
  startDate: unknown;
  granularity: Types.GraphGranularity;
  accountIds?: Array<unknown> | unknown | null | undefined;
  saleIds?: Array<unknown> | unknown | null | undefined;
  filters?: Array<Types.CostDetailsFilter> | Types.CostDetailsFilter | null | undefined;
}>;


export type PowerspaceBudgetsQuery = { powerspace: { budgets: { global: Array<{ date: unknown, dailyBudget: number, revenue: number, impressions: unknown, clicks: unknown }>, adGroups: Array<{ date: unknown, advertiserName: string, advertiserSlug: string, campaignName: string, campaignId: unknown, adGroupName: string, adGroupId: unknown, salesId: unknown, accountId: unknown, dailyBudget: number | null, revenue: number, impressions: unknown, clicks: unknown }> } } };

export type PowerspaceDemandSourcesQueryVariables = Exact<{
  endDate: unknown;
  startDate: unknown;
  granularity: Types.GraphGranularity;
  filters?: Array<Types.CostDetailsFilter> | Types.CostDetailsFilter | null | undefined;
}>;


export type PowerspaceDemandSourcesQuery = { powerspace: { demandSources: Array<{ date: unknown, publisherResellerId: unknown, publisherResellerName: string, advertiserResellerId: unknown, advertiserResellerName: string | null, impressions: unknown }> } };

export type PowerspaceAdGroupsQueryVariables = Exact<{
  endDate: unknown;
  startDate: unknown;
  filters?: Array<Types.CostDetailsFilter> | Types.CostDetailsFilter | null | undefined;
}>;


export type PowerspaceAdGroupsQuery = { powerspace: { iabRepartition: Array<{ iab: Types.Iab, adGroupCount: unknown, impressions: unknown, clicks: unknown, conversions: unknown }>, adGroupIABStatsAnalysis: Array<{ iabCategory: string, adGroupId: unknown, campaignId: unknown, impressions: unknown, clicks: unknown, revenues: number, conversions: unknown }> } };

export type PowerspaceAdProductTiersQueryVariables = Exact<{
  endDate: unknown;
  startDate: unknown;
  timezone: string;
  filters?: Array<Types.CostDetailsFilter> | Types.CostDetailsFilter | null | undefined;
  source: Types.AdGroupClassificationSource;
}>;


export type PowerspaceAdProductTiersQuery = { powerspace: { adGroupAdProductTiers: Array<{ tier: Types.AdProductTier, categories: Array<{ category: string, stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number }, ageRanges: Array<{ name: string, stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number }, genders: Array<{ name: string, stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number } }> }>, iabCategories: Array<{ name: string, stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number } }>, websites: Array<{ website: { id: unknown, name: string, url: string, iabCategory: Types.Iab }, stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number } }>, adGroups: Array<{ stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number }, adGroup: { id: unknown, name: string, campaign: { name: string, advertiser: { slug: string, name: string } } }, iabCategories: Array<{ name: string, stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number } }>, websites: Array<{ website: { id: unknown, name: string, url: string, iabCategory: Types.Iab }, stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number } }> }> }> }> } };

export type ProgrammaticCampaignPartsFragment = { id: unknown, marketId: unknown, name: string, status: Types.Status, companyId: unknown, dsp: string, open: boolean };

export type ProgrammaticCampaignTimeseriesQueryVariables = Exact<{
  endDate: unknown;
  startDate: unknown;
  id: unknown;
  granularity: Types.GraphGranularity;
}>;


export type ProgrammaticCampaignTimeseriesQuery = { campaignProgrammatic: { id: unknown, timeseries: { timeseries: Array<{ date: unknown, stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number } }>, stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number } } } };

export type ProgrammaticCampaignPerformanceStatsQueryVariables = Exact<{
  endDate: unknown;
  startDate: unknown;
  id: unknown;
}>;


export type ProgrammaticCampaignPerformanceStatsQuery = { campaignProgrammatic: { id: unknown, performanceStats: { stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number }, publisherResellers: Array<{ name: string, stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number }, publishers: Array<{ name: string, stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number }, websites: Array<{ name: string, stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number }, positions: Array<{ name: string, stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number } }> }> }> }> } } };

export type ProgrammaticCampaignQueryVariables = Exact<{
  id: unknown;
}>;


export type ProgrammaticCampaignQuery = { campaignProgrammatic: { id: unknown, marketId: unknown, name: string, status: Types.Status, companyId: unknown, dsp: string, open: boolean } };

export type ArchiveProgrammaticCampaignMutationVariables = Exact<{
  campaignId: unknown;
}>;


export type ArchiveProgrammaticCampaignMutation = { archiveProgrammaticCampaign: boolean };

export type ProgrammaticCampaignHasInventoryQueryVariables = Exact<{
  campaignId: unknown;
  pagination: Types.Pagination;
}>;


export type ProgrammaticCampaignHasInventoryQuery = { campaignProgrammatic: { id: unknown, inventory: Array<{ id: unknown }> } };

export type PublisherInvoicePartsFragment = { reference: unknown, date: unknown, period: unknown, dueDate: unknown, status: Types.InvoiceStatus, publisherName: string, resellerName: string, amount: number, comment: string | null, total: number, createdAt: unknown, updatedAt: unknown, tax: { amount: number, percentage: unknown }, paid: { amount: number, date: unknown }, items: Array<
    | { description: string, total: number, createdAt: unknown, updatedAt: unknown }
    | { websiteName: string, total: number, createdAt: unknown, updatedAt: unknown }
  >, publisher: { addressLine1: string | null, zipCode: string | null, city: string | null, vatId: string | null, paymentTerm: Types.PaymentTerm | null, country: { label: string } } };

export type PublisherPopulationFragment = { os: Array<{ label: string, impressions: number, clicks: number, conversions: number, revenues: number }>, deviceType: Array<{ label: string, impressions: number, clicks: number, conversions: number, revenues: number }>, ageRange: Array<{ label: string, impressions: number, clicks: number, conversions: number, revenues: number }>, gender: Array<{ label: string, impressions: number, clicks: number, conversions: number, revenues: number }> };

export type PublisherNameQueryVariables = Exact<{
  id: unknown;
}>;


export type PublisherNameQuery = { publisher: { id: unknown, name: string } };

export type CompanyPositionRevSharesQueryVariables = Exact<{
  searchQuery: Types.WebsiteSearchQuery;
}>;


export type CompanyPositionRevSharesQuery = { searchWebsites: Array<{ id: unknown, name: string, positions: Array<{ id: unknown, name: string, status: Types.Status, revenueShare: number }> }> };

export type UpdatePositionsRevenueShareMutationVariables = Exact<{
  positionIds: Array<unknown> | unknown;
  revenueShare: number;
}>;


export type UpdatePositionsRevenueShareMutation = { updatePositionsRevenueShare: boolean };

export type PublisherTimeseriesQueryVariables = Exact<{
  endDate: unknown;
  startDate: unknown;
  publisherId?: unknown;
  slug?: string | null | undefined;
  granularity: Types.GraphGranularity;
  filters?: Array<Types.CostDetailsFilter> | Types.CostDetailsFilter | null | undefined;
}>;


export type PublisherTimeseriesQuery = { publisher: { id: unknown, timeseries: { timeseries: Array<{ date: unknown, stats: { displays: unknown, impressions: unknown, clicks: unknown, commissions: number, ctr: number, cpc: number, cpm: number, rpm: number, leads: unknown } }>, stats: { displays: unknown, impressions: unknown, clicks: unknown, commissions: number, ctr: number, cpc: number, cpm: number, rpm: number, leads: unknown } } } };

export type PublisherPerformanceStatsQueryVariables = Exact<{
  endDate: unknown;
  startDate: unknown;
  publisherId?: unknown;
  slug?: string | null | undefined;
  filters?: Array<Types.CostDetailsFilter> | Types.CostDetailsFilter | null | undefined;
}>;


export type PublisherPerformanceStatsQuery = { publisher: { id: unknown, performanceStats: { stats: { displays: unknown, impressions: unknown, clicks: unknown, commissions: number, ctr: number, cpc: number, cpm: number, rpm: number, leads: unknown }, advertiserResellers: Array<{ name: string, stats: { displays: unknown, impressions: unknown, clicks: unknown, commissions: number, ctr: number, cpc: number, cpm: number, rpm: number, leads: unknown }, advertisers: Array<{ slug: string | null, campaigns: Array<{ name: string, stats: { displays: unknown, impressions: unknown, clicks: unknown, commissions: number, ctr: number, cpc: number, cpm: number, rpm: number, leads: unknown } }> }> }>, websites: Array<{ id: unknown, name: string, stats: { displays: unknown, impressions: unknown, clicks: unknown, commissions: number, ctr: number, cpc: number, cpm: number, rpm: number, leads: unknown }, positions: Array<{ id: unknown, name: string, channelType: Types.ChannelType, status: Types.Status, stats: { displays: unknown, impressions: unknown, clicks: unknown, commissions: number, ctr: number, cpc: number, cpm: number, rpm: number, leads: unknown } }> }> } } };

export type PublisherConfigQueryVariables = Exact<{
  id: unknown;
}>;


export type PublisherConfigQuery = { publisher: { id: unknown, config: { global: { network: Types.Network, formats: Array<{ height: number, width: number }> }, position: { min: { zones: number }, max: { zones: number } } } } };

export type SearchPublisherInvoicesQueryVariables = Exact<{
  pagination?: Types.Pagination | null | undefined;
  searchQuery: Types.InvoicePublisherSearchQuery;
}>;


export type SearchPublisherInvoicesQuery = { searchPublisherInvoices: Array<{ reference: unknown, date: unknown, period: unknown, dueDate: unknown, status: Types.InvoiceStatus, publisherName: string, resellerName: string, amount: number, total: number, createdAt: unknown, updatedAt: unknown, tax: { amount: number, percentage: unknown }, paid: { amount: number, date: unknown }, publisher: { slug: string } }> };

export type PublisherInvoiceQueryVariables = Exact<{
  reference: unknown;
}>;


export type PublisherInvoiceQuery = { publisherInvoice: { reference: unknown, date: unknown, period: unknown, dueDate: unknown, status: Types.InvoiceStatus, publisherName: string, resellerName: string, amount: number, comment: string | null, total: number, createdAt: unknown, updatedAt: unknown, tax: { amount: number, percentage: unknown }, paid: { amount: number, date: unknown }, items: Array<
      | { description: string, total: number, createdAt: unknown, updatedAt: unknown }
      | { websiteName: string, total: number, createdAt: unknown, updatedAt: unknown }
    >, publisher: { addressLine1: string | null, zipCode: string | null, city: string | null, vatId: string | null, paymentTerm: Types.PaymentTerm | null, country: { label: string } } } };

export type PublisherPopulationStatsQueryVariables = Exact<{
  slug: string;
}>;


export type PublisherPopulationStatsQuery = { publisher: { population: { os: Array<{ label: string, impressions: number, clicks: number, conversions: number, revenues: number }>, deviceType: Array<{ label: string, impressions: number, clicks: number, conversions: number, revenues: number }>, ageRange: Array<{ label: string, impressions: number, clicks: number, conversions: number, revenues: number }>, gender: Array<{ label: string, impressions: number, clicks: number, conversions: number, revenues: number }> } } };

export type CreatePublisherInvoicesMutationVariables = Exact<{
  year: number;
  month: number;
  minAmount: number;
}>;


export type CreatePublisherInvoicesMutation = { createPublisherInvoices: boolean | null };

export type UpdatePublisherInvoiceMutationVariables = Exact<{
  reference: string;
  comment?: string | null | undefined;
  adjustments: Array<Types.InvoiceAdjustmentItemInput> | Types.InvoiceAdjustmentItemInput;
}>;


export type UpdatePublisherInvoiceMutation = { updatePublisherInvoice: { reference: unknown, date: unknown, period: unknown, dueDate: unknown, status: Types.InvoiceStatus, publisherName: string, resellerName: string, amount: number, comment: string | null, total: number, createdAt: unknown, updatedAt: unknown, tax: { amount: number, percentage: unknown }, paid: { amount: number, date: unknown }, items: Array<
      | { description: string, total: number, createdAt: unknown, updatedAt: unknown }
      | { websiteName: string, total: number, createdAt: unknown, updatedAt: unknown }
    >, publisher: { addressLine1: string | null, zipCode: string | null, city: string | null, vatId: string | null, paymentTerm: Types.PaymentTerm | null, country: { label: string } } } | null };

export type ValidatePublisherInvoiceMutationVariables = Exact<{
  reference: string;
}>;


export type ValidatePublisherInvoiceMutation = { validatePublisherInvoice: boolean | null };

export type PaidPublisherInvoiceMutationVariables = Exact<{
  reference: string;
  date: unknown;
  amount: number;
}>;


export type PaidPublisherInvoiceMutation = { paidPublisherInvoice: boolean | null };

export type PublisherBlacklistsQueryVariables = Exact<{
  slug: string;
}>;


export type PublisherBlacklistsQuery = { publisher: { id: unknown, advertiserExclusions: Array<{ createdAt: unknown, advertiser: { id: unknown, name: string } }>, campaignExclusions: Array<{ createdAt: unknown, campaign: { id: unknown, name: string, iabCategory: Types.Iab, advertiserDomainName: string | null } }>, iabExclusions: Array<{ iabCategory: Types.Iab, createdAt: unknown }>, domainExclusions: Array<{ domain: string, createdAt: unknown }> } };

export type PublisherParentBlacklistsQueryVariables = Exact<{
  slug: string;
}>;


export type PublisherParentBlacklistsQuery = { publisher: { reseller: { advertiserExclusions: Array<{ createdAt: unknown, advertiser: { id: unknown, name: string } }>, campaignExclusions: Array<{ createdAt: unknown, campaign: { id: unknown, name: string, iabCategory: Types.Iab, advertiserDomainName: string | null } }>, iabExclusions: Array<{ iabCategory: Types.Iab, createdAt: unknown }>, domainExclusions: Array<{ domain: string, createdAt: unknown }> } } };

export type UpdatePublisherAdvertiserExclusionsMutationVariables = Exact<{
  publisherId: unknown;
  advertiserExclusions: Array<unknown> | unknown;
}>;


export type UpdatePublisherAdvertiserExclusionsMutation = { updatePublisherAdvertiserExclusions: boolean };

export type UpdatePublisherCampaignExclusionsMutationVariables = Exact<{
  publisherId: unknown;
  campaignExclusions: Array<unknown> | unknown;
}>;


export type UpdatePublisherCampaignExclusionsMutation = { updatePublisherCampaignExclusions: boolean };

export type UpdatePublisherIabExclusionsMutationVariables = Exact<{
  publisherId: unknown;
  iabExclusions: Array<Types.Iab> | Types.Iab;
}>;


export type UpdatePublisherIabExclusionsMutation = { updatePublisherIabExclusions: boolean };

export type UpdatePublisherDomainExclusionsMutationVariables = Exact<{
  publisherId: unknown;
  domainExclusions: Array<unknown> | unknown;
}>;


export type UpdatePublisherDomainExclusionsMutation = { updatePublisherDomainExclusions: boolean };

export type PublisherManagersQueryVariables = Exact<{
  id: unknown;
}>;


export type PublisherManagersQuery = { publisher: { id: unknown, accountManagerId: unknown, salesManagerId: unknown } };

export type UpdatePublisherSettingsMutationVariables = Exact<{
  publisherId: unknown;
  settings: Types.PublisherSettingsInput;
}>;


export type UpdatePublisherSettingsMutation = { updatePublisherSettings: { accountManagerId: unknown, salesManagerId: unknown } };

export type ExclusionPresetSummaryFragment = { id: unknown, name: string, description: string | null, createdAt: unknown };

export type ExclusionPresetAvailableSummaryFragment = { id: unknown, name: string, description: string | null, createdAt: unknown, owner: { id: unknown, name: string } };

export type ExclusionPresetWithExclusionsFragment = { excludedIABCategories: Array<Types.Iab>, id: unknown, name: string, description: string | null, createdAt: unknown, excludedCompanies: Array<{ id: unknown, name: string }>, excludedCampaigns: Array<{ id: unknown, name: string, iabCategory: Types.Iab, advertiserDomainName: string | null }> };

export type ResellerExclusionPresetsQueryVariables = Exact<{
  slug: string;
}>;


export type ResellerExclusionPresetsQuery = { reseller: { id: unknown, name: string, assignedExclusionPresets: Array<{ id: unknown, name: string, description: string | null, createdAt: unknown }>, availableExclusionPresets: Array<{ id: unknown, name: string, description: string | null, createdAt: unknown, owner: { id: unknown, name: string } }>, exclusionPresets: Array<{ id: unknown, name: string, description: string | null, createdAt: unknown }> } };

export type PublisherExclusionPresetsQueryVariables = Exact<{
  slug: string;
}>;


export type PublisherExclusionPresetsQuery = { publisher: { id: unknown, name: string, assignedExclusionPresets: Array<{ id: unknown, name: string, description: string | null, createdAt: unknown }>, availableExclusionPresets: Array<{ id: unknown, name: string, description: string | null, createdAt: unknown, owner: { id: unknown, name: string } }>, exclusionPresets: Array<{ id: unknown, name: string, description: string | null, createdAt: unknown }>, reseller: { id: unknown, name: string, assignedExclusionPresets: Array<{ id: unknown, name: string, description: string | null, createdAt: unknown }> } } };

export type WebsiteExclusionPresetsQueryVariables = Exact<{
  id: unknown;
}>;


export type WebsiteExclusionPresetsQuery = { website: { id: unknown, assignedExclusionPresets: Array<{ id: unknown, name: string, description: string | null, createdAt: unknown }>, publisher: { id: unknown, name: string, assignedExclusionPresets: Array<{ id: unknown, name: string, description: string | null, createdAt: unknown }>, availableExclusionPresets: Array<{ id: unknown, name: string, description: string | null, createdAt: unknown, owner: { id: unknown, name: string } }>, reseller: { id: unknown, name: string, assignedExclusionPresets: Array<{ id: unknown, name: string, description: string | null, createdAt: unknown }> } } } };

export type PublisherExclusionPresetQueryVariables = Exact<{
  id: unknown;
}>;


export type PublisherExclusionPresetQuery = { publisherExclusionPreset: { excludedIABCategories: Array<Types.Iab>, id: unknown, name: string, description: string | null, createdAt: unknown, excludedCompanies: Array<{ id: unknown, name: string }>, excludedCampaigns: Array<{ id: unknown, name: string, iabCategory: Types.Iab, advertiserDomainName: string | null }> } };

export type CreatePublisherExclusionPresetMutationVariables = Exact<{
  name: string;
  companyId: unknown;
  description?: string | null | undefined;
}>;


export type CreatePublisherExclusionPresetMutation = { createPublisherExclusionPreset: { id: unknown, name: string, description: string | null, createdAt: unknown } };

export type UpdatePublisherExclusionPresetMutationVariables = Exact<{
  id: unknown;
  name: string;
  description?: string | null | undefined;
  excludedCompanyIds: Array<unknown> | unknown;
  excludedCampaignIds: Array<unknown> | unknown;
  excludedIABCategories: Array<Types.Iab> | Types.Iab;
}>;


export type UpdatePublisherExclusionPresetMutation = { updatePublisherExclusionPreset: { id: unknown, name: string, description: string | null, createdAt: unknown } };

export type DeletePublisherExclusionPresetMutationVariables = Exact<{
  id: unknown;
}>;


export type DeletePublisherExclusionPresetMutation = { deletePublisherExclusionPreset: boolean };

export type AssignPublisherExclusionPresetToWebsiteMutationVariables = Exact<{
  presetId: unknown;
  websiteId: unknown;
}>;


export type AssignPublisherExclusionPresetToWebsiteMutation = { assignPublisherExclusionPresetToWebsite: boolean };

export type UnassignPublisherExclusionPresetFromWebsiteMutationVariables = Exact<{
  presetId: unknown;
  websiteId: unknown;
}>;


export type UnassignPublisherExclusionPresetFromWebsiteMutation = { unassignPublisherExclusionPresetFromWebsite: boolean };

export type AssignExclusionPresetToCompanyMutationVariables = Exact<{
  presetId: unknown;
  companyId: unknown;
}>;


export type AssignExclusionPresetToCompanyMutation = { assignExclusionPresetToCompany: boolean };

export type UnassignExclusionPresetFromCompanyMutationVariables = Exact<{
  presetId: unknown;
  companyId: unknown;
}>;


export type UnassignExclusionPresetFromCompanyMutation = { unassignExclusionPresetFromCompany: boolean };

export type DomainExclusionItemPartsFragment = { domain: string, createdAt: unknown };

export type IabExclusionItemPartsFragment = { iabCategory: Types.Iab, createdAt: unknown };

export type CampaignExclusionItemPartsFragment = { createdAt: unknown, campaign: { id: unknown, name: string, iabCategory: Types.Iab, advertiserDomainName: string | null } };

export type AdvertiserExclusionItemPartsFragment = { createdAt: unknown, advertiser: { id: unknown, name: string } };

export type ResellerPublisherTimeseriesQueryVariables = Exact<{
  endDate: unknown;
  startDate: unknown;
  resellerId?: unknown;
  slug?: string | null | undefined;
  granularity: Types.GraphGranularity;
  filters?: Array<Types.CostDetailsFilter> | Types.CostDetailsFilter | null | undefined;
}>;


export type ResellerPublisherTimeseriesQuery = { reseller: { id: unknown, publisherTimeseries: { timeseries: Array<{ date: unknown, stats: { displays: unknown, impressions: unknown, clicks: unknown, commissions: number, ctr: number, cpc: number, cpm: number, rpm: number, leads: unknown } }>, stats: { displays: unknown, impressions: unknown, clicks: unknown, commissions: number, ctr: number, cpc: number, cpm: number, rpm: number, leads: unknown } } } };

export type ResellerPublisherPopulationStatsQueryVariables = Exact<{
  slug?: string | null | undefined;
}>;


export type ResellerPublisherPopulationStatsQuery = { reseller: { publisherPopulation: { os: Array<{ label: string, impressions: number, clicks: number, conversions: number, revenues: number }>, deviceType: Array<{ label: string, impressions: number, clicks: number, conversions: number, revenues: number }>, ageRange: Array<{ label: string, impressions: number, clicks: number, conversions: number, revenues: number }>, gender: Array<{ label: string, impressions: number, clicks: number, conversions: number, revenues: number }> } } };

export type ResellerAdvertiserTimeseriesQueryVariables = Exact<{
  endDate: unknown;
  startDate: unknown;
  resellerId?: unknown;
  slug?: string | null | undefined;
  granularity: Types.GraphGranularity;
  filters?: Array<Types.CostDetailsFilter> | Types.CostDetailsFilter | null | undefined;
}>;


export type ResellerAdvertiserTimeseriesQuery = { reseller: { id: unknown, advertiserTimeseries: { timeseries: Array<{ date: unknown, stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number } }>, stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number } } } };

export type ResellerPublisherPerformanceStatsQueryVariables = Exact<{
  endDate: unknown;
  startDate: unknown;
  resellerId?: unknown;
  slug?: string | null | undefined;
  filters?: Array<Types.CostDetailsFilter> | Types.CostDetailsFilter | null | undefined;
}>;


export type ResellerPublisherPerformanceStatsQuery = { reseller: { id: unknown, publisherPerformanceStats: { stats: { displays: unknown, impressions: unknown, clicks: unknown, commissions: number, ctr: number, cpc: number, cpm: number, rpm: number, leads: unknown }, publishers: Array<{ name: string, slug: string, stats: { displays: unknown, impressions: unknown, clicks: unknown, commissions: number, ctr: number, cpc: number, cpm: number, rpm: number, leads: unknown } }>, advertiserResellers: Array<{ name: string, stats: { displays: unknown, impressions: unknown, clicks: unknown, commissions: number, ctr: number, cpc: number, cpm: number, rpm: number, leads: unknown }, advertisers: Array<{ name: string, stats: { displays: unknown, impressions: unknown, clicks: unknown, commissions: number, ctr: number, cpc: number, cpm: number, rpm: number, leads: unknown } }> }> } } };

export type ResellerAdvertiserPerformanceStatsQueryVariables = Exact<{
  endDate: unknown;
  startDate: unknown;
  resellerId?: unknown;
  slug?: string | null | undefined;
  filters?: Array<Types.CostDetailsFilter> | Types.CostDetailsFilter | null | undefined;
}>;


export type ResellerAdvertiserPerformanceStatsQuery = { reseller: { id: unknown, advertiserPerformanceStats: { stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number }, publisherResellers: Array<{ name: string, stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number }, publishers: Array<{ name: string, stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number } }> }>, advertisers: Array<{ id: unknown, slug: string, name: string, stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number }, campaigns: Array<{ id: unknown, name: string, status: Types.Status, stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number } }> }> } } };

export type AdGroupsFromAllPwsAccountsQueryVariables = Exact<{
  id: unknown;
  endDate: unknown;
  startDate: unknown;
}>;


export type AdGroupsFromAllPwsAccountsQuery = { reseller: { id: unknown, advertiserPerformanceStats: { stats: { cpm: number } }, accounts: Array<{ id: unknown, firstName: string, lastName: string, advertisers: Array<{ id: unknown, slug: string, name: string, agencyId: unknown, campaigns: Array<{ id: unknown, name: string, adGroups: Array<{ id: unknown, name: string, dailyBudget: number | null, dailyBudgetType: Types.DailyBudgetType, budgetCapping: number | null, budgetCappingType: Types.BudgetCapping, startDate: unknown, endDate: unknown, status: Types.AdGroupStatus, updatedAt: unknown, assistant: { recommendations: Array<{ isHidden: boolean }> }, budget: { date: unknown, budgetMeasures: { dayBudget: number | null, daySpent: number, monthBudget: number | null, monthSpent: number, periodBudget: number | null, periodSpent: number, overallBudget: number | null, overallSpent: number }, budgetStatus: { dayOverspent: boolean, monthOverspent: boolean, overallOverspent: boolean } } | null, targeting: { targetingCount: unknown } | null, performanceStats: { stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number } } }> }> }> }> } };

export type PriorityListSettingsQueryVariables = Exact<{
  resellerSlug: string;
}>;


export type PriorityListSettingsQuery = { reseller: { priorities: Array<{ id: unknown, name: string, value: number, isDefault: boolean, isDeletable: boolean, isPowerspaceDefault: boolean }> } };

export type UpdateResellerPrioritiesMutationVariables = Exact<{
  resellerId: unknown;
  priorities: Array<Types.AdPriorityInput> | Types.AdPriorityInput;
}>;


export type UpdateResellerPrioritiesMutation = { updateResellerPriorities: boolean };

export type UpdateResellerBannerSizesMutationVariables = Exact<{
  resellerId: unknown;
  bannerSizes: Array<Types.SizeInput> | Types.SizeInput;
}>;


export type UpdateResellerBannerSizesMutation = { updateResellerBannerSizes: { id: unknown, bannerSizes: Array<{ width: number, height: number }> | null } };

export type ResellerBlacklistsQueryVariables = Exact<{
  slug: string;
}>;


export type ResellerBlacklistsQuery = { reseller: { id: unknown, advertiserExclusions: Array<{ createdAt: unknown, advertiser: { id: unknown, name: string } }>, campaignExclusions: Array<{ createdAt: unknown, campaign: { id: unknown, name: string, iabCategory: Types.Iab, advertiserDomainName: string | null } }>, iabExclusions: Array<{ iabCategory: Types.Iab, createdAt: unknown }>, domainExclusions: Array<{ domain: string, createdAt: unknown }> } };

export type UpdateResellerAdvertiserExclusionsMutationVariables = Exact<{
  resellerId: unknown;
  advertiserExclusions: Array<unknown> | unknown;
}>;


export type UpdateResellerAdvertiserExclusionsMutation = { updateResellerAdvertiserExclusions: boolean };

export type UpdateResellerCampaignExclusionsMutationVariables = Exact<{
  resellerId: unknown;
  campaignExclusions: Array<unknown> | unknown;
}>;


export type UpdateResellerCampaignExclusionsMutation = { updateResellerCampaignExclusions: boolean };

export type UpdateResellerIabExclusionsMutationVariables = Exact<{
  resellerId: unknown;
  iabExclusions: Array<Types.Iab> | Types.Iab;
}>;


export type UpdateResellerIabExclusionsMutation = { updateResellerIabExclusions: boolean };

export type UpdateResellerDomainExclusionsMutationVariables = Exact<{
  resellerId: unknown;
  domainExclusions: Array<unknown> | unknown;
}>;


export type UpdateResellerDomainExclusionsMutation = { updateResellerDomainExclusions: boolean };

export type ResellerSettingsQueryVariables = Exact<{
  id: unknown;
}>;


export type ResellerSettingsQuery = { reseller: { id: unknown, settings: { accountManagerId: unknown, salesManagerId: unknown } } };

export type UpdateResellerSettingsMutationVariables = Exact<{
  resellerId: unknown;
  settings: Types.ResellerSettingsInput;
}>;


export type UpdateResellerSettingsMutation = { updateResellerSettings: { accountManagerId: unknown, salesManagerId: unknown } };

export type SentEmailPartsFragment = { id: unknown, recipientEmail: string, subject: string, type: Types.SentEmailType, invoiceId: unknown, received: boolean | null, mailjetStatus: string | null, emailDoesNotExist: boolean, errorMessage: string | null, checkedAt: unknown, createdAt: unknown, updatedAt: unknown };

export type SearchSentEmailsQueryVariables = Exact<{
  searchQuery: Types.SentEmailSearchQuery;
  pagination?: Types.Pagination | null | undefined;
}>;


export type SearchSentEmailsQuery = { searchSentEmails: Array<{ id: unknown, recipientEmail: string, subject: string, type: Types.SentEmailType, invoiceId: unknown, received: boolean | null, mailjetStatus: string | null, emailDoesNotExist: boolean, errorMessage: string | null, checkedAt: unknown, createdAt: unknown, updatedAt: unknown }> };

export type SidebarPublisherQueryVariables = Exact<{
  companyId: unknown;
  status?: Array<Types.Status> | Types.Status | null | undefined;
  pagination: Types.Pagination;
}>;


export type SidebarPublisherQuery = { searchWebsites: Array<{ id: unknown, name: string, status: Types.Status, subItems: Array<{ id: unknown, name: string, status: Types.Status }> }> };

export type SidebarAdvertiserQueryVariables = Exact<{
  companyId: unknown;
  campaignStatus?: Array<Types.Status> | Types.Status | null | undefined;
  adGroupStatus?: Array<Types.AdGroupStatus> | Types.AdGroupStatus | null | undefined;
  pagination: Types.Pagination;
}>;


export type SidebarAdvertiserQuery = { searchCampaigns: Array<{ id: unknown, name: string, status: Types.Status, subItems: Array<{ id: unknown, name: string, status: Types.AdGroupStatus }> }> };

export type SidebarTradingDeskQueryVariables = Exact<{
  companyId: unknown;
  campaignStatus?: Array<Types.Status> | Types.Status | null | undefined;
  adGroupStatus?: Array<Types.AdGroupStatus> | Types.AdGroupStatus | null | undefined;
  pagination: Types.Pagination;
}>;


export type SidebarTradingDeskQuery = { searchProgrammaticCampaigns: Array<{ id: unknown, name: string, status: Types.Status, subItems: Array<{ id: unknown, name: string, status: Types.AdGroupStatus }> }> };

export type SidebarAgencyQueryVariables = Exact<{
  agencyId: string;
  status?: Array<Types.Status> | Types.Status | null | undefined;
  pagination: Types.Pagination;
}>;


export type SidebarAgencyQuery = { searchCompanies: Array<{ id: unknown, slug: string, name: string, status: Types.Status }> };

export type PublisherTimeseriesFragment = { timeseries: Array<{ date: unknown, stats: { displays: unknown, impressions: unknown, clicks: unknown, commissions: number, ctr: number, cpc: number, cpm: number, rpm: number, leads: unknown } }>, stats: { displays: unknown, impressions: unknown, clicks: unknown, commissions: number, ctr: number, cpc: number, cpm: number, rpm: number, leads: unknown } };

export type AdvertiserTimeseriesFragment = { timeseries: Array<{ date: unknown, stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number } }>, stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number } };

export type AdvertiserTimeseriesFullFragment = { timeseries: Array<{ date: unknown, stats: { pageViews: number, sessions: number, engagedSessions: number, totalUsers: number, newUsers: number, bounceRate: number, engagementRate: number, sessionTimeSeconds: number, cpv: number, impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number } }>, stats: { pageViews: number, sessions: number, engagedSessions: number, totalUsers: number, newUsers: number, bounceRate: number, engagementRate: number, sessionTimeSeconds: number, cpv: number, impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number } };

export type TradingDeskPartsFragment = { id: unknown, resellerId: unknown, accountManagerId: unknown, salesManagerId: unknown, agencyId: unknown, slug: string, type: Types.CompanyType, name: string, genericName: string, addressLine1: string | null, zipCode: string | null, city: string | null, phone: string | null, fax: string | null, website: string | null, vatId: string | null, accountingId: string | null, bankName: string | null, iban: string | null, swift: string | null, taxId: string | null, registrationId: string | null, paymentTerm: Types.PaymentTerm | null, contactEmail: string | null, currency: Types.Currency | null, invoiceLanguage: Types.InvoiceLanguage | null, invoicingCompany: Types.InvoicingCompany | null, status: Types.Status, rootDomain: string | null, kpis: string | null, seats: Array<{ dsp: string, seat: string }>, campaigns: Array<{ id: unknown, name: string, inventory: Array<{ id: unknown, name: string, format: Types.AdFormat, status: Types.AdGroupStatus, network: Types.Network, contentStrategy: Types.ContentStrategy, channelWeb: boolean, channelEmail: boolean, startDate: unknown, endDate: unknown, dspId: number | null, dealId: string | null }> }> };

export type TradingDeskTimeseriesQueryVariables = Exact<{
  endDate: unknown;
  startDate: unknown;
  tradingDeskId?: unknown;
  slug?: string | null | undefined;
  granularity: Types.GraphGranularity;
}>;


export type TradingDeskTimeseriesQuery = { tradingDesk: { id: unknown, timeseries: { timeseries: Array<{ date: unknown, stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number } }>, stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number } } } };

export type TradingDeskPerformanceStatsQueryVariables = Exact<{
  endDate: unknown;
  startDate: unknown;
  tradingDeskId?: unknown;
  slug?: string | null | undefined;
}>;


export type TradingDeskPerformanceStatsQuery = { tradingDesk: { id: unknown, performanceStats: { stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number }, publisherResellers: Array<{ name: string, stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number }, publishers: Array<{ name: string, stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number }, websites: Array<{ name: string, stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number }, positions: Array<{ name: string, stats: { impressions: unknown, costs: number, cpm: number, clicks: unknown, ctr: number, cpc: number, leads: unknown, cpl: number, lr: number, orders: unknown, cpo: number, or: number, roi: number, revenue: number } }> }> }> }> } } };

export type TradingDeskQueryVariables = Exact<{
  id?: unknown;
  slug?: string | null | undefined;
}>;


export type TradingDeskQuery = { tradingDesk: { id: unknown, resellerId: unknown, accountManagerId: unknown, salesManagerId: unknown, agencyId: unknown, slug: string, type: Types.CompanyType, name: string, genericName: string, addressLine1: string | null, zipCode: string | null, city: string | null, phone: string | null, fax: string | null, website: string | null, vatId: string | null, accountingId: string | null, bankName: string | null, iban: string | null, swift: string | null, taxId: string | null, registrationId: string | null, paymentTerm: Types.PaymentTerm | null, contactEmail: string | null, currency: Types.Currency | null, invoiceLanguage: Types.InvoiceLanguage | null, invoicingCompany: Types.InvoicingCompany | null, status: Types.Status, rootDomain: string | null, kpis: string | null, seats: Array<{ dsp: string, seat: string }>, campaigns: Array<{ id: unknown, name: string, inventory: Array<{ id: unknown, name: string, format: Types.AdFormat, status: Types.AdGroupStatus, network: Types.Network, contentStrategy: Types.ContentStrategy, channelWeb: boolean, channelEmail: boolean, startDate: unknown, endDate: unknown, dspId: number | null, dealId: string | null }> }> } };

export type UserPermissionPartsFragment = { companyType: Types.CompanyType, read: boolean, edit: boolean, admin: boolean, superAdmin: boolean, api: boolean, adgroupCpm: boolean, adgroupCpl: boolean, adgroupExclusions: boolean, adgroupCustomcpcs: boolean, adgroupReportwebsites: boolean, adgroupUsertargeting: boolean, adgroupGeotargeting: boolean, adgroupDevicetargeting: boolean, adgroupTimetargeting: boolean, adgroupSegments: boolean, adgroupAutoSegments: boolean, adgroupPriority: boolean, adgroupBudgetCapping: boolean, adgroupMonthlyBudgetCapping: boolean, adgroupOverallBudgetCapping: boolean, adgroupOpenBudgetCapping: boolean, adgroupOpenDailyBudget: boolean, adgroupDatesRequired: boolean, adCopyValidation: boolean, adCopyDates: boolean, assistant: boolean, aiAssistant: boolean, costHistory: boolean, costRecommendation: boolean, advertiserDirectoryPresets: boolean, publisherBlacklistPresets: boolean, positionAdvancedsettings: boolean, websiteExclusions: boolean, web: boolean, banner: boolean };

export type UserPartsFragment = { id: unknown, firstName: string, lastName: string, email: unknown, title: string | null, status: Types.UserStatus, mobile: string | null, language: string, isPrimaryContact: boolean | null, role: Types.UserRole | null, market: { language: { code: string }, country: { code: string } } | null, company: { resellerId: unknown, agencyId: unknown, id: unknown, name: string, type: Types.CompanyType, slug: string, approvedTerms: { version: string } | null, style: { primaryColor: string, secondaryColor: string, logoUrl: string } | null, userPermissions: { companyType: Types.CompanyType, read: boolean, edit: boolean, admin: boolean, superAdmin: boolean, api: boolean, adgroupCpm: boolean, adgroupCpl: boolean, adgroupExclusions: boolean, adgroupCustomcpcs: boolean, adgroupReportwebsites: boolean, adgroupUsertargeting: boolean, adgroupGeotargeting: boolean, adgroupDevicetargeting: boolean, adgroupTimetargeting: boolean, adgroupSegments: boolean, adgroupAutoSegments: boolean, adgroupPriority: boolean, adgroupBudgetCapping: boolean, adgroupMonthlyBudgetCapping: boolean, adgroupOverallBudgetCapping: boolean, adgroupOpenBudgetCapping: boolean, adgroupOpenDailyBudget: boolean, adgroupDatesRequired: boolean, adCopyValidation: boolean, adCopyDates: boolean, assistant: boolean, aiAssistant: boolean, costHistory: boolean, costRecommendation: boolean, advertiserDirectoryPresets: boolean, publisherBlacklistPresets: boolean, positionAdvancedsettings: boolean, websiteExclusions: boolean, web: boolean, banner: boolean } } };

export type AuthQueryVariables = Exact<{ [key: string]: never; }>;


export type AuthQuery = { me: { id: unknown, firstName: string, lastName: string, email: unknown, title: string | null, status: Types.UserStatus, mobile: string | null, language: string, isPrimaryContact: boolean | null, role: Types.UserRole | null, market: { language: { code: string }, country: { code: string } } | null, company: { resellerId: unknown, agencyId: unknown, id: unknown, name: string, type: Types.CompanyType, slug: string, approvedTerms: { version: string } | null, style: { primaryColor: string, secondaryColor: string, logoUrl: string } | null, userPermissions: { companyType: Types.CompanyType, read: boolean, edit: boolean, admin: boolean, superAdmin: boolean, api: boolean, adgroupCpm: boolean, adgroupCpl: boolean, adgroupExclusions: boolean, adgroupCustomcpcs: boolean, adgroupReportwebsites: boolean, adgroupUsertargeting: boolean, adgroupGeotargeting: boolean, adgroupDevicetargeting: boolean, adgroupTimetargeting: boolean, adgroupSegments: boolean, adgroupAutoSegments: boolean, adgroupPriority: boolean, adgroupBudgetCapping: boolean, adgroupMonthlyBudgetCapping: boolean, adgroupOverallBudgetCapping: boolean, adgroupOpenBudgetCapping: boolean, adgroupOpenDailyBudget: boolean, adgroupDatesRequired: boolean, adCopyValidation: boolean, adCopyDates: boolean, assistant: boolean, aiAssistant: boolean, costHistory: boolean, costRecommendation: boolean, advertiserDirectoryPresets: boolean, publisherBlacklistPresets: boolean, positionAdvancedsettings: boolean, websiteExclusions: boolean, web: boolean, banner: boolean } } } };

export type GetUserQueryVariables = Exact<{
  id?: unknown;
}>;


export type GetUserQuery = { user: { id: unknown, marketId: unknown, role: Types.UserRole | null, lastName: string, firstName: string, email: unknown, status: Types.UserStatus, title: string | null, mobile: string | null, createdAt: unknown, companyId: unknown, accessType: Types.AccessType, language: string, isPrimaryContact: boolean | null } };

export type AuthWithCompanyQueryVariables = Exact<{
  slug: string;
}>;


export type AuthWithCompanyQuery = { me: { id: unknown, firstName: string, lastName: string, email: unknown, title: string | null, status: Types.UserStatus, mobile: string | null, language: string, isPrimaryContact: boolean | null, role: Types.UserRole | null, market: { language: { code: string }, country: { code: string } } | null, company: { resellerId: unknown, agencyId: unknown, id: unknown, name: string, type: Types.CompanyType, slug: string, approvedTerms: { version: string } | null, style: { primaryColor: string, secondaryColor: string, logoUrl: string } | null, userPermissions: { companyType: Types.CompanyType, read: boolean, edit: boolean, admin: boolean, superAdmin: boolean, api: boolean, adgroupCpm: boolean, adgroupCpl: boolean, adgroupExclusions: boolean, adgroupCustomcpcs: boolean, adgroupReportwebsites: boolean, adgroupUsertargeting: boolean, adgroupGeotargeting: boolean, adgroupDevicetargeting: boolean, adgroupTimetargeting: boolean, adgroupSegments: boolean, adgroupAutoSegments: boolean, adgroupPriority: boolean, adgroupBudgetCapping: boolean, adgroupMonthlyBudgetCapping: boolean, adgroupOverallBudgetCapping: boolean, adgroupOpenBudgetCapping: boolean, adgroupOpenDailyBudget: boolean, adgroupDatesRequired: boolean, adCopyValidation: boolean, adCopyDates: boolean, assistant: boolean, aiAssistant: boolean, costHistory: boolean, costRecommendation: boolean, advertiserDirectoryPresets: boolean, publisherBlacklistPresets: boolean, positionAdvancedsettings: boolean, websiteExclusions: boolean, web: boolean, banner: boolean } } }, company: { id: unknown, resellerId: unknown, agencyId: unknown, accountManagerId: unknown, salesManagerId: unknown, slug: string, type: Types.CompanyType, name: string, genericName: string, addressLine1: string | null, zipCode: string | null, city: string | null, phone: string | null, fax: string | null, website: string | null, vatId: string | null, accountingId: string | null, bankName: string | null, iban: string | null, swift: string | null, taxId: string | null, registrationId: string | null, paymentTerm: Types.PaymentTerm | null, contactEmail: string | null, currency: Types.Currency | null, invoiceLanguage: Types.InvoiceLanguage | null, invoicingCompany: Types.InvoicingCompany | null, status: Types.Status, rootDomain: string | null, kpis: string | null, country: { code: string, label: string }, userPermissions: { companyType: Types.CompanyType, read: boolean, edit: boolean, admin: boolean, superAdmin: boolean, api: boolean, adgroupCpm: boolean, adgroupCpl: boolean, adgroupExclusions: boolean, adgroupCustomcpcs: boolean, adgroupReportwebsites: boolean, adgroupUsertargeting: boolean, adgroupGeotargeting: boolean, adgroupDevicetargeting: boolean, adgroupTimetargeting: boolean, adgroupSegments: boolean, adgroupAutoSegments: boolean, adgroupPriority: boolean, adgroupBudgetCapping: boolean, adgroupMonthlyBudgetCapping: boolean, adgroupOverallBudgetCapping: boolean, adgroupOpenBudgetCapping: boolean, adgroupOpenDailyBudget: boolean, adgroupDatesRequired: boolean, adCopyValidation: boolean, adCopyDates: boolean, assistant: boolean, aiAssistant: boolean, costHistory: boolean, costRecommendation: boolean, advertiserDirectoryPresets: boolean, publisherBlacklistPresets: boolean, positionAdvancedsettings: boolean, websiteExclusions: boolean, web: boolean, banner: boolean } } };

export type LoginMutationVariables = Exact<{
  email: string;
  password: string;
  rememberMe?: boolean | null | undefined;
}>;


export type LoginMutation = { login: { token: string, slug: string } };

export type LoginWithGoogleMutationVariables = Exact<{
  idToken: string;
  rememberMe?: boolean | null | undefined;
}>;


export type LoginWithGoogleMutation = { loginWithGoogle: { token: string, slug: string } };

export type AskResetUserPasswordMutationVariables = Exact<{
  email: string;
}>;


export type AskResetUserPasswordMutation = { askResetUserPassword: boolean };

export type ResetPasswordMutationVariables = Exact<{
  newPassword: string;
  resetToken: string;
}>;


export type ResetPasswordMutation = { resetPassword: boolean };

export type DeleteUserMutationVariables = Exact<{
  id: unknown;
}>;


export type DeleteUserMutation = { deleteUser: boolean | null };

export type UpdateUserPasswordMutationVariables = Exact<{
  password: unknown;
  user: Types.UserInput;
}>;


export type UpdateUserPasswordMutation = { updateUserPassword: boolean };

export type UpdateUserMutationVariables = Exact<{
  user: Types.UserInput;
}>;


export type UpdateUserMutation = { updateUser: { accessType: Types.AccessType, id: unknown, firstName: string, lastName: string, email: unknown, title: string | null, status: Types.UserStatus, mobile: string | null, language: string, isPrimaryContact: boolean | null, role: Types.UserRole | null, market: { language: { code: string }, country: { code: string } } | null, company: { resellerId: unknown, agencyId: unknown, id: unknown, name: string, type: Types.CompanyType, slug: string, approvedTerms: { version: string } | null, style: { primaryColor: string, secondaryColor: string, logoUrl: string } | null, userPermissions: { companyType: Types.CompanyType, read: boolean, edit: boolean, admin: boolean, superAdmin: boolean, api: boolean, adgroupCpm: boolean, adgroupCpl: boolean, adgroupExclusions: boolean, adgroupCustomcpcs: boolean, adgroupReportwebsites: boolean, adgroupUsertargeting: boolean, adgroupGeotargeting: boolean, adgroupDevicetargeting: boolean, adgroupTimetargeting: boolean, adgroupSegments: boolean, adgroupAutoSegments: boolean, adgroupPriority: boolean, adgroupBudgetCapping: boolean, adgroupMonthlyBudgetCapping: boolean, adgroupOverallBudgetCapping: boolean, adgroupOpenBudgetCapping: boolean, adgroupOpenDailyBudget: boolean, adgroupDatesRequired: boolean, adCopyValidation: boolean, adCopyDates: boolean, assistant: boolean, aiAssistant: boolean, costHistory: boolean, costRecommendation: boolean, advertiserDirectoryPresets: boolean, publisherBlacklistPresets: boolean, positionAdvancedsettings: boolean, websiteExclusions: boolean, web: boolean, banner: boolean } } } };

export type CreateUserMutationVariables = Exact<{
  newUser: Types.UserCreateInput;
}>;


export type CreateUserMutation = { createUser: { accessType: Types.AccessType, id: unknown, firstName: string, lastName: string, email: unknown, title: string | null, status: Types.UserStatus, mobile: string | null, language: string, isPrimaryContact: boolean | null, role: Types.UserRole | null, market: { language: { code: string }, country: { code: string } } | null, company: { resellerId: unknown, agencyId: unknown, id: unknown, name: string, type: Types.CompanyType, slug: string, approvedTerms: { version: string } | null, style: { primaryColor: string, secondaryColor: string, logoUrl: string } | null, userPermissions: { companyType: Types.CompanyType, read: boolean, edit: boolean, admin: boolean, superAdmin: boolean, api: boolean, adgroupCpm: boolean, adgroupCpl: boolean, adgroupExclusions: boolean, adgroupCustomcpcs: boolean, adgroupReportwebsites: boolean, adgroupUsertargeting: boolean, adgroupGeotargeting: boolean, adgroupDevicetargeting: boolean, adgroupTimetargeting: boolean, adgroupSegments: boolean, adgroupAutoSegments: boolean, adgroupPriority: boolean, adgroupBudgetCapping: boolean, adgroupMonthlyBudgetCapping: boolean, adgroupOverallBudgetCapping: boolean, adgroupOpenBudgetCapping: boolean, adgroupOpenDailyBudget: boolean, adgroupDatesRequired: boolean, adCopyValidation: boolean, adCopyDates: boolean, assistant: boolean, aiAssistant: boolean, costHistory: boolean, costRecommendation: boolean, advertiserDirectoryPresets: boolean, publisherBlacklistPresets: boolean, positionAdvancedsettings: boolean, websiteExclusions: boolean, web: boolean, banner: boolean } } } | null };

export type InviteUserMutationVariables = Exact<{
  newUser: Types.UserInviteInput;
}>;


export type InviteUserMutation = { inviteUser: { accessType: Types.AccessType, id: unknown, firstName: string, lastName: string, email: unknown, title: string | null, status: Types.UserStatus, mobile: string | null, language: string, isPrimaryContact: boolean | null, role: Types.UserRole | null, market: { language: { code: string }, country: { code: string } } | null, company: { resellerId: unknown, agencyId: unknown, id: unknown, name: string, type: Types.CompanyType, slug: string, approvedTerms: { version: string } | null, style: { primaryColor: string, secondaryColor: string, logoUrl: string } | null, userPermissions: { companyType: Types.CompanyType, read: boolean, edit: boolean, admin: boolean, superAdmin: boolean, api: boolean, adgroupCpm: boolean, adgroupCpl: boolean, adgroupExclusions: boolean, adgroupCustomcpcs: boolean, adgroupReportwebsites: boolean, adgroupUsertargeting: boolean, adgroupGeotargeting: boolean, adgroupDevicetargeting: boolean, adgroupTimetargeting: boolean, adgroupSegments: boolean, adgroupAutoSegments: boolean, adgroupPriority: boolean, adgroupBudgetCapping: boolean, adgroupMonthlyBudgetCapping: boolean, adgroupOverallBudgetCapping: boolean, adgroupOpenBudgetCapping: boolean, adgroupOpenDailyBudget: boolean, adgroupDatesRequired: boolean, adCopyValidation: boolean, adCopyDates: boolean, assistant: boolean, aiAssistant: boolean, costHistory: boolean, costRecommendation: boolean, advertiserDirectoryPresets: boolean, publisherBlacklistPresets: boolean, positionAdvancedsettings: boolean, websiteExclusions: boolean, web: boolean, banner: boolean } } } | null };

export type AcceptInviteMutationVariables = Exact<{
  acceptInvite: Types.AcceptInviteInput;
}>;


export type AcceptInviteMutation = { acceptInvite: boolean | null };

export type StartImpersonationMutationVariables = Exact<{
  userId: unknown;
}>;


export type StartImpersonationMutation = { startImpersonation: { token: string, slug: string, expiresAt: unknown, actorId: unknown, targetUserId: unknown } };

export type SearchUsersLiteQueryVariables = Exact<{
  pagination: Types.Pagination;
  searchQuery: Types.UserSearchQuery;
}>;


export type SearchUsersLiteQuery = { searchUsers: Array<{ id: unknown, firstName: string, lastName: string }> };

export type SearchUsersQueryVariables = Exact<{
  pagination: Types.Pagination;
  searchQuery: Types.UserSearchQuery;
}>;


export type SearchUsersQuery = { searchUsers: Array<{ id: unknown, firstName: string, lastName: string, email: unknown, status: Types.UserStatus, accessType: Types.AccessType, company: { id: unknown, name: string, slug: string, type: Types.CompanyType } }> };

export type EnabledPowerspaceUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type EnabledPowerspaceUsersQuery = { users: Array<{ id: unknown, firstName: string, lastName: string, email: unknown, status: Types.UserStatus }> };

export type PasswordSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type PasswordSettingsQuery = { passwordSettings: { minLength: number, maxLength: number, requireLowercase: boolean, requireUppercase: boolean, requireNumber: boolean, requireSpecial: boolean } };

export type UserExistsQueryVariables = Exact<{
  email: string;
}>;


export type UserExistsQuery = { userExists: boolean };

export type WebsiteBasicPartsFragment = { id: unknown, url: string, name: string, iabCategory: Types.Iab, status: Types.Status, publisher: { id: unknown, slug: string }, market: { id: unknown } };

export type WebsitePartsFragment = { id: unknown, url: string, name: string, iabCategory: Types.Iab, status: Types.Status, publisher: { id: unknown, slug: string, reseller: { id: unknown, name: string } }, positions: Array<{ id: unknown, name: string, channelType: Types.ChannelType }>, market: { id: unknown } };

export type WebsiteNameQueryVariables = Exact<{
  id: unknown;
}>;


export type WebsiteNameQuery = { website: { id: unknown, name: string } };

export type ResellerWebsitesQueryVariables = Exact<{
  companyId: unknown;
}>;


export type ResellerWebsitesQuery = { searchWebsites: Array<{ id: unknown, url: string, name: string, iabCategory: Types.Iab, status: Types.Status, publisher: { id: unknown, slug: string, reseller: { id: unknown, name: string } }, positions: Array<{ id: unknown, name: string, channelType: Types.ChannelType }>, market: { id: unknown } }> };

export type PublisherWebsitesQueryVariables = Exact<{
  companyId: unknown;
}>;


export type PublisherWebsitesQuery = { searchWebsites: Array<{ id: unknown, url: string, name: string, iabCategory: Types.Iab, status: Types.Status, publisher: { id: unknown, slug: string, reseller: { id: unknown, name: string } }, positions: Array<{ id: unknown, name: string, channelType: Types.ChannelType }>, market: { id: unknown } }> };

export type WebsiteQueryVariables = Exact<{
  id: unknown;
}>;


export type WebsiteQuery = { website: { id: unknown, url: string, name: string, iabCategory: Types.Iab, status: Types.Status, publisher: { id: unknown, slug: string, reseller: { id: unknown, name: string } }, positions: Array<{ id: unknown, name: string, channelType: Types.ChannelType }>, market: { id: unknown } } };

export type WebsiteWithExclusionsOnlyQueryVariables = Exact<{
  id: unknown;
}>;


export type WebsiteWithExclusionsOnlyQuery = { website: { id: unknown, url: string, name: string, iabCategory: Types.Iab, status: Types.Status, recommendedIabCategory: { iabCategory: Types.Iab, iabTiers: { iabId: string, type: Types.IabTaxonomyType, tier1Name: string | null, tier2Name: string | null, tier3Name: string | null } } | null, advertiserExclusions: Array<{ createdAt: unknown, advertiser: { id: unknown, name: string } }>, campaignExclusions: Array<{ createdAt: unknown, campaign: { id: unknown, name: string, iabCategory: Types.Iab, advertiserDomainName: string | null } }>, iabExclusions: Array<{ iabCategory: Types.Iab, createdAt: unknown }>, domainExclusions: Array<{ domain: string, createdAt: unknown }>, publisher: { id: unknown, slug: string, reseller: { id: unknown, name: string } }, positions: Array<{ id: unknown, name: string, channelType: Types.ChannelType }>, market: { id: unknown } } };

export type WebsiteParentBlacklistQueryVariables = Exact<{
  id: unknown;
}>;


export type WebsiteParentBlacklistQuery = { website: { publisher: { reseller: { advertiserExclusions: Array<{ createdAt: unknown, advertiser: { id: unknown, name: string } }>, campaignExclusions: Array<{ createdAt: unknown, campaign: { id: unknown, name: string, iabCategory: Types.Iab, advertiserDomainName: string | null } }>, iabExclusions: Array<{ iabCategory: Types.Iab, createdAt: unknown }>, domainExclusions: Array<{ domain: string, createdAt: unknown }> }, advertiserExclusions: Array<{ createdAt: unknown, advertiser: { id: unknown, name: string } }>, campaignExclusions: Array<{ createdAt: unknown, campaign: { id: unknown, name: string, iabCategory: Types.Iab, advertiserDomainName: string | null } }>, iabExclusions: Array<{ iabCategory: Types.Iab, createdAt: unknown }>, domainExclusions: Array<{ domain: string, createdAt: unknown }> } } };

export type SearchWebsiteForPositionWizzardQueryVariables = Exact<{
  pagination: Types.Pagination;
  searchQuery: Types.WebsiteSearchQuery;
}>;


export type SearchWebsiteForPositionWizzardQuery = { searchWebsites: Array<{ id: unknown, name: string }> };

export type SearchWebsitesForDashboardQueryVariables = Exact<{
  pagination: Types.Pagination;
  searchQuery: Types.WebsiteSearchQuery;
}>;


export type SearchWebsitesForDashboardQuery = { searchWebsites: Array<{ id: unknown, name: string, iabCategory: Types.Iab, status: Types.Status, publisher: { id: unknown, slug: string, genericName: string, reseller: { genericName: string } }, positions: Array<{ name: string, nbZone: number, channelType: Types.ChannelType }> }> };

export type WebsiteTimeseriesQueryVariables = Exact<{
  endDate: unknown;
  startDate: unknown;
  websiteId: unknown;
  granularity: Types.GraphGranularity;
  filters?: Array<Types.CostDetailsFilter> | Types.CostDetailsFilter | null | undefined;
}>;


export type WebsiteTimeseriesQuery = { website: { id: unknown, timeseries: { timeseries: Array<{ date: unknown, stats: { displays: unknown, impressions: unknown, clicks: unknown, commissions: number, ctr: number, cpc: number, cpm: number, rpm: number, leads: unknown } }>, stats: { displays: unknown, impressions: unknown, clicks: unknown, commissions: number, ctr: number, cpc: number, cpm: number, rpm: number, leads: unknown } } } };

export type WebsitePerformanceStatsQueryVariables = Exact<{
  endDate: unknown;
  startDate: unknown;
  websiteId: unknown;
  filters?: Array<Types.CostDetailsFilter> | Types.CostDetailsFilter | null | undefined;
}>;


export type WebsitePerformanceStatsQuery = { website: { id: unknown, performanceStats: { stats: { displays: unknown, impressions: unknown, clicks: unknown, commissions: number, ctr: number, cpc: number, cpm: number, rpm: number, leads: unknown }, advertiserResellers: Array<{ name: string, stats: { displays: unknown, impressions: unknown, clicks: unknown, commissions: number, ctr: number, cpc: number, cpm: number, rpm: number, leads: unknown }, advertisers: Array<{ slug: string | null, campaigns: Array<{ name: string, stats: { displays: unknown, impressions: unknown, clicks: unknown, commissions: number, ctr: number, cpc: number, cpm: number, rpm: number, leads: unknown } }> }> }>, positions: Array<{ id: unknown, name: string, channelType: Types.ChannelType, status: Types.Status, stats: { displays: unknown, impressions: unknown, clicks: unknown, commissions: number, ctr: number, cpc: number, cpm: number, rpm: number, leads: unknown } }> } } };

export type WebsitePopulationStatsQueryVariables = Exact<{
  id: unknown;
}>;


export type WebsitePopulationStatsQuery = { website: { population: { os: Array<{ label: string, impressions: number, clicks: number, conversions: number, revenues: number }>, deviceType: Array<{ label: string, impressions: number, clicks: number, conversions: number, revenues: number }>, ageRange: Array<{ label: string, impressions: number, clicks: number, conversions: number, revenues: number }>, gender: Array<{ label: string, impressions: number, clicks: number, conversions: number, revenues: number }> } } };

export type UpdateWebsiteMutationVariables = Exact<{
  website: Types.WebsiteInput;
}>;


export type UpdateWebsiteMutation = { updateWebsite: { id: unknown, url: string, name: string, iabCategory: Types.Iab, status: Types.Status, publisher: { id: unknown, slug: string, reseller: { id: unknown, name: string } }, positions: Array<{ id: unknown, name: string, channelType: Types.ChannelType }>, market: { id: unknown } } };

export type ArchiveWebsiteMutationVariables = Exact<{
  websiteId: unknown;
}>;


export type ArchiveWebsiteMutation = { archiveWebsite: boolean };

export type WebsiteHasPositionsQueryVariables = Exact<{
  websiteId: unknown;
}>;


export type WebsiteHasPositionsQuery = { website: { id: unknown, positions: Array<{ id: unknown }> } };

export type UpdateWebsiteAdvertiserExclusionsMutationVariables = Exact<{
  websiteId: unknown;
  advertiserExclusions: Array<unknown> | unknown;
}>;


export type UpdateWebsiteAdvertiserExclusionsMutation = { updateWebsiteAdvertiserExclusions: boolean };

export type UpdateWebsiteCampaignExclusionsMutationVariables = Exact<{
  websiteId: unknown;
  campaignExclusions: Array<unknown> | unknown;
}>;


export type UpdateWebsiteCampaignExclusionsMutation = { updateWebsiteCampaignExclusions: boolean };

export type UpdateWebsiteIabExclusionsMutationVariables = Exact<{
  websiteId: unknown;
  iabExclusions: Array<Types.Iab> | Types.Iab;
}>;


export type UpdateWebsiteIabExclusionsMutation = { updateWebsiteIabExclusions: boolean };

export type UpdateWebsiteDomainExclusionsMutationVariables = Exact<{
  websiteId: unknown;
  domainExclusions: Array<unknown> | unknown;
}>;


export type UpdateWebsiteDomainExclusionsMutation = { updateWebsiteDomainExclusions: boolean };

export type CreateWebsiteMutationVariables = Exact<{
  website: Types.WebsiteCreateInput;
}>;


export type CreateWebsiteMutation = { createWebsite: { id: unknown, url: string, name: string, iabCategory: Types.Iab, status: Types.Status, publisher: { id: unknown, slug: string, reseller: { id: unknown, name: string } }, positions: Array<{ id: unknown, name: string, channelType: Types.ChannelType }>, market: { id: unknown } } | null };

export const AdvertiserPerformanceStatsPartsFragmentDoc = gql`
    fragment AdvertiserPerformanceStatsParts on AdvertiserCostDetails {
  impressions
  costs
  cpm
  clicks
  ctr
  cpc
  leads
  cpl
  lr
  orders
  cpo
  or
  roi
  revenue
}
    `;
export const AccountAdvertiserPartsFragmentDoc = gql`
    fragment AccountAdvertiserParts on Advertiser {
  id
  slug
  name
  agencyId
  campaigns(status: [Active], pagination: {limit: 200, offset: 0}) {
    id
    name
    adGroups(status: [Active], pagination: {limit: 200, offset: 0}) {
      id
      name
      assistant {
        recommendations {
          isHidden
        }
      }
      dailyBudget
      dailyBudgetType
      budget {
        budgetMeasures {
          dayBudget
          daySpent
          monthBudget
          monthSpent
          periodBudget
          periodSpent
          overallBudget
          overallSpent
        }
        budgetStatus {
          dayOverspent
          monthOverspent
          overallOverspent
        }
        date
      }
      targeting {
        targetingCount
      }
      budgetCapping
      budgetCappingType
      startDate
      endDate
      status
      updatedAt
      performanceStats(endDate: $endDate, startDate: $startDate) {
        stats {
          ...AdvertiserPerformanceStatsParts
        }
      }
    }
  }
}
    ${AdvertiserPerformanceStatsPartsFragmentDoc}`;
export const PartialCompanyPartsFragmentDoc = gql`
    fragment PartialCompanyParts on PartialCompany {
  id
  name
  slug
  type
}
    `;
export const ActivityFeedEntityPartsFragmentDoc = gql`
    fragment ActivityFeedEntityParts on ActivityFeedEntity {
  __typename
  ... on AdCopy {
    id
    name
    adGroup {
      id
      campaign {
        advertiser {
          slug
        }
      }
    }
  }
  ... on AdGroup {
    id
    name
    campaign {
      advertiser {
        slug
      }
    }
  }
  ... on AdGroupBudgetPlan {
    id
    adGroupId
    plannedDate
  }
  ... on BillingContact {
    id
    firstName
    lastName
    companyId
  }
  ... on AdTemplateBanner {
    id
    name
    position {
      id
      website {
        publisher {
          slug
        }
      }
    }
  }
  ... on AdTemplateNative {
    id
    name
    position {
      id
      website {
        publisher {
          slug
        }
      }
    }
  }
  ... on AdTemplateWeb {
    id
    name
    position {
      id
      website {
        publisher {
          slug
        }
      }
    }
  }
  ... on Campaign {
    id
    name
    advertiser {
      slug
    }
  }
  ... on CampaignProgrammatic {
    id
    name
    tradingDesk {
      slug
    }
  }
  ... on Advertiser {
    id
    name
    slug
    type
  }
  ... on Publisher {
    id
    name
    slug
    type
  }
  ... on Agency {
    id
    name
    slug
    type
  }
  ... on Reseller {
    id
    name
    slug
    type
  }
  ... on TradingDesk {
    id
    name
    slug
    type
  }
  ... on CompanyApiToken {
    token
  }
  ... on Position {
    id
    name
    website {
      publisher {
        slug
      }
    }
  }
  ... on SegmentCrm {
    id
    name
  }
  ... on SegmentBehavioural {
    id
    name
  }
  ... on User {
    id
    firstName
    lastName
  }
  ... on Website {
    id
    name
    publisher {
      slug
    }
  }
  ... on AdGroupDirectoryPreset {
    id
    name
  }
  ... on PublisherExclusionPreset {
    id
    name
  }
}
    `;
export const ActivityFeedPartsFragmentDoc = gql`
    fragment ActivityFeedParts on ActivityFeed {
  user {
    id
    firstName
    lastName
    company {
      ...PartialCompanyParts
    }
  }
  company {
    ...PartialCompanyParts
  }
  createdAt
  entityType
  entityId
  property
  oldValue
  newValue
  oldValueEntity {
    ...ActivityFeedEntityParts
  }
  newValueEntity {
    ...ActivityFeedEntityParts
  }
  activityType
  origin
  entity {
    ...ActivityFeedEntityParts
  }
}
    ${PartialCompanyPartsFragmentDoc}
${ActivityFeedEntityPartsFragmentDoc}`;
export const ActivityFeedGroupItemPartsFragmentDoc = gql`
    fragment ActivityFeedGroupItemParts on ActivityFeedGroupItem {
  property
  oldValue
  newValue
  oldValueEntity {
    ...ActivityFeedEntityParts
  }
  newValueEntity {
    ...ActivityFeedEntityParts
  }
  activityType
}
    ${ActivityFeedEntityPartsFragmentDoc}`;
export const ActivityFeedGroupPartsFragmentDoc = gql`
    fragment ActivityFeedGroupParts on ActivityFeedGroup {
  groupId
  activityType
  createdAt
  origin
  user {
    id
    firstName
    lastName
    company {
      ...PartialCompanyParts
    }
  }
  company {
    ...PartialCompanyParts
  }
  entity {
    ...ActivityFeedEntityParts
  }
  items {
    ...ActivityFeedGroupItemParts
  }
}
    ${PartialCompanyPartsFragmentDoc}
${ActivityFeedEntityPartsFragmentDoc}
${ActivityFeedGroupItemPartsFragmentDoc}`;
export const AdcopyPartsFragmentDoc = gql`
    fragment AdcopyParts on AdCopy {
  id
  name
  title
  description
  callToAction
  advertiserName
  image
  forceRedirectUrl
  comments
  status
  rejectedReason
  lastValidatedDate
  weight
  width
  height
  impressionPixels
  createdAt
  updatedAt
  statusUpdatedAt
  visualUpdatedAt
  startDate
  endDate
  imageCheck {
    hasText
  }
  adCopyTags {
    keyword
    adCopyId
  }
}
    `;
export const SegmentBehaviouralPartsFragmentDoc = gql`
    fragment SegmentBehaviouralParts on SegmentBehavioural {
  id
  name
  errorReason
  nbProfiles
  existingProfiles
  reach
  archived
  status
  updatedAt
  createdAt
  duration
  rules {
    type
    urls
  }
}
    `;
export const SegmentCrmPartsFragmentDoc = gql`
    fragment SegmentCrmParts on SegmentCrm {
  id
  name
  errorReason
  nbProfiles
  existingProfiles
  reach
  archived
  status
  originalFilename
  updatedAt
  createdAt
}
    `;
export const AdGroupPartsFragmentDoc = gql`
    fragment AdGroupParts on AdGroup {
  id
  name
  status
  impressionPixels
  clickPixels
  authorizedCountries {
    code
    label
  }
  format
  dailyBudget
  dailyBudgetType
  redirectUrl
  network
  contentStrategy
  channelWeb
  channelEmail
  startDate
  endDate
  budgetCapping
  budgetCappingType
  dspId
  dealId
  userCappingType
  userCappingValue
  userCappingTimeframe
  costType
  costValue
  countryBlacklistRedirectUrl
  campaign {
    id
    name
    status
  }
  targeting {
    age {
      range
      unknown
    }
    gender
    device {
      type
      exclusive
    }
    geoTargeting {
      geoExclusive
      cities {
        name
        radius
        location {
          latitude
          longitude
        }
      }
      regions {
        name
        geometry {
          southwest {
            latitude
            longitude
          }
          northeast {
            latitude
            longitude
          }
        }
      }
      departements {
        name
        geometry {
          southwest {
            latitude
            longitude
          }
          northeast {
            latitude
            longitude
          }
        }
      }
      countries
    }
    os {
      type
      exclusive
    }
    time {
      days
      hours
    }
    segments {
      isExcluded
      segment {
        ... on SegmentBehavioural {
          ...SegmentBehaviouralParts
        }
        ... on SegmentCrm {
          ...SegmentCrmParts
        }
      }
    }
    autoSegments {
      type
      dimension
      id
      isExcluded
    }
    tags {
      id
      origin
      name
      description
      profileCount
      isExcluded
    }
  }
  budget {
    budgetMeasures {
      dayBudget
      daySpent
      monthBudget
      monthSpent
      periodBudget
      periodSpent
      overallBudget
      overallSpent
    }
    budgetStatus {
      monthOverspent
      overallOverspent
    }
    date
  }
}
    ${SegmentBehaviouralPartsFragmentDoc}
${SegmentCrmPartsFragmentDoc}`;
export const AdGroupBudgetPlanPartsFragmentDoc = gql`
    fragment AdGroupBudgetPlanParts on AdGroupBudgetPlan {
  id
  adGroupId
  plannedDate
  dailyBudget
  dailyBudgetType
  budgetCapping
  budgetCappingType
  costValue
  costType
  changeDailyBudget
  changeBudgetCapping
  changeCost
  changeDates
  processed
  startDate
  endDate
}
    `;
export const DirectoryPresetWebsitePartsFragmentDoc = gql`
    fragment DirectoryPresetWebsiteParts on WebsiteDirectory {
  id
  name
  url
  iabCategory
  reseller {
    id
    name
  }
  positions {
    id
    name
    channelType
    iabCategory
    isEnabled
  }
}
    `;
export const AdGroupDirectoryPresetPartsFragmentDoc = gql`
    fragment AdGroupDirectoryPresetParts on AdGroupDirectoryPreset {
  id
  name
  description
  websites {
    ...DirectoryPresetWebsiteParts
  }
}
    ${DirectoryPresetWebsitePartsFragmentDoc}`;
export const AdTemplateBannerPartsFragmentDoc = gql`
    fragment AdTemplateBannerParts on AdTemplateBanner {
  id
  name
  status
  width
  height
  format
}
    `;
export const AdTemplateNativePartsFragmentDoc = gql`
    fragment AdTemplateNativeParts on AdTemplateNative {
  id
  name
  status
  isDefault
  format
}
    `;
export const AdTemplateWebPartsFragmentDoc = gql`
    fragment AdTemplateWebParts on AdTemplateWeb {
  id
  name
  status
  masterTemplate
  zoneTemplate
  css
  js
  cssSelector
  cssSelectorPosition
  format
}
    `;
export const AdTemplateNativeImageDescriptorPartsFragmentDoc = gql`
    fragment AdTemplateNativeImageDescriptorParts on AdTemplateNative {
  id
  template {
    canvas {
      width
      height
      backgroundColor
      backgroundImageUrl
    }
    elements {
      ... on Line {
        type
        top
        left
        color
      }
      ... on Rectangle {
        type
        top
        left
        border {
          width
          color
          radius
        }
        backgroundColor
        width
        height
      }
      ... on Triangle {
        type
        top
        left
        border {
          width
          color
        }
        backgroundColor
        width
        height
      }
      ... on Ellipse {
        type
        top
        left
        border {
          width
          color
        }
        backgroundColor
      }
      ... on Circle {
        type
        top
        left
        radius
        border {
          width
          color
        }
        backgroundColor
      }
      ... on Image {
        type
        top
        left
        width
        height
      }
      ... on RichText {
        type
        top
        left
        text
        font {
          family
          size
          color
          backgroundColor
          italic
          bold
          underline
          uppercase
        }
        border {
          width
          color
        }
        backgroundColor
        horizontalAlign
        verticalAlign
        overrides {
          characterIndex
          family
          size
          color
          backgroundColor
          italic
          bold
          underline
          uppercase
        }
        width
        height
      }
    }
  }
  mobileTemplate {
    canvas {
      width
      height
      backgroundColor
      backgroundImageUrl
    }
    elements {
      ... on Line {
        type
        top
        left
        color
      }
      ... on Rectangle {
        type
        top
        left
        border {
          width
          color
          radius
        }
        backgroundColor
        width
        height
      }
      ... on Triangle {
        type
        top
        left
        border {
          width
          color
        }
        backgroundColor
        width
        height
      }
      ... on Ellipse {
        type
        top
        left
        border {
          width
          color
        }
        backgroundColor
      }
      ... on Circle {
        type
        top
        left
        radius
        border {
          width
          color
        }
        backgroundColor
      }
      ... on Image {
        type
        top
        left
        width
        height
      }
      ... on RichText {
        type
        top
        left
        text
        font {
          family
          size
          color
          backgroundColor
          italic
          bold
          underline
          uppercase
        }
        border {
          width
          color
        }
        backgroundColor
        horizontalAlign
        verticalAlign
        overrides {
          characterIndex
          family
          size
          color
          backgroundColor
          italic
          bold
          underline
          uppercase
        }
        width
        height
      }
    }
  }
}
    `;
export const AdvertiserInvoicePartsFragmentDoc = gql`
    fragment AdvertiserInvoiceParts on InvoiceAdvertiser {
  reference
  date
  period
  status
  advertiserName
  advertiserId
  agencyName
  agencyId
  resellerName
  resellerId
  amount
  comment
  tax {
    amount
    percentage
  }
  total
  createdAt
  updatedAt
  items {
    ... on InvoiceAdjustmentItem {
      description
      total
      createdAt
      updatedAt
    }
    ... on InvoiceAdvertiserItem {
      campaignName
      campaignId
      adGroupName
      adGroupId
      total
      impressions
      clicks
      leads
      orders
      market {
        language {
          code
        }
        country {
          code
        }
      }
      network
      createdAt
      updatedAt
    }
  }
  advertiser {
    slug
  }
}
    `;
export const AssistantRuleSystemFieldsFragmentDoc = gql`
    fragment AssistantRuleSystemFields on AssistantRuleSystem {
  id
  key
  name
  description
  entity
  isActive
  executionOrder
  importance
  config
}
    `;
export const AssistantRuleUserFieldsFragmentDoc = gql`
    fragment AssistantRuleUserFields on AssistantRuleUser {
  id
  name
  description
  entity
  isActive
  executionOrder
  importance
  conditions {
    all {
      scope
      field
      operator
      value
      params
      compareField {
        scope
        field
        params
      }
    }
    any {
      scope
      field
      operator
      value
      params
      compareField {
        scope
        field
        params
      }
    }
  }
  recommendedChanges {
    message
    all {
      scope
      field
      action
      value
      message
    }
    any {
      scope
      field
      action
      value
      message
    }
  }
  createdAt
  updatedAt
}
    `;
export const CampaignPartsFragmentDoc = gql`
    fragment CampaignParts on Campaign {
  id
  leadEvent
  orderEvent
  name
  iabCategory
  shortCode
  status
  advertiserDomainName
  conversionClickAge
  segments {
    ... on SegmentBehavioural {
      ...SegmentBehaviouralParts
    }
    ... on SegmentCrm {
      ...SegmentCrmParts
    }
  }
  market {
    country {
      code
      label
    }
    id
  }
}
    ${SegmentBehaviouralPartsFragmentDoc}
${SegmentCrmPartsFragmentDoc}`;
export const UserPermissionPartsFragmentDoc = gql`
    fragment UserPermissionParts on UserPermission {
  companyType
  read
  edit
  admin
  superAdmin
  api
  adgroupCpm
  adgroupCpl
  adgroupExclusions
  adgroupCustomcpcs
  adgroupReportwebsites
  adgroupUsertargeting
  adgroupGeotargeting
  adgroupDevicetargeting
  adgroupTimetargeting
  adgroupSegments
  adgroupAutoSegments
  adgroupPriority
  adgroupBudgetCapping
  adgroupMonthlyBudgetCapping
  adgroupOverallBudgetCapping
  adgroupOpenBudgetCapping
  adgroupOpenDailyBudget
  adgroupDatesRequired
  adCopyValidation
  adCopyDates
  assistant
  aiAssistant
  costHistory
  costRecommendation
  advertiserDirectoryPresets
  publisherBlacklistPresets
  positionAdvancedsettings
  websiteExclusions
  web
  banner
}
    `;
export const CompanyPartsFragmentDoc = gql`
    fragment CompanyParts on Company {
  id
  resellerId
  agencyId
  country {
    code
    label
  }
  accountManagerId
  salesManagerId
  slug
  type
  name
  genericName
  addressLine1
  zipCode
  city
  phone
  fax
  website
  vatId
  accountingId
  bankName
  iban
  swift
  taxId
  registrationId
  paymentTerm
  contactEmail
  currency
  invoiceLanguage
  invoicingCompany
  status
  rootDomain
  userPermissions {
    ...UserPermissionParts
  }
  kpis
}
    ${UserPermissionPartsFragmentDoc}`;
export const CompanyPermissionsFragmentDoc = gql`
    fragment CompanyPermissions on Company {
  id
  permissions {
    api
    adgroupCpm
    adgroupCpl
    adgroupExclusions
    adgroupCustomcpcs
    adgroupReportwebsites
    adgroupUsertargeting
    adgroupGeotargeting
    adgroupDevicetargeting
    adgroupTimetargeting
    adgroupSegments
    adgroupAutoSegments
    adgroupPriority
    adgroupBudgetCapping
    adgroupMonthlyBudgetCapping
    adgroupOverallBudgetCapping
    adgroupOpenBudgetCapping
    adgroupOpenDailyBudget
    adgroupDatesRequired
    adCopyDates
    positionAdvancedsettings
    websiteExclusions
    banner
    web
    editable
  }
}
    `;
export const CompanyWebhookPartsFragmentDoc = gql`
    fragment CompanyWebhookParts on CompanyWebhook {
  id
  companyId
  types
  url
}
    `;
export const ArchiverConfigPartsFragmentDoc = gql`
    fragment ArchiverConfigParts on ArchiverConfig {
  adcopyMonths
  adgroupMonths
  adtemplateMonths
  positionMonths
}
    `;
export const InventoryPartsFragmentDoc = gql`
    fragment InventoryParts on Inventory {
  id
  name
  format
  status
  network
  contentStrategy
  channelWeb
  channelEmail
  startDate
  endDate
  dspId
  dealId
  campaign {
    id
    name
    status
  }
}
    `;
export const PositionCustomDomainPartsFragmentDoc = gql`
    fragment PositionCustomDomainParts on PositionCustomDomain {
  domain
  sslStatus
  failureReason
  createdAt
  updatedAt
}
    `;
export const PositionPartsFragmentDoc = gql`
    fragment PositionParts on Position {
  acceptEditorial
  acceptPromotional
  demandSources {
    name
    seat
    dsp
    isEnabled
  }
  channelType
  cpmFloor
  customDomain {
    ...PositionCustomDomainParts
  }
  dealId
  iabCategory
  id
  name
  nbZone
  network
  passbackImage
  passbackJs
  passbackLink
  positionType
  revenueShare
  shortCode
  sspId
  status
  subchannelType
  website {
    id
  }
}
    ${PositionCustomDomainPartsFragmentDoc}`;
export const ZoneFragmentFragmentDoc = gql`
    fragment ZoneFragment on PositionZone {
  zone
  templates {
    banners {
      id
      name
      status
      format
      height
      width
    }
    natives {
      format
      height
      id
      status
      isDefault
      name
      width
    }
  }
}
    `;
export const AdGroupAdProductTierAdGroupPartsFragmentDoc = gql`
    fragment AdGroupAdProductTierAdGroupParts on AdGroup {
  id
  name
  campaign {
    name
    advertiser {
      slug
      name
    }
  }
}
    `;
export const AdGroupAdProductTierBreakdownPartsFragmentDoc = gql`
    fragment AdGroupAdProductTierBreakdownParts on AdGroupAdProductTierBreakdown {
  name
  stats {
    ...AdvertiserPerformanceStatsParts
  }
}
    ${AdvertiserPerformanceStatsPartsFragmentDoc}`;
export const AdGroupAdProductTierAgeRangeBreakdownPartsFragmentDoc = gql`
    fragment AdGroupAdProductTierAgeRangeBreakdownParts on AdGroupAdProductTierAgeRangeBreakdown {
  name
  stats {
    ...AdvertiserPerformanceStatsParts
  }
  genders {
    ...AdGroupAdProductTierBreakdownParts
  }
}
    ${AdvertiserPerformanceStatsPartsFragmentDoc}
${AdGroupAdProductTierBreakdownPartsFragmentDoc}`;
export const AdGroupAdProductTierWebsiteBreakdownPartsFragmentDoc = gql`
    fragment AdGroupAdProductTierWebsiteBreakdownParts on AdGroupAdProductTierWebsiteBreakdown {
  website {
    id
    name
    url
    iabCategory
  }
  stats {
    ...AdvertiserPerformanceStatsParts
  }
}
    ${AdvertiserPerformanceStatsPartsFragmentDoc}`;
export const ProgrammaticCampaignPartsFragmentDoc = gql`
    fragment ProgrammaticCampaignParts on CampaignProgrammatic {
  id
  marketId
  name
  status
  companyId
  dsp
  open
}
    `;
export const PublisherInvoicePartsFragmentDoc = gql`
    fragment PublisherInvoiceParts on InvoicePublisher {
  reference
  date
  period
  dueDate
  status
  publisherName
  resellerName
  amount
  comment
  tax {
    amount
    percentage
  }
  total
  paid {
    amount
    date
  }
  createdAt
  updatedAt
  items {
    ... on InvoiceAdjustmentItem {
      description
      total
      createdAt
      updatedAt
    }
    ... on InvoicePublisherItem {
      websiteName
      total
      createdAt
      updatedAt
    }
  }
  publisher {
    addressLine1
    zipCode
    city
    country {
      label
    }
    vatId
    paymentTerm
  }
}
    `;
export const PublisherPopulationFragmentDoc = gql`
    fragment PublisherPopulation on PublisherPopulation {
  os {
    label
    impressions
    clicks
    conversions
    revenues
  }
  deviceType {
    label
    impressions
    clicks
    conversions
    revenues
  }
  ageRange {
    label
    impressions
    clicks
    conversions
    revenues
  }
  gender {
    label
    impressions
    clicks
    conversions
    revenues
  }
}
    `;
export const ExclusionPresetSummaryFragmentDoc = gql`
    fragment ExclusionPresetSummary on PublisherExclusionPreset {
  id
  name
  description
  createdAt
}
    `;
export const ExclusionPresetAvailableSummaryFragmentDoc = gql`
    fragment ExclusionPresetAvailableSummary on PublisherExclusionPreset {
  ...ExclusionPresetSummary
  owner {
    id
    name
  }
}
    ${ExclusionPresetSummaryFragmentDoc}`;
export const ExclusionPresetWithExclusionsFragmentDoc = gql`
    fragment ExclusionPresetWithExclusions on PublisherExclusionPreset {
  ...ExclusionPresetSummary
  excludedCompanies {
    id
    name
  }
  excludedCampaigns {
    id
    name
    iabCategory
    advertiserDomainName
  }
  excludedIABCategories
}
    ${ExclusionPresetSummaryFragmentDoc}`;
export const DomainExclusionItemPartsFragmentDoc = gql`
    fragment DomainExclusionItemParts on DomainExclusionItem {
  domain
  createdAt
}
    `;
export const IabExclusionItemPartsFragmentDoc = gql`
    fragment IabExclusionItemParts on IabExclusionItem {
  iabCategory
  createdAt
}
    `;
export const CampaignExclusionItemPartsFragmentDoc = gql`
    fragment CampaignExclusionItemParts on CampaignExclusionItem {
  campaign {
    id
    name
    iabCategory
    advertiserDomainName
  }
  createdAt
}
    `;
export const AdvertiserExclusionItemPartsFragmentDoc = gql`
    fragment AdvertiserExclusionItemParts on AdvertiserExclusionItem {
  advertiser {
    id
    name
  }
  createdAt
}
    `;
export const SentEmailPartsFragmentDoc = gql`
    fragment SentEmailParts on SentEmail {
  id
  recipientEmail
  subject
  type
  invoiceId
  received
  mailjetStatus
  emailDoesNotExist
  errorMessage
  checkedAt
  createdAt
  updatedAt
}
    `;
export const PublisherPerformanceStatsPartsFragmentDoc = gql`
    fragment PublisherPerformanceStatsParts on PublisherCostDetails {
  displays
  impressions
  clicks
  commissions
  ctr
  cpc
  cpm
  rpm
  leads
}
    `;
export const PublisherTimeseriesFragmentDoc = gql`
    fragment PublisherTimeseries on PublisherTimeseriesTotal {
  timeseries {
    date
    stats {
      ...PublisherPerformanceStatsParts
    }
  }
  stats {
    ...PublisherPerformanceStatsParts
  }
}
    ${PublisherPerformanceStatsPartsFragmentDoc}`;
export const AdvertiserTimeseriesFragmentDoc = gql`
    fragment AdvertiserTimeseries on AdvertiserTimeseriesTotal {
  timeseries {
    date
    stats {
      ...AdvertiserPerformanceStatsParts
    }
  }
  stats {
    ...AdvertiserPerformanceStatsParts
  }
}
    ${AdvertiserPerformanceStatsPartsFragmentDoc}`;
export const AdvertiserPerformanceStatsFullPartsFragmentDoc = gql`
    fragment AdvertiserPerformanceStatsFullParts on AdvertiserCostDetails {
  ...AdvertiserPerformanceStatsParts
  pageViews
  sessions
  engagedSessions
  totalUsers
  newUsers
  bounceRate
  engagementRate
  sessionTimeSeconds
  cpv
}
    ${AdvertiserPerformanceStatsPartsFragmentDoc}`;
export const AdvertiserTimeseriesFullFragmentDoc = gql`
    fragment AdvertiserTimeseriesFull on AdvertiserTimeseriesTotal {
  timeseries {
    date
    stats {
      ...AdvertiserPerformanceStatsFullParts
    }
  }
  stats {
    ...AdvertiserPerformanceStatsFullParts
  }
}
    ${AdvertiserPerformanceStatsFullPartsFragmentDoc}`;
export const TradingDeskPartsFragmentDoc = gql`
    fragment TradingDeskParts on TradingDesk {
  id
  resellerId
  accountManagerId
  salesManagerId
  agencyId
  slug
  type
  name
  genericName
  addressLine1
  zipCode
  city
  phone
  fax
  website
  vatId
  accountingId
  bankName
  iban
  swift
  taxId
  registrationId
  paymentTerm
  contactEmail
  currency
  invoiceLanguage
  invoicingCompany
  status
  rootDomain
  kpis
  seats {
    dsp
    seat
  }
  campaigns {
    id
    name
    inventory {
      id
      name
      format
      status
      network
      contentStrategy
      channelWeb
      channelEmail
      startDate
      endDate
      dspId
      dealId
    }
  }
}
    `;
export const UserPartsFragmentDoc = gql`
    fragment UserParts on User {
  id
  firstName
  lastName
  email
  title
  status
  mobile
  language
  isPrimaryContact
  market {
    language {
      code
    }
    country {
      code
    }
  }
  role
  company {
    resellerId
    agencyId
    approvedTerms {
      version
    }
    id
    name
    type
    slug
    style {
      primaryColor
      secondaryColor
      logoUrl
    }
    userPermissions {
      ...UserPermissionParts
    }
  }
}
    ${UserPermissionPartsFragmentDoc}`;
export const WebsiteBasicPartsFragmentDoc = gql`
    fragment WebsiteBasicParts on Website {
  id
  url
  name
  iabCategory
  status
  publisher {
    id
    slug
  }
  market {
    id
  }
}
    `;
export const WebsitePartsFragmentDoc = gql`
    fragment WebsiteParts on Website {
  ...WebsiteBasicParts
  publisher {
    id
    slug
    reseller {
      id
      name
    }
  }
  positions {
    id
    name
    channelType
  }
}
    ${WebsiteBasicPartsFragmentDoc}`;
export const AccountTimeseriesDocument = gql`
    query accountTimeseries($endDate: DateTime!, $startDate: DateTime!, $accountId: PwsID!, $granularity: GraphGranularity!) {
  account(id: $accountId) {
    id
    timeseries(granularity: $granularity, endDate: $endDate, startDate: $startDate) {
      ...AdvertiserTimeseries
    }
  }
}
    ${AdvertiserTimeseriesFragmentDoc}`;

/**
 * __useAccountTimeseriesQuery__
 *
 * To run a query within a React component, call `useAccountTimeseriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountTimeseriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountTimeseriesQuery({
 *   variables: {
 *      endDate: // value for 'endDate'
 *      startDate: // value for 'startDate'
 *      accountId: // value for 'accountId'
 *      granularity: // value for 'granularity'
 *   },
 * });
 */
export function useAccountTimeseriesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AccountTimeseriesQuery, AccountTimeseriesQueryVariables> & ({ variables: AccountTimeseriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AccountTimeseriesQuery, AccountTimeseriesQueryVariables>(AccountTimeseriesDocument, options);
      }
export function useAccountTimeseriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccountTimeseriesQuery, AccountTimeseriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AccountTimeseriesQuery, AccountTimeseriesQueryVariables>(AccountTimeseriesDocument, options);
        }
// @ts-ignore
export function useAccountTimeseriesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AccountTimeseriesQuery, AccountTimeseriesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AccountTimeseriesQuery, AccountTimeseriesQueryVariables>;
export function useAccountTimeseriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AccountTimeseriesQuery, AccountTimeseriesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AccountTimeseriesQuery | undefined, AccountTimeseriesQueryVariables>;
export function useAccountTimeseriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AccountTimeseriesQuery, AccountTimeseriesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AccountTimeseriesQuery, AccountTimeseriesQueryVariables>(AccountTimeseriesDocument, options);
        }
export type AccountTimeseriesQueryHookResult = ReturnType<typeof useAccountTimeseriesQuery>;
export type AccountTimeseriesLazyQueryHookResult = ReturnType<typeof useAccountTimeseriesLazyQuery>;
export type AccountTimeseriesSuspenseQueryHookResult = ReturnType<typeof useAccountTimeseriesSuspenseQuery>;
export type AccountTimeseriesQueryResult = ApolloReactCommon.QueryResult<AccountTimeseriesQuery, AccountTimeseriesQueryVariables>;
export const AdGroupsFromAccountDocument = gql`
    query adGroupsFromAccount($id: PwsID!, $endDate: DateTime!, $startDate: DateTime!) {
  account(id: $id) {
    id
    reseller {
      id
      advertiserPerformanceStats(endDate: $endDate, startDate: $startDate) {
        stats {
          cpm
        }
      }
    }
    advertisers {
      ...AccountAdvertiserParts
    }
  }
}
    ${AccountAdvertiserPartsFragmentDoc}`;

/**
 * __useAdGroupsFromAccountQuery__
 *
 * To run a query within a React component, call `useAdGroupsFromAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdGroupsFromAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdGroupsFromAccountQuery({
 *   variables: {
 *      id: // value for 'id'
 *      endDate: // value for 'endDate'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useAdGroupsFromAccountQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdGroupsFromAccountQuery, AdGroupsFromAccountQueryVariables> & ({ variables: AdGroupsFromAccountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdGroupsFromAccountQuery, AdGroupsFromAccountQueryVariables>(AdGroupsFromAccountDocument, options);
      }
export function useAdGroupsFromAccountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdGroupsFromAccountQuery, AdGroupsFromAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdGroupsFromAccountQuery, AdGroupsFromAccountQueryVariables>(AdGroupsFromAccountDocument, options);
        }
// @ts-ignore
export function useAdGroupsFromAccountSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdGroupsFromAccountQuery, AdGroupsFromAccountQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdGroupsFromAccountQuery, AdGroupsFromAccountQueryVariables>;
export function useAdGroupsFromAccountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdGroupsFromAccountQuery, AdGroupsFromAccountQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdGroupsFromAccountQuery | undefined, AdGroupsFromAccountQueryVariables>;
export function useAdGroupsFromAccountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdGroupsFromAccountQuery, AdGroupsFromAccountQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdGroupsFromAccountQuery, AdGroupsFromAccountQueryVariables>(AdGroupsFromAccountDocument, options);
        }
export type AdGroupsFromAccountQueryHookResult = ReturnType<typeof useAdGroupsFromAccountQuery>;
export type AdGroupsFromAccountLazyQueryHookResult = ReturnType<typeof useAdGroupsFromAccountLazyQuery>;
export type AdGroupsFromAccountSuspenseQueryHookResult = ReturnType<typeof useAdGroupsFromAccountSuspenseQuery>;
export type AdGroupsFromAccountQueryResult = ApolloReactCommon.QueryResult<AdGroupsFromAccountQuery, AdGroupsFromAccountQueryVariables>;
export const ActivityFeedDocument = gql`
    query activityFeed($companyId: PwsID, $pagination: Pagination, $userId: PwsID, $entityType: EntityType, $origin: [ActivityFeedOrigin!]) {
  searchActivityFeedGrouped(
    companyId: $companyId
    userId: $userId
    entityType: $entityType
    origin: $origin
    pagination: $pagination
  ) {
    ...ActivityFeedGroupParts
  }
}
    ${ActivityFeedGroupPartsFragmentDoc}`;

/**
 * __useActivityFeedQuery__
 *
 * To run a query within a React component, call `useActivityFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityFeedQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      pagination: // value for 'pagination'
 *      userId: // value for 'userId'
 *      entityType: // value for 'entityType'
 *      origin: // value for 'origin'
 *   },
 * });
 */
export function useActivityFeedQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ActivityFeedQuery, ActivityFeedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ActivityFeedQuery, ActivityFeedQueryVariables>(ActivityFeedDocument, options);
      }
export function useActivityFeedLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ActivityFeedQuery, ActivityFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ActivityFeedQuery, ActivityFeedQueryVariables>(ActivityFeedDocument, options);
        }
// @ts-ignore
export function useActivityFeedSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ActivityFeedQuery, ActivityFeedQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ActivityFeedQuery, ActivityFeedQueryVariables>;
export function useActivityFeedSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ActivityFeedQuery, ActivityFeedQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ActivityFeedQuery | undefined, ActivityFeedQueryVariables>;
export function useActivityFeedSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ActivityFeedQuery, ActivityFeedQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ActivityFeedQuery, ActivityFeedQueryVariables>(ActivityFeedDocument, options);
        }
export type ActivityFeedQueryHookResult = ReturnType<typeof useActivityFeedQuery>;
export type ActivityFeedLazyQueryHookResult = ReturnType<typeof useActivityFeedLazyQuery>;
export type ActivityFeedSuspenseQueryHookResult = ReturnType<typeof useActivityFeedSuspenseQuery>;
export type ActivityFeedQueryResult = ApolloReactCommon.QueryResult<ActivityFeedQuery, ActivityFeedQueryVariables>;
export const AdCopyMinSizeDocument = gql`
    query adCopyMinSize($reseller: PwsID!) {
  adCopyMinSize(reseller: $reseller) {
    width
    height
  }
}
    `;

/**
 * __useAdCopyMinSizeQuery__
 *
 * To run a query within a React component, call `useAdCopyMinSizeQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdCopyMinSizeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdCopyMinSizeQuery({
 *   variables: {
 *      reseller: // value for 'reseller'
 *   },
 * });
 */
export function useAdCopyMinSizeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdCopyMinSizeQuery, AdCopyMinSizeQueryVariables> & ({ variables: AdCopyMinSizeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdCopyMinSizeQuery, AdCopyMinSizeQueryVariables>(AdCopyMinSizeDocument, options);
      }
export function useAdCopyMinSizeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdCopyMinSizeQuery, AdCopyMinSizeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdCopyMinSizeQuery, AdCopyMinSizeQueryVariables>(AdCopyMinSizeDocument, options);
        }
// @ts-ignore
export function useAdCopyMinSizeSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdCopyMinSizeQuery, AdCopyMinSizeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdCopyMinSizeQuery, AdCopyMinSizeQueryVariables>;
export function useAdCopyMinSizeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdCopyMinSizeQuery, AdCopyMinSizeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdCopyMinSizeQuery | undefined, AdCopyMinSizeQueryVariables>;
export function useAdCopyMinSizeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdCopyMinSizeQuery, AdCopyMinSizeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdCopyMinSizeQuery, AdCopyMinSizeQueryVariables>(AdCopyMinSizeDocument, options);
        }
export type AdCopyMinSizeQueryHookResult = ReturnType<typeof useAdCopyMinSizeQuery>;
export type AdCopyMinSizeLazyQueryHookResult = ReturnType<typeof useAdCopyMinSizeLazyQuery>;
export type AdCopyMinSizeSuspenseQueryHookResult = ReturnType<typeof useAdCopyMinSizeSuspenseQuery>;
export type AdCopyMinSizeQueryResult = ApolloReactCommon.QueryResult<AdCopyMinSizeQuery, AdCopyMinSizeQueryVariables>;
export const AdTestDocument = gql`
    query adTest($pagination: Pagination!, $searchQuery: PositionSearchQuery!) {
  searchPositions(pagination: $pagination, searchQuery: $searchQuery) {
    id
    name
    shortCode
    nbZone
    channelType
    website {
      name
      publisher {
        name
        slug
      }
    }
    status
  }
}
    `;

/**
 * __useAdTestQuery__
 *
 * To run a query within a React component, call `useAdTestQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdTestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdTestQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function useAdTestQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdTestQuery, AdTestQueryVariables> & ({ variables: AdTestQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdTestQuery, AdTestQueryVariables>(AdTestDocument, options);
      }
export function useAdTestLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdTestQuery, AdTestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdTestQuery, AdTestQueryVariables>(AdTestDocument, options);
        }
// @ts-ignore
export function useAdTestSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdTestQuery, AdTestQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdTestQuery, AdTestQueryVariables>;
export function useAdTestSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdTestQuery, AdTestQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdTestQuery | undefined, AdTestQueryVariables>;
export function useAdTestSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdTestQuery, AdTestQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdTestQuery, AdTestQueryVariables>(AdTestDocument, options);
        }
export type AdTestQueryHookResult = ReturnType<typeof useAdTestQuery>;
export type AdTestLazyQueryHookResult = ReturnType<typeof useAdTestLazyQuery>;
export type AdTestSuspenseQueryHookResult = ReturnType<typeof useAdTestSuspenseQuery>;
export type AdTestQueryResult = ApolloReactCommon.QueryResult<AdTestQuery, AdTestQueryVariables>;
export const SearchAdCopiesDocument = gql`
    query searchAdCopies($pagination: Pagination!, $searchQuery: AdCopySearchQuery!) {
  searchAdCopies(pagination: $pagination, searchQuery: $searchQuery) {
    ...AdcopyParts
    adGroup {
      id
      name
      network
      campaign {
        id
        name
        advertiser {
          slug
          genericName
        }
      }
    }
  }
}
    ${AdcopyPartsFragmentDoc}`;

/**
 * __useSearchAdCopiesQuery__
 *
 * To run a query within a React component, call `useSearchAdCopiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchAdCopiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchAdCopiesQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function useSearchAdCopiesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchAdCopiesQuery, SearchAdCopiesQueryVariables> & ({ variables: SearchAdCopiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchAdCopiesQuery, SearchAdCopiesQueryVariables>(SearchAdCopiesDocument, options);
      }
export function useSearchAdCopiesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchAdCopiesQuery, SearchAdCopiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchAdCopiesQuery, SearchAdCopiesQueryVariables>(SearchAdCopiesDocument, options);
        }
// @ts-ignore
export function useSearchAdCopiesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SearchAdCopiesQuery, SearchAdCopiesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SearchAdCopiesQuery, SearchAdCopiesQueryVariables>;
export function useSearchAdCopiesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchAdCopiesQuery, SearchAdCopiesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SearchAdCopiesQuery | undefined, SearchAdCopiesQueryVariables>;
export function useSearchAdCopiesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchAdCopiesQuery, SearchAdCopiesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SearchAdCopiesQuery, SearchAdCopiesQueryVariables>(SearchAdCopiesDocument, options);
        }
export type SearchAdCopiesQueryHookResult = ReturnType<typeof useSearchAdCopiesQuery>;
export type SearchAdCopiesLazyQueryHookResult = ReturnType<typeof useSearchAdCopiesLazyQuery>;
export type SearchAdCopiesSuspenseQueryHookResult = ReturnType<typeof useSearchAdCopiesSuspenseQuery>;
export type SearchAdCopiesQueryResult = ApolloReactCommon.QueryResult<SearchAdCopiesQuery, SearchAdCopiesQueryVariables>;
export const AdgroupAdCopiesDocument = gql`
    query adgroupAdCopies($adGroupId: PwsID!, $pagination: Pagination!, $status: [AdCopyStatus!]) {
  adGroup(id: $adGroupId) {
    adCopies(pagination: $pagination, status: $status) {
      ...AdcopyParts
    }
  }
}
    ${AdcopyPartsFragmentDoc}`;

/**
 * __useAdgroupAdCopiesQuery__
 *
 * To run a query within a React component, call `useAdgroupAdCopiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdgroupAdCopiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdgroupAdCopiesQuery({
 *   variables: {
 *      adGroupId: // value for 'adGroupId'
 *      pagination: // value for 'pagination'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useAdgroupAdCopiesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdgroupAdCopiesQuery, AdgroupAdCopiesQueryVariables> & ({ variables: AdgroupAdCopiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdgroupAdCopiesQuery, AdgroupAdCopiesQueryVariables>(AdgroupAdCopiesDocument, options);
      }
export function useAdgroupAdCopiesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdgroupAdCopiesQuery, AdgroupAdCopiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdgroupAdCopiesQuery, AdgroupAdCopiesQueryVariables>(AdgroupAdCopiesDocument, options);
        }
// @ts-ignore
export function useAdgroupAdCopiesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdgroupAdCopiesQuery, AdgroupAdCopiesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdgroupAdCopiesQuery, AdgroupAdCopiesQueryVariables>;
export function useAdgroupAdCopiesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdgroupAdCopiesQuery, AdgroupAdCopiesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdgroupAdCopiesQuery | undefined, AdgroupAdCopiesQueryVariables>;
export function useAdgroupAdCopiesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdgroupAdCopiesQuery, AdgroupAdCopiesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdgroupAdCopiesQuery, AdgroupAdCopiesQueryVariables>(AdgroupAdCopiesDocument, options);
        }
export type AdgroupAdCopiesQueryHookResult = ReturnType<typeof useAdgroupAdCopiesQuery>;
export type AdgroupAdCopiesLazyQueryHookResult = ReturnType<typeof useAdgroupAdCopiesLazyQuery>;
export type AdgroupAdCopiesSuspenseQueryHookResult = ReturnType<typeof useAdgroupAdCopiesSuspenseQuery>;
export type AdgroupAdCopiesQueryResult = ApolloReactCommon.QueryResult<AdgroupAdCopiesQuery, AdgroupAdCopiesQueryVariables>;
export const AdCopyDocument = gql`
    query adCopy($id: PwsID!) {
  adCopy(id: $id) {
    ...AdcopyParts
  }
}
    ${AdcopyPartsFragmentDoc}`;

/**
 * __useAdCopyQuery__
 *
 * To run a query within a React component, call `useAdCopyQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdCopyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdCopyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdCopyQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdCopyQuery, AdCopyQueryVariables> & ({ variables: AdCopyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdCopyQuery, AdCopyQueryVariables>(AdCopyDocument, options);
      }
export function useAdCopyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdCopyQuery, AdCopyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdCopyQuery, AdCopyQueryVariables>(AdCopyDocument, options);
        }
// @ts-ignore
export function useAdCopySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdCopyQuery, AdCopyQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdCopyQuery, AdCopyQueryVariables>;
export function useAdCopySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdCopyQuery, AdCopyQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdCopyQuery | undefined, AdCopyQueryVariables>;
export function useAdCopySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdCopyQuery, AdCopyQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdCopyQuery, AdCopyQueryVariables>(AdCopyDocument, options);
        }
export type AdCopyQueryHookResult = ReturnType<typeof useAdCopyQuery>;
export type AdCopyLazyQueryHookResult = ReturnType<typeof useAdCopyLazyQuery>;
export type AdCopySuspenseQueryHookResult = ReturnType<typeof useAdCopySuspenseQuery>;
export type AdCopyQueryResult = ApolloReactCommon.QueryResult<AdCopyQuery, AdCopyQueryVariables>;
export const UpdateAdCopyDocument = gql`
    mutation updateAdCopy($adCopy: AdCopyInput!, $file: Upload) {
  updateAdCopy(adCopy: $adCopy, file: $file) {
    ...AdcopyParts
  }
}
    ${AdcopyPartsFragmentDoc}`;
export type UpdateAdCopyMutationFn = ApolloReactCommon.MutationFunction<UpdateAdCopyMutation, UpdateAdCopyMutationVariables>;

/**
 * __useUpdateAdCopyMutation__
 *
 * To run a mutation, you first call `useUpdateAdCopyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdCopyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdCopyMutation, { data, loading, error }] = useUpdateAdCopyMutation({
 *   variables: {
 *      adCopy: // value for 'adCopy'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUpdateAdCopyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAdCopyMutation, UpdateAdCopyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateAdCopyMutation, UpdateAdCopyMutationVariables>(UpdateAdCopyDocument, options);
      }
export type UpdateAdCopyMutationHookResult = ReturnType<typeof useUpdateAdCopyMutation>;
export type UpdateAdCopyMutationResult = ApolloReactCommon.MutationResult<UpdateAdCopyMutation>;
export type UpdateAdCopyMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateAdCopyMutation, UpdateAdCopyMutationVariables>;
export const UpdateAdCopyStatusDocument = gql`
    mutation updateAdCopyStatus($adCopyId: PwsID!, $status: AdCopyStatus!, $rejectedReason: String) {
  updateAdCopyStatus(
    adCopyId: $adCopyId
    status: $status
    rejectedReason: $rejectedReason
  ) {
    ...AdcopyParts
  }
}
    ${AdcopyPartsFragmentDoc}`;
export type UpdateAdCopyStatusMutationFn = ApolloReactCommon.MutationFunction<UpdateAdCopyStatusMutation, UpdateAdCopyStatusMutationVariables>;

/**
 * __useUpdateAdCopyStatusMutation__
 *
 * To run a mutation, you first call `useUpdateAdCopyStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdCopyStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdCopyStatusMutation, { data, loading, error }] = useUpdateAdCopyStatusMutation({
 *   variables: {
 *      adCopyId: // value for 'adCopyId'
 *      status: // value for 'status'
 *      rejectedReason: // value for 'rejectedReason'
 *   },
 * });
 */
export function useUpdateAdCopyStatusMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAdCopyStatusMutation, UpdateAdCopyStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateAdCopyStatusMutation, UpdateAdCopyStatusMutationVariables>(UpdateAdCopyStatusDocument, options);
      }
export type UpdateAdCopyStatusMutationHookResult = ReturnType<typeof useUpdateAdCopyStatusMutation>;
export type UpdateAdCopyStatusMutationResult = ApolloReactCommon.MutationResult<UpdateAdCopyStatusMutation>;
export type UpdateAdCopyStatusMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateAdCopyStatusMutation, UpdateAdCopyStatusMutationVariables>;
export const DuplicateAdCopyDocument = gql`
    mutation duplicateAdCopy($id: PwsID!, $override: AdCopyDuplicateInput!, $file: Upload) {
  duplicateAdCopy(id: $id, override: $override, file: $file) {
    ...AdcopyParts
  }
}
    ${AdcopyPartsFragmentDoc}`;
export type DuplicateAdCopyMutationFn = ApolloReactCommon.MutationFunction<DuplicateAdCopyMutation, DuplicateAdCopyMutationVariables>;

/**
 * __useDuplicateAdCopyMutation__
 *
 * To run a mutation, you first call `useDuplicateAdCopyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateAdCopyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateAdCopyMutation, { data, loading, error }] = useDuplicateAdCopyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      override: // value for 'override'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useDuplicateAdCopyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DuplicateAdCopyMutation, DuplicateAdCopyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DuplicateAdCopyMutation, DuplicateAdCopyMutationVariables>(DuplicateAdCopyDocument, options);
      }
export type DuplicateAdCopyMutationHookResult = ReturnType<typeof useDuplicateAdCopyMutation>;
export type DuplicateAdCopyMutationResult = ApolloReactCommon.MutationResult<DuplicateAdCopyMutation>;
export type DuplicateAdCopyMutationOptions = ApolloReactCommon.BaseMutationOptions<DuplicateAdCopyMutation, DuplicateAdCopyMutationVariables>;
export const CreateAdCopiesDocument = gql`
    mutation createAdCopies($newAdCopies: [AdCopyCreateInput!]!, $images: [Upload!], $adGroupId: PwsID!) {
  createAdCopies(
    newAdCopies: $newAdCopies
    images: $images
    adGroupId: $adGroupId
  ) {
    success {
      ...AdcopyParts
    }
    errors
  }
}
    ${AdcopyPartsFragmentDoc}`;
export type CreateAdCopiesMutationFn = ApolloReactCommon.MutationFunction<CreateAdCopiesMutation, CreateAdCopiesMutationVariables>;

/**
 * __useCreateAdCopiesMutation__
 *
 * To run a mutation, you first call `useCreateAdCopiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdCopiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdCopiesMutation, { data, loading, error }] = useCreateAdCopiesMutation({
 *   variables: {
 *      newAdCopies: // value for 'newAdCopies'
 *      images: // value for 'images'
 *      adGroupId: // value for 'adGroupId'
 *   },
 * });
 */
export function useCreateAdCopiesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateAdCopiesMutation, CreateAdCopiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateAdCopiesMutation, CreateAdCopiesMutationVariables>(CreateAdCopiesDocument, options);
      }
export type CreateAdCopiesMutationHookResult = ReturnType<typeof useCreateAdCopiesMutation>;
export type CreateAdCopiesMutationResult = ApolloReactCommon.MutationResult<CreateAdCopiesMutation>;
export type CreateAdCopiesMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateAdCopiesMutation, CreateAdCopiesMutationVariables>;
export const AdGroupNameDocument = gql`
    query adGroupName($id: PwsID!) {
  adGroup(id: $id) {
    id
    name
  }
}
    `;

/**
 * __useAdGroupNameQuery__
 *
 * To run a query within a React component, call `useAdGroupNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdGroupNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdGroupNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdGroupNameQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdGroupNameQuery, AdGroupNameQueryVariables> & ({ variables: AdGroupNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdGroupNameQuery, AdGroupNameQueryVariables>(AdGroupNameDocument, options);
      }
export function useAdGroupNameLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdGroupNameQuery, AdGroupNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdGroupNameQuery, AdGroupNameQueryVariables>(AdGroupNameDocument, options);
        }
// @ts-ignore
export function useAdGroupNameSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdGroupNameQuery, AdGroupNameQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdGroupNameQuery, AdGroupNameQueryVariables>;
export function useAdGroupNameSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdGroupNameQuery, AdGroupNameQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdGroupNameQuery | undefined, AdGroupNameQueryVariables>;
export function useAdGroupNameSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdGroupNameQuery, AdGroupNameQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdGroupNameQuery, AdGroupNameQueryVariables>(AdGroupNameDocument, options);
        }
export type AdGroupNameQueryHookResult = ReturnType<typeof useAdGroupNameQuery>;
export type AdGroupNameLazyQueryHookResult = ReturnType<typeof useAdGroupNameLazyQuery>;
export type AdGroupNameSuspenseQueryHookResult = ReturnType<typeof useAdGroupNameSuspenseQuery>;
export type AdGroupNameQueryResult = ApolloReactCommon.QueryResult<AdGroupNameQuery, AdGroupNameQueryVariables>;
export const AdGroupAdvertiserSlugDocument = gql`
    query adGroupAdvertiserSlug($id: PwsID!) {
  adGroup(id: $id) {
    id
    campaign {
      advertiser {
        slug
      }
    }
  }
}
    `;

/**
 * __useAdGroupAdvertiserSlugQuery__
 *
 * To run a query within a React component, call `useAdGroupAdvertiserSlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdGroupAdvertiserSlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdGroupAdvertiserSlugQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdGroupAdvertiserSlugQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdGroupAdvertiserSlugQuery, AdGroupAdvertiserSlugQueryVariables> & ({ variables: AdGroupAdvertiserSlugQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdGroupAdvertiserSlugQuery, AdGroupAdvertiserSlugQueryVariables>(AdGroupAdvertiserSlugDocument, options);
      }
export function useAdGroupAdvertiserSlugLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdGroupAdvertiserSlugQuery, AdGroupAdvertiserSlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdGroupAdvertiserSlugQuery, AdGroupAdvertiserSlugQueryVariables>(AdGroupAdvertiserSlugDocument, options);
        }
// @ts-ignore
export function useAdGroupAdvertiserSlugSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdGroupAdvertiserSlugQuery, AdGroupAdvertiserSlugQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdGroupAdvertiserSlugQuery, AdGroupAdvertiserSlugQueryVariables>;
export function useAdGroupAdvertiserSlugSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdGroupAdvertiserSlugQuery, AdGroupAdvertiserSlugQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdGroupAdvertiserSlugQuery | undefined, AdGroupAdvertiserSlugQueryVariables>;
export function useAdGroupAdvertiserSlugSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdGroupAdvertiserSlugQuery, AdGroupAdvertiserSlugQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdGroupAdvertiserSlugQuery, AdGroupAdvertiserSlugQueryVariables>(AdGroupAdvertiserSlugDocument, options);
        }
export type AdGroupAdvertiserSlugQueryHookResult = ReturnType<typeof useAdGroupAdvertiserSlugQuery>;
export type AdGroupAdvertiserSlugLazyQueryHookResult = ReturnType<typeof useAdGroupAdvertiserSlugLazyQuery>;
export type AdGroupAdvertiserSlugSuspenseQueryHookResult = ReturnType<typeof useAdGroupAdvertiserSlugSuspenseQuery>;
export type AdGroupAdvertiserSlugQueryResult = ApolloReactCommon.QueryResult<AdGroupAdvertiserSlugQuery, AdGroupAdvertiserSlugQueryVariables>;
export const AdgroupsDocument = gql`
    query adgroups($pagination: Pagination!, $searchQuery: AdGroupSearchQuery!) {
  searchAdGroups(pagination: $pagination, searchQuery: $searchQuery) {
    id
    name
    status
    network
    costType
    costValue
    dailyBudget
    dailyBudgetType
    startDate
    endDate
    budgetCapping
    budgetCappingType
    campaign {
      id
      name
      advertiser {
        slug
        genericName
        currency
        reseller {
          genericName
        }
      }
      market {
        language {
          code
        }
        country {
          code
        }
      }
    }
    budget {
      budgetMeasures {
        dayBudget
        daySpent
        monthBudget
        monthSpent
        periodBudget
        periodSpent
        overallBudget
        overallSpent
      }
      budgetStatus {
        monthOverspent
        overallOverspent
      }
      date
    }
  }
}
    `;

/**
 * __useAdgroupsQuery__
 *
 * To run a query within a React component, call `useAdgroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdgroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdgroupsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function useAdgroupsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdgroupsQuery, AdgroupsQueryVariables> & ({ variables: AdgroupsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdgroupsQuery, AdgroupsQueryVariables>(AdgroupsDocument, options);
      }
export function useAdgroupsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdgroupsQuery, AdgroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdgroupsQuery, AdgroupsQueryVariables>(AdgroupsDocument, options);
        }
// @ts-ignore
export function useAdgroupsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdgroupsQuery, AdgroupsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdgroupsQuery, AdgroupsQueryVariables>;
export function useAdgroupsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdgroupsQuery, AdgroupsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdgroupsQuery | undefined, AdgroupsQueryVariables>;
export function useAdgroupsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdgroupsQuery, AdgroupsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdgroupsQuery, AdgroupsQueryVariables>(AdgroupsDocument, options);
        }
export type AdgroupsQueryHookResult = ReturnType<typeof useAdgroupsQuery>;
export type AdgroupsLazyQueryHookResult = ReturnType<typeof useAdgroupsLazyQuery>;
export type AdgroupsSuspenseQueryHookResult = ReturnType<typeof useAdgroupsSuspenseQuery>;
export type AdgroupsQueryResult = ApolloReactCommon.QueryResult<AdgroupsQuery, AdgroupsQueryVariables>;
export const AdgroupSettingsDocument = gql`
    query adgroupSettings($id: PwsID!) {
  adGroup(id: $id) {
    ...AdGroupParts
    priorityId
  }
}
    ${AdGroupPartsFragmentDoc}`;

/**
 * __useAdgroupSettingsQuery__
 *
 * To run a query within a React component, call `useAdgroupSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdgroupSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdgroupSettingsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdgroupSettingsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdgroupSettingsQuery, AdgroupSettingsQueryVariables> & ({ variables: AdgroupSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdgroupSettingsQuery, AdgroupSettingsQueryVariables>(AdgroupSettingsDocument, options);
      }
export function useAdgroupSettingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdgroupSettingsQuery, AdgroupSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdgroupSettingsQuery, AdgroupSettingsQueryVariables>(AdgroupSettingsDocument, options);
        }
// @ts-ignore
export function useAdgroupSettingsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdgroupSettingsQuery, AdgroupSettingsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdgroupSettingsQuery, AdgroupSettingsQueryVariables>;
export function useAdgroupSettingsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdgroupSettingsQuery, AdgroupSettingsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdgroupSettingsQuery | undefined, AdgroupSettingsQueryVariables>;
export function useAdgroupSettingsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdgroupSettingsQuery, AdgroupSettingsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdgroupSettingsQuery, AdgroupSettingsQueryVariables>(AdgroupSettingsDocument, options);
        }
export type AdgroupSettingsQueryHookResult = ReturnType<typeof useAdgroupSettingsQuery>;
export type AdgroupSettingsLazyQueryHookResult = ReturnType<typeof useAdgroupSettingsLazyQuery>;
export type AdgroupSettingsSuspenseQueryHookResult = ReturnType<typeof useAdgroupSettingsSuspenseQuery>;
export type AdgroupSettingsQueryResult = ApolloReactCommon.QueryResult<AdgroupSettingsQuery, AdgroupSettingsQueryVariables>;
export const AdgroupDirectoryDocument = gql`
    query adgroupDirectory($id: PwsID!) {
  adGroup(id: $id) {
    id
    directoryWithPreset {
      directory {
        type
        websites {
          id
          name
          reseller {
            name
            id
          }
          url
          iabCategory
          positions {
            id
            name
            channelType
            iabCategory
            isEnabled
            impressions
            adTemplateSizes {
              zone
              width
              height
            }
          }
        }
      }
      presets {
        id
        name
        description
        company {
          name
        }
        websites {
          id
          name
          reseller {
            name
            id
          }
          url
          iabCategory
          positions {
            id
            name
            channelType
            iabCategory
            isEnabled
            impressions
          }
        }
      }
    }
  }
}
    `;

/**
 * __useAdgroupDirectoryQuery__
 *
 * To run a query within a React component, call `useAdgroupDirectoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdgroupDirectoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdgroupDirectoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdgroupDirectoryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdgroupDirectoryQuery, AdgroupDirectoryQueryVariables> & ({ variables: AdgroupDirectoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdgroupDirectoryQuery, AdgroupDirectoryQueryVariables>(AdgroupDirectoryDocument, options);
      }
export function useAdgroupDirectoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdgroupDirectoryQuery, AdgroupDirectoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdgroupDirectoryQuery, AdgroupDirectoryQueryVariables>(AdgroupDirectoryDocument, options);
        }
// @ts-ignore
export function useAdgroupDirectorySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdgroupDirectoryQuery, AdgroupDirectoryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdgroupDirectoryQuery, AdgroupDirectoryQueryVariables>;
export function useAdgroupDirectorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdgroupDirectoryQuery, AdgroupDirectoryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdgroupDirectoryQuery | undefined, AdgroupDirectoryQueryVariables>;
export function useAdgroupDirectorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdgroupDirectoryQuery, AdgroupDirectoryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdgroupDirectoryQuery, AdgroupDirectoryQueryVariables>(AdgroupDirectoryDocument, options);
        }
export type AdgroupDirectoryQueryHookResult = ReturnType<typeof useAdgroupDirectoryQuery>;
export type AdgroupDirectoryLazyQueryHookResult = ReturnType<typeof useAdgroupDirectoryLazyQuery>;
export type AdgroupDirectorySuspenseQueryHookResult = ReturnType<typeof useAdgroupDirectorySuspenseQuery>;
export type AdgroupDirectoryQueryResult = ApolloReactCommon.QueryResult<AdgroupDirectoryQuery, AdgroupDirectoryQueryVariables>;
export const DeviceAdjustmentByAdGroupDocument = gql`
    query deviceAdjustmentByAdGroup($adGroupId: PwsID!) {
  adGroup(id: $adGroupId) {
    id
    deviceAdjustments {
      realAdjustment
      wantedAdjustment
      deviceType
    }
  }
}
    `;

/**
 * __useDeviceAdjustmentByAdGroupQuery__
 *
 * To run a query within a React component, call `useDeviceAdjustmentByAdGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeviceAdjustmentByAdGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeviceAdjustmentByAdGroupQuery({
 *   variables: {
 *      adGroupId: // value for 'adGroupId'
 *   },
 * });
 */
export function useDeviceAdjustmentByAdGroupQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DeviceAdjustmentByAdGroupQuery, DeviceAdjustmentByAdGroupQueryVariables> & ({ variables: DeviceAdjustmentByAdGroupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DeviceAdjustmentByAdGroupQuery, DeviceAdjustmentByAdGroupQueryVariables>(DeviceAdjustmentByAdGroupDocument, options);
      }
export function useDeviceAdjustmentByAdGroupLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DeviceAdjustmentByAdGroupQuery, DeviceAdjustmentByAdGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DeviceAdjustmentByAdGroupQuery, DeviceAdjustmentByAdGroupQueryVariables>(DeviceAdjustmentByAdGroupDocument, options);
        }
// @ts-ignore
export function useDeviceAdjustmentByAdGroupSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DeviceAdjustmentByAdGroupQuery, DeviceAdjustmentByAdGroupQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DeviceAdjustmentByAdGroupQuery, DeviceAdjustmentByAdGroupQueryVariables>;
export function useDeviceAdjustmentByAdGroupSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DeviceAdjustmentByAdGroupQuery, DeviceAdjustmentByAdGroupQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DeviceAdjustmentByAdGroupQuery | undefined, DeviceAdjustmentByAdGroupQueryVariables>;
export function useDeviceAdjustmentByAdGroupSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DeviceAdjustmentByAdGroupQuery, DeviceAdjustmentByAdGroupQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DeviceAdjustmentByAdGroupQuery, DeviceAdjustmentByAdGroupQueryVariables>(DeviceAdjustmentByAdGroupDocument, options);
        }
export type DeviceAdjustmentByAdGroupQueryHookResult = ReturnType<typeof useDeviceAdjustmentByAdGroupQuery>;
export type DeviceAdjustmentByAdGroupLazyQueryHookResult = ReturnType<typeof useDeviceAdjustmentByAdGroupLazyQuery>;
export type DeviceAdjustmentByAdGroupSuspenseQueryHookResult = ReturnType<typeof useDeviceAdjustmentByAdGroupSuspenseQuery>;
export type DeviceAdjustmentByAdGroupQueryResult = ApolloReactCommon.QueryResult<DeviceAdjustmentByAdGroupQuery, DeviceAdjustmentByAdGroupQueryVariables>;
export const WebsiteAdjustmentByAdGroupDocument = gql`
    query websiteAdjustmentByAdGroup($adGroupId: PwsID!) {
  adGroup(id: $adGroupId) {
    id
    websiteAdjustments {
      id
      name
      reseller {
        id
        name
      }
      url
      iabCategory
      realAdjustment
      wantedAdjustment
      positions {
        id
        name
        realAdjustment
        wantedAdjustment
        channelType
        iabCategory
      }
    }
  }
}
    `;

/**
 * __useWebsiteAdjustmentByAdGroupQuery__
 *
 * To run a query within a React component, call `useWebsiteAdjustmentByAdGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebsiteAdjustmentByAdGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebsiteAdjustmentByAdGroupQuery({
 *   variables: {
 *      adGroupId: // value for 'adGroupId'
 *   },
 * });
 */
export function useWebsiteAdjustmentByAdGroupQuery(baseOptions: ApolloReactHooks.QueryHookOptions<WebsiteAdjustmentByAdGroupQuery, WebsiteAdjustmentByAdGroupQueryVariables> & ({ variables: WebsiteAdjustmentByAdGroupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WebsiteAdjustmentByAdGroupQuery, WebsiteAdjustmentByAdGroupQueryVariables>(WebsiteAdjustmentByAdGroupDocument, options);
      }
export function useWebsiteAdjustmentByAdGroupLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WebsiteAdjustmentByAdGroupQuery, WebsiteAdjustmentByAdGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WebsiteAdjustmentByAdGroupQuery, WebsiteAdjustmentByAdGroupQueryVariables>(WebsiteAdjustmentByAdGroupDocument, options);
        }
// @ts-ignore
export function useWebsiteAdjustmentByAdGroupSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<WebsiteAdjustmentByAdGroupQuery, WebsiteAdjustmentByAdGroupQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WebsiteAdjustmentByAdGroupQuery, WebsiteAdjustmentByAdGroupQueryVariables>;
export function useWebsiteAdjustmentByAdGroupSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WebsiteAdjustmentByAdGroupQuery, WebsiteAdjustmentByAdGroupQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WebsiteAdjustmentByAdGroupQuery | undefined, WebsiteAdjustmentByAdGroupQueryVariables>;
export function useWebsiteAdjustmentByAdGroupSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WebsiteAdjustmentByAdGroupQuery, WebsiteAdjustmentByAdGroupQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<WebsiteAdjustmentByAdGroupQuery, WebsiteAdjustmentByAdGroupQueryVariables>(WebsiteAdjustmentByAdGroupDocument, options);
        }
export type WebsiteAdjustmentByAdGroupQueryHookResult = ReturnType<typeof useWebsiteAdjustmentByAdGroupQuery>;
export type WebsiteAdjustmentByAdGroupLazyQueryHookResult = ReturnType<typeof useWebsiteAdjustmentByAdGroupLazyQuery>;
export type WebsiteAdjustmentByAdGroupSuspenseQueryHookResult = ReturnType<typeof useWebsiteAdjustmentByAdGroupSuspenseQuery>;
export type WebsiteAdjustmentByAdGroupQueryResult = ApolloReactCommon.QueryResult<WebsiteAdjustmentByAdGroupQuery, WebsiteAdjustmentByAdGroupQueryVariables>;
export const SearchOutsideDirectoryDocument = gql`
    query searchOutsideDirectory($pagination: Pagination, $searchQuery: DirectorySearchQuery!, $adGroupId: PwsID!) {
  searchOutsideDirectory(
    searchQuery: $searchQuery
    adGroupId: $adGroupId
    pagination: $pagination
  ) {
    id
    name
    reseller {
      name
      id
    }
    url
    iabCategory
    positions {
      id
      name
      channelType
      impressions
      iabCategory
      isEnabled
    }
  }
}
    `;

/**
 * __useSearchOutsideDirectoryQuery__
 *
 * To run a query within a React component, call `useSearchOutsideDirectoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchOutsideDirectoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchOutsideDirectoryQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      searchQuery: // value for 'searchQuery'
 *      adGroupId: // value for 'adGroupId'
 *   },
 * });
 */
export function useSearchOutsideDirectoryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchOutsideDirectoryQuery, SearchOutsideDirectoryQueryVariables> & ({ variables: SearchOutsideDirectoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchOutsideDirectoryQuery, SearchOutsideDirectoryQueryVariables>(SearchOutsideDirectoryDocument, options);
      }
export function useSearchOutsideDirectoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchOutsideDirectoryQuery, SearchOutsideDirectoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchOutsideDirectoryQuery, SearchOutsideDirectoryQueryVariables>(SearchOutsideDirectoryDocument, options);
        }
// @ts-ignore
export function useSearchOutsideDirectorySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SearchOutsideDirectoryQuery, SearchOutsideDirectoryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SearchOutsideDirectoryQuery, SearchOutsideDirectoryQueryVariables>;
export function useSearchOutsideDirectorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchOutsideDirectoryQuery, SearchOutsideDirectoryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SearchOutsideDirectoryQuery | undefined, SearchOutsideDirectoryQueryVariables>;
export function useSearchOutsideDirectorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchOutsideDirectoryQuery, SearchOutsideDirectoryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SearchOutsideDirectoryQuery, SearchOutsideDirectoryQueryVariables>(SearchOutsideDirectoryDocument, options);
        }
export type SearchOutsideDirectoryQueryHookResult = ReturnType<typeof useSearchOutsideDirectoryQuery>;
export type SearchOutsideDirectoryLazyQueryHookResult = ReturnType<typeof useSearchOutsideDirectoryLazyQuery>;
export type SearchOutsideDirectorySuspenseQueryHookResult = ReturnType<typeof useSearchOutsideDirectorySuspenseQuery>;
export type SearchOutsideDirectoryQueryResult = ApolloReactCommon.QueryResult<SearchOutsideDirectoryQuery, SearchOutsideDirectoryQueryVariables>;
export const SearchInDirectoryDocument = gql`
    query searchInDirectory($pagination: Pagination, $searchQuery: DirectorySearchQuery!, $adGroupId: PwsID!) {
  searchInDirectory(
    searchQuery: $searchQuery
    adGroupId: $adGroupId
    pagination: $pagination
  ) {
    id
    name
    reseller {
      name
      id
    }
    url
    iabCategory
    positions {
      id
      name
      channelType
      iabCategory
      adTemplateSizes {
        zone
        width
        height
      }
    }
  }
}
    `;

/**
 * __useSearchInDirectoryQuery__
 *
 * To run a query within a React component, call `useSearchInDirectoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchInDirectoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchInDirectoryQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      searchQuery: // value for 'searchQuery'
 *      adGroupId: // value for 'adGroupId'
 *   },
 * });
 */
export function useSearchInDirectoryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchInDirectoryQuery, SearchInDirectoryQueryVariables> & ({ variables: SearchInDirectoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchInDirectoryQuery, SearchInDirectoryQueryVariables>(SearchInDirectoryDocument, options);
      }
export function useSearchInDirectoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchInDirectoryQuery, SearchInDirectoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchInDirectoryQuery, SearchInDirectoryQueryVariables>(SearchInDirectoryDocument, options);
        }
// @ts-ignore
export function useSearchInDirectorySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SearchInDirectoryQuery, SearchInDirectoryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SearchInDirectoryQuery, SearchInDirectoryQueryVariables>;
export function useSearchInDirectorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchInDirectoryQuery, SearchInDirectoryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SearchInDirectoryQuery | undefined, SearchInDirectoryQueryVariables>;
export function useSearchInDirectorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchInDirectoryQuery, SearchInDirectoryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SearchInDirectoryQuery, SearchInDirectoryQueryVariables>(SearchInDirectoryDocument, options);
        }
export type SearchInDirectoryQueryHookResult = ReturnType<typeof useSearchInDirectoryQuery>;
export type SearchInDirectoryLazyQueryHookResult = ReturnType<typeof useSearchInDirectoryLazyQuery>;
export type SearchInDirectorySuspenseQueryHookResult = ReturnType<typeof useSearchInDirectorySuspenseQuery>;
export type SearchInDirectoryQueryResult = ApolloReactCommon.QueryResult<SearchInDirectoryQuery, SearchInDirectoryQueryVariables>;
export const AdGroupPerformanceStatsDocument = gql`
    query adGroupPerformanceStats($endDate: DateTime!, $startDate: DateTime!, $adGroupId: PwsID!, $filters: [CostDetailsFilter!]) {
  adGroup(id: $adGroupId) {
    id
    performanceStats(endDate: $endDate, startDate: $startDate, filters: $filters) {
      stats {
        ...AdvertiserPerformanceStatsFullParts
      }
      devices {
        name
        stats {
          ...AdvertiserPerformanceStatsParts
        }
      }
      publisherResellers {
        name
        stats {
          ...AdvertiserPerformanceStatsParts
        }
        publishers {
          name
          stats {
            ...AdvertiserPerformanceStatsParts
          }
          websites {
            name
            stats {
              ...AdvertiserPerformanceStatsParts
            }
            positions {
              name
              stats {
                ...AdvertiserPerformanceStatsParts
              }
            }
          }
        }
      }
      adCopies {
        id
        name
        title
        description
        callToAction
        advertiserName
        image
        status
        statusUpdatedAt
        stats {
          ...AdvertiserPerformanceStatsFullParts
        }
      }
    }
  }
}
    ${AdvertiserPerformanceStatsFullPartsFragmentDoc}
${AdvertiserPerformanceStatsPartsFragmentDoc}`;

/**
 * __useAdGroupPerformanceStatsQuery__
 *
 * To run a query within a React component, call `useAdGroupPerformanceStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdGroupPerformanceStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdGroupPerformanceStatsQuery({
 *   variables: {
 *      endDate: // value for 'endDate'
 *      startDate: // value for 'startDate'
 *      adGroupId: // value for 'adGroupId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useAdGroupPerformanceStatsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdGroupPerformanceStatsQuery, AdGroupPerformanceStatsQueryVariables> & ({ variables: AdGroupPerformanceStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdGroupPerformanceStatsQuery, AdGroupPerformanceStatsQueryVariables>(AdGroupPerformanceStatsDocument, options);
      }
export function useAdGroupPerformanceStatsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdGroupPerformanceStatsQuery, AdGroupPerformanceStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdGroupPerformanceStatsQuery, AdGroupPerformanceStatsQueryVariables>(AdGroupPerformanceStatsDocument, options);
        }
// @ts-ignore
export function useAdGroupPerformanceStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdGroupPerformanceStatsQuery, AdGroupPerformanceStatsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdGroupPerformanceStatsQuery, AdGroupPerformanceStatsQueryVariables>;
export function useAdGroupPerformanceStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdGroupPerformanceStatsQuery, AdGroupPerformanceStatsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdGroupPerformanceStatsQuery | undefined, AdGroupPerformanceStatsQueryVariables>;
export function useAdGroupPerformanceStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdGroupPerformanceStatsQuery, AdGroupPerformanceStatsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdGroupPerformanceStatsQuery, AdGroupPerformanceStatsQueryVariables>(AdGroupPerformanceStatsDocument, options);
        }
export type AdGroupPerformanceStatsQueryHookResult = ReturnType<typeof useAdGroupPerformanceStatsQuery>;
export type AdGroupPerformanceStatsLazyQueryHookResult = ReturnType<typeof useAdGroupPerformanceStatsLazyQuery>;
export type AdGroupPerformanceStatsSuspenseQueryHookResult = ReturnType<typeof useAdGroupPerformanceStatsSuspenseQuery>;
export type AdGroupPerformanceStatsQueryResult = ApolloReactCommon.QueryResult<AdGroupPerformanceStatsQuery, AdGroupPerformanceStatsQueryVariables>;
export const AdGroupTimeseriesDocument = gql`
    query adGroupTimeseries($endDate: DateTime!, $startDate: DateTime!, $adGroupId: PwsID!, $granularity: GraphGranularity!, $filters: [CostDetailsFilter!]) {
  adGroup(id: $adGroupId) {
    id
    timeseries(
      granularity: $granularity
      endDate: $endDate
      startDate: $startDate
      filters: $filters
    ) {
      ...AdvertiserTimeseriesFull
    }
  }
}
    ${AdvertiserTimeseriesFullFragmentDoc}`;

/**
 * __useAdGroupTimeseriesQuery__
 *
 * To run a query within a React component, call `useAdGroupTimeseriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdGroupTimeseriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdGroupTimeseriesQuery({
 *   variables: {
 *      endDate: // value for 'endDate'
 *      startDate: // value for 'startDate'
 *      adGroupId: // value for 'adGroupId'
 *      granularity: // value for 'granularity'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useAdGroupTimeseriesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdGroupTimeseriesQuery, AdGroupTimeseriesQueryVariables> & ({ variables: AdGroupTimeseriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdGroupTimeseriesQuery, AdGroupTimeseriesQueryVariables>(AdGroupTimeseriesDocument, options);
      }
export function useAdGroupTimeseriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdGroupTimeseriesQuery, AdGroupTimeseriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdGroupTimeseriesQuery, AdGroupTimeseriesQueryVariables>(AdGroupTimeseriesDocument, options);
        }
// @ts-ignore
export function useAdGroupTimeseriesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdGroupTimeseriesQuery, AdGroupTimeseriesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdGroupTimeseriesQuery, AdGroupTimeseriesQueryVariables>;
export function useAdGroupTimeseriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdGroupTimeseriesQuery, AdGroupTimeseriesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdGroupTimeseriesQuery | undefined, AdGroupTimeseriesQueryVariables>;
export function useAdGroupTimeseriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdGroupTimeseriesQuery, AdGroupTimeseriesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdGroupTimeseriesQuery, AdGroupTimeseriesQueryVariables>(AdGroupTimeseriesDocument, options);
        }
export type AdGroupTimeseriesQueryHookResult = ReturnType<typeof useAdGroupTimeseriesQuery>;
export type AdGroupTimeseriesLazyQueryHookResult = ReturnType<typeof useAdGroupTimeseriesLazyQuery>;
export type AdGroupTimeseriesSuspenseQueryHookResult = ReturnType<typeof useAdGroupTimeseriesSuspenseQuery>;
export type AdGroupTimeseriesQueryResult = ApolloReactCommon.QueryResult<AdGroupTimeseriesQuery, AdGroupTimeseriesQueryVariables>;
export const AdGroupPreviewDocument = gql`
    query adGroupPreview($adGroupId: PwsID!, $positionId: PwsID!) {
  adGroupPreview(adGroupId: $adGroupId, positionId: $positionId) {
    id
    name
    image
  }
}
    `;

/**
 * __useAdGroupPreviewQuery__
 *
 * To run a query within a React component, call `useAdGroupPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdGroupPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdGroupPreviewQuery({
 *   variables: {
 *      adGroupId: // value for 'adGroupId'
 *      positionId: // value for 'positionId'
 *   },
 * });
 */
export function useAdGroupPreviewQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdGroupPreviewQuery, AdGroupPreviewQueryVariables> & ({ variables: AdGroupPreviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdGroupPreviewQuery, AdGroupPreviewQueryVariables>(AdGroupPreviewDocument, options);
      }
export function useAdGroupPreviewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdGroupPreviewQuery, AdGroupPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdGroupPreviewQuery, AdGroupPreviewQueryVariables>(AdGroupPreviewDocument, options);
        }
// @ts-ignore
export function useAdGroupPreviewSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdGroupPreviewQuery, AdGroupPreviewQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdGroupPreviewQuery, AdGroupPreviewQueryVariables>;
export function useAdGroupPreviewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdGroupPreviewQuery, AdGroupPreviewQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdGroupPreviewQuery | undefined, AdGroupPreviewQueryVariables>;
export function useAdGroupPreviewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdGroupPreviewQuery, AdGroupPreviewQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdGroupPreviewQuery, AdGroupPreviewQueryVariables>(AdGroupPreviewDocument, options);
        }
export type AdGroupPreviewQueryHookResult = ReturnType<typeof useAdGroupPreviewQuery>;
export type AdGroupPreviewLazyQueryHookResult = ReturnType<typeof useAdGroupPreviewLazyQuery>;
export type AdGroupPreviewSuspenseQueryHookResult = ReturnType<typeof useAdGroupPreviewSuspenseQuery>;
export type AdGroupPreviewQueryResult = ApolloReactCommon.QueryResult<AdGroupPreviewQuery, AdGroupPreviewQueryVariables>;
export const CreateAdgroupDocument = gql`
    mutation createAdgroup($adgroup: AdGroupCreateInput!) {
  createAdGroup(newAdGroup: $adgroup) {
    ...AdGroupParts
  }
}
    ${AdGroupPartsFragmentDoc}`;
export type CreateAdgroupMutationFn = ApolloReactCommon.MutationFunction<CreateAdgroupMutation, CreateAdgroupMutationVariables>;

/**
 * __useCreateAdgroupMutation__
 *
 * To run a mutation, you first call `useCreateAdgroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdgroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdgroupMutation, { data, loading, error }] = useCreateAdgroupMutation({
 *   variables: {
 *      adgroup: // value for 'adgroup'
 *   },
 * });
 */
export function useCreateAdgroupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateAdgroupMutation, CreateAdgroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateAdgroupMutation, CreateAdgroupMutationVariables>(CreateAdgroupDocument, options);
      }
export type CreateAdgroupMutationHookResult = ReturnType<typeof useCreateAdgroupMutation>;
export type CreateAdgroupMutationResult = ApolloReactCommon.MutationResult<CreateAdgroupMutation>;
export type CreateAdgroupMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateAdgroupMutation, CreateAdgroupMutationVariables>;
export const UpdateAdgroupDocument = gql`
    mutation updateAdgroup($adgroup: AdGroupInput!) {
  updateAdGroup(adGroup: $adgroup) {
    ...AdGroupParts
  }
}
    ${AdGroupPartsFragmentDoc}`;
export type UpdateAdgroupMutationFn = ApolloReactCommon.MutationFunction<UpdateAdgroupMutation, UpdateAdgroupMutationVariables>;

/**
 * __useUpdateAdgroupMutation__
 *
 * To run a mutation, you first call `useUpdateAdgroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdgroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdgroupMutation, { data, loading, error }] = useUpdateAdgroupMutation({
 *   variables: {
 *      adgroup: // value for 'adgroup'
 *   },
 * });
 */
export function useUpdateAdgroupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAdgroupMutation, UpdateAdgroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateAdgroupMutation, UpdateAdgroupMutationVariables>(UpdateAdgroupDocument, options);
      }
export type UpdateAdgroupMutationHookResult = ReturnType<typeof useUpdateAdgroupMutation>;
export type UpdateAdgroupMutationResult = ApolloReactCommon.MutationResult<UpdateAdgroupMutation>;
export type UpdateAdgroupMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateAdgroupMutation, UpdateAdgroupMutationVariables>;
export type AdGroupSettingsQueryVariables = Exact<{
  id: unknown;
}>;


export type AdGroupSettingsQuery = { adGroup: { id: unknown, settings: { commission: number | null } } };

export const AdGroupSettingsDocument = gql`
    query adGroupSettings($id: PwsID!) {
  adGroup(id: $id) {
    id
    settings {
      commission
    }
  }
}
    `;
export function useAdGroupSettingsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdGroupSettingsQuery, AdGroupSettingsQueryVariables> & ({ variables: AdGroupSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdGroupSettingsQuery, AdGroupSettingsQueryVariables>(AdGroupSettingsDocument, options);
      }
export type UpdateAdGroupSettingsMutationVariables = Exact<{
  adGroupId: unknown;
  settings: Types.AdGroupSettingsInput;
}>;


export type UpdateAdGroupSettingsMutation = { updateAdGroupSettings: { commission: number | null } };

export const UpdateAdGroupSettingsDocument = gql`
    mutation updateAdGroupSettings($adGroupId: PwsID!, $settings: AdGroupSettingsInput!) {
  updateAdGroupSettings(adGroupId: $adGroupId, settings: $settings) {
    commission
  }
}
    `;
export type UpdateAdGroupSettingsMutationFn = ApolloReactCommon.MutationFunction<UpdateAdGroupSettingsMutation, UpdateAdGroupSettingsMutationVariables>;
export function useUpdateAdGroupSettingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAdGroupSettingsMutation, UpdateAdGroupSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateAdGroupSettingsMutation, UpdateAdGroupSettingsMutationVariables>(UpdateAdGroupSettingsDocument, options);
      }
export const CopyAdGroupDocument = gql`
    mutation copyAdGroup($name: String!, $adGroupId: PwsID!, $isActive: Boolean!) {
  copyAdGroup(name: $name, adGroupId: $adGroupId, isActive: $isActive)
}
    `;
export type CopyAdGroupMutationFn = ApolloReactCommon.MutationFunction<CopyAdGroupMutation, CopyAdGroupMutationVariables>;

/**
 * __useCopyAdGroupMutation__
 *
 * To run a mutation, you first call `useCopyAdGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyAdGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyAdGroupMutation, { data, loading, error }] = useCopyAdGroupMutation({
 *   variables: {
 *      name: // value for 'name'
 *      adGroupId: // value for 'adGroupId'
 *      isActive: // value for 'isActive'
 *   },
 * });
 */
export function useCopyAdGroupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CopyAdGroupMutation, CopyAdGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CopyAdGroupMutation, CopyAdGroupMutationVariables>(CopyAdGroupDocument, options);
      }
export type CopyAdGroupMutationHookResult = ReturnType<typeof useCopyAdGroupMutation>;
export type CopyAdGroupMutationResult = ApolloReactCommon.MutationResult<CopyAdGroupMutation>;
export type CopyAdGroupMutationOptions = ApolloReactCommon.BaseMutationOptions<CopyAdGroupMutation, CopyAdGroupMutationVariables>;
export const UpdateDeviceAdjustmentsDocument = gql`
    mutation updateDeviceAdjustments($adjustments: [AdGroupDeviceAdjustmentInput!]!, $adGroupId: PwsID!) {
  updateDeviceAdjustments(adjustments: $adjustments, adGroupId: $adGroupId)
}
    `;
export type UpdateDeviceAdjustmentsMutationFn = ApolloReactCommon.MutationFunction<UpdateDeviceAdjustmentsMutation, UpdateDeviceAdjustmentsMutationVariables>;

/**
 * __useUpdateDeviceAdjustmentsMutation__
 *
 * To run a mutation, you first call `useUpdateDeviceAdjustmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDeviceAdjustmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDeviceAdjustmentsMutation, { data, loading, error }] = useUpdateDeviceAdjustmentsMutation({
 *   variables: {
 *      adjustments: // value for 'adjustments'
 *      adGroupId: // value for 'adGroupId'
 *   },
 * });
 */
export function useUpdateDeviceAdjustmentsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateDeviceAdjustmentsMutation, UpdateDeviceAdjustmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateDeviceAdjustmentsMutation, UpdateDeviceAdjustmentsMutationVariables>(UpdateDeviceAdjustmentsDocument, options);
      }
export type UpdateDeviceAdjustmentsMutationHookResult = ReturnType<typeof useUpdateDeviceAdjustmentsMutation>;
export type UpdateDeviceAdjustmentsMutationResult = ApolloReactCommon.MutationResult<UpdateDeviceAdjustmentsMutation>;
export type UpdateDeviceAdjustmentsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateDeviceAdjustmentsMutation, UpdateDeviceAdjustmentsMutationVariables>;
export const UpdateWebsiteAdjustmentsDocument = gql`
    mutation updateWebsiteAdjustments($adjustments: [WebsiteAdjustmentInput!]!, $adGroupId: PwsID!) {
  updateWebsiteAdjustments(adjustments: $adjustments, adGroupId: $adGroupId)
}
    `;
export type UpdateWebsiteAdjustmentsMutationFn = ApolloReactCommon.MutationFunction<UpdateWebsiteAdjustmentsMutation, UpdateWebsiteAdjustmentsMutationVariables>;

/**
 * __useUpdateWebsiteAdjustmentsMutation__
 *
 * To run a mutation, you first call `useUpdateWebsiteAdjustmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWebsiteAdjustmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWebsiteAdjustmentsMutation, { data, loading, error }] = useUpdateWebsiteAdjustmentsMutation({
 *   variables: {
 *      adjustments: // value for 'adjustments'
 *      adGroupId: // value for 'adGroupId'
 *   },
 * });
 */
export function useUpdateWebsiteAdjustmentsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateWebsiteAdjustmentsMutation, UpdateWebsiteAdjustmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateWebsiteAdjustmentsMutation, UpdateWebsiteAdjustmentsMutationVariables>(UpdateWebsiteAdjustmentsDocument, options);
      }
export type UpdateWebsiteAdjustmentsMutationHookResult = ReturnType<typeof useUpdateWebsiteAdjustmentsMutation>;
export type UpdateWebsiteAdjustmentsMutationResult = ApolloReactCommon.MutationResult<UpdateWebsiteAdjustmentsMutation>;
export type UpdateWebsiteAdjustmentsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateWebsiteAdjustmentsMutation, UpdateWebsiteAdjustmentsMutationVariables>;
export const UpdateAdgroupTargetingDocument = gql`
    mutation updateAdgroupTargeting($targeting: AdGroupTargetingInput!, $adgroupId: PwsID!) {
  updateAdgroupTargeting(adGroupId: $adgroupId, targeting: $targeting)
}
    `;
export type UpdateAdgroupTargetingMutationFn = ApolloReactCommon.MutationFunction<UpdateAdgroupTargetingMutation, UpdateAdgroupTargetingMutationVariables>;

/**
 * __useUpdateAdgroupTargetingMutation__
 *
 * To run a mutation, you first call `useUpdateAdgroupTargetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdgroupTargetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdgroupTargetingMutation, { data, loading, error }] = useUpdateAdgroupTargetingMutation({
 *   variables: {
 *      targeting: // value for 'targeting'
 *      adgroupId: // value for 'adgroupId'
 *   },
 * });
 */
export function useUpdateAdgroupTargetingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAdgroupTargetingMutation, UpdateAdgroupTargetingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateAdgroupTargetingMutation, UpdateAdgroupTargetingMutationVariables>(UpdateAdgroupTargetingDocument, options);
      }
export type UpdateAdgroupTargetingMutationHookResult = ReturnType<typeof useUpdateAdgroupTargetingMutation>;
export type UpdateAdgroupTargetingMutationResult = ApolloReactCommon.MutationResult<UpdateAdgroupTargetingMutation>;
export type UpdateAdgroupTargetingMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateAdgroupTargetingMutation, UpdateAdgroupTargetingMutationVariables>;
export const AddAdGroupTargetingAdressesDocument = gql`
    mutation addAdGroupTargetingAdresses($adGroupId: PwsID!, $clearPrevious: Boolean, $radius: Int, $addresses: [String!]!) {
  addAdGroupTargetingAdresses(
    adGroupId: $adGroupId
    clearPrevious: $clearPrevious
    radius: $radius
    addresses: $addresses
  ) {
    address
    invalidReason
  }
}
    `;
export type AddAdGroupTargetingAdressesMutationFn = ApolloReactCommon.MutationFunction<AddAdGroupTargetingAdressesMutation, AddAdGroupTargetingAdressesMutationVariables>;

/**
 * __useAddAdGroupTargetingAdressesMutation__
 *
 * To run a mutation, you first call `useAddAdGroupTargetingAdressesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAdGroupTargetingAdressesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAdGroupTargetingAdressesMutation, { data, loading, error }] = useAddAdGroupTargetingAdressesMutation({
 *   variables: {
 *      adGroupId: // value for 'adGroupId'
 *      clearPrevious: // value for 'clearPrevious'
 *      radius: // value for 'radius'
 *      addresses: // value for 'addresses'
 *   },
 * });
 */
export function useAddAdGroupTargetingAdressesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddAdGroupTargetingAdressesMutation, AddAdGroupTargetingAdressesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddAdGroupTargetingAdressesMutation, AddAdGroupTargetingAdressesMutationVariables>(AddAdGroupTargetingAdressesDocument, options);
      }
export type AddAdGroupTargetingAdressesMutationHookResult = ReturnType<typeof useAddAdGroupTargetingAdressesMutation>;
export type AddAdGroupTargetingAdressesMutationResult = ApolloReactCommon.MutationResult<AddAdGroupTargetingAdressesMutation>;
export type AddAdGroupTargetingAdressesMutationOptions = ApolloReactCommon.BaseMutationOptions<AddAdGroupTargetingAdressesMutation, AddAdGroupTargetingAdressesMutationVariables>;
export const AddToDirectoryDocument = gql`
    mutation addToDirectory($toAdd: [WebsiteDirectoryInput!]!, $adGroupId: PwsID!) {
  addToDirectory(toAdd: $toAdd, adGroupId: $adGroupId)
}
    `;
export type AddToDirectoryMutationFn = ApolloReactCommon.MutationFunction<AddToDirectoryMutation, AddToDirectoryMutationVariables>;

/**
 * __useAddToDirectoryMutation__
 *
 * To run a mutation, you first call `useAddToDirectoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddToDirectoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addToDirectoryMutation, { data, loading, error }] = useAddToDirectoryMutation({
 *   variables: {
 *      toAdd: // value for 'toAdd'
 *      adGroupId: // value for 'adGroupId'
 *   },
 * });
 */
export function useAddToDirectoryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddToDirectoryMutation, AddToDirectoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddToDirectoryMutation, AddToDirectoryMutationVariables>(AddToDirectoryDocument, options);
      }
export type AddToDirectoryMutationHookResult = ReturnType<typeof useAddToDirectoryMutation>;
export type AddToDirectoryMutationResult = ApolloReactCommon.MutationResult<AddToDirectoryMutation>;
export type AddToDirectoryMutationOptions = ApolloReactCommon.BaseMutationOptions<AddToDirectoryMutation, AddToDirectoryMutationVariables>;
export const AddToWebsiteAdjustmentsDocument = gql`
    mutation addToWebsiteAdjustments($toAdd: [WebsiteAdjustmentInput!]!, $adGroupId: PwsID!) {
  addToWebsiteAdjustments(toAdd: $toAdd, adGroupId: $adGroupId)
}
    `;
export type AddToWebsiteAdjustmentsMutationFn = ApolloReactCommon.MutationFunction<AddToWebsiteAdjustmentsMutation, AddToWebsiteAdjustmentsMutationVariables>;

/**
 * __useAddToWebsiteAdjustmentsMutation__
 *
 * To run a mutation, you first call `useAddToWebsiteAdjustmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddToWebsiteAdjustmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addToWebsiteAdjustmentsMutation, { data, loading, error }] = useAddToWebsiteAdjustmentsMutation({
 *   variables: {
 *      toAdd: // value for 'toAdd'
 *      adGroupId: // value for 'adGroupId'
 *   },
 * });
 */
export function useAddToWebsiteAdjustmentsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddToWebsiteAdjustmentsMutation, AddToWebsiteAdjustmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddToWebsiteAdjustmentsMutation, AddToWebsiteAdjustmentsMutationVariables>(AddToWebsiteAdjustmentsDocument, options);
      }
export type AddToWebsiteAdjustmentsMutationHookResult = ReturnType<typeof useAddToWebsiteAdjustmentsMutation>;
export type AddToWebsiteAdjustmentsMutationResult = ApolloReactCommon.MutationResult<AddToWebsiteAdjustmentsMutation>;
export type AddToWebsiteAdjustmentsMutationOptions = ApolloReactCommon.BaseMutationOptions<AddToWebsiteAdjustmentsMutation, AddToWebsiteAdjustmentsMutationVariables>;
export const UpdateDirectoryDocument = gql`
    mutation updateDirectory($directory: [WebsiteDirectoryInput!]!, $adGroupId: PwsID!, $type: DirectoryType!) {
  updateDirectory(directory: $directory, adGroupId: $adGroupId, type: $type)
}
    `;
export type UpdateDirectoryMutationFn = ApolloReactCommon.MutationFunction<UpdateDirectoryMutation, UpdateDirectoryMutationVariables>;

/**
 * __useUpdateDirectoryMutation__
 *
 * To run a mutation, you first call `useUpdateDirectoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDirectoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDirectoryMutation, { data, loading, error }] = useUpdateDirectoryMutation({
 *   variables: {
 *      directory: // value for 'directory'
 *      adGroupId: // value for 'adGroupId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useUpdateDirectoryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateDirectoryMutation, UpdateDirectoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateDirectoryMutation, UpdateDirectoryMutationVariables>(UpdateDirectoryDocument, options);
      }
export type UpdateDirectoryMutationHookResult = ReturnType<typeof useUpdateDirectoryMutation>;
export type UpdateDirectoryMutationResult = ApolloReactCommon.MutationResult<UpdateDirectoryMutation>;
export type UpdateDirectoryMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateDirectoryMutation, UpdateDirectoryMutationVariables>;
export const AnalyticsDataDocument = gql`
    query analyticsData($advertiserId: PwsID!, $startDate: DateTime!, $endDate: DateTime!) {
  analyticsImportParameters(advertiserId: $advertiserId)
  adCopiesForAnalyticsImport(
    advertiserId: $advertiserId
    startDate: $startDate
    endDate: $endDate
  ) {
    id
    adGroupId
    name
    forceRedirectUrl
    startDate
    endDate
    analyticsStats {
      pageViews
      sessions
      engagedSessions
      totalUsers
      newUsers
      revenue
      bounceRate
      engagementRate
      sessionTimeSeconds
      leads
      orders
      lastAt
    }
  }
}
    `;

/**
 * __useAnalyticsDataQuery__
 *
 * To run a query within a React component, call `useAnalyticsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsDataQuery({
 *   variables: {
 *      advertiserId: // value for 'advertiserId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useAnalyticsDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AnalyticsDataQuery, AnalyticsDataQueryVariables> & ({ variables: AnalyticsDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AnalyticsDataQuery, AnalyticsDataQueryVariables>(AnalyticsDataDocument, options);
      }
export function useAnalyticsDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AnalyticsDataQuery, AnalyticsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AnalyticsDataQuery, AnalyticsDataQueryVariables>(AnalyticsDataDocument, options);
        }
// @ts-ignore
export function useAnalyticsDataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AnalyticsDataQuery, AnalyticsDataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AnalyticsDataQuery, AnalyticsDataQueryVariables>;
export function useAnalyticsDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AnalyticsDataQuery, AnalyticsDataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AnalyticsDataQuery | undefined, AnalyticsDataQueryVariables>;
export function useAnalyticsDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AnalyticsDataQuery, AnalyticsDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AnalyticsDataQuery, AnalyticsDataQueryVariables>(AnalyticsDataDocument, options);
        }
export type AnalyticsDataQueryHookResult = ReturnType<typeof useAnalyticsDataQuery>;
export type AnalyticsDataLazyQueryHookResult = ReturnType<typeof useAnalyticsDataLazyQuery>;
export type AnalyticsDataSuspenseQueryHookResult = ReturnType<typeof useAnalyticsDataSuspenseQuery>;
export type AnalyticsDataQueryResult = ApolloReactCommon.QueryResult<AnalyticsDataQuery, AnalyticsDataQueryVariables>;
export const ImportAnalyticsDataDocument = gql`
    mutation importAnalyticsData($analyticsData: [AnalayticsStatInput!]!, $analyticsImportParameters: JSON) {
  importAnalyticsData(
    analyticsData: $analyticsData
    analyticsImportParameters: $analyticsImportParameters
  ) {
    adGroupId
    adCopyId
    at
    pageViews
    sessions
    engagedSessions
    totalUsers
    newUsers
    revenue
    bounceRate
    engagementRate
    sessionTimeSeconds
    leads
    orders
  }
}
    `;
export type ImportAnalyticsDataMutationFn = ApolloReactCommon.MutationFunction<ImportAnalyticsDataMutation, ImportAnalyticsDataMutationVariables>;

/**
 * __useImportAnalyticsDataMutation__
 *
 * To run a mutation, you first call `useImportAnalyticsDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportAnalyticsDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importAnalyticsDataMutation, { data, loading, error }] = useImportAnalyticsDataMutation({
 *   variables: {
 *      analyticsData: // value for 'analyticsData'
 *      analyticsImportParameters: // value for 'analyticsImportParameters'
 *   },
 * });
 */
export function useImportAnalyticsDataMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ImportAnalyticsDataMutation, ImportAnalyticsDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ImportAnalyticsDataMutation, ImportAnalyticsDataMutationVariables>(ImportAnalyticsDataDocument, options);
      }
export type ImportAnalyticsDataMutationHookResult = ReturnType<typeof useImportAnalyticsDataMutation>;
export type ImportAnalyticsDataMutationResult = ApolloReactCommon.MutationResult<ImportAnalyticsDataMutation>;
export type ImportAnalyticsDataMutationOptions = ApolloReactCommon.BaseMutationOptions<ImportAnalyticsDataMutation, ImportAnalyticsDataMutationVariables>;
export const TargetingReachDocument = gql`
    query targetingReach($adGroupId: PwsID!, $targeting: AdGroupTargetingInput!) {
  targetingReach(adGroupId: $adGroupId, targeting: $targeting) {
    impressions
    cpc
  }
}
    `;

/**
 * __useTargetingReachQuery__
 *
 * To run a query within a React component, call `useTargetingReachQuery` and pass it any options that fit your needs.
 * When your component renders, `useTargetingReachQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTargetingReachQuery({
 *   variables: {
 *      adGroupId: // value for 'adGroupId'
 *      targeting: // value for 'targeting'
 *   },
 * });
 */
export function useTargetingReachQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TargetingReachQuery, TargetingReachQueryVariables> & ({ variables: TargetingReachQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TargetingReachQuery, TargetingReachQueryVariables>(TargetingReachDocument, options);
      }
export function useTargetingReachLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TargetingReachQuery, TargetingReachQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TargetingReachQuery, TargetingReachQueryVariables>(TargetingReachDocument, options);
        }
// @ts-ignore
export function useTargetingReachSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TargetingReachQuery, TargetingReachQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TargetingReachQuery, TargetingReachQueryVariables>;
export function useTargetingReachSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TargetingReachQuery, TargetingReachQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TargetingReachQuery | undefined, TargetingReachQueryVariables>;
export function useTargetingReachSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TargetingReachQuery, TargetingReachQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TargetingReachQuery, TargetingReachQueryVariables>(TargetingReachDocument, options);
        }
export type TargetingReachQueryHookResult = ReturnType<typeof useTargetingReachQuery>;
export type TargetingReachLazyQueryHookResult = ReturnType<typeof useTargetingReachLazyQuery>;
export type TargetingReachSuspenseQueryHookResult = ReturnType<typeof useTargetingReachSuspenseQuery>;
export type TargetingReachQueryResult = ApolloReactCommon.QueryResult<TargetingReachQuery, TargetingReachQueryVariables>;
export const SimulateReachDocument = gql`
    query simulateReach($market: PwsID!, $targeting: AdGroupTargetingInput!, $network: Network, $adFormat: AdFormat, $directory: AdGroupDirectoryInput) {
  simulateReach(
    market: $market
    targeting: $targeting
    network: $network
    adFormat: $adFormat
    directory: $directory
  ) {
    impressions
    cpc
  }
}
    `;

/**
 * __useSimulateReachQuery__
 *
 * To run a query within a React component, call `useSimulateReachQuery` and pass it any options that fit your needs.
 * When your component renders, `useSimulateReachQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSimulateReachQuery({
 *   variables: {
 *      market: // value for 'market'
 *      targeting: // value for 'targeting'
 *      network: // value for 'network'
 *      adFormat: // value for 'adFormat'
 *      directory: // value for 'directory'
 *   },
 * });
 */
export function useSimulateReachQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SimulateReachQuery, SimulateReachQueryVariables> & ({ variables: SimulateReachQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SimulateReachQuery, SimulateReachQueryVariables>(SimulateReachDocument, options);
      }
export function useSimulateReachLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SimulateReachQuery, SimulateReachQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SimulateReachQuery, SimulateReachQueryVariables>(SimulateReachDocument, options);
        }
// @ts-ignore
export function useSimulateReachSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SimulateReachQuery, SimulateReachQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SimulateReachQuery, SimulateReachQueryVariables>;
export function useSimulateReachSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SimulateReachQuery, SimulateReachQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SimulateReachQuery | undefined, SimulateReachQueryVariables>;
export function useSimulateReachSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SimulateReachQuery, SimulateReachQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SimulateReachQuery, SimulateReachQueryVariables>(SimulateReachDocument, options);
        }
export type SimulateReachQueryHookResult = ReturnType<typeof useSimulateReachQuery>;
export type SimulateReachLazyQueryHookResult = ReturnType<typeof useSimulateReachLazyQuery>;
export type SimulateReachSuspenseQueryHookResult = ReturnType<typeof useSimulateReachSuspenseQuery>;
export type SimulateReachQueryResult = ApolloReactCommon.QueryResult<SimulateReachQuery, SimulateReachQueryVariables>;
export const ProfileTagOriginsDocument = gql`
    query profileTagOrigins {
  profileTagOrigins
}
    `;

/**
 * __useProfileTagOriginsQuery__
 *
 * To run a query within a React component, call `useProfileTagOriginsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileTagOriginsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileTagOriginsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProfileTagOriginsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProfileTagOriginsQuery, ProfileTagOriginsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProfileTagOriginsQuery, ProfileTagOriginsQueryVariables>(ProfileTagOriginsDocument, options);
      }
export function useProfileTagOriginsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProfileTagOriginsQuery, ProfileTagOriginsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProfileTagOriginsQuery, ProfileTagOriginsQueryVariables>(ProfileTagOriginsDocument, options);
        }
// @ts-ignore
export function useProfileTagOriginsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProfileTagOriginsQuery, ProfileTagOriginsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProfileTagOriginsQuery, ProfileTagOriginsQueryVariables>;
export function useProfileTagOriginsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProfileTagOriginsQuery, ProfileTagOriginsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProfileTagOriginsQuery | undefined, ProfileTagOriginsQueryVariables>;
export function useProfileTagOriginsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProfileTagOriginsQuery, ProfileTagOriginsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProfileTagOriginsQuery, ProfileTagOriginsQueryVariables>(ProfileTagOriginsDocument, options);
        }
export type ProfileTagOriginsQueryHookResult = ReturnType<typeof useProfileTagOriginsQuery>;
export type ProfileTagOriginsLazyQueryHookResult = ReturnType<typeof useProfileTagOriginsLazyQuery>;
export type ProfileTagOriginsSuspenseQueryHookResult = ReturnType<typeof useProfileTagOriginsSuspenseQuery>;
export type ProfileTagOriginsQueryResult = ApolloReactCommon.QueryResult<ProfileTagOriginsQuery, ProfileTagOriginsQueryVariables>;
export const SearchTagsDocument = gql`
    query searchTags($pagination: Pagination!, $origin: String, $query: String!) {
  searchTags(pagination: $pagination, origin: $origin, query: $query) {
    id
    origin
    name
    description
    profileCount
  }
}
    `;

/**
 * __useSearchTagsQuery__
 *
 * To run a query within a React component, call `useSearchTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchTagsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      origin: // value for 'origin'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useSearchTagsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchTagsQuery, SearchTagsQueryVariables> & ({ variables: SearchTagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchTagsQuery, SearchTagsQueryVariables>(SearchTagsDocument, options);
      }
export function useSearchTagsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchTagsQuery, SearchTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchTagsQuery, SearchTagsQueryVariables>(SearchTagsDocument, options);
        }
// @ts-ignore
export function useSearchTagsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SearchTagsQuery, SearchTagsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SearchTagsQuery, SearchTagsQueryVariables>;
export function useSearchTagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchTagsQuery, SearchTagsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SearchTagsQuery | undefined, SearchTagsQueryVariables>;
export function useSearchTagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchTagsQuery, SearchTagsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SearchTagsQuery, SearchTagsQueryVariables>(SearchTagsDocument, options);
        }
export type SearchTagsQueryHookResult = ReturnType<typeof useSearchTagsQuery>;
export type SearchTagsLazyQueryHookResult = ReturnType<typeof useSearchTagsLazyQuery>;
export type SearchTagsSuspenseQueryHookResult = ReturnType<typeof useSearchTagsSuspenseQuery>;
export type SearchTagsQueryResult = ApolloReactCommon.QueryResult<SearchTagsQuery, SearchTagsQueryVariables>;
export const AdgroupBlacklistDocument = gql`
    query adgroupBlacklist($id: PwsID!) {
  adGroup(id: $id) {
    id
    blacklistedOn {
      maximumTraffic
      websites {
        website {
          id
          name
          publisher {
            id
            name
            reseller {
              id
              name
            }
          }
        }
        traffic
        reasons
      }
    }
  }
}
    `;

/**
 * __useAdgroupBlacklistQuery__
 *
 * To run a query within a React component, call `useAdgroupBlacklistQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdgroupBlacklistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdgroupBlacklistQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdgroupBlacklistQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdgroupBlacklistQuery, AdgroupBlacklistQueryVariables> & ({ variables: AdgroupBlacklistQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdgroupBlacklistQuery, AdgroupBlacklistQueryVariables>(AdgroupBlacklistDocument, options);
      }
export function useAdgroupBlacklistLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdgroupBlacklistQuery, AdgroupBlacklistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdgroupBlacklistQuery, AdgroupBlacklistQueryVariables>(AdgroupBlacklistDocument, options);
        }
// @ts-ignore
export function useAdgroupBlacklistSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdgroupBlacklistQuery, AdgroupBlacklistQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdgroupBlacklistQuery, AdgroupBlacklistQueryVariables>;
export function useAdgroupBlacklistSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdgroupBlacklistQuery, AdgroupBlacklistQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdgroupBlacklistQuery | undefined, AdgroupBlacklistQueryVariables>;
export function useAdgroupBlacklistSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdgroupBlacklistQuery, AdgroupBlacklistQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdgroupBlacklistQuery, AdgroupBlacklistQueryVariables>(AdgroupBlacklistDocument, options);
        }
export type AdgroupBlacklistQueryHookResult = ReturnType<typeof useAdgroupBlacklistQuery>;
export type AdgroupBlacklistLazyQueryHookResult = ReturnType<typeof useAdgroupBlacklistLazyQuery>;
export type AdgroupBlacklistSuspenseQueryHookResult = ReturnType<typeof useAdgroupBlacklistSuspenseQuery>;
export type AdgroupBlacklistQueryResult = ApolloReactCommon.QueryResult<AdgroupBlacklistQuery, AdgroupBlacklistQueryVariables>;
export const AdGroupBudgetHistoryDocument = gql`
    query adGroupBudgetHistory($adGroupId: PwsID!, $days: Int!) {
  adGroupBudgetHistory(adGroupId: $adGroupId, days: $days) {
    at
    changeType
    dailyBudget
    dailyBudgetType
    budgetCapping
    budgetCappingType
    costValue
    costType
    user {
      id
      firstName
      lastName
      company {
        ...PartialCompanyParts
      }
    }
  }
}
    ${PartialCompanyPartsFragmentDoc}`;

/**
 * __useAdGroupBudgetHistoryQuery__
 *
 * To run a query within a React component, call `useAdGroupBudgetHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdGroupBudgetHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdGroupBudgetHistoryQuery({
 *   variables: {
 *      adGroupId: // value for 'adGroupId'
 *      days: // value for 'days'
 *   },
 * });
 */
export function useAdGroupBudgetHistoryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdGroupBudgetHistoryQuery, AdGroupBudgetHistoryQueryVariables> & ({ variables: AdGroupBudgetHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdGroupBudgetHistoryQuery, AdGroupBudgetHistoryQueryVariables>(AdGroupBudgetHistoryDocument, options);
      }
export function useAdGroupBudgetHistoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdGroupBudgetHistoryQuery, AdGroupBudgetHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdGroupBudgetHistoryQuery, AdGroupBudgetHistoryQueryVariables>(AdGroupBudgetHistoryDocument, options);
        }
// @ts-ignore
export function useAdGroupBudgetHistorySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdGroupBudgetHistoryQuery, AdGroupBudgetHistoryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdGroupBudgetHistoryQuery, AdGroupBudgetHistoryQueryVariables>;
export function useAdGroupBudgetHistorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdGroupBudgetHistoryQuery, AdGroupBudgetHistoryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdGroupBudgetHistoryQuery | undefined, AdGroupBudgetHistoryQueryVariables>;
export function useAdGroupBudgetHistorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdGroupBudgetHistoryQuery, AdGroupBudgetHistoryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdGroupBudgetHistoryQuery, AdGroupBudgetHistoryQueryVariables>(AdGroupBudgetHistoryDocument, options);
        }
export type AdGroupBudgetHistoryQueryHookResult = ReturnType<typeof useAdGroupBudgetHistoryQuery>;
export type AdGroupBudgetHistoryLazyQueryHookResult = ReturnType<typeof useAdGroupBudgetHistoryLazyQuery>;
export type AdGroupBudgetHistorySuspenseQueryHookResult = ReturnType<typeof useAdGroupBudgetHistorySuspenseQuery>;
export type AdGroupBudgetHistoryQueryResult = ApolloReactCommon.QueryResult<AdGroupBudgetHistoryQuery, AdGroupBudgetHistoryQueryVariables>;
export const AdGroupBudgetPlansDocument = gql`
    query adGroupBudgetPlans($id: PwsID!) {
  adGroup(id: $id) {
    id
    budgetPlans {
      ...AdGroupBudgetPlanParts
    }
  }
}
    ${AdGroupBudgetPlanPartsFragmentDoc}`;

/**
 * __useAdGroupBudgetPlansQuery__
 *
 * To run a query within a React component, call `useAdGroupBudgetPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdGroupBudgetPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdGroupBudgetPlansQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdGroupBudgetPlansQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdGroupBudgetPlansQuery, AdGroupBudgetPlansQueryVariables> & ({ variables: AdGroupBudgetPlansQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdGroupBudgetPlansQuery, AdGroupBudgetPlansQueryVariables>(AdGroupBudgetPlansDocument, options);
      }
export function useAdGroupBudgetPlansLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdGroupBudgetPlansQuery, AdGroupBudgetPlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdGroupBudgetPlansQuery, AdGroupBudgetPlansQueryVariables>(AdGroupBudgetPlansDocument, options);
        }
// @ts-ignore
export function useAdGroupBudgetPlansSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdGroupBudgetPlansQuery, AdGroupBudgetPlansQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdGroupBudgetPlansQuery, AdGroupBudgetPlansQueryVariables>;
export function useAdGroupBudgetPlansSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdGroupBudgetPlansQuery, AdGroupBudgetPlansQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdGroupBudgetPlansQuery | undefined, AdGroupBudgetPlansQueryVariables>;
export function useAdGroupBudgetPlansSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdGroupBudgetPlansQuery, AdGroupBudgetPlansQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdGroupBudgetPlansQuery, AdGroupBudgetPlansQueryVariables>(AdGroupBudgetPlansDocument, options);
        }
export type AdGroupBudgetPlansQueryHookResult = ReturnType<typeof useAdGroupBudgetPlansQuery>;
export type AdGroupBudgetPlansLazyQueryHookResult = ReturnType<typeof useAdGroupBudgetPlansLazyQuery>;
export type AdGroupBudgetPlansSuspenseQueryHookResult = ReturnType<typeof useAdGroupBudgetPlansSuspenseQuery>;
export type AdGroupBudgetPlansQueryResult = ApolloReactCommon.QueryResult<AdGroupBudgetPlansQuery, AdGroupBudgetPlansQueryVariables>;
export const CreateAdGroupBudgetPlanDocument = gql`
    mutation createAdGroupBudgetPlan($plan: AdGroupBudgetPlanCreateInput!) {
  createAdGroupBudgetPlan(plan: $plan) {
    ...AdGroupBudgetPlanParts
  }
}
    ${AdGroupBudgetPlanPartsFragmentDoc}`;
export type CreateAdGroupBudgetPlanMutationFn = ApolloReactCommon.MutationFunction<CreateAdGroupBudgetPlanMutation, CreateAdGroupBudgetPlanMutationVariables>;

/**
 * __useCreateAdGroupBudgetPlanMutation__
 *
 * To run a mutation, you first call `useCreateAdGroupBudgetPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdGroupBudgetPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdGroupBudgetPlanMutation, { data, loading, error }] = useCreateAdGroupBudgetPlanMutation({
 *   variables: {
 *      plan: // value for 'plan'
 *   },
 * });
 */
export function useCreateAdGroupBudgetPlanMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateAdGroupBudgetPlanMutation, CreateAdGroupBudgetPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateAdGroupBudgetPlanMutation, CreateAdGroupBudgetPlanMutationVariables>(CreateAdGroupBudgetPlanDocument, options);
      }
export type CreateAdGroupBudgetPlanMutationHookResult = ReturnType<typeof useCreateAdGroupBudgetPlanMutation>;
export type CreateAdGroupBudgetPlanMutationResult = ApolloReactCommon.MutationResult<CreateAdGroupBudgetPlanMutation>;
export type CreateAdGroupBudgetPlanMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateAdGroupBudgetPlanMutation, CreateAdGroupBudgetPlanMutationVariables>;
export const UpdateAdGroupBudgetPlanDocument = gql`
    mutation updateAdGroupBudgetPlan($plan: AdGroupBudgetPlanUpdateInput!) {
  updateAdGroupBudgetPlan(plan: $plan) {
    ...AdGroupBudgetPlanParts
  }
}
    ${AdGroupBudgetPlanPartsFragmentDoc}`;
export type UpdateAdGroupBudgetPlanMutationFn = ApolloReactCommon.MutationFunction<UpdateAdGroupBudgetPlanMutation, UpdateAdGroupBudgetPlanMutationVariables>;

/**
 * __useUpdateAdGroupBudgetPlanMutation__
 *
 * To run a mutation, you first call `useUpdateAdGroupBudgetPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdGroupBudgetPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdGroupBudgetPlanMutation, { data, loading, error }] = useUpdateAdGroupBudgetPlanMutation({
 *   variables: {
 *      plan: // value for 'plan'
 *   },
 * });
 */
export function useUpdateAdGroupBudgetPlanMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAdGroupBudgetPlanMutation, UpdateAdGroupBudgetPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateAdGroupBudgetPlanMutation, UpdateAdGroupBudgetPlanMutationVariables>(UpdateAdGroupBudgetPlanDocument, options);
      }
export type UpdateAdGroupBudgetPlanMutationHookResult = ReturnType<typeof useUpdateAdGroupBudgetPlanMutation>;
export type UpdateAdGroupBudgetPlanMutationResult = ApolloReactCommon.MutationResult<UpdateAdGroupBudgetPlanMutation>;
export type UpdateAdGroupBudgetPlanMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateAdGroupBudgetPlanMutation, UpdateAdGroupBudgetPlanMutationVariables>;
export const DeleteAdGroupBudgetPlanDocument = gql`
    mutation deleteAdGroupBudgetPlan($id: PwsID!) {
  deleteAdGroupBudgetPlan(id: $id)
}
    `;
export type DeleteAdGroupBudgetPlanMutationFn = ApolloReactCommon.MutationFunction<DeleteAdGroupBudgetPlanMutation, DeleteAdGroupBudgetPlanMutationVariables>;

/**
 * __useDeleteAdGroupBudgetPlanMutation__
 *
 * To run a mutation, you first call `useDeleteAdGroupBudgetPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAdGroupBudgetPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAdGroupBudgetPlanMutation, { data, loading, error }] = useDeleteAdGroupBudgetPlanMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAdGroupBudgetPlanMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteAdGroupBudgetPlanMutation, DeleteAdGroupBudgetPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteAdGroupBudgetPlanMutation, DeleteAdGroupBudgetPlanMutationVariables>(DeleteAdGroupBudgetPlanDocument, options);
      }
export type DeleteAdGroupBudgetPlanMutationHookResult = ReturnType<typeof useDeleteAdGroupBudgetPlanMutation>;
export type DeleteAdGroupBudgetPlanMutationResult = ApolloReactCommon.MutationResult<DeleteAdGroupBudgetPlanMutation>;
export type DeleteAdGroupBudgetPlanMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteAdGroupBudgetPlanMutation, DeleteAdGroupBudgetPlanMutationVariables>;
export const AdGroupDirectoryPresetsDocument = gql`
    query adGroupDirectoryPresets($companyId: PwsID!) {
  adGroupDirectoryPresets(companyId: $companyId) {
    ...AdGroupDirectoryPresetParts
  }
}
    ${AdGroupDirectoryPresetPartsFragmentDoc}`;

/**
 * __useAdGroupDirectoryPresetsQuery__
 *
 * To run a query within a React component, call `useAdGroupDirectoryPresetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdGroupDirectoryPresetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdGroupDirectoryPresetsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useAdGroupDirectoryPresetsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdGroupDirectoryPresetsQuery, AdGroupDirectoryPresetsQueryVariables> & ({ variables: AdGroupDirectoryPresetsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdGroupDirectoryPresetsQuery, AdGroupDirectoryPresetsQueryVariables>(AdGroupDirectoryPresetsDocument, options);
      }
export function useAdGroupDirectoryPresetsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdGroupDirectoryPresetsQuery, AdGroupDirectoryPresetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdGroupDirectoryPresetsQuery, AdGroupDirectoryPresetsQueryVariables>(AdGroupDirectoryPresetsDocument, options);
        }
// @ts-ignore
export function useAdGroupDirectoryPresetsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdGroupDirectoryPresetsQuery, AdGroupDirectoryPresetsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdGroupDirectoryPresetsQuery, AdGroupDirectoryPresetsQueryVariables>;
export function useAdGroupDirectoryPresetsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdGroupDirectoryPresetsQuery, AdGroupDirectoryPresetsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdGroupDirectoryPresetsQuery | undefined, AdGroupDirectoryPresetsQueryVariables>;
export function useAdGroupDirectoryPresetsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdGroupDirectoryPresetsQuery, AdGroupDirectoryPresetsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdGroupDirectoryPresetsQuery, AdGroupDirectoryPresetsQueryVariables>(AdGroupDirectoryPresetsDocument, options);
        }
export type AdGroupDirectoryPresetsQueryHookResult = ReturnType<typeof useAdGroupDirectoryPresetsQuery>;
export type AdGroupDirectoryPresetsLazyQueryHookResult = ReturnType<typeof useAdGroupDirectoryPresetsLazyQuery>;
export type AdGroupDirectoryPresetsSuspenseQueryHookResult = ReturnType<typeof useAdGroupDirectoryPresetsSuspenseQuery>;
export type AdGroupDirectoryPresetsQueryResult = ApolloReactCommon.QueryResult<AdGroupDirectoryPresetsQuery, AdGroupDirectoryPresetsQueryVariables>;
export const SearchWebsitesForDirectoryPresetDocument = gql`
    query searchWebsitesForDirectoryPreset($pagination: Pagination!, $searchQuery: WebsiteSearchQuery!) {
  searchWebsites(pagination: $pagination, searchQuery: $searchQuery) {
    id
    name
    url
    iabCategory
    positions(status: [Active]) {
      id
      name
      channelType
      iabCategory
    }
  }
}
    `;

/**
 * __useSearchWebsitesForDirectoryPresetQuery__
 *
 * To run a query within a React component, call `useSearchWebsitesForDirectoryPresetQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchWebsitesForDirectoryPresetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchWebsitesForDirectoryPresetQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function useSearchWebsitesForDirectoryPresetQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchWebsitesForDirectoryPresetQuery, SearchWebsitesForDirectoryPresetQueryVariables> & ({ variables: SearchWebsitesForDirectoryPresetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchWebsitesForDirectoryPresetQuery, SearchWebsitesForDirectoryPresetQueryVariables>(SearchWebsitesForDirectoryPresetDocument, options);
      }
export function useSearchWebsitesForDirectoryPresetLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchWebsitesForDirectoryPresetQuery, SearchWebsitesForDirectoryPresetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchWebsitesForDirectoryPresetQuery, SearchWebsitesForDirectoryPresetQueryVariables>(SearchWebsitesForDirectoryPresetDocument, options);
        }
// @ts-ignore
export function useSearchWebsitesForDirectoryPresetSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SearchWebsitesForDirectoryPresetQuery, SearchWebsitesForDirectoryPresetQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SearchWebsitesForDirectoryPresetQuery, SearchWebsitesForDirectoryPresetQueryVariables>;
export function useSearchWebsitesForDirectoryPresetSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchWebsitesForDirectoryPresetQuery, SearchWebsitesForDirectoryPresetQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SearchWebsitesForDirectoryPresetQuery | undefined, SearchWebsitesForDirectoryPresetQueryVariables>;
export function useSearchWebsitesForDirectoryPresetSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchWebsitesForDirectoryPresetQuery, SearchWebsitesForDirectoryPresetQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SearchWebsitesForDirectoryPresetQuery, SearchWebsitesForDirectoryPresetQueryVariables>(SearchWebsitesForDirectoryPresetDocument, options);
        }
export type SearchWebsitesForDirectoryPresetQueryHookResult = ReturnType<typeof useSearchWebsitesForDirectoryPresetQuery>;
export type SearchWebsitesForDirectoryPresetLazyQueryHookResult = ReturnType<typeof useSearchWebsitesForDirectoryPresetLazyQuery>;
export type SearchWebsitesForDirectoryPresetSuspenseQueryHookResult = ReturnType<typeof useSearchWebsitesForDirectoryPresetSuspenseQuery>;
export type SearchWebsitesForDirectoryPresetQueryResult = ApolloReactCommon.QueryResult<SearchWebsitesForDirectoryPresetQuery, SearchWebsitesForDirectoryPresetQueryVariables>;
export const CreateAdGroupDirectoryPresetDocument = gql`
    mutation createAdGroupDirectoryPreset($name: String!, $companyId: PwsID!, $description: String) {
  createAdGroupDirectoryPreset(
    name: $name
    companyId: $companyId
    description: $description
  ) {
    id
    name
    description
  }
}
    `;
export type CreateAdGroupDirectoryPresetMutationFn = ApolloReactCommon.MutationFunction<CreateAdGroupDirectoryPresetMutation, CreateAdGroupDirectoryPresetMutationVariables>;

/**
 * __useCreateAdGroupDirectoryPresetMutation__
 *
 * To run a mutation, you first call `useCreateAdGroupDirectoryPresetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdGroupDirectoryPresetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdGroupDirectoryPresetMutation, { data, loading, error }] = useCreateAdGroupDirectoryPresetMutation({
 *   variables: {
 *      name: // value for 'name'
 *      companyId: // value for 'companyId'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useCreateAdGroupDirectoryPresetMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateAdGroupDirectoryPresetMutation, CreateAdGroupDirectoryPresetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateAdGroupDirectoryPresetMutation, CreateAdGroupDirectoryPresetMutationVariables>(CreateAdGroupDirectoryPresetDocument, options);
      }
export type CreateAdGroupDirectoryPresetMutationHookResult = ReturnType<typeof useCreateAdGroupDirectoryPresetMutation>;
export type CreateAdGroupDirectoryPresetMutationResult = ApolloReactCommon.MutationResult<CreateAdGroupDirectoryPresetMutation>;
export type CreateAdGroupDirectoryPresetMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateAdGroupDirectoryPresetMutation, CreateAdGroupDirectoryPresetMutationVariables>;
export const UpdateAdGroupDirectoryPresetDocument = gql`
    mutation updateAdGroupDirectoryPreset($preset: AdGroupDirectoryPresetInput!) {
  updateAdGroupDirectoryPreset(preset: $preset)
}
    `;
export type UpdateAdGroupDirectoryPresetMutationFn = ApolloReactCommon.MutationFunction<UpdateAdGroupDirectoryPresetMutation, UpdateAdGroupDirectoryPresetMutationVariables>;

/**
 * __useUpdateAdGroupDirectoryPresetMutation__
 *
 * To run a mutation, you first call `useUpdateAdGroupDirectoryPresetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdGroupDirectoryPresetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdGroupDirectoryPresetMutation, { data, loading, error }] = useUpdateAdGroupDirectoryPresetMutation({
 *   variables: {
 *      preset: // value for 'preset'
 *   },
 * });
 */
export function useUpdateAdGroupDirectoryPresetMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAdGroupDirectoryPresetMutation, UpdateAdGroupDirectoryPresetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateAdGroupDirectoryPresetMutation, UpdateAdGroupDirectoryPresetMutationVariables>(UpdateAdGroupDirectoryPresetDocument, options);
      }
export type UpdateAdGroupDirectoryPresetMutationHookResult = ReturnType<typeof useUpdateAdGroupDirectoryPresetMutation>;
export type UpdateAdGroupDirectoryPresetMutationResult = ApolloReactCommon.MutationResult<UpdateAdGroupDirectoryPresetMutation>;
export type UpdateAdGroupDirectoryPresetMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateAdGroupDirectoryPresetMutation, UpdateAdGroupDirectoryPresetMutationVariables>;
export const DeleteAdGroupDirectoryPresetDocument = gql`
    mutation deleteAdGroupDirectoryPreset($id: PwsID!) {
  deleteAdGroupDirectoryPreset(id: $id)
}
    `;
export type DeleteAdGroupDirectoryPresetMutationFn = ApolloReactCommon.MutationFunction<DeleteAdGroupDirectoryPresetMutation, DeleteAdGroupDirectoryPresetMutationVariables>;

/**
 * __useDeleteAdGroupDirectoryPresetMutation__
 *
 * To run a mutation, you first call `useDeleteAdGroupDirectoryPresetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAdGroupDirectoryPresetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAdGroupDirectoryPresetMutation, { data, loading, error }] = useDeleteAdGroupDirectoryPresetMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAdGroupDirectoryPresetMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteAdGroupDirectoryPresetMutation, DeleteAdGroupDirectoryPresetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteAdGroupDirectoryPresetMutation, DeleteAdGroupDirectoryPresetMutationVariables>(DeleteAdGroupDirectoryPresetDocument, options);
      }
export type DeleteAdGroupDirectoryPresetMutationHookResult = ReturnType<typeof useDeleteAdGroupDirectoryPresetMutation>;
export type DeleteAdGroupDirectoryPresetMutationResult = ApolloReactCommon.MutationResult<DeleteAdGroupDirectoryPresetMutation>;
export type DeleteAdGroupDirectoryPresetMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteAdGroupDirectoryPresetMutation, DeleteAdGroupDirectoryPresetMutationVariables>;
export const SelectAdGroupDirectoryPresetsDocument = gql`
    mutation selectAdGroupDirectoryPresets($adGroupId: PwsID!, $presetIds: [PwsID!]!) {
  selectAdGroupDirectoryPresets(adGroupId: $adGroupId, presetIds: $presetIds)
}
    `;
export type SelectAdGroupDirectoryPresetsMutationFn = ApolloReactCommon.MutationFunction<SelectAdGroupDirectoryPresetsMutation, SelectAdGroupDirectoryPresetsMutationVariables>;

/**
 * __useSelectAdGroupDirectoryPresetsMutation__
 *
 * To run a mutation, you first call `useSelectAdGroupDirectoryPresetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSelectAdGroupDirectoryPresetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [selectAdGroupDirectoryPresetsMutation, { data, loading, error }] = useSelectAdGroupDirectoryPresetsMutation({
 *   variables: {
 *      adGroupId: // value for 'adGroupId'
 *      presetIds: // value for 'presetIds'
 *   },
 * });
 */
export function useSelectAdGroupDirectoryPresetsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SelectAdGroupDirectoryPresetsMutation, SelectAdGroupDirectoryPresetsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SelectAdGroupDirectoryPresetsMutation, SelectAdGroupDirectoryPresetsMutationVariables>(SelectAdGroupDirectoryPresetsDocument, options);
      }
export type SelectAdGroupDirectoryPresetsMutationHookResult = ReturnType<typeof useSelectAdGroupDirectoryPresetsMutation>;
export type SelectAdGroupDirectoryPresetsMutationResult = ApolloReactCommon.MutationResult<SelectAdGroupDirectoryPresetsMutation>;
export type SelectAdGroupDirectoryPresetsMutationOptions = ApolloReactCommon.BaseMutationOptions<SelectAdGroupDirectoryPresetsMutation, SelectAdGroupDirectoryPresetsMutationVariables>;
export const PositionTemplatesDocument = gql`
    query positionTemplates($id: PwsID!, $pagination: Pagination, $searchQuery: AdTemplateSearchQuery!) {
  position(id: $id) {
    id
    adTemplates(pagination: $pagination, searchQuery: $searchQuery) {
      ... on AdTemplateNative {
        ...AdTemplateNativeParts
        ...AdTemplateNativeImageDescriptorParts
      }
      ... on AdTemplateBanner {
        ...AdTemplateBannerParts
      }
      ... on AdTemplateWeb {
        ...AdTemplateWebParts
      }
    }
  }
}
    ${AdTemplateNativePartsFragmentDoc}
${AdTemplateNativeImageDescriptorPartsFragmentDoc}
${AdTemplateBannerPartsFragmentDoc}
${AdTemplateWebPartsFragmentDoc}`;

/**
 * __usePositionTemplatesQuery__
 *
 * To run a query within a React component, call `usePositionTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePositionTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePositionTemplatesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      pagination: // value for 'pagination'
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function usePositionTemplatesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PositionTemplatesQuery, PositionTemplatesQueryVariables> & ({ variables: PositionTemplatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PositionTemplatesQuery, PositionTemplatesQueryVariables>(PositionTemplatesDocument, options);
      }
export function usePositionTemplatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PositionTemplatesQuery, PositionTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PositionTemplatesQuery, PositionTemplatesQueryVariables>(PositionTemplatesDocument, options);
        }
// @ts-ignore
export function usePositionTemplatesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PositionTemplatesQuery, PositionTemplatesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PositionTemplatesQuery, PositionTemplatesQueryVariables>;
export function usePositionTemplatesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PositionTemplatesQuery, PositionTemplatesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PositionTemplatesQuery | undefined, PositionTemplatesQueryVariables>;
export function usePositionTemplatesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PositionTemplatesQuery, PositionTemplatesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PositionTemplatesQuery, PositionTemplatesQueryVariables>(PositionTemplatesDocument, options);
        }
export type PositionTemplatesQueryHookResult = ReturnType<typeof usePositionTemplatesQuery>;
export type PositionTemplatesLazyQueryHookResult = ReturnType<typeof usePositionTemplatesLazyQuery>;
export type PositionTemplatesSuspenseQueryHookResult = ReturnType<typeof usePositionTemplatesSuspenseQuery>;
export type PositionTemplatesQueryResult = ApolloReactCommon.QueryResult<PositionTemplatesQuery, PositionTemplatesQueryVariables>;
export const LoadTemplateDocument = gql`
    query loadTemplate($positionId: PwsID!, $id: PwsID!) {
  adTemplate(positionId: $positionId, id: $id) {
    ... on AdTemplateNative {
      ...AdTemplateNativeParts
      ...AdTemplateNativeImageDescriptorParts
    }
    ... on AdTemplateBanner {
      ...AdTemplateBannerParts
    }
    ... on AdTemplateWeb {
      ...AdTemplateWebParts
    }
  }
}
    ${AdTemplateNativePartsFragmentDoc}
${AdTemplateNativeImageDescriptorPartsFragmentDoc}
${AdTemplateBannerPartsFragmentDoc}
${AdTemplateWebPartsFragmentDoc}`;

/**
 * __useLoadTemplateQuery__
 *
 * To run a query within a React component, call `useLoadTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadTemplateQuery({
 *   variables: {
 *      positionId: // value for 'positionId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLoadTemplateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<LoadTemplateQuery, LoadTemplateQueryVariables> & ({ variables: LoadTemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LoadTemplateQuery, LoadTemplateQueryVariables>(LoadTemplateDocument, options);
      }
export function useLoadTemplateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LoadTemplateQuery, LoadTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LoadTemplateQuery, LoadTemplateQueryVariables>(LoadTemplateDocument, options);
        }
// @ts-ignore
export function useLoadTemplateSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<LoadTemplateQuery, LoadTemplateQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<LoadTemplateQuery, LoadTemplateQueryVariables>;
export function useLoadTemplateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<LoadTemplateQuery, LoadTemplateQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<LoadTemplateQuery | undefined, LoadTemplateQueryVariables>;
export function useLoadTemplateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<LoadTemplateQuery, LoadTemplateQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<LoadTemplateQuery, LoadTemplateQueryVariables>(LoadTemplateDocument, options);
        }
export type LoadTemplateQueryHookResult = ReturnType<typeof useLoadTemplateQuery>;
export type LoadTemplateLazyQueryHookResult = ReturnType<typeof useLoadTemplateLazyQuery>;
export type LoadTemplateSuspenseQueryHookResult = ReturnType<typeof useLoadTemplateSuspenseQuery>;
export type LoadTemplateQueryResult = ApolloReactCommon.QueryResult<LoadTemplateQuery, LoadTemplateQueryVariables>;
export const AdTemplateNativeImageDescriptorDocument = gql`
    query adTemplateNativeImageDescriptor($positionId: PwsID!, $id: PwsID!) {
  adTemplate(positionId: $positionId, id: $id) {
    ... on AdTemplateNative {
      ...AdTemplateNativeImageDescriptorParts
    }
  }
}
    ${AdTemplateNativeImageDescriptorPartsFragmentDoc}`;

/**
 * __useAdTemplateNativeImageDescriptorQuery__
 *
 * To run a query within a React component, call `useAdTemplateNativeImageDescriptorQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdTemplateNativeImageDescriptorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdTemplateNativeImageDescriptorQuery({
 *   variables: {
 *      positionId: // value for 'positionId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdTemplateNativeImageDescriptorQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdTemplateNativeImageDescriptorQuery, AdTemplateNativeImageDescriptorQueryVariables> & ({ variables: AdTemplateNativeImageDescriptorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdTemplateNativeImageDescriptorQuery, AdTemplateNativeImageDescriptorQueryVariables>(AdTemplateNativeImageDescriptorDocument, options);
      }
export function useAdTemplateNativeImageDescriptorLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdTemplateNativeImageDescriptorQuery, AdTemplateNativeImageDescriptorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdTemplateNativeImageDescriptorQuery, AdTemplateNativeImageDescriptorQueryVariables>(AdTemplateNativeImageDescriptorDocument, options);
        }
// @ts-ignore
export function useAdTemplateNativeImageDescriptorSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdTemplateNativeImageDescriptorQuery, AdTemplateNativeImageDescriptorQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdTemplateNativeImageDescriptorQuery, AdTemplateNativeImageDescriptorQueryVariables>;
export function useAdTemplateNativeImageDescriptorSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdTemplateNativeImageDescriptorQuery, AdTemplateNativeImageDescriptorQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdTemplateNativeImageDescriptorQuery | undefined, AdTemplateNativeImageDescriptorQueryVariables>;
export function useAdTemplateNativeImageDescriptorSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdTemplateNativeImageDescriptorQuery, AdTemplateNativeImageDescriptorQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdTemplateNativeImageDescriptorQuery, AdTemplateNativeImageDescriptorQueryVariables>(AdTemplateNativeImageDescriptorDocument, options);
        }
export type AdTemplateNativeImageDescriptorQueryHookResult = ReturnType<typeof useAdTemplateNativeImageDescriptorQuery>;
export type AdTemplateNativeImageDescriptorLazyQueryHookResult = ReturnType<typeof useAdTemplateNativeImageDescriptorLazyQuery>;
export type AdTemplateNativeImageDescriptorSuspenseQueryHookResult = ReturnType<typeof useAdTemplateNativeImageDescriptorSuspenseQuery>;
export type AdTemplateNativeImageDescriptorQueryResult = ApolloReactCommon.QueryResult<AdTemplateNativeImageDescriptorQuery, AdTemplateNativeImageDescriptorQueryVariables>;
export const AdTemplateNativePreviewDocument = gql`
    query adTemplateNativePreview($template: ImageTemplateDescriptorInput!) {
  template1: adTemplateNativePreview(advertisement: 1, template: $template)
  template2: adTemplateNativePreview(advertisement: 2, template: $template)
  template3: adTemplateNativePreview(advertisement: 3, template: $template)
}
    `;

/**
 * __useAdTemplateNativePreviewQuery__
 *
 * To run a query within a React component, call `useAdTemplateNativePreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdTemplateNativePreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdTemplateNativePreviewQuery({
 *   variables: {
 *      template: // value for 'template'
 *   },
 * });
 */
export function useAdTemplateNativePreviewQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdTemplateNativePreviewQuery, AdTemplateNativePreviewQueryVariables> & ({ variables: AdTemplateNativePreviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdTemplateNativePreviewQuery, AdTemplateNativePreviewQueryVariables>(AdTemplateNativePreviewDocument, options);
      }
export function useAdTemplateNativePreviewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdTemplateNativePreviewQuery, AdTemplateNativePreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdTemplateNativePreviewQuery, AdTemplateNativePreviewQueryVariables>(AdTemplateNativePreviewDocument, options);
        }
// @ts-ignore
export function useAdTemplateNativePreviewSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdTemplateNativePreviewQuery, AdTemplateNativePreviewQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdTemplateNativePreviewQuery, AdTemplateNativePreviewQueryVariables>;
export function useAdTemplateNativePreviewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdTemplateNativePreviewQuery, AdTemplateNativePreviewQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdTemplateNativePreviewQuery | undefined, AdTemplateNativePreviewQueryVariables>;
export function useAdTemplateNativePreviewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdTemplateNativePreviewQuery, AdTemplateNativePreviewQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdTemplateNativePreviewQuery, AdTemplateNativePreviewQueryVariables>(AdTemplateNativePreviewDocument, options);
        }
export type AdTemplateNativePreviewQueryHookResult = ReturnType<typeof useAdTemplateNativePreviewQuery>;
export type AdTemplateNativePreviewLazyQueryHookResult = ReturnType<typeof useAdTemplateNativePreviewLazyQuery>;
export type AdTemplateNativePreviewSuspenseQueryHookResult = ReturnType<typeof useAdTemplateNativePreviewSuspenseQuery>;
export type AdTemplateNativePreviewQueryResult = ApolloReactCommon.QueryResult<AdTemplateNativePreviewQuery, AdTemplateNativePreviewQueryVariables>;
export const AdTemplateImageMaxSizeDocument = gql`
    query adTemplateImageMaxSize($reseller: PwsID!) {
  adTemplateImageMaxSize(reseller: $reseller) {
    width
    height
  }
}
    `;

/**
 * __useAdTemplateImageMaxSizeQuery__
 *
 * To run a query within a React component, call `useAdTemplateImageMaxSizeQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdTemplateImageMaxSizeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdTemplateImageMaxSizeQuery({
 *   variables: {
 *      reseller: // value for 'reseller'
 *   },
 * });
 */
export function useAdTemplateImageMaxSizeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdTemplateImageMaxSizeQuery, AdTemplateImageMaxSizeQueryVariables> & ({ variables: AdTemplateImageMaxSizeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdTemplateImageMaxSizeQuery, AdTemplateImageMaxSizeQueryVariables>(AdTemplateImageMaxSizeDocument, options);
      }
export function useAdTemplateImageMaxSizeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdTemplateImageMaxSizeQuery, AdTemplateImageMaxSizeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdTemplateImageMaxSizeQuery, AdTemplateImageMaxSizeQueryVariables>(AdTemplateImageMaxSizeDocument, options);
        }
// @ts-ignore
export function useAdTemplateImageMaxSizeSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdTemplateImageMaxSizeQuery, AdTemplateImageMaxSizeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdTemplateImageMaxSizeQuery, AdTemplateImageMaxSizeQueryVariables>;
export function useAdTemplateImageMaxSizeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdTemplateImageMaxSizeQuery, AdTemplateImageMaxSizeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdTemplateImageMaxSizeQuery | undefined, AdTemplateImageMaxSizeQueryVariables>;
export function useAdTemplateImageMaxSizeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdTemplateImageMaxSizeQuery, AdTemplateImageMaxSizeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdTemplateImageMaxSizeQuery, AdTemplateImageMaxSizeQueryVariables>(AdTemplateImageMaxSizeDocument, options);
        }
export type AdTemplateImageMaxSizeQueryHookResult = ReturnType<typeof useAdTemplateImageMaxSizeQuery>;
export type AdTemplateImageMaxSizeLazyQueryHookResult = ReturnType<typeof useAdTemplateImageMaxSizeLazyQuery>;
export type AdTemplateImageMaxSizeSuspenseQueryHookResult = ReturnType<typeof useAdTemplateImageMaxSizeSuspenseQuery>;
export type AdTemplateImageMaxSizeQueryResult = ApolloReactCommon.QueryResult<AdTemplateImageMaxSizeQuery, AdTemplateImageMaxSizeQueryVariables>;
export const CreateAdTemplateNativeDocument = gql`
    mutation createAdTemplateNative($newAdTemplate: AdTemplateNativeCreateInput!) {
  createAdTemplateNative(newAdTemplate: $newAdTemplate) {
    ...AdTemplateNativeParts
  }
}
    ${AdTemplateNativePartsFragmentDoc}`;
export type CreateAdTemplateNativeMutationFn = ApolloReactCommon.MutationFunction<CreateAdTemplateNativeMutation, CreateAdTemplateNativeMutationVariables>;

/**
 * __useCreateAdTemplateNativeMutation__
 *
 * To run a mutation, you first call `useCreateAdTemplateNativeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdTemplateNativeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdTemplateNativeMutation, { data, loading, error }] = useCreateAdTemplateNativeMutation({
 *   variables: {
 *      newAdTemplate: // value for 'newAdTemplate'
 *   },
 * });
 */
export function useCreateAdTemplateNativeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateAdTemplateNativeMutation, CreateAdTemplateNativeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateAdTemplateNativeMutation, CreateAdTemplateNativeMutationVariables>(CreateAdTemplateNativeDocument, options);
      }
export type CreateAdTemplateNativeMutationHookResult = ReturnType<typeof useCreateAdTemplateNativeMutation>;
export type CreateAdTemplateNativeMutationResult = ApolloReactCommon.MutationResult<CreateAdTemplateNativeMutation>;
export type CreateAdTemplateNativeMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateAdTemplateNativeMutation, CreateAdTemplateNativeMutationVariables>;
export const CreateAdTemplateBannerDocument = gql`
    mutation createAdTemplateBanner($newAdTemplate: AdTemplateBannerCreateInput!) {
  createAdTemplateBanner(newAdTemplate: $newAdTemplate) {
    ...AdTemplateBannerParts
  }
}
    ${AdTemplateBannerPartsFragmentDoc}`;
export type CreateAdTemplateBannerMutationFn = ApolloReactCommon.MutationFunction<CreateAdTemplateBannerMutation, CreateAdTemplateBannerMutationVariables>;

/**
 * __useCreateAdTemplateBannerMutation__
 *
 * To run a mutation, you first call `useCreateAdTemplateBannerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdTemplateBannerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdTemplateBannerMutation, { data, loading, error }] = useCreateAdTemplateBannerMutation({
 *   variables: {
 *      newAdTemplate: // value for 'newAdTemplate'
 *   },
 * });
 */
export function useCreateAdTemplateBannerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateAdTemplateBannerMutation, CreateAdTemplateBannerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateAdTemplateBannerMutation, CreateAdTemplateBannerMutationVariables>(CreateAdTemplateBannerDocument, options);
      }
export type CreateAdTemplateBannerMutationHookResult = ReturnType<typeof useCreateAdTemplateBannerMutation>;
export type CreateAdTemplateBannerMutationResult = ApolloReactCommon.MutationResult<CreateAdTemplateBannerMutation>;
export type CreateAdTemplateBannerMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateAdTemplateBannerMutation, CreateAdTemplateBannerMutationVariables>;
export const CreateAdTemplateWebDocument = gql`
    mutation createAdTemplateWeb($newAdTemplate: AdTemplateWebCreateInput!) {
  createAdTemplateWeb(newAdTemplate: $newAdTemplate) {
    ...AdTemplateWebParts
  }
}
    ${AdTemplateWebPartsFragmentDoc}`;
export type CreateAdTemplateWebMutationFn = ApolloReactCommon.MutationFunction<CreateAdTemplateWebMutation, CreateAdTemplateWebMutationVariables>;

/**
 * __useCreateAdTemplateWebMutation__
 *
 * To run a mutation, you first call `useCreateAdTemplateWebMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdTemplateWebMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdTemplateWebMutation, { data, loading, error }] = useCreateAdTemplateWebMutation({
 *   variables: {
 *      newAdTemplate: // value for 'newAdTemplate'
 *   },
 * });
 */
export function useCreateAdTemplateWebMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateAdTemplateWebMutation, CreateAdTemplateWebMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateAdTemplateWebMutation, CreateAdTemplateWebMutationVariables>(CreateAdTemplateWebDocument, options);
      }
export type CreateAdTemplateWebMutationHookResult = ReturnType<typeof useCreateAdTemplateWebMutation>;
export type CreateAdTemplateWebMutationResult = ApolloReactCommon.MutationResult<CreateAdTemplateWebMutation>;
export type CreateAdTemplateWebMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateAdTemplateWebMutation, CreateAdTemplateWebMutationVariables>;
export const DuplicateAdTemplateDocument = gql`
    mutation duplicateAdTemplate($adTemplateId: PwsID!, $positionId: PwsID!, $newName: String!) {
  duplicateAdTemplate(
    adTemplateId: $adTemplateId
    positionId: $positionId
    newName: $newName
  ) {
    ... on AdTemplateNative {
      ...AdTemplateNativeParts
    }
    ... on AdTemplateBanner {
      ...AdTemplateBannerParts
    }
    ... on AdTemplateWeb {
      ...AdTemplateWebParts
    }
  }
}
    ${AdTemplateNativePartsFragmentDoc}
${AdTemplateBannerPartsFragmentDoc}
${AdTemplateWebPartsFragmentDoc}`;
export type DuplicateAdTemplateMutationFn = ApolloReactCommon.MutationFunction<DuplicateAdTemplateMutation, DuplicateAdTemplateMutationVariables>;

/**
 * __useDuplicateAdTemplateMutation__
 *
 * To run a mutation, you first call `useDuplicateAdTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateAdTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateAdTemplateMutation, { data, loading, error }] = useDuplicateAdTemplateMutation({
 *   variables: {
 *      adTemplateId: // value for 'adTemplateId'
 *      positionId: // value for 'positionId'
 *      newName: // value for 'newName'
 *   },
 * });
 */
export function useDuplicateAdTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DuplicateAdTemplateMutation, DuplicateAdTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DuplicateAdTemplateMutation, DuplicateAdTemplateMutationVariables>(DuplicateAdTemplateDocument, options);
      }
export type DuplicateAdTemplateMutationHookResult = ReturnType<typeof useDuplicateAdTemplateMutation>;
export type DuplicateAdTemplateMutationResult = ApolloReactCommon.MutationResult<DuplicateAdTemplateMutation>;
export type DuplicateAdTemplateMutationOptions = ApolloReactCommon.BaseMutationOptions<DuplicateAdTemplateMutation, DuplicateAdTemplateMutationVariables>;
export const UpdateAdTemplateNativeDocument = gql`
    mutation updateAdTemplateNative($adTemplate: AdTemplateNativeInput!, $mobileBackground: Upload, $normalBackground: Upload) {
  updateAdTemplateNative(
    adTemplate: $adTemplate
    mobileBackground: $mobileBackground
    normalBackground: $normalBackground
  ) {
    ...AdTemplateNativeParts
    ...AdTemplateNativeImageDescriptorParts
  }
}
    ${AdTemplateNativePartsFragmentDoc}
${AdTemplateNativeImageDescriptorPartsFragmentDoc}`;
export type UpdateAdTemplateNativeMutationFn = ApolloReactCommon.MutationFunction<UpdateAdTemplateNativeMutation, UpdateAdTemplateNativeMutationVariables>;

/**
 * __useUpdateAdTemplateNativeMutation__
 *
 * To run a mutation, you first call `useUpdateAdTemplateNativeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdTemplateNativeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdTemplateNativeMutation, { data, loading, error }] = useUpdateAdTemplateNativeMutation({
 *   variables: {
 *      adTemplate: // value for 'adTemplate'
 *      mobileBackground: // value for 'mobileBackground'
 *      normalBackground: // value for 'normalBackground'
 *   },
 * });
 */
export function useUpdateAdTemplateNativeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAdTemplateNativeMutation, UpdateAdTemplateNativeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateAdTemplateNativeMutation, UpdateAdTemplateNativeMutationVariables>(UpdateAdTemplateNativeDocument, options);
      }
export type UpdateAdTemplateNativeMutationHookResult = ReturnType<typeof useUpdateAdTemplateNativeMutation>;
export type UpdateAdTemplateNativeMutationResult = ApolloReactCommon.MutationResult<UpdateAdTemplateNativeMutation>;
export type UpdateAdTemplateNativeMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateAdTemplateNativeMutation, UpdateAdTemplateNativeMutationVariables>;
export const UpdateAdTemplateBannerDocument = gql`
    mutation updateAdTemplateBanner($adTemplate: AdTemplateBannerInput!) {
  updateAdTemplateBanner(adTemplate: $adTemplate) {
    ...AdTemplateBannerParts
  }
}
    ${AdTemplateBannerPartsFragmentDoc}`;
export type UpdateAdTemplateBannerMutationFn = ApolloReactCommon.MutationFunction<UpdateAdTemplateBannerMutation, UpdateAdTemplateBannerMutationVariables>;

/**
 * __useUpdateAdTemplateBannerMutation__
 *
 * To run a mutation, you first call `useUpdateAdTemplateBannerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdTemplateBannerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdTemplateBannerMutation, { data, loading, error }] = useUpdateAdTemplateBannerMutation({
 *   variables: {
 *      adTemplate: // value for 'adTemplate'
 *   },
 * });
 */
export function useUpdateAdTemplateBannerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAdTemplateBannerMutation, UpdateAdTemplateBannerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateAdTemplateBannerMutation, UpdateAdTemplateBannerMutationVariables>(UpdateAdTemplateBannerDocument, options);
      }
export type UpdateAdTemplateBannerMutationHookResult = ReturnType<typeof useUpdateAdTemplateBannerMutation>;
export type UpdateAdTemplateBannerMutationResult = ApolloReactCommon.MutationResult<UpdateAdTemplateBannerMutation>;
export type UpdateAdTemplateBannerMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateAdTemplateBannerMutation, UpdateAdTemplateBannerMutationVariables>;
export const UpdateAdTemplateWebDocument = gql`
    mutation updateAdTemplateWeb($adTemplate: AdTemplateWebInput!) {
  updateAdTemplateWeb(adTemplate: $adTemplate) {
    ...AdTemplateWebParts
  }
}
    ${AdTemplateWebPartsFragmentDoc}`;
export type UpdateAdTemplateWebMutationFn = ApolloReactCommon.MutationFunction<UpdateAdTemplateWebMutation, UpdateAdTemplateWebMutationVariables>;

/**
 * __useUpdateAdTemplateWebMutation__
 *
 * To run a mutation, you first call `useUpdateAdTemplateWebMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdTemplateWebMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdTemplateWebMutation, { data, loading, error }] = useUpdateAdTemplateWebMutation({
 *   variables: {
 *      adTemplate: // value for 'adTemplate'
 *   },
 * });
 */
export function useUpdateAdTemplateWebMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAdTemplateWebMutation, UpdateAdTemplateWebMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateAdTemplateWebMutation, UpdateAdTemplateWebMutationVariables>(UpdateAdTemplateWebDocument, options);
      }
export type UpdateAdTemplateWebMutationHookResult = ReturnType<typeof useUpdateAdTemplateWebMutation>;
export type UpdateAdTemplateWebMutationResult = ApolloReactCommon.MutationResult<UpdateAdTemplateWebMutation>;
export type UpdateAdTemplateWebMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateAdTemplateWebMutation, UpdateAdTemplateWebMutationVariables>;
export const DeleteAdTemplateDocument = gql`
    mutation deleteAdTemplate($positionId: PwsID!, $adTemplateId: PwsID!) {
  deleteAdTemplate(positionId: $positionId, adTemplateId: $adTemplateId)
}
    `;
export type DeleteAdTemplateMutationFn = ApolloReactCommon.MutationFunction<DeleteAdTemplateMutation, DeleteAdTemplateMutationVariables>;

/**
 * __useDeleteAdTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteAdTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAdTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAdTemplateMutation, { data, loading, error }] = useDeleteAdTemplateMutation({
 *   variables: {
 *      positionId: // value for 'positionId'
 *      adTemplateId: // value for 'adTemplateId'
 *   },
 * });
 */
export function useDeleteAdTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteAdTemplateMutation, DeleteAdTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteAdTemplateMutation, DeleteAdTemplateMutationVariables>(DeleteAdTemplateDocument, options);
      }
export type DeleteAdTemplateMutationHookResult = ReturnType<typeof useDeleteAdTemplateMutation>;
export type DeleteAdTemplateMutationResult = ApolloReactCommon.MutationResult<DeleteAdTemplateMutation>;
export type DeleteAdTemplateMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteAdTemplateMutation, DeleteAdTemplateMutationVariables>;
export const GetFontListDocument = gql`
    query getFontList {
  getFontList
}
    `;

/**
 * __useGetFontListQuery__
 *
 * To run a query within a React component, call `useGetFontListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFontListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFontListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFontListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetFontListQuery, GetFontListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFontListQuery, GetFontListQueryVariables>(GetFontListDocument, options);
      }
export function useGetFontListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFontListQuery, GetFontListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFontListQuery, GetFontListQueryVariables>(GetFontListDocument, options);
        }
// @ts-ignore
export function useGetFontListSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetFontListQuery, GetFontListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetFontListQuery, GetFontListQueryVariables>;
export function useGetFontListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetFontListQuery, GetFontListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetFontListQuery | undefined, GetFontListQueryVariables>;
export function useGetFontListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetFontListQuery, GetFontListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetFontListQuery, GetFontListQueryVariables>(GetFontListDocument, options);
        }
export type GetFontListQueryHookResult = ReturnType<typeof useGetFontListQuery>;
export type GetFontListLazyQueryHookResult = ReturnType<typeof useGetFontListLazyQuery>;
export type GetFontListSuspenseQueryHookResult = ReturnType<typeof useGetFontListSuspenseQuery>;
export type GetFontListQueryResult = ApolloReactCommon.QueryResult<GetFontListQuery, GetFontListQueryVariables>;
export const AdvertiserNameDocument = gql`
    query advertiserName($id: PwsID!) {
  advertiser(id: $id) {
    id
    name
  }
}
    `;

/**
 * __useAdvertiserNameQuery__
 *
 * To run a query within a React component, call `useAdvertiserNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdvertiserNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdvertiserNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdvertiserNameQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdvertiserNameQuery, AdvertiserNameQueryVariables> & ({ variables: AdvertiserNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdvertiserNameQuery, AdvertiserNameQueryVariables>(AdvertiserNameDocument, options);
      }
export function useAdvertiserNameLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdvertiserNameQuery, AdvertiserNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdvertiserNameQuery, AdvertiserNameQueryVariables>(AdvertiserNameDocument, options);
        }
// @ts-ignore
export function useAdvertiserNameSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdvertiserNameQuery, AdvertiserNameQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdvertiserNameQuery, AdvertiserNameQueryVariables>;
export function useAdvertiserNameSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdvertiserNameQuery, AdvertiserNameQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdvertiserNameQuery | undefined, AdvertiserNameQueryVariables>;
export function useAdvertiserNameSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdvertiserNameQuery, AdvertiserNameQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdvertiserNameQuery, AdvertiserNameQueryVariables>(AdvertiserNameDocument, options);
        }
export type AdvertiserNameQueryHookResult = ReturnType<typeof useAdvertiserNameQuery>;
export type AdvertiserNameLazyQueryHookResult = ReturnType<typeof useAdvertiserNameLazyQuery>;
export type AdvertiserNameSuspenseQueryHookResult = ReturnType<typeof useAdvertiserNameSuspenseQuery>;
export type AdvertiserNameQueryResult = ApolloReactCommon.QueryResult<AdvertiserNameQuery, AdvertiserNameQueryVariables>;
export const AdvertiserSettingsDocument = gql`
    query advertiserSettings($id: PwsID!) {
  advertiser(id: $id) {
    id
    agency {
      id
      name
    }
    settings {
      gestion
      subType
      unknownTrafficRate
      copperId
      accountManagerId
      salesManagerId
    }
  }
}
    `;

/**
 * __useAdvertiserSettingsQuery__
 *
 * To run a query within a React component, call `useAdvertiserSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdvertiserSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdvertiserSettingsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdvertiserSettingsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdvertiserSettingsQuery, AdvertiserSettingsQueryVariables> & ({ variables: AdvertiserSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdvertiserSettingsQuery, AdvertiserSettingsQueryVariables>(AdvertiserSettingsDocument, options);
      }
export function useAdvertiserSettingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdvertiserSettingsQuery, AdvertiserSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdvertiserSettingsQuery, AdvertiserSettingsQueryVariables>(AdvertiserSettingsDocument, options);
        }
// @ts-ignore
export function useAdvertiserSettingsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdvertiserSettingsQuery, AdvertiserSettingsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdvertiserSettingsQuery, AdvertiserSettingsQueryVariables>;
export function useAdvertiserSettingsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdvertiserSettingsQuery, AdvertiserSettingsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdvertiserSettingsQuery | undefined, AdvertiserSettingsQueryVariables>;
export function useAdvertiserSettingsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdvertiserSettingsQuery, AdvertiserSettingsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdvertiserSettingsQuery, AdvertiserSettingsQueryVariables>(AdvertiserSettingsDocument, options);
        }
export type AdvertiserSettingsQueryHookResult = ReturnType<typeof useAdvertiserSettingsQuery>;
export type AdvertiserSettingsLazyQueryHookResult = ReturnType<typeof useAdvertiserSettingsLazyQuery>;
export type AdvertiserSettingsSuspenseQueryHookResult = ReturnType<typeof useAdvertiserSettingsSuspenseQuery>;
export type AdvertiserSettingsQueryResult = ApolloReactCommon.QueryResult<AdvertiserSettingsQuery, AdvertiserSettingsQueryVariables>;
export const AdvertiserTimeseriesDocument = gql`
    query advertiserTimeseries($endDate: DateTime!, $startDate: DateTime!, $advertiserId: PwsID, $slug: String, $granularity: GraphGranularity!, $filters: [CostDetailsFilter!]) {
  advertiser(id: $advertiserId, slug: $slug) {
    id
    timeseries(
      granularity: $granularity
      endDate: $endDate
      startDate: $startDate
      filters: $filters
    ) {
      ...AdvertiserTimeseries
    }
  }
}
    ${AdvertiserTimeseriesFragmentDoc}`;

/**
 * __useAdvertiserTimeseriesQuery__
 *
 * To run a query within a React component, call `useAdvertiserTimeseriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdvertiserTimeseriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdvertiserTimeseriesQuery({
 *   variables: {
 *      endDate: // value for 'endDate'
 *      startDate: // value for 'startDate'
 *      advertiserId: // value for 'advertiserId'
 *      slug: // value for 'slug'
 *      granularity: // value for 'granularity'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useAdvertiserTimeseriesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdvertiserTimeseriesQuery, AdvertiserTimeseriesQueryVariables> & ({ variables: AdvertiserTimeseriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdvertiserTimeseriesQuery, AdvertiserTimeseriesQueryVariables>(AdvertiserTimeseriesDocument, options);
      }
export function useAdvertiserTimeseriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdvertiserTimeseriesQuery, AdvertiserTimeseriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdvertiserTimeseriesQuery, AdvertiserTimeseriesQueryVariables>(AdvertiserTimeseriesDocument, options);
        }
// @ts-ignore
export function useAdvertiserTimeseriesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdvertiserTimeseriesQuery, AdvertiserTimeseriesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdvertiserTimeseriesQuery, AdvertiserTimeseriesQueryVariables>;
export function useAdvertiserTimeseriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdvertiserTimeseriesQuery, AdvertiserTimeseriesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdvertiserTimeseriesQuery | undefined, AdvertiserTimeseriesQueryVariables>;
export function useAdvertiserTimeseriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdvertiserTimeseriesQuery, AdvertiserTimeseriesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdvertiserTimeseriesQuery, AdvertiserTimeseriesQueryVariables>(AdvertiserTimeseriesDocument, options);
        }
export type AdvertiserTimeseriesQueryHookResult = ReturnType<typeof useAdvertiserTimeseriesQuery>;
export type AdvertiserTimeseriesLazyQueryHookResult = ReturnType<typeof useAdvertiserTimeseriesLazyQuery>;
export type AdvertiserTimeseriesSuspenseQueryHookResult = ReturnType<typeof useAdvertiserTimeseriesSuspenseQuery>;
export type AdvertiserTimeseriesQueryResult = ApolloReactCommon.QueryResult<AdvertiserTimeseriesQuery, AdvertiserTimeseriesQueryVariables>;
export const AdvertiserPerformanceStatsDocument = gql`
    query advertiserPerformanceStats($endDate: DateTime!, $startDate: DateTime!, $slug: String, $filters: [CostDetailsFilter!]) {
  advertiser(slug: $slug) {
    id
    performanceStats(endDate: $endDate, startDate: $startDate, filters: $filters) {
      stats {
        ...AdvertiserPerformanceStatsParts
      }
      publisherResellers {
        name
        stats {
          ...AdvertiserPerformanceStatsParts
        }
        publishers {
          name
          stats {
            ...AdvertiserPerformanceStatsParts
          }
          websites {
            name
            stats {
              ...AdvertiserPerformanceStatsParts
            }
            positions {
              name
              stats {
                ...AdvertiserPerformanceStatsParts
              }
            }
          }
        }
      }
      campaigns {
        id
        name
        status
        stats {
          ...AdvertiserPerformanceStatsParts
        }
      }
    }
  }
}
    ${AdvertiserPerformanceStatsPartsFragmentDoc}`;

/**
 * __useAdvertiserPerformanceStatsQuery__
 *
 * To run a query within a React component, call `useAdvertiserPerformanceStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdvertiserPerformanceStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdvertiserPerformanceStatsQuery({
 *   variables: {
 *      endDate: // value for 'endDate'
 *      startDate: // value for 'startDate'
 *      slug: // value for 'slug'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useAdvertiserPerformanceStatsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdvertiserPerformanceStatsQuery, AdvertiserPerformanceStatsQueryVariables> & ({ variables: AdvertiserPerformanceStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdvertiserPerformanceStatsQuery, AdvertiserPerformanceStatsQueryVariables>(AdvertiserPerformanceStatsDocument, options);
      }
export function useAdvertiserPerformanceStatsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdvertiserPerformanceStatsQuery, AdvertiserPerformanceStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdvertiserPerformanceStatsQuery, AdvertiserPerformanceStatsQueryVariables>(AdvertiserPerformanceStatsDocument, options);
        }
// @ts-ignore
export function useAdvertiserPerformanceStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdvertiserPerformanceStatsQuery, AdvertiserPerformanceStatsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdvertiserPerformanceStatsQuery, AdvertiserPerformanceStatsQueryVariables>;
export function useAdvertiserPerformanceStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdvertiserPerformanceStatsQuery, AdvertiserPerformanceStatsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdvertiserPerformanceStatsQuery | undefined, AdvertiserPerformanceStatsQueryVariables>;
export function useAdvertiserPerformanceStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdvertiserPerformanceStatsQuery, AdvertiserPerformanceStatsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdvertiserPerformanceStatsQuery, AdvertiserPerformanceStatsQueryVariables>(AdvertiserPerformanceStatsDocument, options);
        }
export type AdvertiserPerformanceStatsQueryHookResult = ReturnType<typeof useAdvertiserPerformanceStatsQuery>;
export type AdvertiserPerformanceStatsLazyQueryHookResult = ReturnType<typeof useAdvertiserPerformanceStatsLazyQuery>;
export type AdvertiserPerformanceStatsSuspenseQueryHookResult = ReturnType<typeof useAdvertiserPerformanceStatsSuspenseQuery>;
export type AdvertiserPerformanceStatsQueryResult = ApolloReactCommon.QueryResult<AdvertiserPerformanceStatsQuery, AdvertiserPerformanceStatsQueryVariables>;
export const AdvertiserConfigDocument = gql`
    query advertiserConfig($id: PwsID!) {
  advertiser(id: $id) {
    id
    config {
      global {
        network
        formats {
          height
          width
        }
      }
      adGroup {
        min {
          cpc
          cpl
          cpo
          cpm
          dailyBudget
          budgetCapping
        }
        max {
          cpc
          cpl
          cpo
          cpm
          dailyBudget
          budgetCapping
        }
      }
      adCopy {
        min {
          title
          description
          callToAction
          advertiserName
        }
        max {
          title
          description
          callToAction
          advertiserName
        }
      }
    }
  }
}
    `;

/**
 * __useAdvertiserConfigQuery__
 *
 * To run a query within a React component, call `useAdvertiserConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdvertiserConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdvertiserConfigQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdvertiserConfigQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdvertiserConfigQuery, AdvertiserConfigQueryVariables> & ({ variables: AdvertiserConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdvertiserConfigQuery, AdvertiserConfigQueryVariables>(AdvertiserConfigDocument, options);
      }
export function useAdvertiserConfigLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdvertiserConfigQuery, AdvertiserConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdvertiserConfigQuery, AdvertiserConfigQueryVariables>(AdvertiserConfigDocument, options);
        }
// @ts-ignore
export function useAdvertiserConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdvertiserConfigQuery, AdvertiserConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdvertiserConfigQuery, AdvertiserConfigQueryVariables>;
export function useAdvertiserConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdvertiserConfigQuery, AdvertiserConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdvertiserConfigQuery | undefined, AdvertiserConfigQueryVariables>;
export function useAdvertiserConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdvertiserConfigQuery, AdvertiserConfigQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdvertiserConfigQuery, AdvertiserConfigQueryVariables>(AdvertiserConfigDocument, options);
        }
export type AdvertiserConfigQueryHookResult = ReturnType<typeof useAdvertiserConfigQuery>;
export type AdvertiserConfigLazyQueryHookResult = ReturnType<typeof useAdvertiserConfigLazyQuery>;
export type AdvertiserConfigSuspenseQueryHookResult = ReturnType<typeof useAdvertiserConfigSuspenseQuery>;
export type AdvertiserConfigQueryResult = ApolloReactCommon.QueryResult<AdvertiserConfigQuery, AdvertiserConfigQueryVariables>;
export const SearchAdvertiserInvoicesDocument = gql`
    query searchAdvertiserInvoices($pagination: Pagination, $searchQuery: InvoiceAdvertiserSearchQuery!) {
  searchAdvertiserInvoices(pagination: $pagination, searchQuery: $searchQuery) {
    ...AdvertiserInvoiceParts
  }
}
    ${AdvertiserInvoicePartsFragmentDoc}`;

/**
 * __useSearchAdvertiserInvoicesQuery__
 *
 * To run a query within a React component, call `useSearchAdvertiserInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchAdvertiserInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchAdvertiserInvoicesQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function useSearchAdvertiserInvoicesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchAdvertiserInvoicesQuery, SearchAdvertiserInvoicesQueryVariables> & ({ variables: SearchAdvertiserInvoicesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchAdvertiserInvoicesQuery, SearchAdvertiserInvoicesQueryVariables>(SearchAdvertiserInvoicesDocument, options);
      }
export function useSearchAdvertiserInvoicesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchAdvertiserInvoicesQuery, SearchAdvertiserInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchAdvertiserInvoicesQuery, SearchAdvertiserInvoicesQueryVariables>(SearchAdvertiserInvoicesDocument, options);
        }
// @ts-ignore
export function useSearchAdvertiserInvoicesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SearchAdvertiserInvoicesQuery, SearchAdvertiserInvoicesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SearchAdvertiserInvoicesQuery, SearchAdvertiserInvoicesQueryVariables>;
export function useSearchAdvertiserInvoicesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchAdvertiserInvoicesQuery, SearchAdvertiserInvoicesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SearchAdvertiserInvoicesQuery | undefined, SearchAdvertiserInvoicesQueryVariables>;
export function useSearchAdvertiserInvoicesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchAdvertiserInvoicesQuery, SearchAdvertiserInvoicesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SearchAdvertiserInvoicesQuery, SearchAdvertiserInvoicesQueryVariables>(SearchAdvertiserInvoicesDocument, options);
        }
export type SearchAdvertiserInvoicesQueryHookResult = ReturnType<typeof useSearchAdvertiserInvoicesQuery>;
export type SearchAdvertiserInvoicesLazyQueryHookResult = ReturnType<typeof useSearchAdvertiserInvoicesLazyQuery>;
export type SearchAdvertiserInvoicesSuspenseQueryHookResult = ReturnType<typeof useSearchAdvertiserInvoicesSuspenseQuery>;
export type SearchAdvertiserInvoicesQueryResult = ApolloReactCommon.QueryResult<SearchAdvertiserInvoicesQuery, SearchAdvertiserInvoicesQueryVariables>;
export const AdvertiserInvoiceDocument = gql`
    query advertiserInvoice($reference: String!) {
  advertiserInvoice(reference: $reference) {
    ...AdvertiserInvoiceParts
  }
}
    ${AdvertiserInvoicePartsFragmentDoc}`;

/**
 * __useAdvertiserInvoiceQuery__
 *
 * To run a query within a React component, call `useAdvertiserInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdvertiserInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdvertiserInvoiceQuery({
 *   variables: {
 *      reference: // value for 'reference'
 *   },
 * });
 */
export function useAdvertiserInvoiceQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdvertiserInvoiceQuery, AdvertiserInvoiceQueryVariables> & ({ variables: AdvertiserInvoiceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdvertiserInvoiceQuery, AdvertiserInvoiceQueryVariables>(AdvertiserInvoiceDocument, options);
      }
export function useAdvertiserInvoiceLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdvertiserInvoiceQuery, AdvertiserInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdvertiserInvoiceQuery, AdvertiserInvoiceQueryVariables>(AdvertiserInvoiceDocument, options);
        }
// @ts-ignore
export function useAdvertiserInvoiceSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdvertiserInvoiceQuery, AdvertiserInvoiceQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdvertiserInvoiceQuery, AdvertiserInvoiceQueryVariables>;
export function useAdvertiserInvoiceSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdvertiserInvoiceQuery, AdvertiserInvoiceQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdvertiserInvoiceQuery | undefined, AdvertiserInvoiceQueryVariables>;
export function useAdvertiserInvoiceSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdvertiserInvoiceQuery, AdvertiserInvoiceQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdvertiserInvoiceQuery, AdvertiserInvoiceQueryVariables>(AdvertiserInvoiceDocument, options);
        }
export type AdvertiserInvoiceQueryHookResult = ReturnType<typeof useAdvertiserInvoiceQuery>;
export type AdvertiserInvoiceLazyQueryHookResult = ReturnType<typeof useAdvertiserInvoiceLazyQuery>;
export type AdvertiserInvoiceSuspenseQueryHookResult = ReturnType<typeof useAdvertiserInvoiceSuspenseQuery>;
export type AdvertiserInvoiceQueryResult = ApolloReactCommon.QueryResult<AdvertiserInvoiceQuery, AdvertiserInvoiceQueryVariables>;
export const CreateAdvertiserInvoicesDocument = gql`
    mutation createAdvertiserInvoices($year: Int!, $month: Int!) {
  createAdvertiserInvoices(year: $year, month: $month)
}
    `;
export type CreateAdvertiserInvoicesMutationFn = ApolloReactCommon.MutationFunction<CreateAdvertiserInvoicesMutation, CreateAdvertiserInvoicesMutationVariables>;

/**
 * __useCreateAdvertiserInvoicesMutation__
 *
 * To run a mutation, you first call `useCreateAdvertiserInvoicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdvertiserInvoicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdvertiserInvoicesMutation, { data, loading, error }] = useCreateAdvertiserInvoicesMutation({
 *   variables: {
 *      year: // value for 'year'
 *      month: // value for 'month'
 *   },
 * });
 */
export function useCreateAdvertiserInvoicesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateAdvertiserInvoicesMutation, CreateAdvertiserInvoicesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateAdvertiserInvoicesMutation, CreateAdvertiserInvoicesMutationVariables>(CreateAdvertiserInvoicesDocument, options);
      }
export type CreateAdvertiserInvoicesMutationHookResult = ReturnType<typeof useCreateAdvertiserInvoicesMutation>;
export type CreateAdvertiserInvoicesMutationResult = ApolloReactCommon.MutationResult<CreateAdvertiserInvoicesMutation>;
export type CreateAdvertiserInvoicesMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateAdvertiserInvoicesMutation, CreateAdvertiserInvoicesMutationVariables>;
export const UpdateAdvertiserSettingsDocument = gql`
    mutation updateAdvertiserSettings($advertiserId: PwsID!, $settings: AdvertiserSettingsInput!) {
  updateAdvertiserSettings(advertiserId: $advertiserId, settings: $settings) {
    agencyId
    gestion
    subType
    unknownTrafficRate
    copperId
    accountManagerId
    salesManagerId
  }
}
    `;
export type UpdateAdvertiserSettingsMutationFn = ApolloReactCommon.MutationFunction<UpdateAdvertiserSettingsMutation, UpdateAdvertiserSettingsMutationVariables>;

/**
 * __useUpdateAdvertiserSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateAdvertiserSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdvertiserSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdvertiserSettingsMutation, { data, loading, error }] = useUpdateAdvertiserSettingsMutation({
 *   variables: {
 *      advertiserId: // value for 'advertiserId'
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useUpdateAdvertiserSettingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAdvertiserSettingsMutation, UpdateAdvertiserSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateAdvertiserSettingsMutation, UpdateAdvertiserSettingsMutationVariables>(UpdateAdvertiserSettingsDocument, options);
      }
export type UpdateAdvertiserSettingsMutationHookResult = ReturnType<typeof useUpdateAdvertiserSettingsMutation>;
export type UpdateAdvertiserSettingsMutationResult = ApolloReactCommon.MutationResult<UpdateAdvertiserSettingsMutation>;
export type UpdateAdvertiserSettingsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateAdvertiserSettingsMutation, UpdateAdvertiserSettingsMutationVariables>;
export const AgencyTimeseriesDocument = gql`
    query agencyTimeseries($endDate: DateTime!, $startDate: DateTime!, $agencyId: PwsID, $slug: String, $granularity: GraphGranularity!) {
  agency(id: $agencyId, slug: $slug) {
    id
    timeseries(granularity: $granularity, endDate: $endDate, startDate: $startDate) {
      ...AdvertiserTimeseries
    }
  }
}
    ${AdvertiserTimeseriesFragmentDoc}`;

/**
 * __useAgencyTimeseriesQuery__
 *
 * To run a query within a React component, call `useAgencyTimeseriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgencyTimeseriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgencyTimeseriesQuery({
 *   variables: {
 *      endDate: // value for 'endDate'
 *      startDate: // value for 'startDate'
 *      agencyId: // value for 'agencyId'
 *      slug: // value for 'slug'
 *      granularity: // value for 'granularity'
 *   },
 * });
 */
export function useAgencyTimeseriesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AgencyTimeseriesQuery, AgencyTimeseriesQueryVariables> & ({ variables: AgencyTimeseriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AgencyTimeseriesQuery, AgencyTimeseriesQueryVariables>(AgencyTimeseriesDocument, options);
      }
export function useAgencyTimeseriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AgencyTimeseriesQuery, AgencyTimeseriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AgencyTimeseriesQuery, AgencyTimeseriesQueryVariables>(AgencyTimeseriesDocument, options);
        }
// @ts-ignore
export function useAgencyTimeseriesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AgencyTimeseriesQuery, AgencyTimeseriesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AgencyTimeseriesQuery, AgencyTimeseriesQueryVariables>;
export function useAgencyTimeseriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AgencyTimeseriesQuery, AgencyTimeseriesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AgencyTimeseriesQuery | undefined, AgencyTimeseriesQueryVariables>;
export function useAgencyTimeseriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AgencyTimeseriesQuery, AgencyTimeseriesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AgencyTimeseriesQuery, AgencyTimeseriesQueryVariables>(AgencyTimeseriesDocument, options);
        }
export type AgencyTimeseriesQueryHookResult = ReturnType<typeof useAgencyTimeseriesQuery>;
export type AgencyTimeseriesLazyQueryHookResult = ReturnType<typeof useAgencyTimeseriesLazyQuery>;
export type AgencyTimeseriesSuspenseQueryHookResult = ReturnType<typeof useAgencyTimeseriesSuspenseQuery>;
export type AgencyTimeseriesQueryResult = ApolloReactCommon.QueryResult<AgencyTimeseriesQuery, AgencyTimeseriesQueryVariables>;
export const AgencyPerformanceStatsDocument = gql`
    query agencyPerformanceStats($endDate: DateTime!, $startDate: DateTime!, $agencyId: PwsID, $slug: String) {
  agency(id: $agencyId, slug: $slug) {
    id
    performanceStats(endDate: $endDate, startDate: $startDate) {
      stats {
        ...AdvertiserPerformanceStatsParts
      }
      publisherResellers {
        name
        stats {
          ...AdvertiserPerformanceStatsParts
        }
        publishers {
          name
          stats {
            ...AdvertiserPerformanceStatsParts
          }
        }
      }
      advertisers {
        name
        stats {
          ...AdvertiserPerformanceStatsParts
        }
      }
    }
  }
}
    ${AdvertiserPerformanceStatsPartsFragmentDoc}`;

/**
 * __useAgencyPerformanceStatsQuery__
 *
 * To run a query within a React component, call `useAgencyPerformanceStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgencyPerformanceStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgencyPerformanceStatsQuery({
 *   variables: {
 *      endDate: // value for 'endDate'
 *      startDate: // value for 'startDate'
 *      agencyId: // value for 'agencyId'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useAgencyPerformanceStatsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AgencyPerformanceStatsQuery, AgencyPerformanceStatsQueryVariables> & ({ variables: AgencyPerformanceStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AgencyPerformanceStatsQuery, AgencyPerformanceStatsQueryVariables>(AgencyPerformanceStatsDocument, options);
      }
export function useAgencyPerformanceStatsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AgencyPerformanceStatsQuery, AgencyPerformanceStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AgencyPerformanceStatsQuery, AgencyPerformanceStatsQueryVariables>(AgencyPerformanceStatsDocument, options);
        }
// @ts-ignore
export function useAgencyPerformanceStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AgencyPerformanceStatsQuery, AgencyPerformanceStatsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AgencyPerformanceStatsQuery, AgencyPerformanceStatsQueryVariables>;
export function useAgencyPerformanceStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AgencyPerformanceStatsQuery, AgencyPerformanceStatsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AgencyPerformanceStatsQuery | undefined, AgencyPerformanceStatsQueryVariables>;
export function useAgencyPerformanceStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AgencyPerformanceStatsQuery, AgencyPerformanceStatsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AgencyPerformanceStatsQuery, AgencyPerformanceStatsQueryVariables>(AgencyPerformanceStatsDocument, options);
        }
export type AgencyPerformanceStatsQueryHookResult = ReturnType<typeof useAgencyPerformanceStatsQuery>;
export type AgencyPerformanceStatsLazyQueryHookResult = ReturnType<typeof useAgencyPerformanceStatsLazyQuery>;
export type AgencyPerformanceStatsSuspenseQueryHookResult = ReturnType<typeof useAgencyPerformanceStatsSuspenseQuery>;
export type AgencyPerformanceStatsQueryResult = ApolloReactCommon.QueryResult<AgencyPerformanceStatsQuery, AgencyPerformanceStatsQueryVariables>;
export const AgencyNameDocument = gql`
    query agencyName($agencyId: PwsID!) {
  agency(id: $agencyId) {
    id
    name
  }
}
    `;

/**
 * __useAgencyNameQuery__
 *
 * To run a query within a React component, call `useAgencyNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgencyNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgencyNameQuery({
 *   variables: {
 *      agencyId: // value for 'agencyId'
 *   },
 * });
 */
export function useAgencyNameQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AgencyNameQuery, AgencyNameQueryVariables> & ({ variables: AgencyNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AgencyNameQuery, AgencyNameQueryVariables>(AgencyNameDocument, options);
      }
export function useAgencyNameLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AgencyNameQuery, AgencyNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AgencyNameQuery, AgencyNameQueryVariables>(AgencyNameDocument, options);
        }
// @ts-ignore
export function useAgencyNameSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AgencyNameQuery, AgencyNameQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AgencyNameQuery, AgencyNameQueryVariables>;
export function useAgencyNameSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AgencyNameQuery, AgencyNameQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AgencyNameQuery | undefined, AgencyNameQueryVariables>;
export function useAgencyNameSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AgencyNameQuery, AgencyNameQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AgencyNameQuery, AgencyNameQueryVariables>(AgencyNameDocument, options);
        }
export type AgencyNameQueryHookResult = ReturnType<typeof useAgencyNameQuery>;
export type AgencyNameLazyQueryHookResult = ReturnType<typeof useAgencyNameLazyQuery>;
export type AgencyNameSuspenseQueryHookResult = ReturnType<typeof useAgencyNameSuspenseQuery>;
export type AgencyNameQueryResult = ApolloReactCommon.QueryResult<AgencyNameQuery, AgencyNameQueryVariables>;
export const AgencySettingsDocument = gql`
    query agencySettings($id: PwsID!) {
  agency(id: $id) {
    id
    settings {
      copperId
      accountManagerId
      salesManagerId
    }
  }
}
    `;

/**
 * __useAgencySettingsQuery__
 *
 * To run a query within a React component, call `useAgencySettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgencySettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgencySettingsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAgencySettingsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AgencySettingsQuery, AgencySettingsQueryVariables> & ({ variables: AgencySettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AgencySettingsQuery, AgencySettingsQueryVariables>(AgencySettingsDocument, options);
      }
export function useAgencySettingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AgencySettingsQuery, AgencySettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AgencySettingsQuery, AgencySettingsQueryVariables>(AgencySettingsDocument, options);
        }
// @ts-ignore
export function useAgencySettingsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AgencySettingsQuery, AgencySettingsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AgencySettingsQuery, AgencySettingsQueryVariables>;
export function useAgencySettingsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AgencySettingsQuery, AgencySettingsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AgencySettingsQuery | undefined, AgencySettingsQueryVariables>;
export function useAgencySettingsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AgencySettingsQuery, AgencySettingsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AgencySettingsQuery, AgencySettingsQueryVariables>(AgencySettingsDocument, options);
        }
export type AgencySettingsQueryHookResult = ReturnType<typeof useAgencySettingsQuery>;
export type AgencySettingsLazyQueryHookResult = ReturnType<typeof useAgencySettingsLazyQuery>;
export type AgencySettingsSuspenseQueryHookResult = ReturnType<typeof useAgencySettingsSuspenseQuery>;
export type AgencySettingsQueryResult = ApolloReactCommon.QueryResult<AgencySettingsQuery, AgencySettingsQueryVariables>;
export const UpdateAgencySettingsDocument = gql`
    mutation updateAgencySettings($agencyId: PwsID!, $settings: AgencySettingsInput!) {
  updateAgencySettings(agencyId: $agencyId, settings: $settings) {
    copperId
    accountManagerId
    salesManagerId
  }
}
    `;
export type UpdateAgencySettingsMutationFn = ApolloReactCommon.MutationFunction<UpdateAgencySettingsMutation, UpdateAgencySettingsMutationVariables>;

/**
 * __useUpdateAgencySettingsMutation__
 *
 * To run a mutation, you first call `useUpdateAgencySettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAgencySettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAgencySettingsMutation, { data, loading, error }] = useUpdateAgencySettingsMutation({
 *   variables: {
 *      agencyId: // value for 'agencyId'
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useUpdateAgencySettingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAgencySettingsMutation, UpdateAgencySettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateAgencySettingsMutation, UpdateAgencySettingsMutationVariables>(UpdateAgencySettingsDocument, options);
      }
export type UpdateAgencySettingsMutationHookResult = ReturnType<typeof useUpdateAgencySettingsMutation>;
export type UpdateAgencySettingsMutationResult = ApolloReactCommon.MutationResult<UpdateAgencySettingsMutation>;
export type UpdateAgencySettingsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateAgencySettingsMutation, UpdateAgencySettingsMutationVariables>;
export const AdGroupAssistantDocument = gql`
    query adGroupAssistant($adGroupId: PwsID!) {
  adGroup(id: $adGroupId) {
    campaign {
      advertiser {
        slug
      }
    }
    assistant {
      recommendations {
        message
        isHidden
        ruleId
        recommendedChanges
        rule {
          ... on AssistantRuleSystem {
            ...AssistantRuleSystemFields
          }
          ... on AssistantRuleUser {
            ...AssistantRuleUserFields
          }
        }
      }
      adCopies {
        adCopy {
          id
          name
          advertiserName
          title
          description
          callToAction
          image
          status
          statusUpdatedAt
        }
        stats {
          impressions
          clicks
          leads
          orders
          costs
          ctr
          lr
          cpl
          or
          cpo
          roi
          startedAt
          abTestImpressions
          abTestClicks
          abTestLeads
          abTestOrders
          abTestCosts
          abTestCtr
          abTestLr
          abTestCpl
          abTestOr
          abTestCpo
          abTestRoi
          abTestStartDate
        }
        message
      }
    }
  }
}
    ${AssistantRuleSystemFieldsFragmentDoc}
${AssistantRuleUserFieldsFragmentDoc}`;

/**
 * __useAdGroupAssistantQuery__
 *
 * To run a query within a React component, call `useAdGroupAssistantQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdGroupAssistantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdGroupAssistantQuery({
 *   variables: {
 *      adGroupId: // value for 'adGroupId'
 *   },
 * });
 */
export function useAdGroupAssistantQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdGroupAssistantQuery, AdGroupAssistantQueryVariables> & ({ variables: AdGroupAssistantQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdGroupAssistantQuery, AdGroupAssistantQueryVariables>(AdGroupAssistantDocument, options);
      }
export function useAdGroupAssistantLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdGroupAssistantQuery, AdGroupAssistantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdGroupAssistantQuery, AdGroupAssistantQueryVariables>(AdGroupAssistantDocument, options);
        }
// @ts-ignore
export function useAdGroupAssistantSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdGroupAssistantQuery, AdGroupAssistantQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdGroupAssistantQuery, AdGroupAssistantQueryVariables>;
export function useAdGroupAssistantSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdGroupAssistantQuery, AdGroupAssistantQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdGroupAssistantQuery | undefined, AdGroupAssistantQueryVariables>;
export function useAdGroupAssistantSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdGroupAssistantQuery, AdGroupAssistantQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdGroupAssistantQuery, AdGroupAssistantQueryVariables>(AdGroupAssistantDocument, options);
        }
export type AdGroupAssistantQueryHookResult = ReturnType<typeof useAdGroupAssistantQuery>;
export type AdGroupAssistantLazyQueryHookResult = ReturnType<typeof useAdGroupAssistantLazyQuery>;
export type AdGroupAssistantSuspenseQueryHookResult = ReturnType<typeof useAdGroupAssistantSuspenseQuery>;
export type AdGroupAssistantQueryResult = ApolloReactCommon.QueryResult<AdGroupAssistantQuery, AdGroupAssistantQueryVariables>;
export const AskAdgroupSuggestionsDocument = gql`
    query askAdgroupSuggestions($adGroupId: PwsID!, $languageOutput: String!, $userInstructions: String!) {
  askAdgroupSuggestions(
    adGroupId: $adGroupId
    languageOutput: $languageOutput
    userInstructions: $userInstructions
  ) {
    keywords
    description
    titles
    actions
  }
}
    `;

/**
 * __useAskAdgroupSuggestionsQuery__
 *
 * To run a query within a React component, call `useAskAdgroupSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAskAdgroupSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAskAdgroupSuggestionsQuery({
 *   variables: {
 *      adGroupId: // value for 'adGroupId'
 *      languageOutput: // value for 'languageOutput'
 *      userInstructions: // value for 'userInstructions'
 *   },
 * });
 */
export function useAskAdgroupSuggestionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AskAdgroupSuggestionsQuery, AskAdgroupSuggestionsQueryVariables> & ({ variables: AskAdgroupSuggestionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AskAdgroupSuggestionsQuery, AskAdgroupSuggestionsQueryVariables>(AskAdgroupSuggestionsDocument, options);
      }
export function useAskAdgroupSuggestionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AskAdgroupSuggestionsQuery, AskAdgroupSuggestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AskAdgroupSuggestionsQuery, AskAdgroupSuggestionsQueryVariables>(AskAdgroupSuggestionsDocument, options);
        }
// @ts-ignore
export function useAskAdgroupSuggestionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AskAdgroupSuggestionsQuery, AskAdgroupSuggestionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AskAdgroupSuggestionsQuery, AskAdgroupSuggestionsQueryVariables>;
export function useAskAdgroupSuggestionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AskAdgroupSuggestionsQuery, AskAdgroupSuggestionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AskAdgroupSuggestionsQuery | undefined, AskAdgroupSuggestionsQueryVariables>;
export function useAskAdgroupSuggestionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AskAdgroupSuggestionsQuery, AskAdgroupSuggestionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AskAdgroupSuggestionsQuery, AskAdgroupSuggestionsQueryVariables>(AskAdgroupSuggestionsDocument, options);
        }
export type AskAdgroupSuggestionsQueryHookResult = ReturnType<typeof useAskAdgroupSuggestionsQuery>;
export type AskAdgroupSuggestionsLazyQueryHookResult = ReturnType<typeof useAskAdgroupSuggestionsLazyQuery>;
export type AskAdgroupSuggestionsSuspenseQueryHookResult = ReturnType<typeof useAskAdgroupSuggestionsSuspenseQuery>;
export type AskAdgroupSuggestionsQueryResult = ApolloReactCommon.QueryResult<AskAdgroupSuggestionsQuery, AskAdgroupSuggestionsQueryVariables>;
export const AdGroupMarketLanguageDocument = gql`
    query adGroupMarketLanguage($id: PwsID!) {
  adGroup(id: $id) {
    id
    campaign {
      market {
        language {
          code
        }
      }
    }
  }
}
    `;

/**
 * __useAdGroupMarketLanguageQuery__
 *
 * To run a query within a React component, call `useAdGroupMarketLanguageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdGroupMarketLanguageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdGroupMarketLanguageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdGroupMarketLanguageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdGroupMarketLanguageQuery, AdGroupMarketLanguageQueryVariables> & ({ variables: AdGroupMarketLanguageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdGroupMarketLanguageQuery, AdGroupMarketLanguageQueryVariables>(AdGroupMarketLanguageDocument, options);
      }
export function useAdGroupMarketLanguageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdGroupMarketLanguageQuery, AdGroupMarketLanguageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdGroupMarketLanguageQuery, AdGroupMarketLanguageQueryVariables>(AdGroupMarketLanguageDocument, options);
        }
// @ts-ignore
export function useAdGroupMarketLanguageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdGroupMarketLanguageQuery, AdGroupMarketLanguageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdGroupMarketLanguageQuery, AdGroupMarketLanguageQueryVariables>;
export function useAdGroupMarketLanguageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdGroupMarketLanguageQuery, AdGroupMarketLanguageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdGroupMarketLanguageQuery | undefined, AdGroupMarketLanguageQueryVariables>;
export function useAdGroupMarketLanguageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdGroupMarketLanguageQuery, AdGroupMarketLanguageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdGroupMarketLanguageQuery, AdGroupMarketLanguageQueryVariables>(AdGroupMarketLanguageDocument, options);
        }
export type AdGroupMarketLanguageQueryHookResult = ReturnType<typeof useAdGroupMarketLanguageQuery>;
export type AdGroupMarketLanguageLazyQueryHookResult = ReturnType<typeof useAdGroupMarketLanguageLazyQuery>;
export type AdGroupMarketLanguageSuspenseQueryHookResult = ReturnType<typeof useAdGroupMarketLanguageSuspenseQuery>;
export type AdGroupMarketLanguageQueryResult = ApolloReactCommon.QueryResult<AdGroupMarketLanguageQuery, AdGroupMarketLanguageQueryVariables>;
export const AssistantRulesDocument = gql`
    query assistantRules($resellerId: PwsID!) {
  assistantRules(resellerId: $resellerId) {
    ... on AssistantRuleSystem {
      ...AssistantRuleSystemFields
    }
    ... on AssistantRuleUser {
      ...AssistantRuleUserFields
    }
  }
}
    ${AssistantRuleSystemFieldsFragmentDoc}
${AssistantRuleUserFieldsFragmentDoc}`;

/**
 * __useAssistantRulesQuery__
 *
 * To run a query within a React component, call `useAssistantRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssistantRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssistantRulesQuery({
 *   variables: {
 *      resellerId: // value for 'resellerId'
 *   },
 * });
 */
export function useAssistantRulesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AssistantRulesQuery, AssistantRulesQueryVariables> & ({ variables: AssistantRulesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AssistantRulesQuery, AssistantRulesQueryVariables>(AssistantRulesDocument, options);
      }
export function useAssistantRulesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AssistantRulesQuery, AssistantRulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AssistantRulesQuery, AssistantRulesQueryVariables>(AssistantRulesDocument, options);
        }
// @ts-ignore
export function useAssistantRulesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AssistantRulesQuery, AssistantRulesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AssistantRulesQuery, AssistantRulesQueryVariables>;
export function useAssistantRulesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AssistantRulesQuery, AssistantRulesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AssistantRulesQuery | undefined, AssistantRulesQueryVariables>;
export function useAssistantRulesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AssistantRulesQuery, AssistantRulesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AssistantRulesQuery, AssistantRulesQueryVariables>(AssistantRulesDocument, options);
        }
export type AssistantRulesQueryHookResult = ReturnType<typeof useAssistantRulesQuery>;
export type AssistantRulesLazyQueryHookResult = ReturnType<typeof useAssistantRulesLazyQuery>;
export type AssistantRulesSuspenseQueryHookResult = ReturnType<typeof useAssistantRulesSuspenseQuery>;
export type AssistantRulesQueryResult = ApolloReactCommon.QueryResult<AssistantRulesQuery, AssistantRulesQueryVariables>;
export const AssistantRuleConditionPropertiesDocument = gql`
    query assistantRuleConditionProperties {
  assistantRuleConditionProperties {
    scope
    field
    valueType
    allowedOperators
    possibleValues
    unit
    paramsJsonSchema
  }
}
    `;

/**
 * __useAssistantRuleConditionPropertiesQuery__
 *
 * To run a query within a React component, call `useAssistantRuleConditionPropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssistantRuleConditionPropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssistantRuleConditionPropertiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAssistantRuleConditionPropertiesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AssistantRuleConditionPropertiesQuery, AssistantRuleConditionPropertiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AssistantRuleConditionPropertiesQuery, AssistantRuleConditionPropertiesQueryVariables>(AssistantRuleConditionPropertiesDocument, options);
      }
export function useAssistantRuleConditionPropertiesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AssistantRuleConditionPropertiesQuery, AssistantRuleConditionPropertiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AssistantRuleConditionPropertiesQuery, AssistantRuleConditionPropertiesQueryVariables>(AssistantRuleConditionPropertiesDocument, options);
        }
// @ts-ignore
export function useAssistantRuleConditionPropertiesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AssistantRuleConditionPropertiesQuery, AssistantRuleConditionPropertiesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AssistantRuleConditionPropertiesQuery, AssistantRuleConditionPropertiesQueryVariables>;
export function useAssistantRuleConditionPropertiesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AssistantRuleConditionPropertiesQuery, AssistantRuleConditionPropertiesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AssistantRuleConditionPropertiesQuery | undefined, AssistantRuleConditionPropertiesQueryVariables>;
export function useAssistantRuleConditionPropertiesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AssistantRuleConditionPropertiesQuery, AssistantRuleConditionPropertiesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AssistantRuleConditionPropertiesQuery, AssistantRuleConditionPropertiesQueryVariables>(AssistantRuleConditionPropertiesDocument, options);
        }
export type AssistantRuleConditionPropertiesQueryHookResult = ReturnType<typeof useAssistantRuleConditionPropertiesQuery>;
export type AssistantRuleConditionPropertiesLazyQueryHookResult = ReturnType<typeof useAssistantRuleConditionPropertiesLazyQuery>;
export type AssistantRuleConditionPropertiesSuspenseQueryHookResult = ReturnType<typeof useAssistantRuleConditionPropertiesSuspenseQuery>;
export type AssistantRuleConditionPropertiesQueryResult = ApolloReactCommon.QueryResult<AssistantRuleConditionPropertiesQuery, AssistantRuleConditionPropertiesQueryVariables>;
export const UpdateAssistantRuleDocument = gql`
    mutation updateAssistantRule($input: UpdateAssistantRuleInput!) {
  updateAssistantRule(input: $input) {
    ... on AssistantRuleSystem {
      ...AssistantRuleSystemFields
    }
    ... on AssistantRuleUser {
      ...AssistantRuleUserFields
    }
  }
}
    ${AssistantRuleSystemFieldsFragmentDoc}
${AssistantRuleUserFieldsFragmentDoc}`;
export type UpdateAssistantRuleMutationFn = ApolloReactCommon.MutationFunction<UpdateAssistantRuleMutation, UpdateAssistantRuleMutationVariables>;

/**
 * __useUpdateAssistantRuleMutation__
 *
 * To run a mutation, you first call `useUpdateAssistantRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAssistantRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAssistantRuleMutation, { data, loading, error }] = useUpdateAssistantRuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAssistantRuleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAssistantRuleMutation, UpdateAssistantRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateAssistantRuleMutation, UpdateAssistantRuleMutationVariables>(UpdateAssistantRuleDocument, options);
      }
export type UpdateAssistantRuleMutationHookResult = ReturnType<typeof useUpdateAssistantRuleMutation>;
export type UpdateAssistantRuleMutationResult = ApolloReactCommon.MutationResult<UpdateAssistantRuleMutation>;
export type UpdateAssistantRuleMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateAssistantRuleMutation, UpdateAssistantRuleMutationVariables>;
export const CreateAssistantUserRuleDocument = gql`
    mutation createAssistantUserRule($input: CreateAssistantUserRuleInput!) {
  createAssistantUserRule(input: $input) {
    ...AssistantRuleUserFields
  }
}
    ${AssistantRuleUserFieldsFragmentDoc}`;
export type CreateAssistantUserRuleMutationFn = ApolloReactCommon.MutationFunction<CreateAssistantUserRuleMutation, CreateAssistantUserRuleMutationVariables>;

/**
 * __useCreateAssistantUserRuleMutation__
 *
 * To run a mutation, you first call `useCreateAssistantUserRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAssistantUserRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAssistantUserRuleMutation, { data, loading, error }] = useCreateAssistantUserRuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAssistantUserRuleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateAssistantUserRuleMutation, CreateAssistantUserRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateAssistantUserRuleMutation, CreateAssistantUserRuleMutationVariables>(CreateAssistantUserRuleDocument, options);
      }
export type CreateAssistantUserRuleMutationHookResult = ReturnType<typeof useCreateAssistantUserRuleMutation>;
export type CreateAssistantUserRuleMutationResult = ApolloReactCommon.MutationResult<CreateAssistantUserRuleMutation>;
export type CreateAssistantUserRuleMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateAssistantUserRuleMutation, CreateAssistantUserRuleMutationVariables>;
export const DeleteAssistantUserRuleDocument = gql`
    mutation deleteAssistantUserRule($ruleId: PwsID!) {
  deleteAssistantUserRule(ruleId: $ruleId)
}
    `;
export type DeleteAssistantUserRuleMutationFn = ApolloReactCommon.MutationFunction<DeleteAssistantUserRuleMutation, DeleteAssistantUserRuleMutationVariables>;

/**
 * __useDeleteAssistantUserRuleMutation__
 *
 * To run a mutation, you first call `useDeleteAssistantUserRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAssistantUserRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAssistantUserRuleMutation, { data, loading, error }] = useDeleteAssistantUserRuleMutation({
 *   variables: {
 *      ruleId: // value for 'ruleId'
 *   },
 * });
 */
export function useDeleteAssistantUserRuleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteAssistantUserRuleMutation, DeleteAssistantUserRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteAssistantUserRuleMutation, DeleteAssistantUserRuleMutationVariables>(DeleteAssistantUserRuleDocument, options);
      }
export type DeleteAssistantUserRuleMutationHookResult = ReturnType<typeof useDeleteAssistantUserRuleMutation>;
export type DeleteAssistantUserRuleMutationResult = ApolloReactCommon.MutationResult<DeleteAssistantUserRuleMutation>;
export type DeleteAssistantUserRuleMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteAssistantUserRuleMutation, DeleteAssistantUserRuleMutationVariables>;
export const DisableAssistantRuleDocument = gql`
    mutation disableAssistantRule($adGroupId: PwsID!, $ruleId: PwsID!) {
  disableAssistantRule(adGroupId: $adGroupId, ruleId: $ruleId)
}
    `;
export type DisableAssistantRuleMutationFn = ApolloReactCommon.MutationFunction<DisableAssistantRuleMutation, DisableAssistantRuleMutationVariables>;

/**
 * __useDisableAssistantRuleMutation__
 *
 * To run a mutation, you first call `useDisableAssistantRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableAssistantRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableAssistantRuleMutation, { data, loading, error }] = useDisableAssistantRuleMutation({
 *   variables: {
 *      adGroupId: // value for 'adGroupId'
 *      ruleId: // value for 'ruleId'
 *   },
 * });
 */
export function useDisableAssistantRuleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DisableAssistantRuleMutation, DisableAssistantRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DisableAssistantRuleMutation, DisableAssistantRuleMutationVariables>(DisableAssistantRuleDocument, options);
      }
export type DisableAssistantRuleMutationHookResult = ReturnType<typeof useDisableAssistantRuleMutation>;
export type DisableAssistantRuleMutationResult = ApolloReactCommon.MutationResult<DisableAssistantRuleMutation>;
export type DisableAssistantRuleMutationOptions = ApolloReactCommon.BaseMutationOptions<DisableAssistantRuleMutation, DisableAssistantRuleMutationVariables>;
export const EnableAssistantRuleDocument = gql`
    mutation enableAssistantRule($adGroupId: PwsID!, $ruleId: PwsID!) {
  enableAssistantRule(adGroupId: $adGroupId, ruleId: $ruleId)
}
    `;
export type EnableAssistantRuleMutationFn = ApolloReactCommon.MutationFunction<EnableAssistantRuleMutation, EnableAssistantRuleMutationVariables>;

/**
 * __useEnableAssistantRuleMutation__
 *
 * To run a mutation, you first call `useEnableAssistantRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableAssistantRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableAssistantRuleMutation, { data, loading, error }] = useEnableAssistantRuleMutation({
 *   variables: {
 *      adGroupId: // value for 'adGroupId'
 *      ruleId: // value for 'ruleId'
 *   },
 * });
 */
export function useEnableAssistantRuleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EnableAssistantRuleMutation, EnableAssistantRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EnableAssistantRuleMutation, EnableAssistantRuleMutationVariables>(EnableAssistantRuleDocument, options);
      }
export type EnableAssistantRuleMutationHookResult = ReturnType<typeof useEnableAssistantRuleMutation>;
export type EnableAssistantRuleMutationResult = ApolloReactCommon.MutationResult<EnableAssistantRuleMutation>;
export type EnableAssistantRuleMutationOptions = ApolloReactCommon.BaseMutationOptions<EnableAssistantRuleMutation, EnableAssistantRuleMutationVariables>;
export const BannerSizesDocument = gql`
    query bannerSizes($resellerId: PwsID!) {
  bannerSizes(resellerId: $resellerId) {
    width
    height
  }
}
    `;

/**
 * __useBannerSizesQuery__
 *
 * To run a query within a React component, call `useBannerSizesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBannerSizesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBannerSizesQuery({
 *   variables: {
 *      resellerId: // value for 'resellerId'
 *   },
 * });
 */
export function useBannerSizesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BannerSizesQuery, BannerSizesQueryVariables> & ({ variables: BannerSizesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BannerSizesQuery, BannerSizesQueryVariables>(BannerSizesDocument, options);
      }
export function useBannerSizesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BannerSizesQuery, BannerSizesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BannerSizesQuery, BannerSizesQueryVariables>(BannerSizesDocument, options);
        }
// @ts-ignore
export function useBannerSizesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<BannerSizesQuery, BannerSizesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BannerSizesQuery, BannerSizesQueryVariables>;
export function useBannerSizesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BannerSizesQuery, BannerSizesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BannerSizesQuery | undefined, BannerSizesQueryVariables>;
export function useBannerSizesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BannerSizesQuery, BannerSizesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BannerSizesQuery, BannerSizesQueryVariables>(BannerSizesDocument, options);
        }
export type BannerSizesQueryHookResult = ReturnType<typeof useBannerSizesQuery>;
export type BannerSizesLazyQueryHookResult = ReturnType<typeof useBannerSizesLazyQuery>;
export type BannerSizesSuspenseQueryHookResult = ReturnType<typeof useBannerSizesSuspenseQuery>;
export type BannerSizesQueryResult = ApolloReactCommon.QueryResult<BannerSizesQuery, BannerSizesQueryVariables>;
export const CampaignNameDocument = gql`
    query campaignName($id: PwsID!) {
  campaign(id: $id) {
    id
    name
  }
}
    `;

/**
 * __useCampaignNameQuery__
 *
 * To run a query within a React component, call `useCampaignNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCampaignNameQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CampaignNameQuery, CampaignNameQueryVariables> & ({ variables: CampaignNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CampaignNameQuery, CampaignNameQueryVariables>(CampaignNameDocument, options);
      }
export function useCampaignNameLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CampaignNameQuery, CampaignNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CampaignNameQuery, CampaignNameQueryVariables>(CampaignNameDocument, options);
        }
// @ts-ignore
export function useCampaignNameSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CampaignNameQuery, CampaignNameQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CampaignNameQuery, CampaignNameQueryVariables>;
export function useCampaignNameSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CampaignNameQuery, CampaignNameQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CampaignNameQuery | undefined, CampaignNameQueryVariables>;
export function useCampaignNameSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CampaignNameQuery, CampaignNameQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CampaignNameQuery, CampaignNameQueryVariables>(CampaignNameDocument, options);
        }
export type CampaignNameQueryHookResult = ReturnType<typeof useCampaignNameQuery>;
export type CampaignNameLazyQueryHookResult = ReturnType<typeof useCampaignNameLazyQuery>;
export type CampaignNameSuspenseQueryHookResult = ReturnType<typeof useCampaignNameSuspenseQuery>;
export type CampaignNameQueryResult = ApolloReactCommon.QueryResult<CampaignNameQuery, CampaignNameQueryVariables>;
export const CampaignDocument = gql`
    query campaign($campaignId: PwsID!) {
  campaign(id: $campaignId) {
    ...CampaignParts
    recommendedIabCategory {
      iabCategory
      adGroupIabCategories {
        adGroup {
          id
          name
        }
        iabCategory
        iabTiers {
          iabId
          type
          tier1Name
          tier2Name
          tier3Name
        }
      }
    }
    adGroups(status: [Active, Inactive, NoBudgetLeft, StartSoon, Ended]) {
      id
      name
      status
      endDate
      budgetCapping
      budgetCappingType
      budget {
        budgetMeasures {
          monthBudget
          monthSpent
          periodBudget
          periodSpent
          overallBudget
          overallSpent
        }
      }
    }
  }
}
    ${CampaignPartsFragmentDoc}`;

/**
 * __useCampaignQuery__
 *
 * To run a query within a React component, call `useCampaignQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useCampaignQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CampaignQuery, CampaignQueryVariables> & ({ variables: CampaignQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CampaignQuery, CampaignQueryVariables>(CampaignDocument, options);
      }
export function useCampaignLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CampaignQuery, CampaignQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CampaignQuery, CampaignQueryVariables>(CampaignDocument, options);
        }
// @ts-ignore
export function useCampaignSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CampaignQuery, CampaignQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CampaignQuery, CampaignQueryVariables>;
export function useCampaignSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CampaignQuery, CampaignQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CampaignQuery | undefined, CampaignQueryVariables>;
export function useCampaignSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CampaignQuery, CampaignQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CampaignQuery, CampaignQueryVariables>(CampaignDocument, options);
        }
export type CampaignQueryHookResult = ReturnType<typeof useCampaignQuery>;
export type CampaignLazyQueryHookResult = ReturnType<typeof useCampaignLazyQuery>;
export type CampaignSuspenseQueryHookResult = ReturnType<typeof useCampaignSuspenseQuery>;
export type CampaignQueryResult = ApolloReactCommon.QueryResult<CampaignQuery, CampaignQueryVariables>;
export const AdvertiserCampaignsDocument = gql`
    query advertiserCampaigns($advertiserId: PwsID!, $status: [Status!]) {
  advertiserCampaigns: searchCampaigns(
    searchQuery: {companyId: $advertiserId, status: $status}
  ) {
    id
    name
    status
    adGroups {
      id
      name
      status
      dailyBudget
    }
  }
}
    `;

/**
 * __useAdvertiserCampaignsQuery__
 *
 * To run a query within a React component, call `useAdvertiserCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdvertiserCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdvertiserCampaignsQuery({
 *   variables: {
 *      advertiserId: // value for 'advertiserId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useAdvertiserCampaignsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdvertiserCampaignsQuery, AdvertiserCampaignsQueryVariables> & ({ variables: AdvertiserCampaignsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdvertiserCampaignsQuery, AdvertiserCampaignsQueryVariables>(AdvertiserCampaignsDocument, options);
      }
export function useAdvertiserCampaignsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdvertiserCampaignsQuery, AdvertiserCampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdvertiserCampaignsQuery, AdvertiserCampaignsQueryVariables>(AdvertiserCampaignsDocument, options);
        }
// @ts-ignore
export function useAdvertiserCampaignsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdvertiserCampaignsQuery, AdvertiserCampaignsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdvertiserCampaignsQuery, AdvertiserCampaignsQueryVariables>;
export function useAdvertiserCampaignsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdvertiserCampaignsQuery, AdvertiserCampaignsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdvertiserCampaignsQuery | undefined, AdvertiserCampaignsQueryVariables>;
export function useAdvertiserCampaignsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdvertiserCampaignsQuery, AdvertiserCampaignsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdvertiserCampaignsQuery, AdvertiserCampaignsQueryVariables>(AdvertiserCampaignsDocument, options);
        }
export type AdvertiserCampaignsQueryHookResult = ReturnType<typeof useAdvertiserCampaignsQuery>;
export type AdvertiserCampaignsLazyQueryHookResult = ReturnType<typeof useAdvertiserCampaignsLazyQuery>;
export type AdvertiserCampaignsSuspenseQueryHookResult = ReturnType<typeof useAdvertiserCampaignsSuspenseQuery>;
export type AdvertiserCampaignsQueryResult = ApolloReactCommon.QueryResult<AdvertiserCampaignsQuery, AdvertiserCampaignsQueryVariables>;
export const ResellerCampaignsDocument = gql`
    query resellerCampaigns($resellerId: PwsID!) {
  searchCampaigns(searchQuery: {resellerId: $resellerId}) {
    id
    name
  }
}
    `;

/**
 * __useResellerCampaignsQuery__
 *
 * To run a query within a React component, call `useResellerCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useResellerCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResellerCampaignsQuery({
 *   variables: {
 *      resellerId: // value for 'resellerId'
 *   },
 * });
 */
export function useResellerCampaignsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ResellerCampaignsQuery, ResellerCampaignsQueryVariables> & ({ variables: ResellerCampaignsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ResellerCampaignsQuery, ResellerCampaignsQueryVariables>(ResellerCampaignsDocument, options);
      }
export function useResellerCampaignsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ResellerCampaignsQuery, ResellerCampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ResellerCampaignsQuery, ResellerCampaignsQueryVariables>(ResellerCampaignsDocument, options);
        }
// @ts-ignore
export function useResellerCampaignsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ResellerCampaignsQuery, ResellerCampaignsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ResellerCampaignsQuery, ResellerCampaignsQueryVariables>;
export function useResellerCampaignsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ResellerCampaignsQuery, ResellerCampaignsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ResellerCampaignsQuery | undefined, ResellerCampaignsQueryVariables>;
export function useResellerCampaignsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ResellerCampaignsQuery, ResellerCampaignsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ResellerCampaignsQuery, ResellerCampaignsQueryVariables>(ResellerCampaignsDocument, options);
        }
export type ResellerCampaignsQueryHookResult = ReturnType<typeof useResellerCampaignsQuery>;
export type ResellerCampaignsLazyQueryHookResult = ReturnType<typeof useResellerCampaignsLazyQuery>;
export type ResellerCampaignsSuspenseQueryHookResult = ReturnType<typeof useResellerCampaignsSuspenseQuery>;
export type ResellerCampaignsQueryResult = ApolloReactCommon.QueryResult<ResellerCampaignsQuery, ResellerCampaignsQueryVariables>;
export const SearchCampaignsDocument = gql`
    query searchCampaigns($pagination: Pagination!, $searchQuery: CampaignSearchQuery!) {
  searchCampaigns(pagination: $pagination, searchQuery: $searchQuery) {
    id
    name
    advertiserDomainName
    iabCategory
    status
    market {
      language {
        code
      }
      country {
        code
      }
    }
    advertiser {
      slug
      genericName
      reseller {
        genericName
      }
    }
    adGroups {
      name
    }
  }
}
    `;

/**
 * __useSearchCampaignsQuery__
 *
 * To run a query within a React component, call `useSearchCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCampaignsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function useSearchCampaignsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchCampaignsQuery, SearchCampaignsQueryVariables> & ({ variables: SearchCampaignsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchCampaignsQuery, SearchCampaignsQueryVariables>(SearchCampaignsDocument, options);
      }
export function useSearchCampaignsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchCampaignsQuery, SearchCampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchCampaignsQuery, SearchCampaignsQueryVariables>(SearchCampaignsDocument, options);
        }
// @ts-ignore
export function useSearchCampaignsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SearchCampaignsQuery, SearchCampaignsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SearchCampaignsQuery, SearchCampaignsQueryVariables>;
export function useSearchCampaignsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchCampaignsQuery, SearchCampaignsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SearchCampaignsQuery | undefined, SearchCampaignsQueryVariables>;
export function useSearchCampaignsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchCampaignsQuery, SearchCampaignsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SearchCampaignsQuery, SearchCampaignsQueryVariables>(SearchCampaignsDocument, options);
        }
export type SearchCampaignsQueryHookResult = ReturnType<typeof useSearchCampaignsQuery>;
export type SearchCampaignsLazyQueryHookResult = ReturnType<typeof useSearchCampaignsLazyQuery>;
export type SearchCampaignsSuspenseQueryHookResult = ReturnType<typeof useSearchCampaignsSuspenseQuery>;
export type SearchCampaignsQueryResult = ApolloReactCommon.QueryResult<SearchCampaignsQuery, SearchCampaignsQueryVariables>;
export const CampaignTimeseriesDocument = gql`
    query campaignTimeseries($endDate: DateTime!, $startDate: DateTime!, $campaignId: PwsID!, $granularity: GraphGranularity!, $filters: [CostDetailsFilter!]) {
  campaign(id: $campaignId) {
    id
    timeseries(
      granularity: $granularity
      endDate: $endDate
      startDate: $startDate
      filters: $filters
    ) {
      ...AdvertiserTimeseries
    }
  }
}
    ${AdvertiserTimeseriesFragmentDoc}`;

/**
 * __useCampaignTimeseriesQuery__
 *
 * To run a query within a React component, call `useCampaignTimeseriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignTimeseriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignTimeseriesQuery({
 *   variables: {
 *      endDate: // value for 'endDate'
 *      startDate: // value for 'startDate'
 *      campaignId: // value for 'campaignId'
 *      granularity: // value for 'granularity'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useCampaignTimeseriesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CampaignTimeseriesQuery, CampaignTimeseriesQueryVariables> & ({ variables: CampaignTimeseriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CampaignTimeseriesQuery, CampaignTimeseriesQueryVariables>(CampaignTimeseriesDocument, options);
      }
export function useCampaignTimeseriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CampaignTimeseriesQuery, CampaignTimeseriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CampaignTimeseriesQuery, CampaignTimeseriesQueryVariables>(CampaignTimeseriesDocument, options);
        }
// @ts-ignore
export function useCampaignTimeseriesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CampaignTimeseriesQuery, CampaignTimeseriesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CampaignTimeseriesQuery, CampaignTimeseriesQueryVariables>;
export function useCampaignTimeseriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CampaignTimeseriesQuery, CampaignTimeseriesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CampaignTimeseriesQuery | undefined, CampaignTimeseriesQueryVariables>;
export function useCampaignTimeseriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CampaignTimeseriesQuery, CampaignTimeseriesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CampaignTimeseriesQuery, CampaignTimeseriesQueryVariables>(CampaignTimeseriesDocument, options);
        }
export type CampaignTimeseriesQueryHookResult = ReturnType<typeof useCampaignTimeseriesQuery>;
export type CampaignTimeseriesLazyQueryHookResult = ReturnType<typeof useCampaignTimeseriesLazyQuery>;
export type CampaignTimeseriesSuspenseQueryHookResult = ReturnType<typeof useCampaignTimeseriesSuspenseQuery>;
export type CampaignTimeseriesQueryResult = ApolloReactCommon.QueryResult<CampaignTimeseriesQuery, CampaignTimeseriesQueryVariables>;
export const CampaignPerformanceStatsDocument = gql`
    query campaignPerformanceStats($endDate: DateTime!, $startDate: DateTime!, $campaignId: PwsID!, $filters: [CostDetailsFilter!]) {
  campaign(id: $campaignId) {
    id
    performanceStats(endDate: $endDate, startDate: $startDate, filters: $filters) {
      stats {
        ...AdvertiserPerformanceStatsParts
      }
      publisherResellers {
        name
        stats {
          ...AdvertiserPerformanceStatsParts
        }
        publishers {
          name
          stats {
            ...AdvertiserPerformanceStatsParts
          }
          websites {
            name
            stats {
              ...AdvertiserPerformanceStatsParts
            }
            positions {
              name
              stats {
                ...AdvertiserPerformanceStatsParts
              }
            }
          }
        }
      }
      adGroups {
        id
        name
        status
        dailyBudget
        stats {
          ...AdvertiserPerformanceStatsParts
        }
      }
    }
  }
}
    ${AdvertiserPerformanceStatsPartsFragmentDoc}`;

/**
 * __useCampaignPerformanceStatsQuery__
 *
 * To run a query within a React component, call `useCampaignPerformanceStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignPerformanceStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignPerformanceStatsQuery({
 *   variables: {
 *      endDate: // value for 'endDate'
 *      startDate: // value for 'startDate'
 *      campaignId: // value for 'campaignId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useCampaignPerformanceStatsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CampaignPerformanceStatsQuery, CampaignPerformanceStatsQueryVariables> & ({ variables: CampaignPerformanceStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CampaignPerformanceStatsQuery, CampaignPerformanceStatsQueryVariables>(CampaignPerformanceStatsDocument, options);
      }
export function useCampaignPerformanceStatsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CampaignPerformanceStatsQuery, CampaignPerformanceStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CampaignPerformanceStatsQuery, CampaignPerformanceStatsQueryVariables>(CampaignPerformanceStatsDocument, options);
        }
// @ts-ignore
export function useCampaignPerformanceStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CampaignPerformanceStatsQuery, CampaignPerformanceStatsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CampaignPerformanceStatsQuery, CampaignPerformanceStatsQueryVariables>;
export function useCampaignPerformanceStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CampaignPerformanceStatsQuery, CampaignPerformanceStatsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CampaignPerformanceStatsQuery | undefined, CampaignPerformanceStatsQueryVariables>;
export function useCampaignPerformanceStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CampaignPerformanceStatsQuery, CampaignPerformanceStatsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CampaignPerformanceStatsQuery, CampaignPerformanceStatsQueryVariables>(CampaignPerformanceStatsDocument, options);
        }
export type CampaignPerformanceStatsQueryHookResult = ReturnType<typeof useCampaignPerformanceStatsQuery>;
export type CampaignPerformanceStatsLazyQueryHookResult = ReturnType<typeof useCampaignPerformanceStatsLazyQuery>;
export type CampaignPerformanceStatsSuspenseQueryHookResult = ReturnType<typeof useCampaignPerformanceStatsSuspenseQuery>;
export type CampaignPerformanceStatsQueryResult = ApolloReactCommon.QueryResult<CampaignPerformanceStatsQuery, CampaignPerformanceStatsQueryVariables>;
export const UpdateCampaignDocument = gql`
    mutation updateCampaign($campaign: CampaignInput!) {
  updateCampaign(campaign: $campaign) {
    ...CampaignParts
  }
}
    ${CampaignPartsFragmentDoc}`;
export type UpdateCampaignMutationFn = ApolloReactCommon.MutationFunction<UpdateCampaignMutation, UpdateCampaignMutationVariables>;

/**
 * __useUpdateCampaignMutation__
 *
 * To run a mutation, you first call `useUpdateCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCampaignMutation, { data, loading, error }] = useUpdateCampaignMutation({
 *   variables: {
 *      campaign: // value for 'campaign'
 *   },
 * });
 */
export function useUpdateCampaignMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCampaignMutation, UpdateCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateCampaignMutation, UpdateCampaignMutationVariables>(UpdateCampaignDocument, options);
      }
export type UpdateCampaignMutationHookResult = ReturnType<typeof useUpdateCampaignMutation>;
export type UpdateCampaignMutationResult = ApolloReactCommon.MutationResult<UpdateCampaignMutation>;
export type UpdateCampaignMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateCampaignMutation, UpdateCampaignMutationVariables>;
export const ArchiveCampaignDocument = gql`
    mutation archiveCampaign($campaignId: PwsID!) {
  archiveCampaign(campaignId: $campaignId)
}
    `;
export type ArchiveCampaignMutationFn = ApolloReactCommon.MutationFunction<ArchiveCampaignMutation, ArchiveCampaignMutationVariables>;

/**
 * __useArchiveCampaignMutation__
 *
 * To run a mutation, you first call `useArchiveCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveCampaignMutation, { data, loading, error }] = useArchiveCampaignMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useArchiveCampaignMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ArchiveCampaignMutation, ArchiveCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ArchiveCampaignMutation, ArchiveCampaignMutationVariables>(ArchiveCampaignDocument, options);
      }
export type ArchiveCampaignMutationHookResult = ReturnType<typeof useArchiveCampaignMutation>;
export type ArchiveCampaignMutationResult = ApolloReactCommon.MutationResult<ArchiveCampaignMutation>;
export type ArchiveCampaignMutationOptions = ApolloReactCommon.BaseMutationOptions<ArchiveCampaignMutation, ArchiveCampaignMutationVariables>;
export const CampaignHasAdGroupsDocument = gql`
    query campaignHasAdGroups($campaignId: PwsID!, $pagination: Pagination!) {
  campaign(id: $campaignId) {
    id
    adGroups(pagination: $pagination) {
      id
    }
  }
}
    `;

/**
 * __useCampaignHasAdGroupsQuery__
 *
 * To run a query within a React component, call `useCampaignHasAdGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignHasAdGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignHasAdGroupsQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useCampaignHasAdGroupsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CampaignHasAdGroupsQuery, CampaignHasAdGroupsQueryVariables> & ({ variables: CampaignHasAdGroupsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CampaignHasAdGroupsQuery, CampaignHasAdGroupsQueryVariables>(CampaignHasAdGroupsDocument, options);
      }
export function useCampaignHasAdGroupsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CampaignHasAdGroupsQuery, CampaignHasAdGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CampaignHasAdGroupsQuery, CampaignHasAdGroupsQueryVariables>(CampaignHasAdGroupsDocument, options);
        }
// @ts-ignore
export function useCampaignHasAdGroupsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CampaignHasAdGroupsQuery, CampaignHasAdGroupsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CampaignHasAdGroupsQuery, CampaignHasAdGroupsQueryVariables>;
export function useCampaignHasAdGroupsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CampaignHasAdGroupsQuery, CampaignHasAdGroupsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CampaignHasAdGroupsQuery | undefined, CampaignHasAdGroupsQueryVariables>;
export function useCampaignHasAdGroupsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CampaignHasAdGroupsQuery, CampaignHasAdGroupsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CampaignHasAdGroupsQuery, CampaignHasAdGroupsQueryVariables>(CampaignHasAdGroupsDocument, options);
        }
export type CampaignHasAdGroupsQueryHookResult = ReturnType<typeof useCampaignHasAdGroupsQuery>;
export type CampaignHasAdGroupsLazyQueryHookResult = ReturnType<typeof useCampaignHasAdGroupsLazyQuery>;
export type CampaignHasAdGroupsSuspenseQueryHookResult = ReturnType<typeof useCampaignHasAdGroupsSuspenseQuery>;
export type CampaignHasAdGroupsQueryResult = ApolloReactCommon.QueryResult<CampaignHasAdGroupsQuery, CampaignHasAdGroupsQueryVariables>;
export const CreateCampaignDocument = gql`
    mutation createCampaign($campaign: CampaignCreateInput!) {
  createCampaign(newCampaign: $campaign) {
    ...CampaignParts
  }
}
    ${CampaignPartsFragmentDoc}`;
export type CreateCampaignMutationFn = ApolloReactCommon.MutationFunction<CreateCampaignMutation, CreateCampaignMutationVariables>;

/**
 * __useCreateCampaignMutation__
 *
 * To run a mutation, you first call `useCreateCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCampaignMutation, { data, loading, error }] = useCreateCampaignMutation({
 *   variables: {
 *      campaign: // value for 'campaign'
 *   },
 * });
 */
export function useCreateCampaignMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateCampaignMutation, CreateCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateCampaignMutation, CreateCampaignMutationVariables>(CreateCampaignDocument, options);
      }
export type CreateCampaignMutationHookResult = ReturnType<typeof useCreateCampaignMutation>;
export type CreateCampaignMutationResult = ApolloReactCommon.MutationResult<CreateCampaignMutation>;
export type CreateCampaignMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateCampaignMutation, CreateCampaignMutationVariables>;
export const DeleteSegmentCrmDocument = gql`
    mutation deleteSegmentCrm($id: PwsID!) {
  deleteSegmentCrm(id: $id)
}
    `;
export type DeleteSegmentCrmMutationFn = ApolloReactCommon.MutationFunction<DeleteSegmentCrmMutation, DeleteSegmentCrmMutationVariables>;

/**
 * __useDeleteSegmentCrmMutation__
 *
 * To run a mutation, you first call `useDeleteSegmentCrmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSegmentCrmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSegmentCrmMutation, { data, loading, error }] = useDeleteSegmentCrmMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSegmentCrmMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteSegmentCrmMutation, DeleteSegmentCrmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteSegmentCrmMutation, DeleteSegmentCrmMutationVariables>(DeleteSegmentCrmDocument, options);
      }
export type DeleteSegmentCrmMutationHookResult = ReturnType<typeof useDeleteSegmentCrmMutation>;
export type DeleteSegmentCrmMutationResult = ApolloReactCommon.MutationResult<DeleteSegmentCrmMutation>;
export type DeleteSegmentCrmMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteSegmentCrmMutation, DeleteSegmentCrmMutationVariables>;
export const CreateSegmentCrmDocument = gql`
    mutation createSegmentCrm($campaignId: PwsID!, $name: String!, $file: Upload!) {
  createSegmentCrm(campaignId: $campaignId, name: $name, file: $file) {
    ...SegmentCrmParts
  }
}
    ${SegmentCrmPartsFragmentDoc}`;
export type CreateSegmentCrmMutationFn = ApolloReactCommon.MutationFunction<CreateSegmentCrmMutation, CreateSegmentCrmMutationVariables>;

/**
 * __useCreateSegmentCrmMutation__
 *
 * To run a mutation, you first call `useCreateSegmentCrmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSegmentCrmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSegmentCrmMutation, { data, loading, error }] = useCreateSegmentCrmMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      name: // value for 'name'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useCreateSegmentCrmMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateSegmentCrmMutation, CreateSegmentCrmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateSegmentCrmMutation, CreateSegmentCrmMutationVariables>(CreateSegmentCrmDocument, options);
      }
export type CreateSegmentCrmMutationHookResult = ReturnType<typeof useCreateSegmentCrmMutation>;
export type CreateSegmentCrmMutationResult = ApolloReactCommon.MutationResult<CreateSegmentCrmMutation>;
export type CreateSegmentCrmMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateSegmentCrmMutation, CreateSegmentCrmMutationVariables>;
export const UpdateSegmentCrmDocument = gql`
    mutation updateSegmentCrm($segment: SegmentCRMInput!) {
  updateSegmentCrm(segment: $segment) {
    ...SegmentCrmParts
  }
}
    ${SegmentCrmPartsFragmentDoc}`;
export type UpdateSegmentCrmMutationFn = ApolloReactCommon.MutationFunction<UpdateSegmentCrmMutation, UpdateSegmentCrmMutationVariables>;

/**
 * __useUpdateSegmentCrmMutation__
 *
 * To run a mutation, you first call `useUpdateSegmentCrmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSegmentCrmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSegmentCrmMutation, { data, loading, error }] = useUpdateSegmentCrmMutation({
 *   variables: {
 *      segment: // value for 'segment'
 *   },
 * });
 */
export function useUpdateSegmentCrmMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateSegmentCrmMutation, UpdateSegmentCrmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateSegmentCrmMutation, UpdateSegmentCrmMutationVariables>(UpdateSegmentCrmDocument, options);
      }
export type UpdateSegmentCrmMutationHookResult = ReturnType<typeof useUpdateSegmentCrmMutation>;
export type UpdateSegmentCrmMutationResult = ApolloReactCommon.MutationResult<UpdateSegmentCrmMutation>;
export type UpdateSegmentCrmMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateSegmentCrmMutation, UpdateSegmentCrmMutationVariables>;
export const DeleteSegmentBehaviouralDocument = gql`
    mutation deleteSegmentBehavioural($id: PwsID!) {
  deleteSegmentBehavioural(id: $id)
}
    `;
export type DeleteSegmentBehaviouralMutationFn = ApolloReactCommon.MutationFunction<DeleteSegmentBehaviouralMutation, DeleteSegmentBehaviouralMutationVariables>;

/**
 * __useDeleteSegmentBehaviouralMutation__
 *
 * To run a mutation, you first call `useDeleteSegmentBehaviouralMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSegmentBehaviouralMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSegmentBehaviouralMutation, { data, loading, error }] = useDeleteSegmentBehaviouralMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSegmentBehaviouralMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteSegmentBehaviouralMutation, DeleteSegmentBehaviouralMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteSegmentBehaviouralMutation, DeleteSegmentBehaviouralMutationVariables>(DeleteSegmentBehaviouralDocument, options);
      }
export type DeleteSegmentBehaviouralMutationHookResult = ReturnType<typeof useDeleteSegmentBehaviouralMutation>;
export type DeleteSegmentBehaviouralMutationResult = ApolloReactCommon.MutationResult<DeleteSegmentBehaviouralMutation>;
export type DeleteSegmentBehaviouralMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteSegmentBehaviouralMutation, DeleteSegmentBehaviouralMutationVariables>;
export const CreateSegmentBehaviouralDocument = gql`
    mutation createSegmentBehavioural($campaignId: PwsID!, $name: String!, $rules: [SegmentBehaviouralRuleInput!]!) {
  createSegmentBehavioural(campaignId: $campaignId, name: $name, rules: $rules) {
    ...SegmentBehaviouralParts
  }
}
    ${SegmentBehaviouralPartsFragmentDoc}`;
export type CreateSegmentBehaviouralMutationFn = ApolloReactCommon.MutationFunction<CreateSegmentBehaviouralMutation, CreateSegmentBehaviouralMutationVariables>;

/**
 * __useCreateSegmentBehaviouralMutation__
 *
 * To run a mutation, you first call `useCreateSegmentBehaviouralMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSegmentBehaviouralMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSegmentBehaviouralMutation, { data, loading, error }] = useCreateSegmentBehaviouralMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      name: // value for 'name'
 *      rules: // value for 'rules'
 *   },
 * });
 */
export function useCreateSegmentBehaviouralMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateSegmentBehaviouralMutation, CreateSegmentBehaviouralMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateSegmentBehaviouralMutation, CreateSegmentBehaviouralMutationVariables>(CreateSegmentBehaviouralDocument, options);
      }
export type CreateSegmentBehaviouralMutationHookResult = ReturnType<typeof useCreateSegmentBehaviouralMutation>;
export type CreateSegmentBehaviouralMutationResult = ApolloReactCommon.MutationResult<CreateSegmentBehaviouralMutation>;
export type CreateSegmentBehaviouralMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateSegmentBehaviouralMutation, CreateSegmentBehaviouralMutationVariables>;
export const UpdateSegmentBehaviouralDocument = gql`
    mutation updateSegmentBehavioural($rules: [SegmentBehaviouralRuleInput!]!, $segment: SegmentBehaviouralInput!) {
  updateSegmentBehavioural(rules: $rules, segment: $segment) {
    ...SegmentBehaviouralParts
  }
}
    ${SegmentBehaviouralPartsFragmentDoc}`;
export type UpdateSegmentBehaviouralMutationFn = ApolloReactCommon.MutationFunction<UpdateSegmentBehaviouralMutation, UpdateSegmentBehaviouralMutationVariables>;

/**
 * __useUpdateSegmentBehaviouralMutation__
 *
 * To run a mutation, you first call `useUpdateSegmentBehaviouralMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSegmentBehaviouralMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSegmentBehaviouralMutation, { data, loading, error }] = useUpdateSegmentBehaviouralMutation({
 *   variables: {
 *      rules: // value for 'rules'
 *      segment: // value for 'segment'
 *   },
 * });
 */
export function useUpdateSegmentBehaviouralMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateSegmentBehaviouralMutation, UpdateSegmentBehaviouralMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateSegmentBehaviouralMutation, UpdateSegmentBehaviouralMutationVariables>(UpdateSegmentBehaviouralDocument, options);
      }
export type UpdateSegmentBehaviouralMutationHookResult = ReturnType<typeof useUpdateSegmentBehaviouralMutation>;
export type UpdateSegmentBehaviouralMutationResult = ApolloReactCommon.MutationResult<UpdateSegmentBehaviouralMutation>;
export type UpdateSegmentBehaviouralMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateSegmentBehaviouralMutation, UpdateSegmentBehaviouralMutationVariables>;
export const PriorityListDocument = gql`
    query priorityList($campaignId: PwsID!) {
  campaign(id: $campaignId) {
    advertiser {
      reseller {
        priorities {
          id
          name
          value
          isDefault
        }
      }
    }
  }
}
    `;

/**
 * __usePriorityListQuery__
 *
 * To run a query within a React component, call `usePriorityListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePriorityListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePriorityListQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function usePriorityListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PriorityListQuery, PriorityListQueryVariables> & ({ variables: PriorityListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PriorityListQuery, PriorityListQueryVariables>(PriorityListDocument, options);
      }
export function usePriorityListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PriorityListQuery, PriorityListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PriorityListQuery, PriorityListQueryVariables>(PriorityListDocument, options);
        }
// @ts-ignore
export function usePriorityListSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PriorityListQuery, PriorityListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PriorityListQuery, PriorityListQueryVariables>;
export function usePriorityListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PriorityListQuery, PriorityListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PriorityListQuery | undefined, PriorityListQueryVariables>;
export function usePriorityListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PriorityListQuery, PriorityListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PriorityListQuery, PriorityListQueryVariables>(PriorityListDocument, options);
        }
export type PriorityListQueryHookResult = ReturnType<typeof usePriorityListQuery>;
export type PriorityListLazyQueryHookResult = ReturnType<typeof usePriorityListLazyQuery>;
export type PriorityListSuspenseQueryHookResult = ReturnType<typeof usePriorityListSuspenseQuery>;
export type PriorityListQueryResult = ApolloReactCommon.QueryResult<PriorityListQuery, PriorityListQueryVariables>;
export const CreateTermsAndConditionDocument = gql`
    mutation createTermsAndCondition($newTermsAndCondition: TermsAndConditionApprovalCreateInput!) {
  createTermsAndCondition(newTermsAndCondition: $newTermsAndCondition) {
    version
  }
}
    `;
export type CreateTermsAndConditionMutationFn = ApolloReactCommon.MutationFunction<CreateTermsAndConditionMutation, CreateTermsAndConditionMutationVariables>;

/**
 * __useCreateTermsAndConditionMutation__
 *
 * To run a mutation, you first call `useCreateTermsAndConditionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTermsAndConditionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTermsAndConditionMutation, { data, loading, error }] = useCreateTermsAndConditionMutation({
 *   variables: {
 *      newTermsAndCondition: // value for 'newTermsAndCondition'
 *   },
 * });
 */
export function useCreateTermsAndConditionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateTermsAndConditionMutation, CreateTermsAndConditionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateTermsAndConditionMutation, CreateTermsAndConditionMutationVariables>(CreateTermsAndConditionDocument, options);
      }
export type CreateTermsAndConditionMutationHookResult = ReturnType<typeof useCreateTermsAndConditionMutation>;
export type CreateTermsAndConditionMutationResult = ApolloReactCommon.MutationResult<CreateTermsAndConditionMutation>;
export type CreateTermsAndConditionMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateTermsAndConditionMutation, CreateTermsAndConditionMutationVariables>;
export const GetCompanyDocument = gql`
    query getCompany($slug: String, $id: PwsID) {
  company(slug: $slug, id: $id) {
    ...CompanyParts
  }
}
    ${CompanyPartsFragmentDoc}`;

/**
 * __useGetCompanyQuery__
 *
 * To run a query within a React component, call `useGetCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCompanyQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCompanyQuery, GetCompanyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCompanyQuery, GetCompanyQueryVariables>(GetCompanyDocument, options);
      }
export function useGetCompanyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCompanyQuery, GetCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCompanyQuery, GetCompanyQueryVariables>(GetCompanyDocument, options);
        }
// @ts-ignore
export function useGetCompanySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetCompanyQuery, GetCompanyQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetCompanyQuery, GetCompanyQueryVariables>;
export function useGetCompanySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCompanyQuery, GetCompanyQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetCompanyQuery | undefined, GetCompanyQueryVariables>;
export function useGetCompanySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCompanyQuery, GetCompanyQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetCompanyQuery, GetCompanyQueryVariables>(GetCompanyDocument, options);
        }
export type GetCompanyQueryHookResult = ReturnType<typeof useGetCompanyQuery>;
export type GetCompanyLazyQueryHookResult = ReturnType<typeof useGetCompanyLazyQuery>;
export type GetCompanySuspenseQueryHookResult = ReturnType<typeof useGetCompanySuspenseQuery>;
export type GetCompanyQueryResult = ApolloReactCommon.QueryResult<GetCompanyQuery, GetCompanyQueryVariables>;
export const CompanyExistsDocument = gql`
    query companyExists($name: String!, $resellerId: PwsID!, $agencyId: PwsID) {
  companyExists(name: $name, resellerId: $resellerId, agencyId: $agencyId)
}
    `;

/**
 * __useCompanyExistsQuery__
 *
 * To run a query within a React component, call `useCompanyExistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyExistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyExistsQuery({
 *   variables: {
 *      name: // value for 'name'
 *      resellerId: // value for 'resellerId'
 *      agencyId: // value for 'agencyId'
 *   },
 * });
 */
export function useCompanyExistsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CompanyExistsQuery, CompanyExistsQueryVariables> & ({ variables: CompanyExistsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CompanyExistsQuery, CompanyExistsQueryVariables>(CompanyExistsDocument, options);
      }
export function useCompanyExistsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CompanyExistsQuery, CompanyExistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CompanyExistsQuery, CompanyExistsQueryVariables>(CompanyExistsDocument, options);
        }
// @ts-ignore
export function useCompanyExistsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CompanyExistsQuery, CompanyExistsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CompanyExistsQuery, CompanyExistsQueryVariables>;
export function useCompanyExistsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CompanyExistsQuery, CompanyExistsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CompanyExistsQuery | undefined, CompanyExistsQueryVariables>;
export function useCompanyExistsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CompanyExistsQuery, CompanyExistsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CompanyExistsQuery, CompanyExistsQueryVariables>(CompanyExistsDocument, options);
        }
export type CompanyExistsQueryHookResult = ReturnType<typeof useCompanyExistsQuery>;
export type CompanyExistsLazyQueryHookResult = ReturnType<typeof useCompanyExistsLazyQuery>;
export type CompanyExistsSuspenseQueryHookResult = ReturnType<typeof useCompanyExistsSuspenseQuery>;
export type CompanyExistsQueryResult = ApolloReactCommon.QueryResult<CompanyExistsQuery, CompanyExistsQueryVariables>;
export const CompaniesForAutoCompleteDocument = gql`
    query companiesForAutoComplete($pagination: Pagination!, $searchQuery: CompanySearchQuery!) {
  searchCompanies(pagination: $pagination, searchQuery: $searchQuery) {
    id
    name
  }
}
    `;

/**
 * __useCompaniesForAutoCompleteQuery__
 *
 * To run a query within a React component, call `useCompaniesForAutoCompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompaniesForAutoCompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompaniesForAutoCompleteQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function useCompaniesForAutoCompleteQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CompaniesForAutoCompleteQuery, CompaniesForAutoCompleteQueryVariables> & ({ variables: CompaniesForAutoCompleteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CompaniesForAutoCompleteQuery, CompaniesForAutoCompleteQueryVariables>(CompaniesForAutoCompleteDocument, options);
      }
export function useCompaniesForAutoCompleteLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CompaniesForAutoCompleteQuery, CompaniesForAutoCompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CompaniesForAutoCompleteQuery, CompaniesForAutoCompleteQueryVariables>(CompaniesForAutoCompleteDocument, options);
        }
// @ts-ignore
export function useCompaniesForAutoCompleteSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CompaniesForAutoCompleteQuery, CompaniesForAutoCompleteQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CompaniesForAutoCompleteQuery, CompaniesForAutoCompleteQueryVariables>;
export function useCompaniesForAutoCompleteSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CompaniesForAutoCompleteQuery, CompaniesForAutoCompleteQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CompaniesForAutoCompleteQuery | undefined, CompaniesForAutoCompleteQueryVariables>;
export function useCompaniesForAutoCompleteSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CompaniesForAutoCompleteQuery, CompaniesForAutoCompleteQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CompaniesForAutoCompleteQuery, CompaniesForAutoCompleteQueryVariables>(CompaniesForAutoCompleteDocument, options);
        }
export type CompaniesForAutoCompleteQueryHookResult = ReturnType<typeof useCompaniesForAutoCompleteQuery>;
export type CompaniesForAutoCompleteLazyQueryHookResult = ReturnType<typeof useCompaniesForAutoCompleteLazyQuery>;
export type CompaniesForAutoCompleteSuspenseQueryHookResult = ReturnType<typeof useCompaniesForAutoCompleteSuspenseQuery>;
export type CompaniesForAutoCompleteQueryResult = ApolloReactCommon.QueryResult<CompaniesForAutoCompleteQuery, CompaniesForAutoCompleteQueryVariables>;
export const GetCompanyDetailsDocument = gql`
    query getCompanyDetails($slug: String, $id: PwsID) {
  company(slug: $slug, id: $id) {
    ...CompanyParts
    country {
      label
    }
    reseller {
      name
      id
      slug
    }
    agency {
      name
      id
      slug
    }
    approvedTerms {
      user {
        firstName
        lastName
      }
      acceptedAt
      version
    }
  }
  getCountries {
    code
    label
  }
  getLanguages {
    id
    code
    label
  }
}
    ${CompanyPartsFragmentDoc}`;

/**
 * __useGetCompanyDetailsQuery__
 *
 * To run a query within a React component, call `useGetCompanyDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyDetailsQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCompanyDetailsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCompanyDetailsQuery, GetCompanyDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCompanyDetailsQuery, GetCompanyDetailsQueryVariables>(GetCompanyDetailsDocument, options);
      }
export function useGetCompanyDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCompanyDetailsQuery, GetCompanyDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCompanyDetailsQuery, GetCompanyDetailsQueryVariables>(GetCompanyDetailsDocument, options);
        }
// @ts-ignore
export function useGetCompanyDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetCompanyDetailsQuery, GetCompanyDetailsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetCompanyDetailsQuery, GetCompanyDetailsQueryVariables>;
export function useGetCompanyDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCompanyDetailsQuery, GetCompanyDetailsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetCompanyDetailsQuery | undefined, GetCompanyDetailsQueryVariables>;
export function useGetCompanyDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCompanyDetailsQuery, GetCompanyDetailsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetCompanyDetailsQuery, GetCompanyDetailsQueryVariables>(GetCompanyDetailsDocument, options);
        }
export type GetCompanyDetailsQueryHookResult = ReturnType<typeof useGetCompanyDetailsQuery>;
export type GetCompanyDetailsLazyQueryHookResult = ReturnType<typeof useGetCompanyDetailsLazyQuery>;
export type GetCompanyDetailsSuspenseQueryHookResult = ReturnType<typeof useGetCompanyDetailsSuspenseQuery>;
export type GetCompanyDetailsQueryResult = ApolloReactCommon.QueryResult<GetCompanyDetailsQuery, GetCompanyDetailsQueryVariables>;
export const BillingContactDocument = gql`
    query billingContact($slug: String, $id: PwsID) {
  company(slug: $slug, id: $id) {
    id
    billingContacts {
      id
      firstName
      lastName
      email
      phone
    }
  }
}
    `;

/**
 * __useBillingContactQuery__
 *
 * To run a query within a React component, call `useBillingContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillingContactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillingContactQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBillingContactQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BillingContactQuery, BillingContactQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BillingContactQuery, BillingContactQueryVariables>(BillingContactDocument, options);
      }
export function useBillingContactLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BillingContactQuery, BillingContactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BillingContactQuery, BillingContactQueryVariables>(BillingContactDocument, options);
        }
// @ts-ignore
export function useBillingContactSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<BillingContactQuery, BillingContactQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BillingContactQuery, BillingContactQueryVariables>;
export function useBillingContactSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BillingContactQuery, BillingContactQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BillingContactQuery | undefined, BillingContactQueryVariables>;
export function useBillingContactSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BillingContactQuery, BillingContactQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BillingContactQuery, BillingContactQueryVariables>(BillingContactDocument, options);
        }
export type BillingContactQueryHookResult = ReturnType<typeof useBillingContactQuery>;
export type BillingContactLazyQueryHookResult = ReturnType<typeof useBillingContactLazyQuery>;
export type BillingContactSuspenseQueryHookResult = ReturnType<typeof useBillingContactSuspenseQuery>;
export type BillingContactQueryResult = ApolloReactCommon.QueryResult<BillingContactQuery, BillingContactQueryVariables>;
export const CompanyInvoiceInfoDocument = gql`
    query companyInvoiceInfo($slug: String, $id: PwsID) {
  company(slug: $slug, id: $id) {
    id
    name
    addressLine1
    zipCode
    city
    vatId
    paymentTerm
    country {
      label
    }
  }
}
    `;

/**
 * __useCompanyInvoiceInfoQuery__
 *
 * To run a query within a React component, call `useCompanyInvoiceInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyInvoiceInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyInvoiceInfoQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCompanyInvoiceInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CompanyInvoiceInfoQuery, CompanyInvoiceInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CompanyInvoiceInfoQuery, CompanyInvoiceInfoQueryVariables>(CompanyInvoiceInfoDocument, options);
      }
export function useCompanyInvoiceInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CompanyInvoiceInfoQuery, CompanyInvoiceInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CompanyInvoiceInfoQuery, CompanyInvoiceInfoQueryVariables>(CompanyInvoiceInfoDocument, options);
        }
// @ts-ignore
export function useCompanyInvoiceInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CompanyInvoiceInfoQuery, CompanyInvoiceInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CompanyInvoiceInfoQuery, CompanyInvoiceInfoQueryVariables>;
export function useCompanyInvoiceInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CompanyInvoiceInfoQuery, CompanyInvoiceInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CompanyInvoiceInfoQuery | undefined, CompanyInvoiceInfoQueryVariables>;
export function useCompanyInvoiceInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CompanyInvoiceInfoQuery, CompanyInvoiceInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CompanyInvoiceInfoQuery, CompanyInvoiceInfoQueryVariables>(CompanyInvoiceInfoDocument, options);
        }
export type CompanyInvoiceInfoQueryHookResult = ReturnType<typeof useCompanyInvoiceInfoQuery>;
export type CompanyInvoiceInfoLazyQueryHookResult = ReturnType<typeof useCompanyInvoiceInfoLazyQuery>;
export type CompanyInvoiceInfoSuspenseQueryHookResult = ReturnType<typeof useCompanyInvoiceInfoSuspenseQuery>;
export type CompanyInvoiceInfoQueryResult = ApolloReactCommon.QueryResult<CompanyInvoiceInfoQuery, CompanyInvoiceInfoQueryVariables>;
export const CompanyPermissionsDocument = gql`
    query companyPermissions($slug: String, $id: PwsID) {
  company(slug: $slug, id: $id) {
    type
    agencyId
    resellerId
    ...CompanyPermissions
  }
}
    ${CompanyPermissionsFragmentDoc}`;

/**
 * __useCompanyPermissionsQuery__
 *
 * To run a query within a React component, call `useCompanyPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyPermissionsQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCompanyPermissionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CompanyPermissionsQuery, CompanyPermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CompanyPermissionsQuery, CompanyPermissionsQueryVariables>(CompanyPermissionsDocument, options);
      }
export function useCompanyPermissionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CompanyPermissionsQuery, CompanyPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CompanyPermissionsQuery, CompanyPermissionsQueryVariables>(CompanyPermissionsDocument, options);
        }
// @ts-ignore
export function useCompanyPermissionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CompanyPermissionsQuery, CompanyPermissionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CompanyPermissionsQuery, CompanyPermissionsQueryVariables>;
export function useCompanyPermissionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CompanyPermissionsQuery, CompanyPermissionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CompanyPermissionsQuery | undefined, CompanyPermissionsQueryVariables>;
export function useCompanyPermissionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CompanyPermissionsQuery, CompanyPermissionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CompanyPermissionsQuery, CompanyPermissionsQueryVariables>(CompanyPermissionsDocument, options);
        }
export type CompanyPermissionsQueryHookResult = ReturnType<typeof useCompanyPermissionsQuery>;
export type CompanyPermissionsLazyQueryHookResult = ReturnType<typeof useCompanyPermissionsLazyQuery>;
export type CompanyPermissionsSuspenseQueryHookResult = ReturnType<typeof useCompanyPermissionsSuspenseQuery>;
export type CompanyPermissionsQueryResult = ApolloReactCommon.QueryResult<CompanyPermissionsQuery, CompanyPermissionsQueryVariables>;
export const CompaniesDocument = gql`
    query companies($pagination: Pagination!, $searchQuery: CompanySearchQuery!) {
  searchCompanies(pagination: $pagination, searchQuery: $searchQuery) {
    id
    slug
    name
    genericName
    agency {
      id
      name
    }
    reseller {
      id
      name
    }
    type
    status
  }
}
    `;

/**
 * __useCompaniesQuery__
 *
 * To run a query within a React component, call `useCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompaniesQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function useCompaniesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CompaniesQuery, CompaniesQueryVariables> & ({ variables: CompaniesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CompaniesQuery, CompaniesQueryVariables>(CompaniesDocument, options);
      }
export function useCompaniesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CompaniesQuery, CompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CompaniesQuery, CompaniesQueryVariables>(CompaniesDocument, options);
        }
// @ts-ignore
export function useCompaniesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CompaniesQuery, CompaniesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CompaniesQuery, CompaniesQueryVariables>;
export function useCompaniesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CompaniesQuery, CompaniesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CompaniesQuery | undefined, CompaniesQueryVariables>;
export function useCompaniesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CompaniesQuery, CompaniesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CompaniesQuery, CompaniesQueryVariables>(CompaniesDocument, options);
        }
export type CompaniesQueryHookResult = ReturnType<typeof useCompaniesQuery>;
export type CompaniesLazyQueryHookResult = ReturnType<typeof useCompaniesLazyQuery>;
export type CompaniesSuspenseQueryHookResult = ReturnType<typeof useCompaniesSuspenseQuery>;
export type CompaniesQueryResult = ApolloReactCommon.QueryResult<CompaniesQuery, CompaniesQueryVariables>;
export const CreateCompanyDocument = gql`
    mutation createCompany($newCompany: CompanyCreateInput!) {
  createCompany(newCompany: $newCompany) {
    ...CompanyParts
  }
}
    ${CompanyPartsFragmentDoc}`;
export type CreateCompanyMutationFn = ApolloReactCommon.MutationFunction<CreateCompanyMutation, CreateCompanyMutationVariables>;

/**
 * __useCreateCompanyMutation__
 *
 * To run a mutation, you first call `useCreateCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompanyMutation, { data, loading, error }] = useCreateCompanyMutation({
 *   variables: {
 *      newCompany: // value for 'newCompany'
 *   },
 * });
 */
export function useCreateCompanyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateCompanyMutation, CreateCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateCompanyMutation, CreateCompanyMutationVariables>(CreateCompanyDocument, options);
      }
export type CreateCompanyMutationHookResult = ReturnType<typeof useCreateCompanyMutation>;
export type CreateCompanyMutationResult = ApolloReactCommon.MutationResult<CreateCompanyMutation>;
export type CreateCompanyMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateCompanyMutation, CreateCompanyMutationVariables>;
export const UpdateCompanyDocument = gql`
    mutation updateCompany($company: CompanyInput!) {
  updateCompany(company: $company) {
    ...CompanyParts
  }
}
    ${CompanyPartsFragmentDoc}`;
export type UpdateCompanyMutationFn = ApolloReactCommon.MutationFunction<UpdateCompanyMutation, UpdateCompanyMutationVariables>;

/**
 * __useUpdateCompanyMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyMutation, { data, loading, error }] = useUpdateCompanyMutation({
 *   variables: {
 *      company: // value for 'company'
 *   },
 * });
 */
export function useUpdateCompanyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCompanyMutation, UpdateCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateCompanyMutation, UpdateCompanyMutationVariables>(UpdateCompanyDocument, options);
      }
export type UpdateCompanyMutationHookResult = ReturnType<typeof useUpdateCompanyMutation>;
export type UpdateCompanyMutationResult = ApolloReactCommon.MutationResult<UpdateCompanyMutation>;
export type UpdateCompanyMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateCompanyMutation, UpdateCompanyMutationVariables>;
export const CompanyUsersDocument = gql`
    query companyUsers($pagination: Pagination, $searchQuery: UserSearchQuery!) {
  users: searchUsers(searchQuery: $searchQuery, pagination: $pagination) {
    id
    firstName
    lastName
    email
    accessType
    status
    isPrimaryContact
  }
}
    `;

/**
 * __useCompanyUsersQuery__
 *
 * To run a query within a React component, call `useCompanyUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyUsersQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function useCompanyUsersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CompanyUsersQuery, CompanyUsersQueryVariables> & ({ variables: CompanyUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CompanyUsersQuery, CompanyUsersQueryVariables>(CompanyUsersDocument, options);
      }
export function useCompanyUsersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CompanyUsersQuery, CompanyUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CompanyUsersQuery, CompanyUsersQueryVariables>(CompanyUsersDocument, options);
        }
// @ts-ignore
export function useCompanyUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CompanyUsersQuery, CompanyUsersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CompanyUsersQuery, CompanyUsersQueryVariables>;
export function useCompanyUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CompanyUsersQuery, CompanyUsersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CompanyUsersQuery | undefined, CompanyUsersQueryVariables>;
export function useCompanyUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CompanyUsersQuery, CompanyUsersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CompanyUsersQuery, CompanyUsersQueryVariables>(CompanyUsersDocument, options);
        }
export type CompanyUsersQueryHookResult = ReturnType<typeof useCompanyUsersQuery>;
export type CompanyUsersLazyQueryHookResult = ReturnType<typeof useCompanyUsersLazyQuery>;
export type CompanyUsersSuspenseQueryHookResult = ReturnType<typeof useCompanyUsersSuspenseQuery>;
export type CompanyUsersQueryResult = ApolloReactCommon.QueryResult<CompanyUsersQuery, CompanyUsersQueryVariables>;
export const AgencyCompaniesDocument = gql`
    query agencyCompanies($resellerIds: [String!]!) {
  searchCompanies(
    searchQuery: {type: Agency, status: [Active], resellerIds: $resellerIds}
  ) {
    id
    name
    genericName
  }
}
    `;

/**
 * __useAgencyCompaniesQuery__
 *
 * To run a query within a React component, call `useAgencyCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgencyCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgencyCompaniesQuery({
 *   variables: {
 *      resellerIds: // value for 'resellerIds'
 *   },
 * });
 */
export function useAgencyCompaniesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AgencyCompaniesQuery, AgencyCompaniesQueryVariables> & ({ variables: AgencyCompaniesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AgencyCompaniesQuery, AgencyCompaniesQueryVariables>(AgencyCompaniesDocument, options);
      }
export function useAgencyCompaniesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AgencyCompaniesQuery, AgencyCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AgencyCompaniesQuery, AgencyCompaniesQueryVariables>(AgencyCompaniesDocument, options);
        }
// @ts-ignore
export function useAgencyCompaniesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AgencyCompaniesQuery, AgencyCompaniesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AgencyCompaniesQuery, AgencyCompaniesQueryVariables>;
export function useAgencyCompaniesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AgencyCompaniesQuery, AgencyCompaniesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AgencyCompaniesQuery | undefined, AgencyCompaniesQueryVariables>;
export function useAgencyCompaniesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AgencyCompaniesQuery, AgencyCompaniesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AgencyCompaniesQuery, AgencyCompaniesQueryVariables>(AgencyCompaniesDocument, options);
        }
export type AgencyCompaniesQueryHookResult = ReturnType<typeof useAgencyCompaniesQuery>;
export type AgencyCompaniesLazyQueryHookResult = ReturnType<typeof useAgencyCompaniesLazyQuery>;
export type AgencyCompaniesSuspenseQueryHookResult = ReturnType<typeof useAgencyCompaniesSuspenseQuery>;
export type AgencyCompaniesQueryResult = ApolloReactCommon.QueryResult<AgencyCompaniesQuery, AgencyCompaniesQueryVariables>;
export const ResellerCompaniesDocument = gql`
    query resellerCompanies {
  searchCompanies(searchQuery: {type: Reseller}) {
    id
    name
    status
  }
}
    `;

/**
 * __useResellerCompaniesQuery__
 *
 * To run a query within a React component, call `useResellerCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useResellerCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResellerCompaniesQuery({
 *   variables: {
 *   },
 * });
 */
export function useResellerCompaniesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ResellerCompaniesQuery, ResellerCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ResellerCompaniesQuery, ResellerCompaniesQueryVariables>(ResellerCompaniesDocument, options);
      }
export function useResellerCompaniesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ResellerCompaniesQuery, ResellerCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ResellerCompaniesQuery, ResellerCompaniesQueryVariables>(ResellerCompaniesDocument, options);
        }
// @ts-ignore
export function useResellerCompaniesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ResellerCompaniesQuery, ResellerCompaniesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ResellerCompaniesQuery, ResellerCompaniesQueryVariables>;
export function useResellerCompaniesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ResellerCompaniesQuery, ResellerCompaniesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ResellerCompaniesQuery | undefined, ResellerCompaniesQueryVariables>;
export function useResellerCompaniesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ResellerCompaniesQuery, ResellerCompaniesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ResellerCompaniesQuery, ResellerCompaniesQueryVariables>(ResellerCompaniesDocument, options);
        }
export type ResellerCompaniesQueryHookResult = ReturnType<typeof useResellerCompaniesQuery>;
export type ResellerCompaniesLazyQueryHookResult = ReturnType<typeof useResellerCompaniesLazyQuery>;
export type ResellerCompaniesSuspenseQueryHookResult = ReturnType<typeof useResellerCompaniesSuspenseQuery>;
export type ResellerCompaniesQueryResult = ApolloReactCommon.QueryResult<ResellerCompaniesQuery, ResellerCompaniesQueryVariables>;
export const ActivePublisherNamesDocument = gql`
    query activePublisherNames {
  searchCompanies(searchQuery: {type: Publisher, status: [Active]}) {
    id
    genericName
  }
}
    `;

/**
 * __useActivePublisherNamesQuery__
 *
 * To run a query within a React component, call `useActivePublisherNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivePublisherNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivePublisherNamesQuery({
 *   variables: {
 *   },
 * });
 */
export function useActivePublisherNamesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ActivePublisherNamesQuery, ActivePublisherNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ActivePublisherNamesQuery, ActivePublisherNamesQueryVariables>(ActivePublisherNamesDocument, options);
      }
export function useActivePublisherNamesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ActivePublisherNamesQuery, ActivePublisherNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ActivePublisherNamesQuery, ActivePublisherNamesQueryVariables>(ActivePublisherNamesDocument, options);
        }
// @ts-ignore
export function useActivePublisherNamesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ActivePublisherNamesQuery, ActivePublisherNamesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ActivePublisherNamesQuery, ActivePublisherNamesQueryVariables>;
export function useActivePublisherNamesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ActivePublisherNamesQuery, ActivePublisherNamesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ActivePublisherNamesQuery | undefined, ActivePublisherNamesQueryVariables>;
export function useActivePublisherNamesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ActivePublisherNamesQuery, ActivePublisherNamesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ActivePublisherNamesQuery, ActivePublisherNamesQueryVariables>(ActivePublisherNamesDocument, options);
        }
export type ActivePublisherNamesQueryHookResult = ReturnType<typeof useActivePublisherNamesQuery>;
export type ActivePublisherNamesLazyQueryHookResult = ReturnType<typeof useActivePublisherNamesLazyQuery>;
export type ActivePublisherNamesSuspenseQueryHookResult = ReturnType<typeof useActivePublisherNamesSuspenseQuery>;
export type ActivePublisherNamesQueryResult = ApolloReactCommon.QueryResult<ActivePublisherNamesQuery, ActivePublisherNamesQueryVariables>;
export const ActiveCompaniesNamesDocument = gql`
    query activeCompaniesNames {
  searchCompanies(searchQuery: {status: [Active]}) {
    id
    genericName
  }
}
    `;

/**
 * __useActiveCompaniesNamesQuery__
 *
 * To run a query within a React component, call `useActiveCompaniesNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveCompaniesNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveCompaniesNamesQuery({
 *   variables: {
 *   },
 * });
 */
export function useActiveCompaniesNamesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ActiveCompaniesNamesQuery, ActiveCompaniesNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ActiveCompaniesNamesQuery, ActiveCompaniesNamesQueryVariables>(ActiveCompaniesNamesDocument, options);
      }
export function useActiveCompaniesNamesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ActiveCompaniesNamesQuery, ActiveCompaniesNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ActiveCompaniesNamesQuery, ActiveCompaniesNamesQueryVariables>(ActiveCompaniesNamesDocument, options);
        }
// @ts-ignore
export function useActiveCompaniesNamesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ActiveCompaniesNamesQuery, ActiveCompaniesNamesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ActiveCompaniesNamesQuery, ActiveCompaniesNamesQueryVariables>;
export function useActiveCompaniesNamesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ActiveCompaniesNamesQuery, ActiveCompaniesNamesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ActiveCompaniesNamesQuery | undefined, ActiveCompaniesNamesQueryVariables>;
export function useActiveCompaniesNamesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ActiveCompaniesNamesQuery, ActiveCompaniesNamesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ActiveCompaniesNamesQuery, ActiveCompaniesNamesQueryVariables>(ActiveCompaniesNamesDocument, options);
        }
export type ActiveCompaniesNamesQueryHookResult = ReturnType<typeof useActiveCompaniesNamesQuery>;
export type ActiveCompaniesNamesLazyQueryHookResult = ReturnType<typeof useActiveCompaniesNamesLazyQuery>;
export type ActiveCompaniesNamesSuspenseQueryHookResult = ReturnType<typeof useActiveCompaniesNamesSuspenseQuery>;
export type ActiveCompaniesNamesQueryResult = ApolloReactCommon.QueryResult<ActiveCompaniesNamesQuery, ActiveCompaniesNamesQueryVariables>;
export const CreateBillingContactDocument = gql`
    mutation createBillingContact($newBillingContact: BillingContactCreateInput!) {
  createBillingContact(newBillingContact: $newBillingContact) {
    id
    firstName
    lastName
    email
    phone
  }
}
    `;
export type CreateBillingContactMutationFn = ApolloReactCommon.MutationFunction<CreateBillingContactMutation, CreateBillingContactMutationVariables>;

/**
 * __useCreateBillingContactMutation__
 *
 * To run a mutation, you first call `useCreateBillingContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBillingContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBillingContactMutation, { data, loading, error }] = useCreateBillingContactMutation({
 *   variables: {
 *      newBillingContact: // value for 'newBillingContact'
 *   },
 * });
 */
export function useCreateBillingContactMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateBillingContactMutation, CreateBillingContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateBillingContactMutation, CreateBillingContactMutationVariables>(CreateBillingContactDocument, options);
      }
export type CreateBillingContactMutationHookResult = ReturnType<typeof useCreateBillingContactMutation>;
export type CreateBillingContactMutationResult = ApolloReactCommon.MutationResult<CreateBillingContactMutation>;
export type CreateBillingContactMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateBillingContactMutation, CreateBillingContactMutationVariables>;
export const DeleteBillingContactDocument = gql`
    mutation deleteBillingContact($id: PwsID!) {
  deleteBillingContact(id: $id)
}
    `;
export type DeleteBillingContactMutationFn = ApolloReactCommon.MutationFunction<DeleteBillingContactMutation, DeleteBillingContactMutationVariables>;

/**
 * __useDeleteBillingContactMutation__
 *
 * To run a mutation, you first call `useDeleteBillingContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBillingContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBillingContactMutation, { data, loading, error }] = useDeleteBillingContactMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteBillingContactMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteBillingContactMutation, DeleteBillingContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteBillingContactMutation, DeleteBillingContactMutationVariables>(DeleteBillingContactDocument, options);
      }
export type DeleteBillingContactMutationHookResult = ReturnType<typeof useDeleteBillingContactMutation>;
export type DeleteBillingContactMutationResult = ApolloReactCommon.MutationResult<DeleteBillingContactMutation>;
export type DeleteBillingContactMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteBillingContactMutation, DeleteBillingContactMutationVariables>;
export const UpdateCompanyPermissionsDocument = gql`
    mutation updateCompanyPermissions($permissions: CompanyPermissionInput!, $companyId: PwsID!) {
  updateCompanyPermissions(permissions: $permissions, companyId: $companyId) {
    ...CompanyPermissions
  }
}
    ${CompanyPermissionsFragmentDoc}`;
export type UpdateCompanyPermissionsMutationFn = ApolloReactCommon.MutationFunction<UpdateCompanyPermissionsMutation, UpdateCompanyPermissionsMutationVariables>;

/**
 * __useUpdateCompanyPermissionsMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyPermissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyPermissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyPermissionsMutation, { data, loading, error }] = useUpdateCompanyPermissionsMutation({
 *   variables: {
 *      permissions: // value for 'permissions'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useUpdateCompanyPermissionsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCompanyPermissionsMutation, UpdateCompanyPermissionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateCompanyPermissionsMutation, UpdateCompanyPermissionsMutationVariables>(UpdateCompanyPermissionsDocument, options);
      }
export type UpdateCompanyPermissionsMutationHookResult = ReturnType<typeof useUpdateCompanyPermissionsMutation>;
export type UpdateCompanyPermissionsMutationResult = ApolloReactCommon.MutationResult<UpdateCompanyPermissionsMutation>;
export type UpdateCompanyPermissionsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateCompanyPermissionsMutation, UpdateCompanyPermissionsMutationVariables>;
export const CompanyApiTokensDocument = gql`
    query companyApiTokens($companyId: PwsID!) {
  company(id: $companyId) {
    apiTokens {
      status
      token
      createdAt
    }
  }
}
    `;

/**
 * __useCompanyApiTokensQuery__
 *
 * To run a query within a React component, call `useCompanyApiTokensQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyApiTokensQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyApiTokensQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useCompanyApiTokensQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CompanyApiTokensQuery, CompanyApiTokensQueryVariables> & ({ variables: CompanyApiTokensQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CompanyApiTokensQuery, CompanyApiTokensQueryVariables>(CompanyApiTokensDocument, options);
      }
export function useCompanyApiTokensLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CompanyApiTokensQuery, CompanyApiTokensQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CompanyApiTokensQuery, CompanyApiTokensQueryVariables>(CompanyApiTokensDocument, options);
        }
// @ts-ignore
export function useCompanyApiTokensSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CompanyApiTokensQuery, CompanyApiTokensQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CompanyApiTokensQuery, CompanyApiTokensQueryVariables>;
export function useCompanyApiTokensSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CompanyApiTokensQuery, CompanyApiTokensQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CompanyApiTokensQuery | undefined, CompanyApiTokensQueryVariables>;
export function useCompanyApiTokensSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CompanyApiTokensQuery, CompanyApiTokensQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CompanyApiTokensQuery, CompanyApiTokensQueryVariables>(CompanyApiTokensDocument, options);
        }
export type CompanyApiTokensQueryHookResult = ReturnType<typeof useCompanyApiTokensQuery>;
export type CompanyApiTokensLazyQueryHookResult = ReturnType<typeof useCompanyApiTokensLazyQuery>;
export type CompanyApiTokensSuspenseQueryHookResult = ReturnType<typeof useCompanyApiTokensSuspenseQuery>;
export type CompanyApiTokensQueryResult = ApolloReactCommon.QueryResult<CompanyApiTokensQuery, CompanyApiTokensQueryVariables>;
export const CreateCompanyApiTokenDocument = gql`
    mutation createCompanyApiToken($companyId: PwsID!) {
  createApiToken(companyId: $companyId) {
    status
    token
    createdAt
  }
}
    `;
export type CreateCompanyApiTokenMutationFn = ApolloReactCommon.MutationFunction<CreateCompanyApiTokenMutation, CreateCompanyApiTokenMutationVariables>;

/**
 * __useCreateCompanyApiTokenMutation__
 *
 * To run a mutation, you first call `useCreateCompanyApiTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompanyApiTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompanyApiTokenMutation, { data, loading, error }] = useCreateCompanyApiTokenMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useCreateCompanyApiTokenMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateCompanyApiTokenMutation, CreateCompanyApiTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateCompanyApiTokenMutation, CreateCompanyApiTokenMutationVariables>(CreateCompanyApiTokenDocument, options);
      }
export type CreateCompanyApiTokenMutationHookResult = ReturnType<typeof useCreateCompanyApiTokenMutation>;
export type CreateCompanyApiTokenMutationResult = ApolloReactCommon.MutationResult<CreateCompanyApiTokenMutation>;
export type CreateCompanyApiTokenMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateCompanyApiTokenMutation, CreateCompanyApiTokenMutationVariables>;
export const CompanyWebhooksDocument = gql`
    query companyWebhooks($companyId: PwsID!) {
  company(id: $companyId) {
    webhooks {
      ...CompanyWebhookParts
    }
  }
}
    ${CompanyWebhookPartsFragmentDoc}`;

/**
 * __useCompanyWebhooksQuery__
 *
 * To run a query within a React component, call `useCompanyWebhooksQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyWebhooksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyWebhooksQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useCompanyWebhooksQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CompanyWebhooksQuery, CompanyWebhooksQueryVariables> & ({ variables: CompanyWebhooksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CompanyWebhooksQuery, CompanyWebhooksQueryVariables>(CompanyWebhooksDocument, options);
      }
export function useCompanyWebhooksLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CompanyWebhooksQuery, CompanyWebhooksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CompanyWebhooksQuery, CompanyWebhooksQueryVariables>(CompanyWebhooksDocument, options);
        }
// @ts-ignore
export function useCompanyWebhooksSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CompanyWebhooksQuery, CompanyWebhooksQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CompanyWebhooksQuery, CompanyWebhooksQueryVariables>;
export function useCompanyWebhooksSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CompanyWebhooksQuery, CompanyWebhooksQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CompanyWebhooksQuery | undefined, CompanyWebhooksQueryVariables>;
export function useCompanyWebhooksSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CompanyWebhooksQuery, CompanyWebhooksQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CompanyWebhooksQuery, CompanyWebhooksQueryVariables>(CompanyWebhooksDocument, options);
        }
export type CompanyWebhooksQueryHookResult = ReturnType<typeof useCompanyWebhooksQuery>;
export type CompanyWebhooksLazyQueryHookResult = ReturnType<typeof useCompanyWebhooksLazyQuery>;
export type CompanyWebhooksSuspenseQueryHookResult = ReturnType<typeof useCompanyWebhooksSuspenseQuery>;
export type CompanyWebhooksQueryResult = ApolloReactCommon.QueryResult<CompanyWebhooksQuery, CompanyWebhooksQueryVariables>;
export const UpdateCompanyWebhookDocument = gql`
    mutation updateCompanyWebhook($companyId: PwsID!, $types: [CompanyWebhookType!]!, $url: String!) {
  updateCompanyWebhook(companyId: $companyId, types: $types, url: $url) {
    ...CompanyWebhookParts
  }
}
    ${CompanyWebhookPartsFragmentDoc}`;
export type UpdateCompanyWebhookMutationFn = ApolloReactCommon.MutationFunction<UpdateCompanyWebhookMutation, UpdateCompanyWebhookMutationVariables>;

/**
 * __useUpdateCompanyWebhookMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyWebhookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyWebhookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyWebhookMutation, { data, loading, error }] = useUpdateCompanyWebhookMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      types: // value for 'types'
 *      url: // value for 'url'
 *   },
 * });
 */
export function useUpdateCompanyWebhookMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCompanyWebhookMutation, UpdateCompanyWebhookMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateCompanyWebhookMutation, UpdateCompanyWebhookMutationVariables>(UpdateCompanyWebhookDocument, options);
      }
export type UpdateCompanyWebhookMutationHookResult = ReturnType<typeof useUpdateCompanyWebhookMutation>;
export type UpdateCompanyWebhookMutationResult = ApolloReactCommon.MutationResult<UpdateCompanyWebhookMutation>;
export type UpdateCompanyWebhookMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateCompanyWebhookMutation, UpdateCompanyWebhookMutationVariables>;
export const DeleteCompanyWebhookDocument = gql`
    mutation deleteCompanyWebhook($id: PwsID!) {
  deleteCompanyWebhook(id: $id)
}
    `;
export type DeleteCompanyWebhookMutationFn = ApolloReactCommon.MutationFunction<DeleteCompanyWebhookMutation, DeleteCompanyWebhookMutationVariables>;

/**
 * __useDeleteCompanyWebhookMutation__
 *
 * To run a mutation, you first call `useDeleteCompanyWebhookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCompanyWebhookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCompanyWebhookMutation, { data, loading, error }] = useDeleteCompanyWebhookMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCompanyWebhookMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteCompanyWebhookMutation, DeleteCompanyWebhookMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteCompanyWebhookMutation, DeleteCompanyWebhookMutationVariables>(DeleteCompanyWebhookDocument, options);
      }
export type DeleteCompanyWebhookMutationHookResult = ReturnType<typeof useDeleteCompanyWebhookMutation>;
export type DeleteCompanyWebhookMutationResult = ApolloReactCommon.MutationResult<DeleteCompanyWebhookMutation>;
export type DeleteCompanyWebhookMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteCompanyWebhookMutation, DeleteCompanyWebhookMutationVariables>;
export const WebhookExampleDocument = gql`
    query webhookExample {
  webhookExample {
    type
    version
    payload
  }
}
    `;

/**
 * __useWebhookExampleQuery__
 *
 * To run a query within a React component, call `useWebhookExampleQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebhookExampleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebhookExampleQuery({
 *   variables: {
 *   },
 * });
 */
export function useWebhookExampleQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<WebhookExampleQuery, WebhookExampleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WebhookExampleQuery, WebhookExampleQueryVariables>(WebhookExampleDocument, options);
      }
export function useWebhookExampleLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WebhookExampleQuery, WebhookExampleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WebhookExampleQuery, WebhookExampleQueryVariables>(WebhookExampleDocument, options);
        }
// @ts-ignore
export function useWebhookExampleSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<WebhookExampleQuery, WebhookExampleQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WebhookExampleQuery, WebhookExampleQueryVariables>;
export function useWebhookExampleSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WebhookExampleQuery, WebhookExampleQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WebhookExampleQuery | undefined, WebhookExampleQueryVariables>;
export function useWebhookExampleSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WebhookExampleQuery, WebhookExampleQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<WebhookExampleQuery, WebhookExampleQueryVariables>(WebhookExampleDocument, options);
        }
export type WebhookExampleQueryHookResult = ReturnType<typeof useWebhookExampleQuery>;
export type WebhookExampleLazyQueryHookResult = ReturnType<typeof useWebhookExampleLazyQuery>;
export type WebhookExampleSuspenseQueryHookResult = ReturnType<typeof useWebhookExampleSuspenseQuery>;
export type WebhookExampleQueryResult = ApolloReactCommon.QueryResult<WebhookExampleQuery, WebhookExampleQueryVariables>;
export const CompanyArchiverConfigDocument = gql`
    query companyArchiverConfig($companyId: PwsID!, $isAdvertiser: Boolean!, $isPublisher: Boolean!, $isAgency: Boolean!, $isReseller: Boolean!) {
  advertiser(id: $companyId) @include(if: $isAdvertiser) {
    id
    archiverConfig {
      ...ArchiverConfigParts
    }
    agency {
      id
      archiverConfig {
        ...ArchiverConfigParts
      }
    }
    reseller {
      id
      archiverConfig {
        ...ArchiverConfigParts
      }
    }
  }
  publisher(id: $companyId) @include(if: $isPublisher) {
    id
    archiverConfig {
      ...ArchiverConfigParts
    }
    reseller {
      id
      archiverConfig {
        ...ArchiverConfigParts
      }
    }
  }
  agency(id: $companyId) @include(if: $isAgency) {
    id
    reseller {
      id
      archiverConfig {
        ...ArchiverConfigParts
      }
    }
  }
  reseller(id: $companyId) @include(if: $isReseller) {
    id
    archiverConfig {
      ...ArchiverConfigParts
    }
  }
}
    ${ArchiverConfigPartsFragmentDoc}`;

/**
 * __useCompanyArchiverConfigQuery__
 *
 * To run a query within a React component, call `useCompanyArchiverConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyArchiverConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyArchiverConfigQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      isAdvertiser: // value for 'isAdvertiser'
 *      isPublisher: // value for 'isPublisher'
 *      isAgency: // value for 'isAgency'
 *      isReseller: // value for 'isReseller'
 *   },
 * });
 */
export function useCompanyArchiverConfigQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CompanyArchiverConfigQuery, CompanyArchiverConfigQueryVariables> & ({ variables: CompanyArchiverConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CompanyArchiverConfigQuery, CompanyArchiverConfigQueryVariables>(CompanyArchiverConfigDocument, options);
      }
export function useCompanyArchiverConfigLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CompanyArchiverConfigQuery, CompanyArchiverConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CompanyArchiverConfigQuery, CompanyArchiverConfigQueryVariables>(CompanyArchiverConfigDocument, options);
        }
// @ts-ignore
export function useCompanyArchiverConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CompanyArchiverConfigQuery, CompanyArchiverConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CompanyArchiverConfigQuery, CompanyArchiverConfigQueryVariables>;
export function useCompanyArchiverConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CompanyArchiverConfigQuery, CompanyArchiverConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CompanyArchiverConfigQuery | undefined, CompanyArchiverConfigQueryVariables>;
export function useCompanyArchiverConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CompanyArchiverConfigQuery, CompanyArchiverConfigQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CompanyArchiverConfigQuery, CompanyArchiverConfigQueryVariables>(CompanyArchiverConfigDocument, options);
        }
export type CompanyArchiverConfigQueryHookResult = ReturnType<typeof useCompanyArchiverConfigQuery>;
export type CompanyArchiverConfigLazyQueryHookResult = ReturnType<typeof useCompanyArchiverConfigLazyQuery>;
export type CompanyArchiverConfigSuspenseQueryHookResult = ReturnType<typeof useCompanyArchiverConfigSuspenseQuery>;
export type CompanyArchiverConfigQueryResult = ApolloReactCommon.QueryResult<CompanyArchiverConfigQuery, CompanyArchiverConfigQueryVariables>;
export const UpdateArchiverConfigDocument = gql`
    mutation updateArchiverConfig($companyId: PwsID!, $config: ArchiverConfigInput!) {
  updateArchiverConfig(companyId: $companyId, config: $config) {
    ...ArchiverConfigParts
  }
}
    ${ArchiverConfigPartsFragmentDoc}`;
export type UpdateArchiverConfigMutationFn = ApolloReactCommon.MutationFunction<UpdateArchiverConfigMutation, UpdateArchiverConfigMutationVariables>;

/**
 * __useUpdateArchiverConfigMutation__
 *
 * To run a mutation, you first call `useUpdateArchiverConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateArchiverConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateArchiverConfigMutation, { data, loading, error }] = useUpdateArchiverConfigMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      config: // value for 'config'
 *   },
 * });
 */
export function useUpdateArchiverConfigMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateArchiverConfigMutation, UpdateArchiverConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateArchiverConfigMutation, UpdateArchiverConfigMutationVariables>(UpdateArchiverConfigDocument, options);
      }
export type UpdateArchiverConfigMutationHookResult = ReturnType<typeof useUpdateArchiverConfigMutation>;
export type UpdateArchiverConfigMutationResult = ApolloReactCommon.MutationResult<UpdateArchiverConfigMutation>;
export type UpdateArchiverConfigMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateArchiverConfigMutation, UpdateArchiverConfigMutationVariables>;
export const ArchiveAdvertiserDocument = gql`
    mutation archiveAdvertiser($advertiserId: PwsID!) {
  archiveAdvertiser(advertiserId: $advertiserId)
}
    `;
export type ArchiveAdvertiserMutationFn = ApolloReactCommon.MutationFunction<ArchiveAdvertiserMutation, ArchiveAdvertiserMutationVariables>;

/**
 * __useArchiveAdvertiserMutation__
 *
 * To run a mutation, you first call `useArchiveAdvertiserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveAdvertiserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveAdvertiserMutation, { data, loading, error }] = useArchiveAdvertiserMutation({
 *   variables: {
 *      advertiserId: // value for 'advertiserId'
 *   },
 * });
 */
export function useArchiveAdvertiserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ArchiveAdvertiserMutation, ArchiveAdvertiserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ArchiveAdvertiserMutation, ArchiveAdvertiserMutationVariables>(ArchiveAdvertiserDocument, options);
      }
export type ArchiveAdvertiserMutationHookResult = ReturnType<typeof useArchiveAdvertiserMutation>;
export type ArchiveAdvertiserMutationResult = ApolloReactCommon.MutationResult<ArchiveAdvertiserMutation>;
export type ArchiveAdvertiserMutationOptions = ApolloReactCommon.BaseMutationOptions<ArchiveAdvertiserMutation, ArchiveAdvertiserMutationVariables>;
export const ArchivePublisherDocument = gql`
    mutation archivePublisher($publisherId: PwsID!) {
  archivePublisher(publisherId: $publisherId)
}
    `;
export type ArchivePublisherMutationFn = ApolloReactCommon.MutationFunction<ArchivePublisherMutation, ArchivePublisherMutationVariables>;

/**
 * __useArchivePublisherMutation__
 *
 * To run a mutation, you first call `useArchivePublisherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchivePublisherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archivePublisherMutation, { data, loading, error }] = useArchivePublisherMutation({
 *   variables: {
 *      publisherId: // value for 'publisherId'
 *   },
 * });
 */
export function useArchivePublisherMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ArchivePublisherMutation, ArchivePublisherMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ArchivePublisherMutation, ArchivePublisherMutationVariables>(ArchivePublisherDocument, options);
      }
export type ArchivePublisherMutationHookResult = ReturnType<typeof useArchivePublisherMutation>;
export type ArchivePublisherMutationResult = ApolloReactCommon.MutationResult<ArchivePublisherMutation>;
export type ArchivePublisherMutationOptions = ApolloReactCommon.BaseMutationOptions<ArchivePublisherMutation, ArchivePublisherMutationVariables>;
export const ArchiveAgencyDocument = gql`
    mutation archiveAgency($agencyId: PwsID!) {
  archiveAgency(agencyId: $agencyId)
}
    `;
export type ArchiveAgencyMutationFn = ApolloReactCommon.MutationFunction<ArchiveAgencyMutation, ArchiveAgencyMutationVariables>;

/**
 * __useArchiveAgencyMutation__
 *
 * To run a mutation, you first call `useArchiveAgencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveAgencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveAgencyMutation, { data, loading, error }] = useArchiveAgencyMutation({
 *   variables: {
 *      agencyId: // value for 'agencyId'
 *   },
 * });
 */
export function useArchiveAgencyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ArchiveAgencyMutation, ArchiveAgencyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ArchiveAgencyMutation, ArchiveAgencyMutationVariables>(ArchiveAgencyDocument, options);
      }
export type ArchiveAgencyMutationHookResult = ReturnType<typeof useArchiveAgencyMutation>;
export type ArchiveAgencyMutationResult = ApolloReactCommon.MutationResult<ArchiveAgencyMutation>;
export type ArchiveAgencyMutationOptions = ApolloReactCommon.BaseMutationOptions<ArchiveAgencyMutation, ArchiveAgencyMutationVariables>;
export const ArchiveResellerDocument = gql`
    mutation archiveReseller($resellerId: PwsID!) {
  archiveReseller(resellerId: $resellerId)
}
    `;
export type ArchiveResellerMutationFn = ApolloReactCommon.MutationFunction<ArchiveResellerMutation, ArchiveResellerMutationVariables>;

/**
 * __useArchiveResellerMutation__
 *
 * To run a mutation, you first call `useArchiveResellerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveResellerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveResellerMutation, { data, loading, error }] = useArchiveResellerMutation({
 *   variables: {
 *      resellerId: // value for 'resellerId'
 *   },
 * });
 */
export function useArchiveResellerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ArchiveResellerMutation, ArchiveResellerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ArchiveResellerMutation, ArchiveResellerMutationVariables>(ArchiveResellerDocument, options);
      }
export type ArchiveResellerMutationHookResult = ReturnType<typeof useArchiveResellerMutation>;
export type ArchiveResellerMutationResult = ApolloReactCommon.MutationResult<ArchiveResellerMutation>;
export type ArchiveResellerMutationOptions = ApolloReactCommon.BaseMutationOptions<ArchiveResellerMutation, ArchiveResellerMutationVariables>;
export const ArchiveTradingDeskDocument = gql`
    mutation archiveTradingDesk($tradingDeskId: PwsID!) {
  archiveTradingDesk(tradingDeskId: $tradingDeskId)
}
    `;
export type ArchiveTradingDeskMutationFn = ApolloReactCommon.MutationFunction<ArchiveTradingDeskMutation, ArchiveTradingDeskMutationVariables>;

/**
 * __useArchiveTradingDeskMutation__
 *
 * To run a mutation, you first call `useArchiveTradingDeskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveTradingDeskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveTradingDeskMutation, { data, loading, error }] = useArchiveTradingDeskMutation({
 *   variables: {
 *      tradingDeskId: // value for 'tradingDeskId'
 *   },
 * });
 */
export function useArchiveTradingDeskMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ArchiveTradingDeskMutation, ArchiveTradingDeskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ArchiveTradingDeskMutation, ArchiveTradingDeskMutationVariables>(ArchiveTradingDeskDocument, options);
      }
export type ArchiveTradingDeskMutationHookResult = ReturnType<typeof useArchiveTradingDeskMutation>;
export type ArchiveTradingDeskMutationResult = ApolloReactCommon.MutationResult<ArchiveTradingDeskMutation>;
export type ArchiveTradingDeskMutationOptions = ApolloReactCommon.BaseMutationOptions<ArchiveTradingDeskMutation, ArchiveTradingDeskMutationVariables>;
export const CompanyHasCampaignsDocument = gql`
    query companyHasCampaigns($companyId: PwsID!, $pagination: Pagination!) {
  searchCampaigns(searchQuery: {companyId: $companyId}, pagination: $pagination) {
    id
  }
}
    `;

/**
 * __useCompanyHasCampaignsQuery__
 *
 * To run a query within a React component, call `useCompanyHasCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyHasCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyHasCampaignsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useCompanyHasCampaignsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CompanyHasCampaignsQuery, CompanyHasCampaignsQueryVariables> & ({ variables: CompanyHasCampaignsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CompanyHasCampaignsQuery, CompanyHasCampaignsQueryVariables>(CompanyHasCampaignsDocument, options);
      }
export function useCompanyHasCampaignsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CompanyHasCampaignsQuery, CompanyHasCampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CompanyHasCampaignsQuery, CompanyHasCampaignsQueryVariables>(CompanyHasCampaignsDocument, options);
        }
// @ts-ignore
export function useCompanyHasCampaignsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CompanyHasCampaignsQuery, CompanyHasCampaignsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CompanyHasCampaignsQuery, CompanyHasCampaignsQueryVariables>;
export function useCompanyHasCampaignsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CompanyHasCampaignsQuery, CompanyHasCampaignsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CompanyHasCampaignsQuery | undefined, CompanyHasCampaignsQueryVariables>;
export function useCompanyHasCampaignsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CompanyHasCampaignsQuery, CompanyHasCampaignsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CompanyHasCampaignsQuery, CompanyHasCampaignsQueryVariables>(CompanyHasCampaignsDocument, options);
        }
export type CompanyHasCampaignsQueryHookResult = ReturnType<typeof useCompanyHasCampaignsQuery>;
export type CompanyHasCampaignsLazyQueryHookResult = ReturnType<typeof useCompanyHasCampaignsLazyQuery>;
export type CompanyHasCampaignsSuspenseQueryHookResult = ReturnType<typeof useCompanyHasCampaignsSuspenseQuery>;
export type CompanyHasCampaignsQueryResult = ApolloReactCommon.QueryResult<CompanyHasCampaignsQuery, CompanyHasCampaignsQueryVariables>;
export const CompanyHasWebsitesDocument = gql`
    query companyHasWebsites($companyId: PwsID!, $pagination: Pagination!) {
  searchWebsites(searchQuery: {companyId: $companyId}, pagination: $pagination) {
    id
  }
}
    `;

/**
 * __useCompanyHasWebsitesQuery__
 *
 * To run a query within a React component, call `useCompanyHasWebsitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyHasWebsitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyHasWebsitesQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useCompanyHasWebsitesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CompanyHasWebsitesQuery, CompanyHasWebsitesQueryVariables> & ({ variables: CompanyHasWebsitesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CompanyHasWebsitesQuery, CompanyHasWebsitesQueryVariables>(CompanyHasWebsitesDocument, options);
      }
export function useCompanyHasWebsitesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CompanyHasWebsitesQuery, CompanyHasWebsitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CompanyHasWebsitesQuery, CompanyHasWebsitesQueryVariables>(CompanyHasWebsitesDocument, options);
        }
// @ts-ignore
export function useCompanyHasWebsitesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CompanyHasWebsitesQuery, CompanyHasWebsitesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CompanyHasWebsitesQuery, CompanyHasWebsitesQueryVariables>;
export function useCompanyHasWebsitesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CompanyHasWebsitesQuery, CompanyHasWebsitesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CompanyHasWebsitesQuery | undefined, CompanyHasWebsitesQueryVariables>;
export function useCompanyHasWebsitesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CompanyHasWebsitesQuery, CompanyHasWebsitesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CompanyHasWebsitesQuery, CompanyHasWebsitesQueryVariables>(CompanyHasWebsitesDocument, options);
        }
export type CompanyHasWebsitesQueryHookResult = ReturnType<typeof useCompanyHasWebsitesQuery>;
export type CompanyHasWebsitesLazyQueryHookResult = ReturnType<typeof useCompanyHasWebsitesLazyQuery>;
export type CompanyHasWebsitesSuspenseQueryHookResult = ReturnType<typeof useCompanyHasWebsitesSuspenseQuery>;
export type CompanyHasWebsitesQueryResult = ApolloReactCommon.QueryResult<CompanyHasWebsitesQuery, CompanyHasWebsitesQueryVariables>;
export const CompanyHasProgrammaticCampaignsDocument = gql`
    query companyHasProgrammaticCampaigns($tradingDeskId: PwsID!, $pagination: Pagination!) {
  searchProgrammaticCampaigns(
    searchQuery: {tradingDeskId: $tradingDeskId}
    pagination: $pagination
  ) {
    id
  }
}
    `;

/**
 * __useCompanyHasProgrammaticCampaignsQuery__
 *
 * To run a query within a React component, call `useCompanyHasProgrammaticCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyHasProgrammaticCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyHasProgrammaticCampaignsQuery({
 *   variables: {
 *      tradingDeskId: // value for 'tradingDeskId'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useCompanyHasProgrammaticCampaignsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CompanyHasProgrammaticCampaignsQuery, CompanyHasProgrammaticCampaignsQueryVariables> & ({ variables: CompanyHasProgrammaticCampaignsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CompanyHasProgrammaticCampaignsQuery, CompanyHasProgrammaticCampaignsQueryVariables>(CompanyHasProgrammaticCampaignsDocument, options);
      }
export function useCompanyHasProgrammaticCampaignsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CompanyHasProgrammaticCampaignsQuery, CompanyHasProgrammaticCampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CompanyHasProgrammaticCampaignsQuery, CompanyHasProgrammaticCampaignsQueryVariables>(CompanyHasProgrammaticCampaignsDocument, options);
        }
// @ts-ignore
export function useCompanyHasProgrammaticCampaignsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CompanyHasProgrammaticCampaignsQuery, CompanyHasProgrammaticCampaignsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CompanyHasProgrammaticCampaignsQuery, CompanyHasProgrammaticCampaignsQueryVariables>;
export function useCompanyHasProgrammaticCampaignsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CompanyHasProgrammaticCampaignsQuery, CompanyHasProgrammaticCampaignsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CompanyHasProgrammaticCampaignsQuery | undefined, CompanyHasProgrammaticCampaignsQueryVariables>;
export function useCompanyHasProgrammaticCampaignsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CompanyHasProgrammaticCampaignsQuery, CompanyHasProgrammaticCampaignsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CompanyHasProgrammaticCampaignsQuery, CompanyHasProgrammaticCampaignsQueryVariables>(CompanyHasProgrammaticCampaignsDocument, options);
        }
export type CompanyHasProgrammaticCampaignsQueryHookResult = ReturnType<typeof useCompanyHasProgrammaticCampaignsQuery>;
export type CompanyHasProgrammaticCampaignsLazyQueryHookResult = ReturnType<typeof useCompanyHasProgrammaticCampaignsLazyQuery>;
export type CompanyHasProgrammaticCampaignsSuspenseQueryHookResult = ReturnType<typeof useCompanyHasProgrammaticCampaignsSuspenseQuery>;
export type CompanyHasProgrammaticCampaignsQueryResult = ApolloReactCommon.QueryResult<CompanyHasProgrammaticCampaignsQuery, CompanyHasProgrammaticCampaignsQueryVariables>;
export const CompanyHasAgencyAdvertisersDocument = gql`
    query companyHasAgencyAdvertisers($agencyId: String!, $pagination: Pagination!) {
  searchCompanies(searchQuery: {agencyId: $agencyId}, pagination: $pagination) {
    id
  }
}
    `;

/**
 * __useCompanyHasAgencyAdvertisersQuery__
 *
 * To run a query within a React component, call `useCompanyHasAgencyAdvertisersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyHasAgencyAdvertisersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyHasAgencyAdvertisersQuery({
 *   variables: {
 *      agencyId: // value for 'agencyId'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useCompanyHasAgencyAdvertisersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CompanyHasAgencyAdvertisersQuery, CompanyHasAgencyAdvertisersQueryVariables> & ({ variables: CompanyHasAgencyAdvertisersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CompanyHasAgencyAdvertisersQuery, CompanyHasAgencyAdvertisersQueryVariables>(CompanyHasAgencyAdvertisersDocument, options);
      }
export function useCompanyHasAgencyAdvertisersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CompanyHasAgencyAdvertisersQuery, CompanyHasAgencyAdvertisersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CompanyHasAgencyAdvertisersQuery, CompanyHasAgencyAdvertisersQueryVariables>(CompanyHasAgencyAdvertisersDocument, options);
        }
// @ts-ignore
export function useCompanyHasAgencyAdvertisersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CompanyHasAgencyAdvertisersQuery, CompanyHasAgencyAdvertisersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CompanyHasAgencyAdvertisersQuery, CompanyHasAgencyAdvertisersQueryVariables>;
export function useCompanyHasAgencyAdvertisersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CompanyHasAgencyAdvertisersQuery, CompanyHasAgencyAdvertisersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CompanyHasAgencyAdvertisersQuery | undefined, CompanyHasAgencyAdvertisersQueryVariables>;
export function useCompanyHasAgencyAdvertisersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CompanyHasAgencyAdvertisersQuery, CompanyHasAgencyAdvertisersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CompanyHasAgencyAdvertisersQuery, CompanyHasAgencyAdvertisersQueryVariables>(CompanyHasAgencyAdvertisersDocument, options);
        }
export type CompanyHasAgencyAdvertisersQueryHookResult = ReturnType<typeof useCompanyHasAgencyAdvertisersQuery>;
export type CompanyHasAgencyAdvertisersLazyQueryHookResult = ReturnType<typeof useCompanyHasAgencyAdvertisersLazyQuery>;
export type CompanyHasAgencyAdvertisersSuspenseQueryHookResult = ReturnType<typeof useCompanyHasAgencyAdvertisersSuspenseQuery>;
export type CompanyHasAgencyAdvertisersQueryResult = ApolloReactCommon.QueryResult<CompanyHasAgencyAdvertisersQuery, CompanyHasAgencyAdvertisersQueryVariables>;
export const CompanyHasResellerChildrenDocument = gql`
    query companyHasResellerChildren($resellerId: String!, $pagination: Pagination!) {
  searchCompanies(
    searchQuery: {resellerIds: [$resellerId]}
    pagination: $pagination
  ) {
    id
  }
}
    `;

/**
 * __useCompanyHasResellerChildrenQuery__
 *
 * To run a query within a React component, call `useCompanyHasResellerChildrenQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyHasResellerChildrenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyHasResellerChildrenQuery({
 *   variables: {
 *      resellerId: // value for 'resellerId'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useCompanyHasResellerChildrenQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CompanyHasResellerChildrenQuery, CompanyHasResellerChildrenQueryVariables> & ({ variables: CompanyHasResellerChildrenQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CompanyHasResellerChildrenQuery, CompanyHasResellerChildrenQueryVariables>(CompanyHasResellerChildrenDocument, options);
      }
export function useCompanyHasResellerChildrenLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CompanyHasResellerChildrenQuery, CompanyHasResellerChildrenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CompanyHasResellerChildrenQuery, CompanyHasResellerChildrenQueryVariables>(CompanyHasResellerChildrenDocument, options);
        }
// @ts-ignore
export function useCompanyHasResellerChildrenSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CompanyHasResellerChildrenQuery, CompanyHasResellerChildrenQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CompanyHasResellerChildrenQuery, CompanyHasResellerChildrenQueryVariables>;
export function useCompanyHasResellerChildrenSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CompanyHasResellerChildrenQuery, CompanyHasResellerChildrenQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CompanyHasResellerChildrenQuery | undefined, CompanyHasResellerChildrenQueryVariables>;
export function useCompanyHasResellerChildrenSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CompanyHasResellerChildrenQuery, CompanyHasResellerChildrenQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CompanyHasResellerChildrenQuery, CompanyHasResellerChildrenQueryVariables>(CompanyHasResellerChildrenDocument, options);
        }
export type CompanyHasResellerChildrenQueryHookResult = ReturnType<typeof useCompanyHasResellerChildrenQuery>;
export type CompanyHasResellerChildrenLazyQueryHookResult = ReturnType<typeof useCompanyHasResellerChildrenLazyQuery>;
export type CompanyHasResellerChildrenSuspenseQueryHookResult = ReturnType<typeof useCompanyHasResellerChildrenSuspenseQuery>;
export type CompanyHasResellerChildrenQueryResult = ApolloReactCommon.QueryResult<CompanyHasResellerChildrenQuery, CompanyHasResellerChildrenQueryVariables>;
export const SearchCopperOpportunitiesByCompanyDocument = gql`
    query searchCopperOpportunitiesByCompany($params: CopperOpportunitySearchParams) {
  searchCopperOpportunities(params: $params) {
    id
    name
    stage
    monetaryValue
  }
}
    `;

/**
 * __useSearchCopperOpportunitiesByCompanyQuery__
 *
 * To run a query within a React component, call `useSearchCopperOpportunitiesByCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCopperOpportunitiesByCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCopperOpportunitiesByCompanyQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useSearchCopperOpportunitiesByCompanyQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SearchCopperOpportunitiesByCompanyQuery, SearchCopperOpportunitiesByCompanyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchCopperOpportunitiesByCompanyQuery, SearchCopperOpportunitiesByCompanyQueryVariables>(SearchCopperOpportunitiesByCompanyDocument, options);
      }
export function useSearchCopperOpportunitiesByCompanyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchCopperOpportunitiesByCompanyQuery, SearchCopperOpportunitiesByCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchCopperOpportunitiesByCompanyQuery, SearchCopperOpportunitiesByCompanyQueryVariables>(SearchCopperOpportunitiesByCompanyDocument, options);
        }
// @ts-ignore
export function useSearchCopperOpportunitiesByCompanySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SearchCopperOpportunitiesByCompanyQuery, SearchCopperOpportunitiesByCompanyQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SearchCopperOpportunitiesByCompanyQuery, SearchCopperOpportunitiesByCompanyQueryVariables>;
export function useSearchCopperOpportunitiesByCompanySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchCopperOpportunitiesByCompanyQuery, SearchCopperOpportunitiesByCompanyQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SearchCopperOpportunitiesByCompanyQuery | undefined, SearchCopperOpportunitiesByCompanyQueryVariables>;
export function useSearchCopperOpportunitiesByCompanySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchCopperOpportunitiesByCompanyQuery, SearchCopperOpportunitiesByCompanyQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SearchCopperOpportunitiesByCompanyQuery, SearchCopperOpportunitiesByCompanyQueryVariables>(SearchCopperOpportunitiesByCompanyDocument, options);
        }
export type SearchCopperOpportunitiesByCompanyQueryHookResult = ReturnType<typeof useSearchCopperOpportunitiesByCompanyQuery>;
export type SearchCopperOpportunitiesByCompanyLazyQueryHookResult = ReturnType<typeof useSearchCopperOpportunitiesByCompanyLazyQuery>;
export type SearchCopperOpportunitiesByCompanySuspenseQueryHookResult = ReturnType<typeof useSearchCopperOpportunitiesByCompanySuspenseQuery>;
export type SearchCopperOpportunitiesByCompanyQueryResult = ApolloReactCommon.QueryResult<SearchCopperOpportunitiesByCompanyQuery, SearchCopperOpportunitiesByCompanyQueryVariables>;
export const SearchCopperOpportunitiesDocument = gql`
    query searchCopperOpportunities($params: CopperOpportunitySearchParams, $pagination: Pagination!) {
  searchCopperOpportunities(params: $params, pagination: $pagination) {
    id
    name
    stage
    company {
      name
      customFields {
        name
        value
      }
      address {
        street
        city
        postalCode
        country
      }
      phoneNumbers {
        number
      }
      websites {
        url
      }
      primaryContact {
        name
        firstName
        lastName
        title
        emails {
          email
        }
        phoneNumbers {
          number
        }
      }
    }
    assignee {
      email
    }
  }
}
    `;

/**
 * __useSearchCopperOpportunitiesQuery__
 *
 * To run a query within a React component, call `useSearchCopperOpportunitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCopperOpportunitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCopperOpportunitiesQuery({
 *   variables: {
 *      params: // value for 'params'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useSearchCopperOpportunitiesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchCopperOpportunitiesQuery, SearchCopperOpportunitiesQueryVariables> & ({ variables: SearchCopperOpportunitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchCopperOpportunitiesQuery, SearchCopperOpportunitiesQueryVariables>(SearchCopperOpportunitiesDocument, options);
      }
export function useSearchCopperOpportunitiesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchCopperOpportunitiesQuery, SearchCopperOpportunitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchCopperOpportunitiesQuery, SearchCopperOpportunitiesQueryVariables>(SearchCopperOpportunitiesDocument, options);
        }
// @ts-ignore
export function useSearchCopperOpportunitiesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SearchCopperOpportunitiesQuery, SearchCopperOpportunitiesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SearchCopperOpportunitiesQuery, SearchCopperOpportunitiesQueryVariables>;
export function useSearchCopperOpportunitiesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchCopperOpportunitiesQuery, SearchCopperOpportunitiesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SearchCopperOpportunitiesQuery | undefined, SearchCopperOpportunitiesQueryVariables>;
export function useSearchCopperOpportunitiesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchCopperOpportunitiesQuery, SearchCopperOpportunitiesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SearchCopperOpportunitiesQuery, SearchCopperOpportunitiesQueryVariables>(SearchCopperOpportunitiesDocument, options);
        }
export type SearchCopperOpportunitiesQueryHookResult = ReturnType<typeof useSearchCopperOpportunitiesQuery>;
export type SearchCopperOpportunitiesLazyQueryHookResult = ReturnType<typeof useSearchCopperOpportunitiesLazyQuery>;
export type SearchCopperOpportunitiesSuspenseQueryHookResult = ReturnType<typeof useSearchCopperOpportunitiesSuspenseQuery>;
export type SearchCopperOpportunitiesQueryResult = ApolloReactCommon.QueryResult<SearchCopperOpportunitiesQuery, SearchCopperOpportunitiesQueryVariables>;
export const SearchCopperCompaniesDocument = gql`
    query searchCopperCompanies($params: CopperCompanySearchParams) {
  searchCopperCompanies(params: $params) {
    id
    name
  }
}
    `;

/**
 * __useSearchCopperCompaniesQuery__
 *
 * To run a query within a React component, call `useSearchCopperCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCopperCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCopperCompaniesQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useSearchCopperCompaniesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SearchCopperCompaniesQuery, SearchCopperCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchCopperCompaniesQuery, SearchCopperCompaniesQueryVariables>(SearchCopperCompaniesDocument, options);
      }
export function useSearchCopperCompaniesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchCopperCompaniesQuery, SearchCopperCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchCopperCompaniesQuery, SearchCopperCompaniesQueryVariables>(SearchCopperCompaniesDocument, options);
        }
// @ts-ignore
export function useSearchCopperCompaniesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SearchCopperCompaniesQuery, SearchCopperCompaniesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SearchCopperCompaniesQuery, SearchCopperCompaniesQueryVariables>;
export function useSearchCopperCompaniesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchCopperCompaniesQuery, SearchCopperCompaniesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SearchCopperCompaniesQuery | undefined, SearchCopperCompaniesQueryVariables>;
export function useSearchCopperCompaniesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchCopperCompaniesQuery, SearchCopperCompaniesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SearchCopperCompaniesQuery, SearchCopperCompaniesQueryVariables>(SearchCopperCompaniesDocument, options);
        }
export type SearchCopperCompaniesQueryHookResult = ReturnType<typeof useSearchCopperCompaniesQuery>;
export type SearchCopperCompaniesLazyQueryHookResult = ReturnType<typeof useSearchCopperCompaniesLazyQuery>;
export type SearchCopperCompaniesSuspenseQueryHookResult = ReturnType<typeof useSearchCopperCompaniesSuspenseQuery>;
export type SearchCopperCompaniesQueryResult = ApolloReactCommon.QueryResult<SearchCopperCompaniesQuery, SearchCopperCompaniesQueryVariables>;
export const CopperCompanyDocument = gql`
    query copperCompany($id: String!) {
  copperCompany(id: $id) {
    id
    name
  }
}
    `;

/**
 * __useCopperCompanyQuery__
 *
 * To run a query within a React component, call `useCopperCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCopperCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCopperCompanyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCopperCompanyQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CopperCompanyQuery, CopperCompanyQueryVariables> & ({ variables: CopperCompanyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CopperCompanyQuery, CopperCompanyQueryVariables>(CopperCompanyDocument, options);
      }
export function useCopperCompanyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CopperCompanyQuery, CopperCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CopperCompanyQuery, CopperCompanyQueryVariables>(CopperCompanyDocument, options);
        }
// @ts-ignore
export function useCopperCompanySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CopperCompanyQuery, CopperCompanyQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CopperCompanyQuery, CopperCompanyQueryVariables>;
export function useCopperCompanySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CopperCompanyQuery, CopperCompanyQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CopperCompanyQuery | undefined, CopperCompanyQueryVariables>;
export function useCopperCompanySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CopperCompanyQuery, CopperCompanyQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CopperCompanyQuery, CopperCompanyQueryVariables>(CopperCompanyDocument, options);
        }
export type CopperCompanyQueryHookResult = ReturnType<typeof useCopperCompanyQuery>;
export type CopperCompanyLazyQueryHookResult = ReturnType<typeof useCopperCompanyLazyQuery>;
export type CopperCompanySuspenseQueryHookResult = ReturnType<typeof useCopperCompanySuspenseQuery>;
export type CopperCompanyQueryResult = ApolloReactCommon.QueryResult<CopperCompanyQuery, CopperCompanyQueryVariables>;
export const GetCountriesDocument = gql`
    query getCountries {
  getCountries {
    code
    label
  }
}
    `;

/**
 * __useGetCountriesQuery__
 *
 * To run a query within a React component, call `useGetCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCountriesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCountriesQuery, GetCountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCountriesQuery, GetCountriesQueryVariables>(GetCountriesDocument, options);
      }
export function useGetCountriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCountriesQuery, GetCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCountriesQuery, GetCountriesQueryVariables>(GetCountriesDocument, options);
        }
// @ts-ignore
export function useGetCountriesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetCountriesQuery, GetCountriesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetCountriesQuery, GetCountriesQueryVariables>;
export function useGetCountriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCountriesQuery, GetCountriesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetCountriesQuery | undefined, GetCountriesQueryVariables>;
export function useGetCountriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCountriesQuery, GetCountriesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetCountriesQuery, GetCountriesQueryVariables>(GetCountriesDocument, options);
        }
export type GetCountriesQueryHookResult = ReturnType<typeof useGetCountriesQuery>;
export type GetCountriesLazyQueryHookResult = ReturnType<typeof useGetCountriesLazyQuery>;
export type GetCountriesSuspenseQueryHookResult = ReturnType<typeof useGetCountriesSuspenseQuery>;
export type GetCountriesQueryResult = ApolloReactCommon.QueryResult<GetCountriesQuery, GetCountriesQueryVariables>;
export const InvalidFlatrecordStatsDocument = gql`
    query invalidFlatrecordStats($start: DateTime!, $end: DateTime!, $timezone: String!, $adGroupId: PwsID!) {
  getInvalidFlatrecordStats(
    start: $start
    end: $end
    timezone: $timezone
    adGroupId: $adGroupId
  ) {
    invalidReason
    leads
    orders
  }
}
    `;

/**
 * __useInvalidFlatrecordStatsQuery__
 *
 * To run a query within a React component, call `useInvalidFlatrecordStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvalidFlatrecordStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvalidFlatrecordStatsQuery({
 *   variables: {
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      timezone: // value for 'timezone'
 *      adGroupId: // value for 'adGroupId'
 *   },
 * });
 */
export function useInvalidFlatrecordStatsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<InvalidFlatrecordStatsQuery, InvalidFlatrecordStatsQueryVariables> & ({ variables: InvalidFlatrecordStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<InvalidFlatrecordStatsQuery, InvalidFlatrecordStatsQueryVariables>(InvalidFlatrecordStatsDocument, options);
      }
export function useInvalidFlatrecordStatsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InvalidFlatrecordStatsQuery, InvalidFlatrecordStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<InvalidFlatrecordStatsQuery, InvalidFlatrecordStatsQueryVariables>(InvalidFlatrecordStatsDocument, options);
        }
// @ts-ignore
export function useInvalidFlatrecordStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<InvalidFlatrecordStatsQuery, InvalidFlatrecordStatsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InvalidFlatrecordStatsQuery, InvalidFlatrecordStatsQueryVariables>;
export function useInvalidFlatrecordStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InvalidFlatrecordStatsQuery, InvalidFlatrecordStatsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InvalidFlatrecordStatsQuery | undefined, InvalidFlatrecordStatsQueryVariables>;
export function useInvalidFlatrecordStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InvalidFlatrecordStatsQuery, InvalidFlatrecordStatsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<InvalidFlatrecordStatsQuery, InvalidFlatrecordStatsQueryVariables>(InvalidFlatrecordStatsDocument, options);
        }
export type InvalidFlatrecordStatsQueryHookResult = ReturnType<typeof useInvalidFlatrecordStatsQuery>;
export type InvalidFlatrecordStatsLazyQueryHookResult = ReturnType<typeof useInvalidFlatrecordStatsLazyQuery>;
export type InvalidFlatrecordStatsSuspenseQueryHookResult = ReturnType<typeof useInvalidFlatrecordStatsSuspenseQuery>;
export type InvalidFlatrecordStatsQueryResult = ApolloReactCommon.QueryResult<InvalidFlatrecordStatsQuery, InvalidFlatrecordStatsQueryVariables>;
export const InventoryTimeseriesDocument = gql`
    query inventoryTimeseries($endDate: DateTime!, $startDate: DateTime!, $id: PwsID!, $granularity: GraphGranularity!) {
  inventory(id: $id) {
    id
    timeseries(granularity: $granularity, endDate: $endDate, startDate: $startDate) {
      ...AdvertiserTimeseries
    }
  }
}
    ${AdvertiserTimeseriesFragmentDoc}`;

/**
 * __useInventoryTimeseriesQuery__
 *
 * To run a query within a React component, call `useInventoryTimeseriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInventoryTimeseriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInventoryTimeseriesQuery({
 *   variables: {
 *      endDate: // value for 'endDate'
 *      startDate: // value for 'startDate'
 *      id: // value for 'id'
 *      granularity: // value for 'granularity'
 *   },
 * });
 */
export function useInventoryTimeseriesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<InventoryTimeseriesQuery, InventoryTimeseriesQueryVariables> & ({ variables: InventoryTimeseriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<InventoryTimeseriesQuery, InventoryTimeseriesQueryVariables>(InventoryTimeseriesDocument, options);
      }
export function useInventoryTimeseriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InventoryTimeseriesQuery, InventoryTimeseriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<InventoryTimeseriesQuery, InventoryTimeseriesQueryVariables>(InventoryTimeseriesDocument, options);
        }
// @ts-ignore
export function useInventoryTimeseriesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<InventoryTimeseriesQuery, InventoryTimeseriesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InventoryTimeseriesQuery, InventoryTimeseriesQueryVariables>;
export function useInventoryTimeseriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InventoryTimeseriesQuery, InventoryTimeseriesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InventoryTimeseriesQuery | undefined, InventoryTimeseriesQueryVariables>;
export function useInventoryTimeseriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InventoryTimeseriesQuery, InventoryTimeseriesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<InventoryTimeseriesQuery, InventoryTimeseriesQueryVariables>(InventoryTimeseriesDocument, options);
        }
export type InventoryTimeseriesQueryHookResult = ReturnType<typeof useInventoryTimeseriesQuery>;
export type InventoryTimeseriesLazyQueryHookResult = ReturnType<typeof useInventoryTimeseriesLazyQuery>;
export type InventoryTimeseriesSuspenseQueryHookResult = ReturnType<typeof useInventoryTimeseriesSuspenseQuery>;
export type InventoryTimeseriesQueryResult = ApolloReactCommon.QueryResult<InventoryTimeseriesQuery, InventoryTimeseriesQueryVariables>;
export const InventoryPerformanceStatsDocument = gql`
    query inventoryPerformanceStats($endDate: DateTime!, $startDate: DateTime!, $id: PwsID!) {
  inventory(id: $id) {
    id
    performanceStats(endDate: $endDate, startDate: $startDate) {
      stats {
        ...AdvertiserPerformanceStatsParts
      }
      publisherResellers {
        name
        stats {
          ...AdvertiserPerformanceStatsParts
        }
        publishers {
          name
          stats {
            ...AdvertiserPerformanceStatsParts
          }
          websites {
            name
            stats {
              ...AdvertiserPerformanceStatsParts
            }
            positions {
              name
              stats {
                ...AdvertiserPerformanceStatsParts
              }
            }
          }
        }
      }
    }
  }
}
    ${AdvertiserPerformanceStatsPartsFragmentDoc}`;

/**
 * __useInventoryPerformanceStatsQuery__
 *
 * To run a query within a React component, call `useInventoryPerformanceStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInventoryPerformanceStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInventoryPerformanceStatsQuery({
 *   variables: {
 *      endDate: // value for 'endDate'
 *      startDate: // value for 'startDate'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInventoryPerformanceStatsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<InventoryPerformanceStatsQuery, InventoryPerformanceStatsQueryVariables> & ({ variables: InventoryPerformanceStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<InventoryPerformanceStatsQuery, InventoryPerformanceStatsQueryVariables>(InventoryPerformanceStatsDocument, options);
      }
export function useInventoryPerformanceStatsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InventoryPerformanceStatsQuery, InventoryPerformanceStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<InventoryPerformanceStatsQuery, InventoryPerformanceStatsQueryVariables>(InventoryPerformanceStatsDocument, options);
        }
// @ts-ignore
export function useInventoryPerformanceStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<InventoryPerformanceStatsQuery, InventoryPerformanceStatsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InventoryPerformanceStatsQuery, InventoryPerformanceStatsQueryVariables>;
export function useInventoryPerformanceStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InventoryPerformanceStatsQuery, InventoryPerformanceStatsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InventoryPerformanceStatsQuery | undefined, InventoryPerformanceStatsQueryVariables>;
export function useInventoryPerformanceStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InventoryPerformanceStatsQuery, InventoryPerformanceStatsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<InventoryPerformanceStatsQuery, InventoryPerformanceStatsQueryVariables>(InventoryPerformanceStatsDocument, options);
        }
export type InventoryPerformanceStatsQueryHookResult = ReturnType<typeof useInventoryPerformanceStatsQuery>;
export type InventoryPerformanceStatsLazyQueryHookResult = ReturnType<typeof useInventoryPerformanceStatsLazyQuery>;
export type InventoryPerformanceStatsSuspenseQueryHookResult = ReturnType<typeof useInventoryPerformanceStatsSuspenseQuery>;
export type InventoryPerformanceStatsQueryResult = ApolloReactCommon.QueryResult<InventoryPerformanceStatsQuery, InventoryPerformanceStatsQueryVariables>;
export const InventoryDocument = gql`
    query inventory($id: PwsID!) {
  inventory(id: $id) {
    ...InventoryParts
  }
}
    ${InventoryPartsFragmentDoc}`;

/**
 * __useInventoryQuery__
 *
 * To run a query within a React component, call `useInventoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useInventoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInventoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInventoryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<InventoryQuery, InventoryQueryVariables> & ({ variables: InventoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<InventoryQuery, InventoryQueryVariables>(InventoryDocument, options);
      }
export function useInventoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InventoryQuery, InventoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<InventoryQuery, InventoryQueryVariables>(InventoryDocument, options);
        }
// @ts-ignore
export function useInventorySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<InventoryQuery, InventoryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InventoryQuery, InventoryQueryVariables>;
export function useInventorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InventoryQuery, InventoryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InventoryQuery | undefined, InventoryQueryVariables>;
export function useInventorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InventoryQuery, InventoryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<InventoryQuery, InventoryQueryVariables>(InventoryDocument, options);
        }
export type InventoryQueryHookResult = ReturnType<typeof useInventoryQuery>;
export type InventoryLazyQueryHookResult = ReturnType<typeof useInventoryLazyQuery>;
export type InventorySuspenseQueryHookResult = ReturnType<typeof useInventorySuspenseQuery>;
export type InventoryQueryResult = ApolloReactCommon.QueryResult<InventoryQuery, InventoryQueryVariables>;
export const GetLanguagesDocument = gql`
    query getLanguages {
  getLanguages {
    id
    code
    label
  }
}
    `;

/**
 * __useGetLanguagesQuery__
 *
 * To run a query within a React component, call `useGetLanguagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLanguagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLanguagesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLanguagesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetLanguagesQuery, GetLanguagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetLanguagesQuery, GetLanguagesQueryVariables>(GetLanguagesDocument, options);
      }
export function useGetLanguagesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetLanguagesQuery, GetLanguagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetLanguagesQuery, GetLanguagesQueryVariables>(GetLanguagesDocument, options);
        }
// @ts-ignore
export function useGetLanguagesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetLanguagesQuery, GetLanguagesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetLanguagesQuery, GetLanguagesQueryVariables>;
export function useGetLanguagesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetLanguagesQuery, GetLanguagesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetLanguagesQuery | undefined, GetLanguagesQueryVariables>;
export function useGetLanguagesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetLanguagesQuery, GetLanguagesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetLanguagesQuery, GetLanguagesQueryVariables>(GetLanguagesDocument, options);
        }
export type GetLanguagesQueryHookResult = ReturnType<typeof useGetLanguagesQuery>;
export type GetLanguagesLazyQueryHookResult = ReturnType<typeof useGetLanguagesLazyQuery>;
export type GetLanguagesSuspenseQueryHookResult = ReturnType<typeof useGetLanguagesSuspenseQuery>;
export type GetLanguagesQueryResult = ApolloReactCommon.QueryResult<GetLanguagesQuery, GetLanguagesQueryVariables>;
export const MarketsDocument = gql`
    query markets {
  searchMarkets(pagination: {limit: 100, offset: 0}, searchQuery: {}) {
    id
    language {
      code
    }
    country {
      code
    }
  }
}
    `;

/**
 * __useMarketsQuery__
 *
 * To run a query within a React component, call `useMarketsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMarketsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MarketsQuery, MarketsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MarketsQuery, MarketsQueryVariables>(MarketsDocument, options);
      }
export function useMarketsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MarketsQuery, MarketsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MarketsQuery, MarketsQueryVariables>(MarketsDocument, options);
        }
// @ts-ignore
export function useMarketsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MarketsQuery, MarketsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MarketsQuery, MarketsQueryVariables>;
export function useMarketsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MarketsQuery, MarketsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MarketsQuery | undefined, MarketsQueryVariables>;
export function useMarketsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MarketsQuery, MarketsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MarketsQuery, MarketsQueryVariables>(MarketsDocument, options);
        }
export type MarketsQueryHookResult = ReturnType<typeof useMarketsQuery>;
export type MarketsLazyQueryHookResult = ReturnType<typeof useMarketsLazyQuery>;
export type MarketsSuspenseQueryHookResult = ReturnType<typeof useMarketsSuspenseQuery>;
export type MarketsQueryResult = ApolloReactCommon.QueryResult<MarketsQuery, MarketsQueryVariables>;
export const PositionsDocument = gql`
    query positions($pagination: Pagination!, $searchQuery: PositionSearchQuery!) {
  searchPositions(pagination: $pagination, searchQuery: $searchQuery) {
    id
    name
    website {
      name
      publisher {
        name
        slug
        reseller {
          name
        }
      }
      market {
        language {
          code
        }
        country {
          code
        }
      }
    }
    iabCategory
    network
    channelType
    subchannelType
    status
  }
}
    `;

/**
 * __usePositionsQuery__
 *
 * To run a query within a React component, call `usePositionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePositionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePositionsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function usePositionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PositionsQuery, PositionsQueryVariables> & ({ variables: PositionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PositionsQuery, PositionsQueryVariables>(PositionsDocument, options);
      }
export function usePositionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PositionsQuery, PositionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PositionsQuery, PositionsQueryVariables>(PositionsDocument, options);
        }
// @ts-ignore
export function usePositionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PositionsQuery, PositionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PositionsQuery, PositionsQueryVariables>;
export function usePositionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PositionsQuery, PositionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PositionsQuery | undefined, PositionsQueryVariables>;
export function usePositionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PositionsQuery, PositionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PositionsQuery, PositionsQueryVariables>(PositionsDocument, options);
        }
export type PositionsQueryHookResult = ReturnType<typeof usePositionsQuery>;
export type PositionsLazyQueryHookResult = ReturnType<typeof usePositionsLazyQuery>;
export type PositionsSuspenseQueryHookResult = ReturnType<typeof usePositionsSuspenseQuery>;
export type PositionsQueryResult = ApolloReactCommon.QueryResult<PositionsQuery, PositionsQueryVariables>;
export const PositionDocument = gql`
    query position($id: PwsID!) {
  position(id: $id) {
    ...PositionParts
  }
}
    ${PositionPartsFragmentDoc}`;

/**
 * __usePositionQuery__
 *
 * To run a query within a React component, call `usePositionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePositionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePositionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePositionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PositionQuery, PositionQueryVariables> & ({ variables: PositionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PositionQuery, PositionQueryVariables>(PositionDocument, options);
      }
export function usePositionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PositionQuery, PositionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PositionQuery, PositionQueryVariables>(PositionDocument, options);
        }
// @ts-ignore
export function usePositionSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PositionQuery, PositionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PositionQuery, PositionQueryVariables>;
export function usePositionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PositionQuery, PositionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PositionQuery | undefined, PositionQueryVariables>;
export function usePositionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PositionQuery, PositionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PositionQuery, PositionQueryVariables>(PositionDocument, options);
        }
export type PositionQueryHookResult = ReturnType<typeof usePositionQuery>;
export type PositionLazyQueryHookResult = ReturnType<typeof usePositionLazyQuery>;
export type PositionSuspenseQueryHookResult = ReturnType<typeof usePositionSuspenseQuery>;
export type PositionQueryResult = ApolloReactCommon.QueryResult<PositionQuery, PositionQueryVariables>;
export const PositionZoneDocument = gql`
    query positionZone($id: PwsID!) {
  position(id: $id) {
    id
    zones {
      ...ZoneFragment
    }
  }
}
    ${ZoneFragmentFragmentDoc}`;

/**
 * __usePositionZoneQuery__
 *
 * To run a query within a React component, call `usePositionZoneQuery` and pass it any options that fit your needs.
 * When your component renders, `usePositionZoneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePositionZoneQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePositionZoneQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PositionZoneQuery, PositionZoneQueryVariables> & ({ variables: PositionZoneQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PositionZoneQuery, PositionZoneQueryVariables>(PositionZoneDocument, options);
      }
export function usePositionZoneLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PositionZoneQuery, PositionZoneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PositionZoneQuery, PositionZoneQueryVariables>(PositionZoneDocument, options);
        }
// @ts-ignore
export function usePositionZoneSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PositionZoneQuery, PositionZoneQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PositionZoneQuery, PositionZoneQueryVariables>;
export function usePositionZoneSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PositionZoneQuery, PositionZoneQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PositionZoneQuery | undefined, PositionZoneQueryVariables>;
export function usePositionZoneSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PositionZoneQuery, PositionZoneQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PositionZoneQuery, PositionZoneQueryVariables>(PositionZoneDocument, options);
        }
export type PositionZoneQueryHookResult = ReturnType<typeof usePositionZoneQuery>;
export type PositionZoneLazyQueryHookResult = ReturnType<typeof usePositionZoneLazyQuery>;
export type PositionZoneSuspenseQueryHookResult = ReturnType<typeof usePositionZoneSuspenseQuery>;
export type PositionZoneQueryResult = ApolloReactCommon.QueryResult<PositionZoneQuery, PositionZoneQueryVariables>;
export const PositionTimeseriesDocument = gql`
    query positionTimeseries($endDate: DateTime!, $startDate: DateTime!, $positionId: PwsID!, $granularity: GraphGranularity!, $filters: [CostDetailsFilter!]) {
  position(id: $positionId) {
    id
    timeseries(
      granularity: $granularity
      endDate: $endDate
      startDate: $startDate
      filters: $filters
    ) {
      ...PublisherTimeseries
    }
  }
}
    ${PublisherTimeseriesFragmentDoc}`;

/**
 * __usePositionTimeseriesQuery__
 *
 * To run a query within a React component, call `usePositionTimeseriesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePositionTimeseriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePositionTimeseriesQuery({
 *   variables: {
 *      endDate: // value for 'endDate'
 *      startDate: // value for 'startDate'
 *      positionId: // value for 'positionId'
 *      granularity: // value for 'granularity'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function usePositionTimeseriesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PositionTimeseriesQuery, PositionTimeseriesQueryVariables> & ({ variables: PositionTimeseriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PositionTimeseriesQuery, PositionTimeseriesQueryVariables>(PositionTimeseriesDocument, options);
      }
export function usePositionTimeseriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PositionTimeseriesQuery, PositionTimeseriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PositionTimeseriesQuery, PositionTimeseriesQueryVariables>(PositionTimeseriesDocument, options);
        }
// @ts-ignore
export function usePositionTimeseriesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PositionTimeseriesQuery, PositionTimeseriesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PositionTimeseriesQuery, PositionTimeseriesQueryVariables>;
export function usePositionTimeseriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PositionTimeseriesQuery, PositionTimeseriesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PositionTimeseriesQuery | undefined, PositionTimeseriesQueryVariables>;
export function usePositionTimeseriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PositionTimeseriesQuery, PositionTimeseriesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PositionTimeseriesQuery, PositionTimeseriesQueryVariables>(PositionTimeseriesDocument, options);
        }
export type PositionTimeseriesQueryHookResult = ReturnType<typeof usePositionTimeseriesQuery>;
export type PositionTimeseriesLazyQueryHookResult = ReturnType<typeof usePositionTimeseriesLazyQuery>;
export type PositionTimeseriesSuspenseQueryHookResult = ReturnType<typeof usePositionTimeseriesSuspenseQuery>;
export type PositionTimeseriesQueryResult = ApolloReactCommon.QueryResult<PositionTimeseriesQuery, PositionTimeseriesQueryVariables>;
export const PositionPerformanceStatsDocument = gql`
    query positionPerformanceStats($endDate: DateTime!, $startDate: DateTime!, $positionId: PwsID!, $filters: [CostDetailsFilter!]) {
  position(id: $positionId) {
    id
    performanceStats(endDate: $endDate, startDate: $startDate, filters: $filters) {
      stats {
        ...PublisherPerformanceStatsParts
      }
      devices {
        name
        stats {
          ...PublisherPerformanceStatsParts
        }
      }
      zones {
        name
        stats {
          ...PublisherPerformanceStatsParts
        }
      }
      advertiserResellers {
        name
        stats {
          ...PublisherPerformanceStatsParts
        }
        advertisers {
          slug
          campaigns {
            name
            stats {
              ...PublisherPerformanceStatsParts
            }
          }
        }
      }
      adTemplates {
        ... on AdTemplateNativeWithPerformance {
          id
          name
          stats {
            ...PublisherPerformanceStatsParts
          }
          zones {
            name
            stats {
              ...PublisherPerformanceStatsParts
            }
          }
        }
        ... on AdTemplateBannerWithPerformance {
          id
          name
          stats {
            ...PublisherPerformanceStatsParts
          }
          zones {
            name
            stats {
              ...PublisherPerformanceStatsParts
            }
          }
        }
        ... on AdTemplateWebWithPerformance {
          id
          name
          stats {
            ...PublisherPerformanceStatsParts
          }
          zones {
            name
            stats {
              ...PublisherPerformanceStatsParts
            }
          }
        }
      }
    }
  }
}
    ${PublisherPerformanceStatsPartsFragmentDoc}`;

/**
 * __usePositionPerformanceStatsQuery__
 *
 * To run a query within a React component, call `usePositionPerformanceStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePositionPerformanceStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePositionPerformanceStatsQuery({
 *   variables: {
 *      endDate: // value for 'endDate'
 *      startDate: // value for 'startDate'
 *      positionId: // value for 'positionId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function usePositionPerformanceStatsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PositionPerformanceStatsQuery, PositionPerformanceStatsQueryVariables> & ({ variables: PositionPerformanceStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PositionPerformanceStatsQuery, PositionPerformanceStatsQueryVariables>(PositionPerformanceStatsDocument, options);
      }
export function usePositionPerformanceStatsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PositionPerformanceStatsQuery, PositionPerformanceStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PositionPerformanceStatsQuery, PositionPerformanceStatsQueryVariables>(PositionPerformanceStatsDocument, options);
        }
// @ts-ignore
export function usePositionPerformanceStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PositionPerformanceStatsQuery, PositionPerformanceStatsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PositionPerformanceStatsQuery, PositionPerformanceStatsQueryVariables>;
export function usePositionPerformanceStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PositionPerformanceStatsQuery, PositionPerformanceStatsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PositionPerformanceStatsQuery | undefined, PositionPerformanceStatsQueryVariables>;
export function usePositionPerformanceStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PositionPerformanceStatsQuery, PositionPerformanceStatsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PositionPerformanceStatsQuery, PositionPerformanceStatsQueryVariables>(PositionPerformanceStatsDocument, options);
        }
export type PositionPerformanceStatsQueryHookResult = ReturnType<typeof usePositionPerformanceStatsQuery>;
export type PositionPerformanceStatsLazyQueryHookResult = ReturnType<typeof usePositionPerformanceStatsLazyQuery>;
export type PositionPerformanceStatsSuspenseQueryHookResult = ReturnType<typeof usePositionPerformanceStatsSuspenseQuery>;
export type PositionPerformanceStatsQueryResult = ApolloReactCommon.QueryResult<PositionPerformanceStatsQuery, PositionPerformanceStatsQueryVariables>;
export const PositionPopulationStatsDocument = gql`
    query positionPopulationStats($id: PwsID!) {
  position(id: $id) {
    population {
      ...PublisherPopulation
    }
  }
}
    ${PublisherPopulationFragmentDoc}`;

/**
 * __usePositionPopulationStatsQuery__
 *
 * To run a query within a React component, call `usePositionPopulationStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePositionPopulationStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePositionPopulationStatsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePositionPopulationStatsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PositionPopulationStatsQuery, PositionPopulationStatsQueryVariables> & ({ variables: PositionPopulationStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PositionPopulationStatsQuery, PositionPopulationStatsQueryVariables>(PositionPopulationStatsDocument, options);
      }
export function usePositionPopulationStatsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PositionPopulationStatsQuery, PositionPopulationStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PositionPopulationStatsQuery, PositionPopulationStatsQueryVariables>(PositionPopulationStatsDocument, options);
        }
// @ts-ignore
export function usePositionPopulationStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PositionPopulationStatsQuery, PositionPopulationStatsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PositionPopulationStatsQuery, PositionPopulationStatsQueryVariables>;
export function usePositionPopulationStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PositionPopulationStatsQuery, PositionPopulationStatsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PositionPopulationStatsQuery | undefined, PositionPopulationStatsQueryVariables>;
export function usePositionPopulationStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PositionPopulationStatsQuery, PositionPopulationStatsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PositionPopulationStatsQuery, PositionPopulationStatsQueryVariables>(PositionPopulationStatsDocument, options);
        }
export type PositionPopulationStatsQueryHookResult = ReturnType<typeof usePositionPopulationStatsQuery>;
export type PositionPopulationStatsLazyQueryHookResult = ReturnType<typeof usePositionPopulationStatsLazyQuery>;
export type PositionPopulationStatsSuspenseQueryHookResult = ReturnType<typeof usePositionPopulationStatsSuspenseQuery>;
export type PositionPopulationStatsQueryResult = ApolloReactCommon.QueryResult<PositionPopulationStatsQuery, PositionPopulationStatsQueryVariables>;
export const CreatePositionDocument = gql`
    mutation createPosition($newPosition: PositionCreateInput!) {
  createPosition(newPosition: $newPosition) {
    id
    name
    website {
      publisher {
        slug
      }
    }
  }
}
    `;
export type CreatePositionMutationFn = ApolloReactCommon.MutationFunction<CreatePositionMutation, CreatePositionMutationVariables>;

/**
 * __useCreatePositionMutation__
 *
 * To run a mutation, you first call `useCreatePositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPositionMutation, { data, loading, error }] = useCreatePositionMutation({
 *   variables: {
 *      newPosition: // value for 'newPosition'
 *   },
 * });
 */
export function useCreatePositionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreatePositionMutation, CreatePositionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreatePositionMutation, CreatePositionMutationVariables>(CreatePositionDocument, options);
      }
export type CreatePositionMutationHookResult = ReturnType<typeof useCreatePositionMutation>;
export type CreatePositionMutationResult = ApolloReactCommon.MutationResult<CreatePositionMutation>;
export type CreatePositionMutationOptions = ApolloReactCommon.BaseMutationOptions<CreatePositionMutation, CreatePositionMutationVariables>;
export const UpdatePositionDocument = gql`
    mutation updatePosition($position: PositionInput!) {
  updatePosition(position: $position) {
    ...PositionParts
  }
}
    ${PositionPartsFragmentDoc}`;
export type UpdatePositionMutationFn = ApolloReactCommon.MutationFunction<UpdatePositionMutation, UpdatePositionMutationVariables>;

/**
 * __useUpdatePositionMutation__
 *
 * To run a mutation, you first call `useUpdatePositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePositionMutation, { data, loading, error }] = useUpdatePositionMutation({
 *   variables: {
 *      position: // value for 'position'
 *   },
 * });
 */
export function useUpdatePositionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePositionMutation, UpdatePositionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdatePositionMutation, UpdatePositionMutationVariables>(UpdatePositionDocument, options);
      }
export type UpdatePositionMutationHookResult = ReturnType<typeof useUpdatePositionMutation>;
export type UpdatePositionMutationResult = ApolloReactCommon.MutationResult<UpdatePositionMutation>;
export type UpdatePositionMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdatePositionMutation, UpdatePositionMutationVariables>;
export const CopyPositionDocument = gql`
    mutation copyPosition($name: String!, $positionId: PwsID!) {
  copyPosition(name: $name, positionId: $positionId)
}
    `;
export type CopyPositionMutationFn = ApolloReactCommon.MutationFunction<CopyPositionMutation, CopyPositionMutationVariables>;

/**
 * __useCopyPositionMutation__
 *
 * To run a mutation, you first call `useCopyPositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyPositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyPositionMutation, { data, loading, error }] = useCopyPositionMutation({
 *   variables: {
 *      name: // value for 'name'
 *      positionId: // value for 'positionId'
 *   },
 * });
 */
export function useCopyPositionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CopyPositionMutation, CopyPositionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CopyPositionMutation, CopyPositionMutationVariables>(CopyPositionDocument, options);
      }
export type CopyPositionMutationHookResult = ReturnType<typeof useCopyPositionMutation>;
export type CopyPositionMutationResult = ApolloReactCommon.MutationResult<CopyPositionMutation>;
export type CopyPositionMutationOptions = ApolloReactCommon.BaseMutationOptions<CopyPositionMutation, CopyPositionMutationVariables>;
export const UpdateDemandSourcesDocument = gql`
    mutation updateDemandSources($positionId: PwsID!, $demandSources: [DemandSourceInput!]!) {
  updateDemandSources(positionId: $positionId, demandSources: $demandSources)
}
    `;
export type UpdateDemandSourcesMutationFn = ApolloReactCommon.MutationFunction<UpdateDemandSourcesMutation, UpdateDemandSourcesMutationVariables>;

/**
 * __useUpdateDemandSourcesMutation__
 *
 * To run a mutation, you first call `useUpdateDemandSourcesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDemandSourcesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDemandSourcesMutation, { data, loading, error }] = useUpdateDemandSourcesMutation({
 *   variables: {
 *      positionId: // value for 'positionId'
 *      demandSources: // value for 'demandSources'
 *   },
 * });
 */
export function useUpdateDemandSourcesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateDemandSourcesMutation, UpdateDemandSourcesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateDemandSourcesMutation, UpdateDemandSourcesMutationVariables>(UpdateDemandSourcesDocument, options);
      }
export type UpdateDemandSourcesMutationHookResult = ReturnType<typeof useUpdateDemandSourcesMutation>;
export type UpdateDemandSourcesMutationResult = ApolloReactCommon.MutationResult<UpdateDemandSourcesMutation>;
export type UpdateDemandSourcesMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateDemandSourcesMutation, UpdateDemandSourcesMutationVariables>;
export const UpdatePositionZonesDocument = gql`
    mutation updatePositionZones($positionId: PwsID!, $zones: [PositionZoneInput!]!) {
  updatePositionZones(positionId: $positionId, zones: $zones) {
    ...ZoneFragment
  }
}
    ${ZoneFragmentFragmentDoc}`;
export type UpdatePositionZonesMutationFn = ApolloReactCommon.MutationFunction<UpdatePositionZonesMutation, UpdatePositionZonesMutationVariables>;

/**
 * __useUpdatePositionZonesMutation__
 *
 * To run a mutation, you first call `useUpdatePositionZonesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePositionZonesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePositionZonesMutation, { data, loading, error }] = useUpdatePositionZonesMutation({
 *   variables: {
 *      positionId: // value for 'positionId'
 *      zones: // value for 'zones'
 *   },
 * });
 */
export function useUpdatePositionZonesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePositionZonesMutation, UpdatePositionZonesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdatePositionZonesMutation, UpdatePositionZonesMutationVariables>(UpdatePositionZonesDocument, options);
      }
export type UpdatePositionZonesMutationHookResult = ReturnType<typeof useUpdatePositionZonesMutation>;
export type UpdatePositionZonesMutationResult = ApolloReactCommon.MutationResult<UpdatePositionZonesMutation>;
export type UpdatePositionZonesMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdatePositionZonesMutation, UpdatePositionZonesMutationVariables>;
export const UpdatePositionCustomDomainDocument = gql`
    mutation updatePositionCustomDomain($positionId: PwsID!, $customDomain: String) {
  updatePositionCustomDomain(positionId: $positionId, customDomain: $customDomain) {
    ...PositionCustomDomainParts
  }
}
    ${PositionCustomDomainPartsFragmentDoc}`;
export type UpdatePositionCustomDomainMutationFn = ApolloReactCommon.MutationFunction<UpdatePositionCustomDomainMutation, UpdatePositionCustomDomainMutationVariables>;

/**
 * __useUpdatePositionCustomDomainMutation__
 *
 * To run a mutation, you first call `useUpdatePositionCustomDomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePositionCustomDomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePositionCustomDomainMutation, { data, loading, error }] = useUpdatePositionCustomDomainMutation({
 *   variables: {
 *      positionId: // value for 'positionId'
 *      customDomain: // value for 'customDomain'
 *   },
 * });
 */
export function useUpdatePositionCustomDomainMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePositionCustomDomainMutation, UpdatePositionCustomDomainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdatePositionCustomDomainMutation, UpdatePositionCustomDomainMutationVariables>(UpdatePositionCustomDomainDocument, options);
      }
export type UpdatePositionCustomDomainMutationHookResult = ReturnType<typeof useUpdatePositionCustomDomainMutation>;
export type UpdatePositionCustomDomainMutationResult = ApolloReactCommon.MutationResult<UpdatePositionCustomDomainMutation>;
export type UpdatePositionCustomDomainMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdatePositionCustomDomainMutation, UpdatePositionCustomDomainMutationVariables>;
export const PowerspacePopulationStatsDocument = gql`
    query powerspacePopulationStats($endDate: DateTime!, $startDate: DateTime!, $filters: [CostDetailsFilter!]) {
  powerspace {
    population(endDate: $endDate, startDate: $startDate, filters: $filters) {
      ...PublisherPopulation
    }
    adGroupIABStatsAnalysis(
      endDate: $endDate
      startDate: $startDate
      filters: $filters
    ) {
      iabCategory
      adGroupId
      campaignId
      impressions
      clicks
      revenues
      conversions
    }
  }
}
    ${PublisherPopulationFragmentDoc}`;

/**
 * __usePowerspacePopulationStatsQuery__
 *
 * To run a query within a React component, call `usePowerspacePopulationStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePowerspacePopulationStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePowerspacePopulationStatsQuery({
 *   variables: {
 *      endDate: // value for 'endDate'
 *      startDate: // value for 'startDate'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function usePowerspacePopulationStatsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PowerspacePopulationStatsQuery, PowerspacePopulationStatsQueryVariables> & ({ variables: PowerspacePopulationStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PowerspacePopulationStatsQuery, PowerspacePopulationStatsQueryVariables>(PowerspacePopulationStatsDocument, options);
      }
export function usePowerspacePopulationStatsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PowerspacePopulationStatsQuery, PowerspacePopulationStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PowerspacePopulationStatsQuery, PowerspacePopulationStatsQueryVariables>(PowerspacePopulationStatsDocument, options);
        }
// @ts-ignore
export function usePowerspacePopulationStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PowerspacePopulationStatsQuery, PowerspacePopulationStatsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PowerspacePopulationStatsQuery, PowerspacePopulationStatsQueryVariables>;
export function usePowerspacePopulationStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PowerspacePopulationStatsQuery, PowerspacePopulationStatsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PowerspacePopulationStatsQuery | undefined, PowerspacePopulationStatsQueryVariables>;
export function usePowerspacePopulationStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PowerspacePopulationStatsQuery, PowerspacePopulationStatsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PowerspacePopulationStatsQuery, PowerspacePopulationStatsQueryVariables>(PowerspacePopulationStatsDocument, options);
        }
export type PowerspacePopulationStatsQueryHookResult = ReturnType<typeof usePowerspacePopulationStatsQuery>;
export type PowerspacePopulationStatsLazyQueryHookResult = ReturnType<typeof usePowerspacePopulationStatsLazyQuery>;
export type PowerspacePopulationStatsSuspenseQueryHookResult = ReturnType<typeof usePowerspacePopulationStatsSuspenseQuery>;
export type PowerspacePopulationStatsQueryResult = ApolloReactCommon.QueryResult<PowerspacePopulationStatsQuery, PowerspacePopulationStatsQueryVariables>;
export const PowerspaceAccountsDocument = gql`
    query powerspaceAccounts {
  powerspace {
    accounts {
      id
      firstName
      lastName
    }
  }
}
    `;

/**
 * __usePowerspaceAccountsQuery__
 *
 * To run a query within a React component, call `usePowerspaceAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePowerspaceAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePowerspaceAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePowerspaceAccountsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PowerspaceAccountsQuery, PowerspaceAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PowerspaceAccountsQuery, PowerspaceAccountsQueryVariables>(PowerspaceAccountsDocument, options);
      }
export function usePowerspaceAccountsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PowerspaceAccountsQuery, PowerspaceAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PowerspaceAccountsQuery, PowerspaceAccountsQueryVariables>(PowerspaceAccountsDocument, options);
        }
// @ts-ignore
export function usePowerspaceAccountsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PowerspaceAccountsQuery, PowerspaceAccountsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PowerspaceAccountsQuery, PowerspaceAccountsQueryVariables>;
export function usePowerspaceAccountsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PowerspaceAccountsQuery, PowerspaceAccountsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PowerspaceAccountsQuery | undefined, PowerspaceAccountsQueryVariables>;
export function usePowerspaceAccountsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PowerspaceAccountsQuery, PowerspaceAccountsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PowerspaceAccountsQuery, PowerspaceAccountsQueryVariables>(PowerspaceAccountsDocument, options);
        }
export type PowerspaceAccountsQueryHookResult = ReturnType<typeof usePowerspaceAccountsQuery>;
export type PowerspaceAccountsLazyQueryHookResult = ReturnType<typeof usePowerspaceAccountsLazyQuery>;
export type PowerspaceAccountsSuspenseQueryHookResult = ReturnType<typeof usePowerspaceAccountsSuspenseQuery>;
export type PowerspaceAccountsQueryResult = ApolloReactCommon.QueryResult<PowerspaceAccountsQuery, PowerspaceAccountsQueryVariables>;
export const PowerspaceSalesDocument = gql`
    query powerspaceSales {
  powerspace {
    sales {
      id
      firstName
      lastName
    }
  }
}
    `;

/**
 * __usePowerspaceSalesQuery__
 *
 * To run a query within a React component, call `usePowerspaceSalesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePowerspaceSalesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePowerspaceSalesQuery({
 *   variables: {
 *   },
 * });
 */
export function usePowerspaceSalesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PowerspaceSalesQuery, PowerspaceSalesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PowerspaceSalesQuery, PowerspaceSalesQueryVariables>(PowerspaceSalesDocument, options);
      }
export function usePowerspaceSalesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PowerspaceSalesQuery, PowerspaceSalesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PowerspaceSalesQuery, PowerspaceSalesQueryVariables>(PowerspaceSalesDocument, options);
        }
// @ts-ignore
export function usePowerspaceSalesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PowerspaceSalesQuery, PowerspaceSalesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PowerspaceSalesQuery, PowerspaceSalesQueryVariables>;
export function usePowerspaceSalesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PowerspaceSalesQuery, PowerspaceSalesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PowerspaceSalesQuery | undefined, PowerspaceSalesQueryVariables>;
export function usePowerspaceSalesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PowerspaceSalesQuery, PowerspaceSalesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PowerspaceSalesQuery, PowerspaceSalesQueryVariables>(PowerspaceSalesDocument, options);
        }
export type PowerspaceSalesQueryHookResult = ReturnType<typeof usePowerspaceSalesQuery>;
export type PowerspaceSalesLazyQueryHookResult = ReturnType<typeof usePowerspaceSalesLazyQuery>;
export type PowerspaceSalesSuspenseQueryHookResult = ReturnType<typeof usePowerspaceSalesSuspenseQuery>;
export type PowerspaceSalesQueryResult = ApolloReactCommon.QueryResult<PowerspaceSalesQuery, PowerspaceSalesQueryVariables>;
export const PowerspaceBudgetsDocument = gql`
    query powerspaceBudgets($endDate: DateTime!, $startDate: DateTime!, $granularity: GraphGranularity!, $accountIds: [PwsID!], $saleIds: [PwsID!], $filters: [CostDetailsFilter!]) {
  powerspace {
    budgets(
      endDate: $endDate
      startDate: $startDate
      granularity: $granularity
      accountIds: $accountIds
      saleIds: $saleIds
      filters: $filters
    ) {
      global {
        date
        dailyBudget
        revenue
        impressions
        clicks
      }
      adGroups {
        date
        advertiserName
        advertiserSlug
        campaignName
        campaignId
        adGroupName
        adGroupId
        salesId
        accountId
        dailyBudget
        revenue
        impressions
        clicks
      }
    }
  }
}
    `;

/**
 * __usePowerspaceBudgetsQuery__
 *
 * To run a query within a React component, call `usePowerspaceBudgetsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePowerspaceBudgetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePowerspaceBudgetsQuery({
 *   variables: {
 *      endDate: // value for 'endDate'
 *      startDate: // value for 'startDate'
 *      granularity: // value for 'granularity'
 *      accountIds: // value for 'accountIds'
 *      saleIds: // value for 'saleIds'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function usePowerspaceBudgetsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PowerspaceBudgetsQuery, PowerspaceBudgetsQueryVariables> & ({ variables: PowerspaceBudgetsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PowerspaceBudgetsQuery, PowerspaceBudgetsQueryVariables>(PowerspaceBudgetsDocument, options);
      }
export function usePowerspaceBudgetsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PowerspaceBudgetsQuery, PowerspaceBudgetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PowerspaceBudgetsQuery, PowerspaceBudgetsQueryVariables>(PowerspaceBudgetsDocument, options);
        }
// @ts-ignore
export function usePowerspaceBudgetsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PowerspaceBudgetsQuery, PowerspaceBudgetsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PowerspaceBudgetsQuery, PowerspaceBudgetsQueryVariables>;
export function usePowerspaceBudgetsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PowerspaceBudgetsQuery, PowerspaceBudgetsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PowerspaceBudgetsQuery | undefined, PowerspaceBudgetsQueryVariables>;
export function usePowerspaceBudgetsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PowerspaceBudgetsQuery, PowerspaceBudgetsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PowerspaceBudgetsQuery, PowerspaceBudgetsQueryVariables>(PowerspaceBudgetsDocument, options);
        }
export type PowerspaceBudgetsQueryHookResult = ReturnType<typeof usePowerspaceBudgetsQuery>;
export type PowerspaceBudgetsLazyQueryHookResult = ReturnType<typeof usePowerspaceBudgetsLazyQuery>;
export type PowerspaceBudgetsSuspenseQueryHookResult = ReturnType<typeof usePowerspaceBudgetsSuspenseQuery>;
export type PowerspaceBudgetsQueryResult = ApolloReactCommon.QueryResult<PowerspaceBudgetsQuery, PowerspaceBudgetsQueryVariables>;
export const PowerspaceDemandSourcesDocument = gql`
    query powerspaceDemandSources($endDate: DateTime!, $startDate: DateTime!, $granularity: GraphGranularity!, $filters: [CostDetailsFilter!]) {
  powerspace {
    demandSources(
      endDate: $endDate
      startDate: $startDate
      granularity: $granularity
      filters: $filters
    ) {
      date
      publisherResellerId
      publisherResellerName
      advertiserResellerId
      advertiserResellerName
      impressions
    }
  }
}
    `;

/**
 * __usePowerspaceDemandSourcesQuery__
 *
 * To run a query within a React component, call `usePowerspaceDemandSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePowerspaceDemandSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePowerspaceDemandSourcesQuery({
 *   variables: {
 *      endDate: // value for 'endDate'
 *      startDate: // value for 'startDate'
 *      granularity: // value for 'granularity'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function usePowerspaceDemandSourcesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PowerspaceDemandSourcesQuery, PowerspaceDemandSourcesQueryVariables> & ({ variables: PowerspaceDemandSourcesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PowerspaceDemandSourcesQuery, PowerspaceDemandSourcesQueryVariables>(PowerspaceDemandSourcesDocument, options);
      }
export function usePowerspaceDemandSourcesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PowerspaceDemandSourcesQuery, PowerspaceDemandSourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PowerspaceDemandSourcesQuery, PowerspaceDemandSourcesQueryVariables>(PowerspaceDemandSourcesDocument, options);
        }
// @ts-ignore
export function usePowerspaceDemandSourcesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PowerspaceDemandSourcesQuery, PowerspaceDemandSourcesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PowerspaceDemandSourcesQuery, PowerspaceDemandSourcesQueryVariables>;
export function usePowerspaceDemandSourcesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PowerspaceDemandSourcesQuery, PowerspaceDemandSourcesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PowerspaceDemandSourcesQuery | undefined, PowerspaceDemandSourcesQueryVariables>;
export function usePowerspaceDemandSourcesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PowerspaceDemandSourcesQuery, PowerspaceDemandSourcesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PowerspaceDemandSourcesQuery, PowerspaceDemandSourcesQueryVariables>(PowerspaceDemandSourcesDocument, options);
        }
export type PowerspaceDemandSourcesQueryHookResult = ReturnType<typeof usePowerspaceDemandSourcesQuery>;
export type PowerspaceDemandSourcesLazyQueryHookResult = ReturnType<typeof usePowerspaceDemandSourcesLazyQuery>;
export type PowerspaceDemandSourcesSuspenseQueryHookResult = ReturnType<typeof usePowerspaceDemandSourcesSuspenseQuery>;
export type PowerspaceDemandSourcesQueryResult = ApolloReactCommon.QueryResult<PowerspaceDemandSourcesQuery, PowerspaceDemandSourcesQueryVariables>;
export const PowerspaceAdGroupsDocument = gql`
    query powerspaceAdGroups($endDate: DateTime!, $startDate: DateTime!, $filters: [CostDetailsFilter!]) {
  powerspace {
    iabRepartition(endDate: $endDate, startDate: $startDate, filters: $filters) {
      iab
      adGroupCount
      impressions
      clicks
      conversions
    }
    adGroupIABStatsAnalysis(
      endDate: $endDate
      startDate: $startDate
      filters: $filters
    ) {
      iabCategory
      adGroupId
      campaignId
      impressions
      clicks
      revenues
      conversions
    }
  }
}
    `;

/**
 * __usePowerspaceAdGroupsQuery__
 *
 * To run a query within a React component, call `usePowerspaceAdGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePowerspaceAdGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePowerspaceAdGroupsQuery({
 *   variables: {
 *      endDate: // value for 'endDate'
 *      startDate: // value for 'startDate'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function usePowerspaceAdGroupsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PowerspaceAdGroupsQuery, PowerspaceAdGroupsQueryVariables> & ({ variables: PowerspaceAdGroupsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PowerspaceAdGroupsQuery, PowerspaceAdGroupsQueryVariables>(PowerspaceAdGroupsDocument, options);
      }
export function usePowerspaceAdGroupsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PowerspaceAdGroupsQuery, PowerspaceAdGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PowerspaceAdGroupsQuery, PowerspaceAdGroupsQueryVariables>(PowerspaceAdGroupsDocument, options);
        }
// @ts-ignore
export function usePowerspaceAdGroupsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PowerspaceAdGroupsQuery, PowerspaceAdGroupsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PowerspaceAdGroupsQuery, PowerspaceAdGroupsQueryVariables>;
export function usePowerspaceAdGroupsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PowerspaceAdGroupsQuery, PowerspaceAdGroupsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PowerspaceAdGroupsQuery | undefined, PowerspaceAdGroupsQueryVariables>;
export function usePowerspaceAdGroupsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PowerspaceAdGroupsQuery, PowerspaceAdGroupsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PowerspaceAdGroupsQuery, PowerspaceAdGroupsQueryVariables>(PowerspaceAdGroupsDocument, options);
        }
export type PowerspaceAdGroupsQueryHookResult = ReturnType<typeof usePowerspaceAdGroupsQuery>;
export type PowerspaceAdGroupsLazyQueryHookResult = ReturnType<typeof usePowerspaceAdGroupsLazyQuery>;
export type PowerspaceAdGroupsSuspenseQueryHookResult = ReturnType<typeof usePowerspaceAdGroupsSuspenseQuery>;
export type PowerspaceAdGroupsQueryResult = ApolloReactCommon.QueryResult<PowerspaceAdGroupsQuery, PowerspaceAdGroupsQueryVariables>;
export const PowerspaceAdProductTiersDocument = gql`
    query powerspaceAdProductTiers($endDate: DateTime!, $startDate: DateTime!, $timezone: String!, $filters: [CostDetailsFilter!], $source: AdGroupClassificationSource!) {
  powerspace {
    adGroupAdProductTiers(
      endDate: $endDate
      startDate: $startDate
      timezone: $timezone
      filters: $filters
      source: $source
    ) {
      tier
      categories {
        category
        stats {
          ...AdvertiserPerformanceStatsParts
        }
        ageRanges {
          ...AdGroupAdProductTierAgeRangeBreakdownParts
        }
        iabCategories {
          ...AdGroupAdProductTierBreakdownParts
        }
        websites {
          ...AdGroupAdProductTierWebsiteBreakdownParts
        }
        adGroups {
          stats {
            ...AdvertiserPerformanceStatsParts
          }
          adGroup {
            ...AdGroupAdProductTierAdGroupParts
          }
          iabCategories {
            ...AdGroupAdProductTierBreakdownParts
          }
          websites {
            ...AdGroupAdProductTierWebsiteBreakdownParts
          }
        }
      }
    }
  }
}
    ${AdvertiserPerformanceStatsPartsFragmentDoc}
${AdGroupAdProductTierAgeRangeBreakdownPartsFragmentDoc}
${AdGroupAdProductTierBreakdownPartsFragmentDoc}
${AdGroupAdProductTierWebsiteBreakdownPartsFragmentDoc}
${AdGroupAdProductTierAdGroupPartsFragmentDoc}`;

/**
 * __usePowerspaceAdProductTiersQuery__
 *
 * To run a query within a React component, call `usePowerspaceAdProductTiersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePowerspaceAdProductTiersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePowerspaceAdProductTiersQuery({
 *   variables: {
 *      endDate: // value for 'endDate'
 *      startDate: // value for 'startDate'
 *      timezone: // value for 'timezone'
 *      filters: // value for 'filters'
 *      source: // value for 'source'
 *   },
 * });
 */
export function usePowerspaceAdProductTiersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PowerspaceAdProductTiersQuery, PowerspaceAdProductTiersQueryVariables> & ({ variables: PowerspaceAdProductTiersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PowerspaceAdProductTiersQuery, PowerspaceAdProductTiersQueryVariables>(PowerspaceAdProductTiersDocument, options);
      }
export function usePowerspaceAdProductTiersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PowerspaceAdProductTiersQuery, PowerspaceAdProductTiersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PowerspaceAdProductTiersQuery, PowerspaceAdProductTiersQueryVariables>(PowerspaceAdProductTiersDocument, options);
        }
// @ts-ignore
export function usePowerspaceAdProductTiersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PowerspaceAdProductTiersQuery, PowerspaceAdProductTiersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PowerspaceAdProductTiersQuery, PowerspaceAdProductTiersQueryVariables>;
export function usePowerspaceAdProductTiersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PowerspaceAdProductTiersQuery, PowerspaceAdProductTiersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PowerspaceAdProductTiersQuery | undefined, PowerspaceAdProductTiersQueryVariables>;
export function usePowerspaceAdProductTiersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PowerspaceAdProductTiersQuery, PowerspaceAdProductTiersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PowerspaceAdProductTiersQuery, PowerspaceAdProductTiersQueryVariables>(PowerspaceAdProductTiersDocument, options);
        }
export type PowerspaceAdProductTiersQueryHookResult = ReturnType<typeof usePowerspaceAdProductTiersQuery>;
export type PowerspaceAdProductTiersLazyQueryHookResult = ReturnType<typeof usePowerspaceAdProductTiersLazyQuery>;
export type PowerspaceAdProductTiersSuspenseQueryHookResult = ReturnType<typeof usePowerspaceAdProductTiersSuspenseQuery>;
export type PowerspaceAdProductTiersQueryResult = ApolloReactCommon.QueryResult<PowerspaceAdProductTiersQuery, PowerspaceAdProductTiersQueryVariables>;
export const ProgrammaticCampaignTimeseriesDocument = gql`
    query programmaticCampaignTimeseries($endDate: DateTime!, $startDate: DateTime!, $id: PwsID!, $granularity: GraphGranularity!) {
  campaignProgrammatic(id: $id) {
    id
    timeseries(granularity: $granularity, endDate: $endDate, startDate: $startDate) {
      ...AdvertiserTimeseries
    }
  }
}
    ${AdvertiserTimeseriesFragmentDoc}`;

/**
 * __useProgrammaticCampaignTimeseriesQuery__
 *
 * To run a query within a React component, call `useProgrammaticCampaignTimeseriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgrammaticCampaignTimeseriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProgrammaticCampaignTimeseriesQuery({
 *   variables: {
 *      endDate: // value for 'endDate'
 *      startDate: // value for 'startDate'
 *      id: // value for 'id'
 *      granularity: // value for 'granularity'
 *   },
 * });
 */
export function useProgrammaticCampaignTimeseriesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProgrammaticCampaignTimeseriesQuery, ProgrammaticCampaignTimeseriesQueryVariables> & ({ variables: ProgrammaticCampaignTimeseriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProgrammaticCampaignTimeseriesQuery, ProgrammaticCampaignTimeseriesQueryVariables>(ProgrammaticCampaignTimeseriesDocument, options);
      }
export function useProgrammaticCampaignTimeseriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProgrammaticCampaignTimeseriesQuery, ProgrammaticCampaignTimeseriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProgrammaticCampaignTimeseriesQuery, ProgrammaticCampaignTimeseriesQueryVariables>(ProgrammaticCampaignTimeseriesDocument, options);
        }
// @ts-ignore
export function useProgrammaticCampaignTimeseriesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProgrammaticCampaignTimeseriesQuery, ProgrammaticCampaignTimeseriesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProgrammaticCampaignTimeseriesQuery, ProgrammaticCampaignTimeseriesQueryVariables>;
export function useProgrammaticCampaignTimeseriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProgrammaticCampaignTimeseriesQuery, ProgrammaticCampaignTimeseriesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProgrammaticCampaignTimeseriesQuery | undefined, ProgrammaticCampaignTimeseriesQueryVariables>;
export function useProgrammaticCampaignTimeseriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProgrammaticCampaignTimeseriesQuery, ProgrammaticCampaignTimeseriesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProgrammaticCampaignTimeseriesQuery, ProgrammaticCampaignTimeseriesQueryVariables>(ProgrammaticCampaignTimeseriesDocument, options);
        }
export type ProgrammaticCampaignTimeseriesQueryHookResult = ReturnType<typeof useProgrammaticCampaignTimeseriesQuery>;
export type ProgrammaticCampaignTimeseriesLazyQueryHookResult = ReturnType<typeof useProgrammaticCampaignTimeseriesLazyQuery>;
export type ProgrammaticCampaignTimeseriesSuspenseQueryHookResult = ReturnType<typeof useProgrammaticCampaignTimeseriesSuspenseQuery>;
export type ProgrammaticCampaignTimeseriesQueryResult = ApolloReactCommon.QueryResult<ProgrammaticCampaignTimeseriesQuery, ProgrammaticCampaignTimeseriesQueryVariables>;
export const ProgrammaticCampaignPerformanceStatsDocument = gql`
    query programmaticCampaignPerformanceStats($endDate: DateTime!, $startDate: DateTime!, $id: PwsID!) {
  campaignProgrammatic(id: $id) {
    id
    performanceStats(endDate: $endDate, startDate: $startDate) {
      stats {
        ...AdvertiserPerformanceStatsParts
      }
      publisherResellers {
        name
        stats {
          ...AdvertiserPerformanceStatsParts
        }
        publishers {
          name
          stats {
            ...AdvertiserPerformanceStatsParts
          }
          websites {
            name
            stats {
              ...AdvertiserPerformanceStatsParts
            }
            positions {
              name
              stats {
                ...AdvertiserPerformanceStatsParts
              }
            }
          }
        }
      }
    }
  }
}
    ${AdvertiserPerformanceStatsPartsFragmentDoc}`;

/**
 * __useProgrammaticCampaignPerformanceStatsQuery__
 *
 * To run a query within a React component, call `useProgrammaticCampaignPerformanceStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgrammaticCampaignPerformanceStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProgrammaticCampaignPerformanceStatsQuery({
 *   variables: {
 *      endDate: // value for 'endDate'
 *      startDate: // value for 'startDate'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProgrammaticCampaignPerformanceStatsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProgrammaticCampaignPerformanceStatsQuery, ProgrammaticCampaignPerformanceStatsQueryVariables> & ({ variables: ProgrammaticCampaignPerformanceStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProgrammaticCampaignPerformanceStatsQuery, ProgrammaticCampaignPerformanceStatsQueryVariables>(ProgrammaticCampaignPerformanceStatsDocument, options);
      }
export function useProgrammaticCampaignPerformanceStatsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProgrammaticCampaignPerformanceStatsQuery, ProgrammaticCampaignPerformanceStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProgrammaticCampaignPerformanceStatsQuery, ProgrammaticCampaignPerformanceStatsQueryVariables>(ProgrammaticCampaignPerformanceStatsDocument, options);
        }
// @ts-ignore
export function useProgrammaticCampaignPerformanceStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProgrammaticCampaignPerformanceStatsQuery, ProgrammaticCampaignPerformanceStatsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProgrammaticCampaignPerformanceStatsQuery, ProgrammaticCampaignPerformanceStatsQueryVariables>;
export function useProgrammaticCampaignPerformanceStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProgrammaticCampaignPerformanceStatsQuery, ProgrammaticCampaignPerformanceStatsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProgrammaticCampaignPerformanceStatsQuery | undefined, ProgrammaticCampaignPerformanceStatsQueryVariables>;
export function useProgrammaticCampaignPerformanceStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProgrammaticCampaignPerformanceStatsQuery, ProgrammaticCampaignPerformanceStatsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProgrammaticCampaignPerformanceStatsQuery, ProgrammaticCampaignPerformanceStatsQueryVariables>(ProgrammaticCampaignPerformanceStatsDocument, options);
        }
export type ProgrammaticCampaignPerformanceStatsQueryHookResult = ReturnType<typeof useProgrammaticCampaignPerformanceStatsQuery>;
export type ProgrammaticCampaignPerformanceStatsLazyQueryHookResult = ReturnType<typeof useProgrammaticCampaignPerformanceStatsLazyQuery>;
export type ProgrammaticCampaignPerformanceStatsSuspenseQueryHookResult = ReturnType<typeof useProgrammaticCampaignPerformanceStatsSuspenseQuery>;
export type ProgrammaticCampaignPerformanceStatsQueryResult = ApolloReactCommon.QueryResult<ProgrammaticCampaignPerformanceStatsQuery, ProgrammaticCampaignPerformanceStatsQueryVariables>;
export const ProgrammaticCampaignDocument = gql`
    query programmaticCampaign($id: PwsID!) {
  campaignProgrammatic(id: $id) {
    ...ProgrammaticCampaignParts
  }
}
    ${ProgrammaticCampaignPartsFragmentDoc}`;

/**
 * __useProgrammaticCampaignQuery__
 *
 * To run a query within a React component, call `useProgrammaticCampaignQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgrammaticCampaignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProgrammaticCampaignQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProgrammaticCampaignQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProgrammaticCampaignQuery, ProgrammaticCampaignQueryVariables> & ({ variables: ProgrammaticCampaignQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProgrammaticCampaignQuery, ProgrammaticCampaignQueryVariables>(ProgrammaticCampaignDocument, options);
      }
export function useProgrammaticCampaignLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProgrammaticCampaignQuery, ProgrammaticCampaignQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProgrammaticCampaignQuery, ProgrammaticCampaignQueryVariables>(ProgrammaticCampaignDocument, options);
        }
// @ts-ignore
export function useProgrammaticCampaignSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProgrammaticCampaignQuery, ProgrammaticCampaignQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProgrammaticCampaignQuery, ProgrammaticCampaignQueryVariables>;
export function useProgrammaticCampaignSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProgrammaticCampaignQuery, ProgrammaticCampaignQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProgrammaticCampaignQuery | undefined, ProgrammaticCampaignQueryVariables>;
export function useProgrammaticCampaignSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProgrammaticCampaignQuery, ProgrammaticCampaignQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProgrammaticCampaignQuery, ProgrammaticCampaignQueryVariables>(ProgrammaticCampaignDocument, options);
        }
export type ProgrammaticCampaignQueryHookResult = ReturnType<typeof useProgrammaticCampaignQuery>;
export type ProgrammaticCampaignLazyQueryHookResult = ReturnType<typeof useProgrammaticCampaignLazyQuery>;
export type ProgrammaticCampaignSuspenseQueryHookResult = ReturnType<typeof useProgrammaticCampaignSuspenseQuery>;
export type ProgrammaticCampaignQueryResult = ApolloReactCommon.QueryResult<ProgrammaticCampaignQuery, ProgrammaticCampaignQueryVariables>;
export const ArchiveProgrammaticCampaignDocument = gql`
    mutation archiveProgrammaticCampaign($campaignId: PwsID!) {
  archiveProgrammaticCampaign(campaignId: $campaignId)
}
    `;
export type ArchiveProgrammaticCampaignMutationFn = ApolloReactCommon.MutationFunction<ArchiveProgrammaticCampaignMutation, ArchiveProgrammaticCampaignMutationVariables>;

/**
 * __useArchiveProgrammaticCampaignMutation__
 *
 * To run a mutation, you first call `useArchiveProgrammaticCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveProgrammaticCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveProgrammaticCampaignMutation, { data, loading, error }] = useArchiveProgrammaticCampaignMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useArchiveProgrammaticCampaignMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ArchiveProgrammaticCampaignMutation, ArchiveProgrammaticCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ArchiveProgrammaticCampaignMutation, ArchiveProgrammaticCampaignMutationVariables>(ArchiveProgrammaticCampaignDocument, options);
      }
export type ArchiveProgrammaticCampaignMutationHookResult = ReturnType<typeof useArchiveProgrammaticCampaignMutation>;
export type ArchiveProgrammaticCampaignMutationResult = ApolloReactCommon.MutationResult<ArchiveProgrammaticCampaignMutation>;
export type ArchiveProgrammaticCampaignMutationOptions = ApolloReactCommon.BaseMutationOptions<ArchiveProgrammaticCampaignMutation, ArchiveProgrammaticCampaignMutationVariables>;
export const ProgrammaticCampaignHasInventoryDocument = gql`
    query programmaticCampaignHasInventory($campaignId: PwsID!, $pagination: Pagination!) {
  campaignProgrammatic(id: $campaignId) {
    id
    inventory(pagination: $pagination) {
      id
    }
  }
}
    `;

/**
 * __useProgrammaticCampaignHasInventoryQuery__
 *
 * To run a query within a React component, call `useProgrammaticCampaignHasInventoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgrammaticCampaignHasInventoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProgrammaticCampaignHasInventoryQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useProgrammaticCampaignHasInventoryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProgrammaticCampaignHasInventoryQuery, ProgrammaticCampaignHasInventoryQueryVariables> & ({ variables: ProgrammaticCampaignHasInventoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProgrammaticCampaignHasInventoryQuery, ProgrammaticCampaignHasInventoryQueryVariables>(ProgrammaticCampaignHasInventoryDocument, options);
      }
export function useProgrammaticCampaignHasInventoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProgrammaticCampaignHasInventoryQuery, ProgrammaticCampaignHasInventoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProgrammaticCampaignHasInventoryQuery, ProgrammaticCampaignHasInventoryQueryVariables>(ProgrammaticCampaignHasInventoryDocument, options);
        }
// @ts-ignore
export function useProgrammaticCampaignHasInventorySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProgrammaticCampaignHasInventoryQuery, ProgrammaticCampaignHasInventoryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProgrammaticCampaignHasInventoryQuery, ProgrammaticCampaignHasInventoryQueryVariables>;
export function useProgrammaticCampaignHasInventorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProgrammaticCampaignHasInventoryQuery, ProgrammaticCampaignHasInventoryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProgrammaticCampaignHasInventoryQuery | undefined, ProgrammaticCampaignHasInventoryQueryVariables>;
export function useProgrammaticCampaignHasInventorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProgrammaticCampaignHasInventoryQuery, ProgrammaticCampaignHasInventoryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProgrammaticCampaignHasInventoryQuery, ProgrammaticCampaignHasInventoryQueryVariables>(ProgrammaticCampaignHasInventoryDocument, options);
        }
export type ProgrammaticCampaignHasInventoryQueryHookResult = ReturnType<typeof useProgrammaticCampaignHasInventoryQuery>;
export type ProgrammaticCampaignHasInventoryLazyQueryHookResult = ReturnType<typeof useProgrammaticCampaignHasInventoryLazyQuery>;
export type ProgrammaticCampaignHasInventorySuspenseQueryHookResult = ReturnType<typeof useProgrammaticCampaignHasInventorySuspenseQuery>;
export type ProgrammaticCampaignHasInventoryQueryResult = ApolloReactCommon.QueryResult<ProgrammaticCampaignHasInventoryQuery, ProgrammaticCampaignHasInventoryQueryVariables>;
export const PublisherNameDocument = gql`
    query publisherName($id: PwsID!) {
  publisher(id: $id) {
    id
    name
  }
}
    `;

/**
 * __usePublisherNameQuery__
 *
 * To run a query within a React component, call `usePublisherNameQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublisherNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublisherNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePublisherNameQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PublisherNameQuery, PublisherNameQueryVariables> & ({ variables: PublisherNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PublisherNameQuery, PublisherNameQueryVariables>(PublisherNameDocument, options);
      }
export function usePublisherNameLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PublisherNameQuery, PublisherNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PublisherNameQuery, PublisherNameQueryVariables>(PublisherNameDocument, options);
        }
// @ts-ignore
export function usePublisherNameSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PublisherNameQuery, PublisherNameQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PublisherNameQuery, PublisherNameQueryVariables>;
export function usePublisherNameSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PublisherNameQuery, PublisherNameQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PublisherNameQuery | undefined, PublisherNameQueryVariables>;
export function usePublisherNameSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PublisherNameQuery, PublisherNameQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PublisherNameQuery, PublisherNameQueryVariables>(PublisherNameDocument, options);
        }
export type PublisherNameQueryHookResult = ReturnType<typeof usePublisherNameQuery>;
export type PublisherNameLazyQueryHookResult = ReturnType<typeof usePublisherNameLazyQuery>;
export type PublisherNameSuspenseQueryHookResult = ReturnType<typeof usePublisherNameSuspenseQuery>;
export type PublisherNameQueryResult = ApolloReactCommon.QueryResult<PublisherNameQuery, PublisherNameQueryVariables>;
export const CompanyPositionRevSharesDocument = gql`
    query companyPositionRevShares($searchQuery: WebsiteSearchQuery!) {
  searchWebsites(searchQuery: $searchQuery) {
    id
    name
    positions {
      id
      name
      status
      revenueShare
    }
  }
}
    `;

/**
 * __useCompanyPositionRevSharesQuery__
 *
 * To run a query within a React component, call `useCompanyPositionRevSharesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyPositionRevSharesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyPositionRevSharesQuery({
 *   variables: {
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function useCompanyPositionRevSharesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CompanyPositionRevSharesQuery, CompanyPositionRevSharesQueryVariables> & ({ variables: CompanyPositionRevSharesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CompanyPositionRevSharesQuery, CompanyPositionRevSharesQueryVariables>(CompanyPositionRevSharesDocument, options);
      }
export function useCompanyPositionRevSharesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CompanyPositionRevSharesQuery, CompanyPositionRevSharesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CompanyPositionRevSharesQuery, CompanyPositionRevSharesQueryVariables>(CompanyPositionRevSharesDocument, options);
        }
// @ts-ignore
export function useCompanyPositionRevSharesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CompanyPositionRevSharesQuery, CompanyPositionRevSharesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CompanyPositionRevSharesQuery, CompanyPositionRevSharesQueryVariables>;
export function useCompanyPositionRevSharesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CompanyPositionRevSharesQuery, CompanyPositionRevSharesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CompanyPositionRevSharesQuery | undefined, CompanyPositionRevSharesQueryVariables>;
export function useCompanyPositionRevSharesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CompanyPositionRevSharesQuery, CompanyPositionRevSharesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CompanyPositionRevSharesQuery, CompanyPositionRevSharesQueryVariables>(CompanyPositionRevSharesDocument, options);
        }
export type CompanyPositionRevSharesQueryHookResult = ReturnType<typeof useCompanyPositionRevSharesQuery>;
export type CompanyPositionRevSharesLazyQueryHookResult = ReturnType<typeof useCompanyPositionRevSharesLazyQuery>;
export type CompanyPositionRevSharesSuspenseQueryHookResult = ReturnType<typeof useCompanyPositionRevSharesSuspenseQuery>;
export type CompanyPositionRevSharesQueryResult = ApolloReactCommon.QueryResult<CompanyPositionRevSharesQuery, CompanyPositionRevSharesQueryVariables>;
export const UpdatePositionsRevenueShareDocument = gql`
    mutation updatePositionsRevenueShare($positionIds: [PwsID!]!, $revenueShare: Float!) {
  updatePositionsRevenueShare(
    positionIds: $positionIds
    revenueShare: $revenueShare
  )
}
    `;
export type UpdatePositionsRevenueShareMutationFn = ApolloReactCommon.MutationFunction<UpdatePositionsRevenueShareMutation, UpdatePositionsRevenueShareMutationVariables>;

/**
 * __useUpdatePositionsRevenueShareMutation__
 *
 * To run a mutation, you first call `useUpdatePositionsRevenueShareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePositionsRevenueShareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePositionsRevenueShareMutation, { data, loading, error }] = useUpdatePositionsRevenueShareMutation({
 *   variables: {
 *      positionIds: // value for 'positionIds'
 *      revenueShare: // value for 'revenueShare'
 *   },
 * });
 */
export function useUpdatePositionsRevenueShareMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePositionsRevenueShareMutation, UpdatePositionsRevenueShareMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdatePositionsRevenueShareMutation, UpdatePositionsRevenueShareMutationVariables>(UpdatePositionsRevenueShareDocument, options);
      }
export type UpdatePositionsRevenueShareMutationHookResult = ReturnType<typeof useUpdatePositionsRevenueShareMutation>;
export type UpdatePositionsRevenueShareMutationResult = ApolloReactCommon.MutationResult<UpdatePositionsRevenueShareMutation>;
export type UpdatePositionsRevenueShareMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdatePositionsRevenueShareMutation, UpdatePositionsRevenueShareMutationVariables>;
export const PublisherTimeseriesDocument = gql`
    query publisherTimeseries($endDate: DateTime!, $startDate: DateTime!, $publisherId: PwsID, $slug: String, $granularity: GraphGranularity!, $filters: [CostDetailsFilter!]) {
  publisher(id: $publisherId, slug: $slug) {
    id
    timeseries(
      granularity: $granularity
      endDate: $endDate
      startDate: $startDate
      filters: $filters
    ) {
      ...PublisherTimeseries
    }
  }
}
    ${PublisherTimeseriesFragmentDoc}`;

/**
 * __usePublisherTimeseriesQuery__
 *
 * To run a query within a React component, call `usePublisherTimeseriesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublisherTimeseriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublisherTimeseriesQuery({
 *   variables: {
 *      endDate: // value for 'endDate'
 *      startDate: // value for 'startDate'
 *      publisherId: // value for 'publisherId'
 *      slug: // value for 'slug'
 *      granularity: // value for 'granularity'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function usePublisherTimeseriesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PublisherTimeseriesQuery, PublisherTimeseriesQueryVariables> & ({ variables: PublisherTimeseriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PublisherTimeseriesQuery, PublisherTimeseriesQueryVariables>(PublisherTimeseriesDocument, options);
      }
export function usePublisherTimeseriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PublisherTimeseriesQuery, PublisherTimeseriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PublisherTimeseriesQuery, PublisherTimeseriesQueryVariables>(PublisherTimeseriesDocument, options);
        }
// @ts-ignore
export function usePublisherTimeseriesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PublisherTimeseriesQuery, PublisherTimeseriesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PublisherTimeseriesQuery, PublisherTimeseriesQueryVariables>;
export function usePublisherTimeseriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PublisherTimeseriesQuery, PublisherTimeseriesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PublisherTimeseriesQuery | undefined, PublisherTimeseriesQueryVariables>;
export function usePublisherTimeseriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PublisherTimeseriesQuery, PublisherTimeseriesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PublisherTimeseriesQuery, PublisherTimeseriesQueryVariables>(PublisherTimeseriesDocument, options);
        }
export type PublisherTimeseriesQueryHookResult = ReturnType<typeof usePublisherTimeseriesQuery>;
export type PublisherTimeseriesLazyQueryHookResult = ReturnType<typeof usePublisherTimeseriesLazyQuery>;
export type PublisherTimeseriesSuspenseQueryHookResult = ReturnType<typeof usePublisherTimeseriesSuspenseQuery>;
export type PublisherTimeseriesQueryResult = ApolloReactCommon.QueryResult<PublisherTimeseriesQuery, PublisherTimeseriesQueryVariables>;
export const PublisherPerformanceStatsDocument = gql`
    query publisherPerformanceStats($endDate: DateTime!, $startDate: DateTime!, $publisherId: PwsID, $slug: String, $filters: [CostDetailsFilter!]) {
  publisher(id: $publisherId, slug: $slug) {
    id
    performanceStats(endDate: $endDate, startDate: $startDate, filters: $filters) {
      stats {
        ...PublisherPerformanceStatsParts
      }
      advertiserResellers {
        name
        stats {
          ...PublisherPerformanceStatsParts
        }
        advertisers {
          slug
          campaigns {
            name
            stats {
              ...PublisherPerformanceStatsParts
            }
          }
        }
      }
      websites {
        id
        name
        stats {
          ...PublisherPerformanceStatsParts
        }
        positions {
          id
          name
          channelType
          status
          stats {
            ...PublisherPerformanceStatsParts
          }
        }
      }
    }
  }
}
    ${PublisherPerformanceStatsPartsFragmentDoc}`;

/**
 * __usePublisherPerformanceStatsQuery__
 *
 * To run a query within a React component, call `usePublisherPerformanceStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublisherPerformanceStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublisherPerformanceStatsQuery({
 *   variables: {
 *      endDate: // value for 'endDate'
 *      startDate: // value for 'startDate'
 *      publisherId: // value for 'publisherId'
 *      slug: // value for 'slug'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function usePublisherPerformanceStatsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PublisherPerformanceStatsQuery, PublisherPerformanceStatsQueryVariables> & ({ variables: PublisherPerformanceStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PublisherPerformanceStatsQuery, PublisherPerformanceStatsQueryVariables>(PublisherPerformanceStatsDocument, options);
      }
export function usePublisherPerformanceStatsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PublisherPerformanceStatsQuery, PublisherPerformanceStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PublisherPerformanceStatsQuery, PublisherPerformanceStatsQueryVariables>(PublisherPerformanceStatsDocument, options);
        }
// @ts-ignore
export function usePublisherPerformanceStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PublisherPerformanceStatsQuery, PublisherPerformanceStatsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PublisherPerformanceStatsQuery, PublisherPerformanceStatsQueryVariables>;
export function usePublisherPerformanceStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PublisherPerformanceStatsQuery, PublisherPerformanceStatsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PublisherPerformanceStatsQuery | undefined, PublisherPerformanceStatsQueryVariables>;
export function usePublisherPerformanceStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PublisherPerformanceStatsQuery, PublisherPerformanceStatsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PublisherPerformanceStatsQuery, PublisherPerformanceStatsQueryVariables>(PublisherPerformanceStatsDocument, options);
        }
export type PublisherPerformanceStatsQueryHookResult = ReturnType<typeof usePublisherPerformanceStatsQuery>;
export type PublisherPerformanceStatsLazyQueryHookResult = ReturnType<typeof usePublisherPerformanceStatsLazyQuery>;
export type PublisherPerformanceStatsSuspenseQueryHookResult = ReturnType<typeof usePublisherPerformanceStatsSuspenseQuery>;
export type PublisherPerformanceStatsQueryResult = ApolloReactCommon.QueryResult<PublisherPerformanceStatsQuery, PublisherPerformanceStatsQueryVariables>;
export const PublisherConfigDocument = gql`
    query publisherConfig($id: PwsID!) {
  publisher(id: $id) {
    id
    config {
      global {
        network
        formats {
          height
          width
        }
      }
      position {
        min {
          zones
        }
        max {
          zones
        }
      }
    }
  }
}
    `;

/**
 * __usePublisherConfigQuery__
 *
 * To run a query within a React component, call `usePublisherConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublisherConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublisherConfigQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePublisherConfigQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PublisherConfigQuery, PublisherConfigQueryVariables> & ({ variables: PublisherConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PublisherConfigQuery, PublisherConfigQueryVariables>(PublisherConfigDocument, options);
      }
export function usePublisherConfigLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PublisherConfigQuery, PublisherConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PublisherConfigQuery, PublisherConfigQueryVariables>(PublisherConfigDocument, options);
        }
// @ts-ignore
export function usePublisherConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PublisherConfigQuery, PublisherConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PublisherConfigQuery, PublisherConfigQueryVariables>;
export function usePublisherConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PublisherConfigQuery, PublisherConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PublisherConfigQuery | undefined, PublisherConfigQueryVariables>;
export function usePublisherConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PublisherConfigQuery, PublisherConfigQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PublisherConfigQuery, PublisherConfigQueryVariables>(PublisherConfigDocument, options);
        }
export type PublisherConfigQueryHookResult = ReturnType<typeof usePublisherConfigQuery>;
export type PublisherConfigLazyQueryHookResult = ReturnType<typeof usePublisherConfigLazyQuery>;
export type PublisherConfigSuspenseQueryHookResult = ReturnType<typeof usePublisherConfigSuspenseQuery>;
export type PublisherConfigQueryResult = ApolloReactCommon.QueryResult<PublisherConfigQuery, PublisherConfigQueryVariables>;
export const SearchPublisherInvoicesDocument = gql`
    query searchPublisherInvoices($pagination: Pagination, $searchQuery: InvoicePublisherSearchQuery!) {
  searchPublisherInvoices(pagination: $pagination, searchQuery: $searchQuery) {
    reference
    date
    period
    dueDate
    status
    publisherName
    resellerName
    amount
    tax {
      amount
      percentage
    }
    total
    paid {
      amount
      date
    }
    createdAt
    updatedAt
    publisher {
      slug
    }
  }
}
    `;

/**
 * __useSearchPublisherInvoicesQuery__
 *
 * To run a query within a React component, call `useSearchPublisherInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchPublisherInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchPublisherInvoicesQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function useSearchPublisherInvoicesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchPublisherInvoicesQuery, SearchPublisherInvoicesQueryVariables> & ({ variables: SearchPublisherInvoicesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchPublisherInvoicesQuery, SearchPublisherInvoicesQueryVariables>(SearchPublisherInvoicesDocument, options);
      }
export function useSearchPublisherInvoicesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchPublisherInvoicesQuery, SearchPublisherInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchPublisherInvoicesQuery, SearchPublisherInvoicesQueryVariables>(SearchPublisherInvoicesDocument, options);
        }
// @ts-ignore
export function useSearchPublisherInvoicesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SearchPublisherInvoicesQuery, SearchPublisherInvoicesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SearchPublisherInvoicesQuery, SearchPublisherInvoicesQueryVariables>;
export function useSearchPublisherInvoicesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchPublisherInvoicesQuery, SearchPublisherInvoicesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SearchPublisherInvoicesQuery | undefined, SearchPublisherInvoicesQueryVariables>;
export function useSearchPublisherInvoicesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchPublisherInvoicesQuery, SearchPublisherInvoicesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SearchPublisherInvoicesQuery, SearchPublisherInvoicesQueryVariables>(SearchPublisherInvoicesDocument, options);
        }
export type SearchPublisherInvoicesQueryHookResult = ReturnType<typeof useSearchPublisherInvoicesQuery>;
export type SearchPublisherInvoicesLazyQueryHookResult = ReturnType<typeof useSearchPublisherInvoicesLazyQuery>;
export type SearchPublisherInvoicesSuspenseQueryHookResult = ReturnType<typeof useSearchPublisherInvoicesSuspenseQuery>;
export type SearchPublisherInvoicesQueryResult = ApolloReactCommon.QueryResult<SearchPublisherInvoicesQuery, SearchPublisherInvoicesQueryVariables>;
export const PublisherInvoiceDocument = gql`
    query publisherInvoice($reference: InvoiceReference!) {
  publisherInvoice(reference: $reference) {
    ...PublisherInvoiceParts
  }
}
    ${PublisherInvoicePartsFragmentDoc}`;

/**
 * __usePublisherInvoiceQuery__
 *
 * To run a query within a React component, call `usePublisherInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublisherInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublisherInvoiceQuery({
 *   variables: {
 *      reference: // value for 'reference'
 *   },
 * });
 */
export function usePublisherInvoiceQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PublisherInvoiceQuery, PublisherInvoiceQueryVariables> & ({ variables: PublisherInvoiceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PublisherInvoiceQuery, PublisherInvoiceQueryVariables>(PublisherInvoiceDocument, options);
      }
export function usePublisherInvoiceLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PublisherInvoiceQuery, PublisherInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PublisherInvoiceQuery, PublisherInvoiceQueryVariables>(PublisherInvoiceDocument, options);
        }
// @ts-ignore
export function usePublisherInvoiceSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PublisherInvoiceQuery, PublisherInvoiceQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PublisherInvoiceQuery, PublisherInvoiceQueryVariables>;
export function usePublisherInvoiceSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PublisherInvoiceQuery, PublisherInvoiceQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PublisherInvoiceQuery | undefined, PublisherInvoiceQueryVariables>;
export function usePublisherInvoiceSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PublisherInvoiceQuery, PublisherInvoiceQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PublisherInvoiceQuery, PublisherInvoiceQueryVariables>(PublisherInvoiceDocument, options);
        }
export type PublisherInvoiceQueryHookResult = ReturnType<typeof usePublisherInvoiceQuery>;
export type PublisherInvoiceLazyQueryHookResult = ReturnType<typeof usePublisherInvoiceLazyQuery>;
export type PublisherInvoiceSuspenseQueryHookResult = ReturnType<typeof usePublisherInvoiceSuspenseQuery>;
export type PublisherInvoiceQueryResult = ApolloReactCommon.QueryResult<PublisherInvoiceQuery, PublisherInvoiceQueryVariables>;
export const PublisherPopulationStatsDocument = gql`
    query publisherPopulationStats($slug: String!) {
  publisher(slug: $slug) {
    population {
      ...PublisherPopulation
    }
  }
}
    ${PublisherPopulationFragmentDoc}`;

/**
 * __usePublisherPopulationStatsQuery__
 *
 * To run a query within a React component, call `usePublisherPopulationStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublisherPopulationStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublisherPopulationStatsQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function usePublisherPopulationStatsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PublisherPopulationStatsQuery, PublisherPopulationStatsQueryVariables> & ({ variables: PublisherPopulationStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PublisherPopulationStatsQuery, PublisherPopulationStatsQueryVariables>(PublisherPopulationStatsDocument, options);
      }
export function usePublisherPopulationStatsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PublisherPopulationStatsQuery, PublisherPopulationStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PublisherPopulationStatsQuery, PublisherPopulationStatsQueryVariables>(PublisherPopulationStatsDocument, options);
        }
// @ts-ignore
export function usePublisherPopulationStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PublisherPopulationStatsQuery, PublisherPopulationStatsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PublisherPopulationStatsQuery, PublisherPopulationStatsQueryVariables>;
export function usePublisherPopulationStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PublisherPopulationStatsQuery, PublisherPopulationStatsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PublisherPopulationStatsQuery | undefined, PublisherPopulationStatsQueryVariables>;
export function usePublisherPopulationStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PublisherPopulationStatsQuery, PublisherPopulationStatsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PublisherPopulationStatsQuery, PublisherPopulationStatsQueryVariables>(PublisherPopulationStatsDocument, options);
        }
export type PublisherPopulationStatsQueryHookResult = ReturnType<typeof usePublisherPopulationStatsQuery>;
export type PublisherPopulationStatsLazyQueryHookResult = ReturnType<typeof usePublisherPopulationStatsLazyQuery>;
export type PublisherPopulationStatsSuspenseQueryHookResult = ReturnType<typeof usePublisherPopulationStatsSuspenseQuery>;
export type PublisherPopulationStatsQueryResult = ApolloReactCommon.QueryResult<PublisherPopulationStatsQuery, PublisherPopulationStatsQueryVariables>;
export const CreatePublisherInvoicesDocument = gql`
    mutation createPublisherInvoices($year: Int!, $month: Int!, $minAmount: Int!) {
  createPublisherInvoices(year: $year, month: $month, minAmount: $minAmount)
}
    `;
export type CreatePublisherInvoicesMutationFn = ApolloReactCommon.MutationFunction<CreatePublisherInvoicesMutation, CreatePublisherInvoicesMutationVariables>;

/**
 * __useCreatePublisherInvoicesMutation__
 *
 * To run a mutation, you first call `useCreatePublisherInvoicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePublisherInvoicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPublisherInvoicesMutation, { data, loading, error }] = useCreatePublisherInvoicesMutation({
 *   variables: {
 *      year: // value for 'year'
 *      month: // value for 'month'
 *      minAmount: // value for 'minAmount'
 *   },
 * });
 */
export function useCreatePublisherInvoicesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreatePublisherInvoicesMutation, CreatePublisherInvoicesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreatePublisherInvoicesMutation, CreatePublisherInvoicesMutationVariables>(CreatePublisherInvoicesDocument, options);
      }
export type CreatePublisherInvoicesMutationHookResult = ReturnType<typeof useCreatePublisherInvoicesMutation>;
export type CreatePublisherInvoicesMutationResult = ApolloReactCommon.MutationResult<CreatePublisherInvoicesMutation>;
export type CreatePublisherInvoicesMutationOptions = ApolloReactCommon.BaseMutationOptions<CreatePublisherInvoicesMutation, CreatePublisherInvoicesMutationVariables>;
export const UpdatePublisherInvoiceDocument = gql`
    mutation updatePublisherInvoice($reference: String!, $comment: String, $adjustments: [InvoiceAdjustmentItemInput!]!) {
  updatePublisherInvoice(
    reference: $reference
    comment: $comment
    adjustments: $adjustments
  ) {
    ...PublisherInvoiceParts
  }
}
    ${PublisherInvoicePartsFragmentDoc}`;
export type UpdatePublisherInvoiceMutationFn = ApolloReactCommon.MutationFunction<UpdatePublisherInvoiceMutation, UpdatePublisherInvoiceMutationVariables>;

/**
 * __useUpdatePublisherInvoiceMutation__
 *
 * To run a mutation, you first call `useUpdatePublisherInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePublisherInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePublisherInvoiceMutation, { data, loading, error }] = useUpdatePublisherInvoiceMutation({
 *   variables: {
 *      reference: // value for 'reference'
 *      comment: // value for 'comment'
 *      adjustments: // value for 'adjustments'
 *   },
 * });
 */
export function useUpdatePublisherInvoiceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePublisherInvoiceMutation, UpdatePublisherInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdatePublisherInvoiceMutation, UpdatePublisherInvoiceMutationVariables>(UpdatePublisherInvoiceDocument, options);
      }
export type UpdatePublisherInvoiceMutationHookResult = ReturnType<typeof useUpdatePublisherInvoiceMutation>;
export type UpdatePublisherInvoiceMutationResult = ApolloReactCommon.MutationResult<UpdatePublisherInvoiceMutation>;
export type UpdatePublisherInvoiceMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdatePublisherInvoiceMutation, UpdatePublisherInvoiceMutationVariables>;
export const ValidatePublisherInvoiceDocument = gql`
    mutation validatePublisherInvoice($reference: String!) {
  validatePublisherInvoice(reference: $reference)
}
    `;
export type ValidatePublisherInvoiceMutationFn = ApolloReactCommon.MutationFunction<ValidatePublisherInvoiceMutation, ValidatePublisherInvoiceMutationVariables>;

/**
 * __useValidatePublisherInvoiceMutation__
 *
 * To run a mutation, you first call `useValidatePublisherInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidatePublisherInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validatePublisherInvoiceMutation, { data, loading, error }] = useValidatePublisherInvoiceMutation({
 *   variables: {
 *      reference: // value for 'reference'
 *   },
 * });
 */
export function useValidatePublisherInvoiceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ValidatePublisherInvoiceMutation, ValidatePublisherInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ValidatePublisherInvoiceMutation, ValidatePublisherInvoiceMutationVariables>(ValidatePublisherInvoiceDocument, options);
      }
export type ValidatePublisherInvoiceMutationHookResult = ReturnType<typeof useValidatePublisherInvoiceMutation>;
export type ValidatePublisherInvoiceMutationResult = ApolloReactCommon.MutationResult<ValidatePublisherInvoiceMutation>;
export type ValidatePublisherInvoiceMutationOptions = ApolloReactCommon.BaseMutationOptions<ValidatePublisherInvoiceMutation, ValidatePublisherInvoiceMutationVariables>;
export const PaidPublisherInvoiceDocument = gql`
    mutation paidPublisherInvoice($reference: String!, $date: DateTime!, $amount: Float!) {
  paidPublisherInvoice(reference: $reference, date: $date, amount: $amount)
}
    `;
export type PaidPublisherInvoiceMutationFn = ApolloReactCommon.MutationFunction<PaidPublisherInvoiceMutation, PaidPublisherInvoiceMutationVariables>;

/**
 * __usePaidPublisherInvoiceMutation__
 *
 * To run a mutation, you first call `usePaidPublisherInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaidPublisherInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paidPublisherInvoiceMutation, { data, loading, error }] = usePaidPublisherInvoiceMutation({
 *   variables: {
 *      reference: // value for 'reference'
 *      date: // value for 'date'
 *      amount: // value for 'amount'
 *   },
 * });
 */
export function usePaidPublisherInvoiceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PaidPublisherInvoiceMutation, PaidPublisherInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PaidPublisherInvoiceMutation, PaidPublisherInvoiceMutationVariables>(PaidPublisherInvoiceDocument, options);
      }
export type PaidPublisherInvoiceMutationHookResult = ReturnType<typeof usePaidPublisherInvoiceMutation>;
export type PaidPublisherInvoiceMutationResult = ApolloReactCommon.MutationResult<PaidPublisherInvoiceMutation>;
export type PaidPublisherInvoiceMutationOptions = ApolloReactCommon.BaseMutationOptions<PaidPublisherInvoiceMutation, PaidPublisherInvoiceMutationVariables>;
export const PublisherBlacklistsDocument = gql`
    query publisherBlacklists($slug: String!) {
  publisher(slug: $slug) {
    id
    advertiserExclusions {
      ...AdvertiserExclusionItemParts
    }
    campaignExclusions {
      ...CampaignExclusionItemParts
    }
    iabExclusions {
      ...IabExclusionItemParts
    }
    domainExclusions {
      ...DomainExclusionItemParts
    }
  }
}
    ${AdvertiserExclusionItemPartsFragmentDoc}
${CampaignExclusionItemPartsFragmentDoc}
${IabExclusionItemPartsFragmentDoc}
${DomainExclusionItemPartsFragmentDoc}`;

/**
 * __usePublisherBlacklistsQuery__
 *
 * To run a query within a React component, call `usePublisherBlacklistsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublisherBlacklistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublisherBlacklistsQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function usePublisherBlacklistsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PublisherBlacklistsQuery, PublisherBlacklistsQueryVariables> & ({ variables: PublisherBlacklistsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PublisherBlacklistsQuery, PublisherBlacklistsQueryVariables>(PublisherBlacklistsDocument, options);
      }
export function usePublisherBlacklistsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PublisherBlacklistsQuery, PublisherBlacklistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PublisherBlacklistsQuery, PublisherBlacklistsQueryVariables>(PublisherBlacklistsDocument, options);
        }
// @ts-ignore
export function usePublisherBlacklistsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PublisherBlacklistsQuery, PublisherBlacklistsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PublisherBlacklistsQuery, PublisherBlacklistsQueryVariables>;
export function usePublisherBlacklistsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PublisherBlacklistsQuery, PublisherBlacklistsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PublisherBlacklistsQuery | undefined, PublisherBlacklistsQueryVariables>;
export function usePublisherBlacklistsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PublisherBlacklistsQuery, PublisherBlacklistsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PublisherBlacklistsQuery, PublisherBlacklistsQueryVariables>(PublisherBlacklistsDocument, options);
        }
export type PublisherBlacklistsQueryHookResult = ReturnType<typeof usePublisherBlacklistsQuery>;
export type PublisherBlacklistsLazyQueryHookResult = ReturnType<typeof usePublisherBlacklistsLazyQuery>;
export type PublisherBlacklistsSuspenseQueryHookResult = ReturnType<typeof usePublisherBlacklistsSuspenseQuery>;
export type PublisherBlacklistsQueryResult = ApolloReactCommon.QueryResult<PublisherBlacklistsQuery, PublisherBlacklistsQueryVariables>;
export const PublisherParentBlacklistsDocument = gql`
    query publisherParentBlacklists($slug: String!) {
  publisher(slug: $slug) {
    reseller {
      advertiserExclusions {
        ...AdvertiserExclusionItemParts
      }
      campaignExclusions {
        ...CampaignExclusionItemParts
      }
      iabExclusions {
        ...IabExclusionItemParts
      }
      domainExclusions {
        ...DomainExclusionItemParts
      }
    }
  }
}
    ${AdvertiserExclusionItemPartsFragmentDoc}
${CampaignExclusionItemPartsFragmentDoc}
${IabExclusionItemPartsFragmentDoc}
${DomainExclusionItemPartsFragmentDoc}`;

/**
 * __usePublisherParentBlacklistsQuery__
 *
 * To run a query within a React component, call `usePublisherParentBlacklistsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublisherParentBlacklistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublisherParentBlacklistsQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function usePublisherParentBlacklistsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PublisherParentBlacklistsQuery, PublisherParentBlacklistsQueryVariables> & ({ variables: PublisherParentBlacklistsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PublisherParentBlacklistsQuery, PublisherParentBlacklistsQueryVariables>(PublisherParentBlacklistsDocument, options);
      }
export function usePublisherParentBlacklistsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PublisherParentBlacklistsQuery, PublisherParentBlacklistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PublisherParentBlacklistsQuery, PublisherParentBlacklistsQueryVariables>(PublisherParentBlacklistsDocument, options);
        }
// @ts-ignore
export function usePublisherParentBlacklistsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PublisherParentBlacklistsQuery, PublisherParentBlacklistsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PublisherParentBlacklistsQuery, PublisherParentBlacklistsQueryVariables>;
export function usePublisherParentBlacklistsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PublisherParentBlacklistsQuery, PublisherParentBlacklistsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PublisherParentBlacklistsQuery | undefined, PublisherParentBlacklistsQueryVariables>;
export function usePublisherParentBlacklistsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PublisherParentBlacklistsQuery, PublisherParentBlacklistsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PublisherParentBlacklistsQuery, PublisherParentBlacklistsQueryVariables>(PublisherParentBlacklistsDocument, options);
        }
export type PublisherParentBlacklistsQueryHookResult = ReturnType<typeof usePublisherParentBlacklistsQuery>;
export type PublisherParentBlacklistsLazyQueryHookResult = ReturnType<typeof usePublisherParentBlacklistsLazyQuery>;
export type PublisherParentBlacklistsSuspenseQueryHookResult = ReturnType<typeof usePublisherParentBlacklistsSuspenseQuery>;
export type PublisherParentBlacklistsQueryResult = ApolloReactCommon.QueryResult<PublisherParentBlacklistsQuery, PublisherParentBlacklistsQueryVariables>;
export const UpdatePublisherAdvertiserExclusionsDocument = gql`
    mutation updatePublisherAdvertiserExclusions($publisherId: PwsID!, $advertiserExclusions: [PwsID!]!) {
  updatePublisherAdvertiserExclusions(
    publisherId: $publisherId
    advertiserExclusions: $advertiserExclusions
  )
}
    `;
export type UpdatePublisherAdvertiserExclusionsMutationFn = ApolloReactCommon.MutationFunction<UpdatePublisherAdvertiserExclusionsMutation, UpdatePublisherAdvertiserExclusionsMutationVariables>;

/**
 * __useUpdatePublisherAdvertiserExclusionsMutation__
 *
 * To run a mutation, you first call `useUpdatePublisherAdvertiserExclusionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePublisherAdvertiserExclusionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePublisherAdvertiserExclusionsMutation, { data, loading, error }] = useUpdatePublisherAdvertiserExclusionsMutation({
 *   variables: {
 *      publisherId: // value for 'publisherId'
 *      advertiserExclusions: // value for 'advertiserExclusions'
 *   },
 * });
 */
export function useUpdatePublisherAdvertiserExclusionsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePublisherAdvertiserExclusionsMutation, UpdatePublisherAdvertiserExclusionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdatePublisherAdvertiserExclusionsMutation, UpdatePublisherAdvertiserExclusionsMutationVariables>(UpdatePublisherAdvertiserExclusionsDocument, options);
      }
export type UpdatePublisherAdvertiserExclusionsMutationHookResult = ReturnType<typeof useUpdatePublisherAdvertiserExclusionsMutation>;
export type UpdatePublisherAdvertiserExclusionsMutationResult = ApolloReactCommon.MutationResult<UpdatePublisherAdvertiserExclusionsMutation>;
export type UpdatePublisherAdvertiserExclusionsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdatePublisherAdvertiserExclusionsMutation, UpdatePublisherAdvertiserExclusionsMutationVariables>;
export const UpdatePublisherCampaignExclusionsDocument = gql`
    mutation updatePublisherCampaignExclusions($publisherId: PwsID!, $campaignExclusions: [PwsID!]!) {
  updatePublisherCampaignExclusions(
    publisherId: $publisherId
    campaignExclusions: $campaignExclusions
  )
}
    `;
export type UpdatePublisherCampaignExclusionsMutationFn = ApolloReactCommon.MutationFunction<UpdatePublisherCampaignExclusionsMutation, UpdatePublisherCampaignExclusionsMutationVariables>;

/**
 * __useUpdatePublisherCampaignExclusionsMutation__
 *
 * To run a mutation, you first call `useUpdatePublisherCampaignExclusionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePublisherCampaignExclusionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePublisherCampaignExclusionsMutation, { data, loading, error }] = useUpdatePublisherCampaignExclusionsMutation({
 *   variables: {
 *      publisherId: // value for 'publisherId'
 *      campaignExclusions: // value for 'campaignExclusions'
 *   },
 * });
 */
export function useUpdatePublisherCampaignExclusionsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePublisherCampaignExclusionsMutation, UpdatePublisherCampaignExclusionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdatePublisherCampaignExclusionsMutation, UpdatePublisherCampaignExclusionsMutationVariables>(UpdatePublisherCampaignExclusionsDocument, options);
      }
export type UpdatePublisherCampaignExclusionsMutationHookResult = ReturnType<typeof useUpdatePublisherCampaignExclusionsMutation>;
export type UpdatePublisherCampaignExclusionsMutationResult = ApolloReactCommon.MutationResult<UpdatePublisherCampaignExclusionsMutation>;
export type UpdatePublisherCampaignExclusionsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdatePublisherCampaignExclusionsMutation, UpdatePublisherCampaignExclusionsMutationVariables>;
export const UpdatePublisherIabExclusionsDocument = gql`
    mutation updatePublisherIabExclusions($publisherId: PwsID!, $iabExclusions: [IAB!]!) {
  updatePublisherIabExclusions(
    publisherId: $publisherId
    iabExclusions: $iabExclusions
  )
}
    `;
export type UpdatePublisherIabExclusionsMutationFn = ApolloReactCommon.MutationFunction<UpdatePublisherIabExclusionsMutation, UpdatePublisherIabExclusionsMutationVariables>;

/**
 * __useUpdatePublisherIabExclusionsMutation__
 *
 * To run a mutation, you first call `useUpdatePublisherIabExclusionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePublisherIabExclusionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePublisherIabExclusionsMutation, { data, loading, error }] = useUpdatePublisherIabExclusionsMutation({
 *   variables: {
 *      publisherId: // value for 'publisherId'
 *      iabExclusions: // value for 'iabExclusions'
 *   },
 * });
 */
export function useUpdatePublisherIabExclusionsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePublisherIabExclusionsMutation, UpdatePublisherIabExclusionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdatePublisherIabExclusionsMutation, UpdatePublisherIabExclusionsMutationVariables>(UpdatePublisherIabExclusionsDocument, options);
      }
export type UpdatePublisherIabExclusionsMutationHookResult = ReturnType<typeof useUpdatePublisherIabExclusionsMutation>;
export type UpdatePublisherIabExclusionsMutationResult = ApolloReactCommon.MutationResult<UpdatePublisherIabExclusionsMutation>;
export type UpdatePublisherIabExclusionsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdatePublisherIabExclusionsMutation, UpdatePublisherIabExclusionsMutationVariables>;
export const UpdatePublisherDomainExclusionsDocument = gql`
    mutation updatePublisherDomainExclusions($publisherId: PwsID!, $domainExclusions: [LimitedString!]!) {
  updatePublisherDomainExclusions(
    publisherId: $publisherId
    domainExclusions: $domainExclusions
  )
}
    `;
export type UpdatePublisherDomainExclusionsMutationFn = ApolloReactCommon.MutationFunction<UpdatePublisherDomainExclusionsMutation, UpdatePublisherDomainExclusionsMutationVariables>;

/**
 * __useUpdatePublisherDomainExclusionsMutation__
 *
 * To run a mutation, you first call `useUpdatePublisherDomainExclusionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePublisherDomainExclusionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePublisherDomainExclusionsMutation, { data, loading, error }] = useUpdatePublisherDomainExclusionsMutation({
 *   variables: {
 *      publisherId: // value for 'publisherId'
 *      domainExclusions: // value for 'domainExclusions'
 *   },
 * });
 */
export function useUpdatePublisherDomainExclusionsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePublisherDomainExclusionsMutation, UpdatePublisherDomainExclusionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdatePublisherDomainExclusionsMutation, UpdatePublisherDomainExclusionsMutationVariables>(UpdatePublisherDomainExclusionsDocument, options);
      }
export type UpdatePublisherDomainExclusionsMutationHookResult = ReturnType<typeof useUpdatePublisherDomainExclusionsMutation>;
export type UpdatePublisherDomainExclusionsMutationResult = ApolloReactCommon.MutationResult<UpdatePublisherDomainExclusionsMutation>;
export type UpdatePublisherDomainExclusionsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdatePublisherDomainExclusionsMutation, UpdatePublisherDomainExclusionsMutationVariables>;
export const PublisherManagersDocument = gql`
    query publisherManagers($id: PwsID!) {
  publisher(id: $id) {
    id
    accountManagerId
    salesManagerId
  }
}
    `;

/**
 * __usePublisherManagersQuery__
 *
 * To run a query within a React component, call `usePublisherManagersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublisherManagersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublisherManagersQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePublisherManagersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PublisherManagersQuery, PublisherManagersQueryVariables> & ({ variables: PublisherManagersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PublisherManagersQuery, PublisherManagersQueryVariables>(PublisherManagersDocument, options);
      }
export function usePublisherManagersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PublisherManagersQuery, PublisherManagersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PublisherManagersQuery, PublisherManagersQueryVariables>(PublisherManagersDocument, options);
        }
// @ts-ignore
export function usePublisherManagersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PublisherManagersQuery, PublisherManagersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PublisherManagersQuery, PublisherManagersQueryVariables>;
export function usePublisherManagersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PublisherManagersQuery, PublisherManagersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PublisherManagersQuery | undefined, PublisherManagersQueryVariables>;
export function usePublisherManagersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PublisherManagersQuery, PublisherManagersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PublisherManagersQuery, PublisherManagersQueryVariables>(PublisherManagersDocument, options);
        }
export type PublisherManagersQueryHookResult = ReturnType<typeof usePublisherManagersQuery>;
export type PublisherManagersLazyQueryHookResult = ReturnType<typeof usePublisherManagersLazyQuery>;
export type PublisherManagersSuspenseQueryHookResult = ReturnType<typeof usePublisherManagersSuspenseQuery>;
export type PublisherManagersQueryResult = ApolloReactCommon.QueryResult<PublisherManagersQuery, PublisherManagersQueryVariables>;
export const UpdatePublisherSettingsDocument = gql`
    mutation updatePublisherSettings($publisherId: PwsID!, $settings: PublisherSettingsInput!) {
  updatePublisherSettings(publisherId: $publisherId, settings: $settings) {
    accountManagerId
    salesManagerId
  }
}
    `;
export type UpdatePublisherSettingsMutationFn = ApolloReactCommon.MutationFunction<UpdatePublisherSettingsMutation, UpdatePublisherSettingsMutationVariables>;

/**
 * __useUpdatePublisherSettingsMutation__
 *
 * To run a mutation, you first call `useUpdatePublisherSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePublisherSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePublisherSettingsMutation, { data, loading, error }] = useUpdatePublisherSettingsMutation({
 *   variables: {
 *      publisherId: // value for 'publisherId'
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useUpdatePublisherSettingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePublisherSettingsMutation, UpdatePublisherSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdatePublisherSettingsMutation, UpdatePublisherSettingsMutationVariables>(UpdatePublisherSettingsDocument, options);
      }
export type UpdatePublisherSettingsMutationHookResult = ReturnType<typeof useUpdatePublisherSettingsMutation>;
export type UpdatePublisherSettingsMutationResult = ApolloReactCommon.MutationResult<UpdatePublisherSettingsMutation>;
export type UpdatePublisherSettingsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdatePublisherSettingsMutation, UpdatePublisherSettingsMutationVariables>;
export const ResellerExclusionPresetsDocument = gql`
    query resellerExclusionPresets($slug: String!) {
  reseller(slug: $slug) {
    id
    name
    assignedExclusionPresets {
      ...ExclusionPresetSummary
    }
    availableExclusionPresets {
      ...ExclusionPresetAvailableSummary
    }
    exclusionPresets {
      ...ExclusionPresetSummary
    }
  }
}
    ${ExclusionPresetSummaryFragmentDoc}
${ExclusionPresetAvailableSummaryFragmentDoc}`;

/**
 * __useResellerExclusionPresetsQuery__
 *
 * To run a query within a React component, call `useResellerExclusionPresetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useResellerExclusionPresetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResellerExclusionPresetsQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useResellerExclusionPresetsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ResellerExclusionPresetsQuery, ResellerExclusionPresetsQueryVariables> & ({ variables: ResellerExclusionPresetsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ResellerExclusionPresetsQuery, ResellerExclusionPresetsQueryVariables>(ResellerExclusionPresetsDocument, options);
      }
export function useResellerExclusionPresetsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ResellerExclusionPresetsQuery, ResellerExclusionPresetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ResellerExclusionPresetsQuery, ResellerExclusionPresetsQueryVariables>(ResellerExclusionPresetsDocument, options);
        }
// @ts-ignore
export function useResellerExclusionPresetsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ResellerExclusionPresetsQuery, ResellerExclusionPresetsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ResellerExclusionPresetsQuery, ResellerExclusionPresetsQueryVariables>;
export function useResellerExclusionPresetsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ResellerExclusionPresetsQuery, ResellerExclusionPresetsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ResellerExclusionPresetsQuery | undefined, ResellerExclusionPresetsQueryVariables>;
export function useResellerExclusionPresetsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ResellerExclusionPresetsQuery, ResellerExclusionPresetsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ResellerExclusionPresetsQuery, ResellerExclusionPresetsQueryVariables>(ResellerExclusionPresetsDocument, options);
        }
export type ResellerExclusionPresetsQueryHookResult = ReturnType<typeof useResellerExclusionPresetsQuery>;
export type ResellerExclusionPresetsLazyQueryHookResult = ReturnType<typeof useResellerExclusionPresetsLazyQuery>;
export type ResellerExclusionPresetsSuspenseQueryHookResult = ReturnType<typeof useResellerExclusionPresetsSuspenseQuery>;
export type ResellerExclusionPresetsQueryResult = ApolloReactCommon.QueryResult<ResellerExclusionPresetsQuery, ResellerExclusionPresetsQueryVariables>;
export const PublisherExclusionPresetsDocument = gql`
    query publisherExclusionPresets($slug: String!) {
  publisher(slug: $slug) {
    id
    name
    assignedExclusionPresets {
      ...ExclusionPresetSummary
    }
    availableExclusionPresets {
      ...ExclusionPresetAvailableSummary
    }
    exclusionPresets {
      ...ExclusionPresetSummary
    }
    reseller {
      id
      name
      assignedExclusionPresets {
        ...ExclusionPresetSummary
      }
    }
  }
}
    ${ExclusionPresetSummaryFragmentDoc}
${ExclusionPresetAvailableSummaryFragmentDoc}`;

/**
 * __usePublisherExclusionPresetsQuery__
 *
 * To run a query within a React component, call `usePublisherExclusionPresetsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublisherExclusionPresetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublisherExclusionPresetsQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function usePublisherExclusionPresetsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PublisherExclusionPresetsQuery, PublisherExclusionPresetsQueryVariables> & ({ variables: PublisherExclusionPresetsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PublisherExclusionPresetsQuery, PublisherExclusionPresetsQueryVariables>(PublisherExclusionPresetsDocument, options);
      }
export function usePublisherExclusionPresetsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PublisherExclusionPresetsQuery, PublisherExclusionPresetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PublisherExclusionPresetsQuery, PublisherExclusionPresetsQueryVariables>(PublisherExclusionPresetsDocument, options);
        }
// @ts-ignore
export function usePublisherExclusionPresetsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PublisherExclusionPresetsQuery, PublisherExclusionPresetsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PublisherExclusionPresetsQuery, PublisherExclusionPresetsQueryVariables>;
export function usePublisherExclusionPresetsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PublisherExclusionPresetsQuery, PublisherExclusionPresetsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PublisherExclusionPresetsQuery | undefined, PublisherExclusionPresetsQueryVariables>;
export function usePublisherExclusionPresetsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PublisherExclusionPresetsQuery, PublisherExclusionPresetsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PublisherExclusionPresetsQuery, PublisherExclusionPresetsQueryVariables>(PublisherExclusionPresetsDocument, options);
        }
export type PublisherExclusionPresetsQueryHookResult = ReturnType<typeof usePublisherExclusionPresetsQuery>;
export type PublisherExclusionPresetsLazyQueryHookResult = ReturnType<typeof usePublisherExclusionPresetsLazyQuery>;
export type PublisherExclusionPresetsSuspenseQueryHookResult = ReturnType<typeof usePublisherExclusionPresetsSuspenseQuery>;
export type PublisherExclusionPresetsQueryResult = ApolloReactCommon.QueryResult<PublisherExclusionPresetsQuery, PublisherExclusionPresetsQueryVariables>;
export const WebsiteExclusionPresetsDocument = gql`
    query websiteExclusionPresets($id: PwsID!) {
  website(id: $id) {
    id
    assignedExclusionPresets {
      ...ExclusionPresetSummary
    }
    publisher {
      id
      name
      assignedExclusionPresets {
        ...ExclusionPresetSummary
      }
      availableExclusionPresets {
        ...ExclusionPresetAvailableSummary
      }
      reseller {
        id
        name
        assignedExclusionPresets {
          ...ExclusionPresetSummary
        }
      }
    }
  }
}
    ${ExclusionPresetSummaryFragmentDoc}
${ExclusionPresetAvailableSummaryFragmentDoc}`;

/**
 * __useWebsiteExclusionPresetsQuery__
 *
 * To run a query within a React component, call `useWebsiteExclusionPresetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebsiteExclusionPresetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebsiteExclusionPresetsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWebsiteExclusionPresetsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<WebsiteExclusionPresetsQuery, WebsiteExclusionPresetsQueryVariables> & ({ variables: WebsiteExclusionPresetsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WebsiteExclusionPresetsQuery, WebsiteExclusionPresetsQueryVariables>(WebsiteExclusionPresetsDocument, options);
      }
export function useWebsiteExclusionPresetsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WebsiteExclusionPresetsQuery, WebsiteExclusionPresetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WebsiteExclusionPresetsQuery, WebsiteExclusionPresetsQueryVariables>(WebsiteExclusionPresetsDocument, options);
        }
// @ts-ignore
export function useWebsiteExclusionPresetsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<WebsiteExclusionPresetsQuery, WebsiteExclusionPresetsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WebsiteExclusionPresetsQuery, WebsiteExclusionPresetsQueryVariables>;
export function useWebsiteExclusionPresetsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WebsiteExclusionPresetsQuery, WebsiteExclusionPresetsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WebsiteExclusionPresetsQuery | undefined, WebsiteExclusionPresetsQueryVariables>;
export function useWebsiteExclusionPresetsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WebsiteExclusionPresetsQuery, WebsiteExclusionPresetsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<WebsiteExclusionPresetsQuery, WebsiteExclusionPresetsQueryVariables>(WebsiteExclusionPresetsDocument, options);
        }
export type WebsiteExclusionPresetsQueryHookResult = ReturnType<typeof useWebsiteExclusionPresetsQuery>;
export type WebsiteExclusionPresetsLazyQueryHookResult = ReturnType<typeof useWebsiteExclusionPresetsLazyQuery>;
export type WebsiteExclusionPresetsSuspenseQueryHookResult = ReturnType<typeof useWebsiteExclusionPresetsSuspenseQuery>;
export type WebsiteExclusionPresetsQueryResult = ApolloReactCommon.QueryResult<WebsiteExclusionPresetsQuery, WebsiteExclusionPresetsQueryVariables>;
export const PublisherExclusionPresetDocument = gql`
    query publisherExclusionPreset($id: PwsID!) {
  publisherExclusionPreset(id: $id) {
    ...ExclusionPresetWithExclusions
  }
}
    ${ExclusionPresetWithExclusionsFragmentDoc}`;

/**
 * __usePublisherExclusionPresetQuery__
 *
 * To run a query within a React component, call `usePublisherExclusionPresetQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublisherExclusionPresetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublisherExclusionPresetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePublisherExclusionPresetQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PublisherExclusionPresetQuery, PublisherExclusionPresetQueryVariables> & ({ variables: PublisherExclusionPresetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PublisherExclusionPresetQuery, PublisherExclusionPresetQueryVariables>(PublisherExclusionPresetDocument, options);
      }
export function usePublisherExclusionPresetLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PublisherExclusionPresetQuery, PublisherExclusionPresetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PublisherExclusionPresetQuery, PublisherExclusionPresetQueryVariables>(PublisherExclusionPresetDocument, options);
        }
// @ts-ignore
export function usePublisherExclusionPresetSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PublisherExclusionPresetQuery, PublisherExclusionPresetQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PublisherExclusionPresetQuery, PublisherExclusionPresetQueryVariables>;
export function usePublisherExclusionPresetSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PublisherExclusionPresetQuery, PublisherExclusionPresetQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PublisherExclusionPresetQuery | undefined, PublisherExclusionPresetQueryVariables>;
export function usePublisherExclusionPresetSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PublisherExclusionPresetQuery, PublisherExclusionPresetQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PublisherExclusionPresetQuery, PublisherExclusionPresetQueryVariables>(PublisherExclusionPresetDocument, options);
        }
export type PublisherExclusionPresetQueryHookResult = ReturnType<typeof usePublisherExclusionPresetQuery>;
export type PublisherExclusionPresetLazyQueryHookResult = ReturnType<typeof usePublisherExclusionPresetLazyQuery>;
export type PublisherExclusionPresetSuspenseQueryHookResult = ReturnType<typeof usePublisherExclusionPresetSuspenseQuery>;
export type PublisherExclusionPresetQueryResult = ApolloReactCommon.QueryResult<PublisherExclusionPresetQuery, PublisherExclusionPresetQueryVariables>;
export const CreatePublisherExclusionPresetDocument = gql`
    mutation createPublisherExclusionPreset($name: String!, $companyId: PwsID!, $description: String) {
  createPublisherExclusionPreset(
    name: $name
    companyId: $companyId
    description: $description
  ) {
    ...ExclusionPresetSummary
  }
}
    ${ExclusionPresetSummaryFragmentDoc}`;
export type CreatePublisherExclusionPresetMutationFn = ApolloReactCommon.MutationFunction<CreatePublisherExclusionPresetMutation, CreatePublisherExclusionPresetMutationVariables>;

/**
 * __useCreatePublisherExclusionPresetMutation__
 *
 * To run a mutation, you first call `useCreatePublisherExclusionPresetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePublisherExclusionPresetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPublisherExclusionPresetMutation, { data, loading, error }] = useCreatePublisherExclusionPresetMutation({
 *   variables: {
 *      name: // value for 'name'
 *      companyId: // value for 'companyId'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useCreatePublisherExclusionPresetMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreatePublisherExclusionPresetMutation, CreatePublisherExclusionPresetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreatePublisherExclusionPresetMutation, CreatePublisherExclusionPresetMutationVariables>(CreatePublisherExclusionPresetDocument, options);
      }
export type CreatePublisherExclusionPresetMutationHookResult = ReturnType<typeof useCreatePublisherExclusionPresetMutation>;
export type CreatePublisherExclusionPresetMutationResult = ApolloReactCommon.MutationResult<CreatePublisherExclusionPresetMutation>;
export type CreatePublisherExclusionPresetMutationOptions = ApolloReactCommon.BaseMutationOptions<CreatePublisherExclusionPresetMutation, CreatePublisherExclusionPresetMutationVariables>;
export const UpdatePublisherExclusionPresetDocument = gql`
    mutation updatePublisherExclusionPreset($id: PwsID!, $name: String!, $description: String, $excludedCompanyIds: [PwsID!]!, $excludedCampaignIds: [PwsID!]!, $excludedIABCategories: [IAB!]!) {
  updatePublisherExclusionPreset(
    id: $id
    name: $name
    description: $description
    excludedCompanyIds: $excludedCompanyIds
    excludedCampaignIds: $excludedCampaignIds
    excludedIABCategories: $excludedIABCategories
  ) {
    ...ExclusionPresetSummary
  }
}
    ${ExclusionPresetSummaryFragmentDoc}`;
export type UpdatePublisherExclusionPresetMutationFn = ApolloReactCommon.MutationFunction<UpdatePublisherExclusionPresetMutation, UpdatePublisherExclusionPresetMutationVariables>;

/**
 * __useUpdatePublisherExclusionPresetMutation__
 *
 * To run a mutation, you first call `useUpdatePublisherExclusionPresetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePublisherExclusionPresetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePublisherExclusionPresetMutation, { data, loading, error }] = useUpdatePublisherExclusionPresetMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      excludedCompanyIds: // value for 'excludedCompanyIds'
 *      excludedCampaignIds: // value for 'excludedCampaignIds'
 *      excludedIABCategories: // value for 'excludedIABCategories'
 *   },
 * });
 */
export function useUpdatePublisherExclusionPresetMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePublisherExclusionPresetMutation, UpdatePublisherExclusionPresetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdatePublisherExclusionPresetMutation, UpdatePublisherExclusionPresetMutationVariables>(UpdatePublisherExclusionPresetDocument, options);
      }
export type UpdatePublisherExclusionPresetMutationHookResult = ReturnType<typeof useUpdatePublisherExclusionPresetMutation>;
export type UpdatePublisherExclusionPresetMutationResult = ApolloReactCommon.MutationResult<UpdatePublisherExclusionPresetMutation>;
export type UpdatePublisherExclusionPresetMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdatePublisherExclusionPresetMutation, UpdatePublisherExclusionPresetMutationVariables>;
export const DeletePublisherExclusionPresetDocument = gql`
    mutation deletePublisherExclusionPreset($id: PwsID!) {
  deletePublisherExclusionPreset(id: $id)
}
    `;
export type DeletePublisherExclusionPresetMutationFn = ApolloReactCommon.MutationFunction<DeletePublisherExclusionPresetMutation, DeletePublisherExclusionPresetMutationVariables>;

/**
 * __useDeletePublisherExclusionPresetMutation__
 *
 * To run a mutation, you first call `useDeletePublisherExclusionPresetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePublisherExclusionPresetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePublisherExclusionPresetMutation, { data, loading, error }] = useDeletePublisherExclusionPresetMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePublisherExclusionPresetMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeletePublisherExclusionPresetMutation, DeletePublisherExclusionPresetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeletePublisherExclusionPresetMutation, DeletePublisherExclusionPresetMutationVariables>(DeletePublisherExclusionPresetDocument, options);
      }
export type DeletePublisherExclusionPresetMutationHookResult = ReturnType<typeof useDeletePublisherExclusionPresetMutation>;
export type DeletePublisherExclusionPresetMutationResult = ApolloReactCommon.MutationResult<DeletePublisherExclusionPresetMutation>;
export type DeletePublisherExclusionPresetMutationOptions = ApolloReactCommon.BaseMutationOptions<DeletePublisherExclusionPresetMutation, DeletePublisherExclusionPresetMutationVariables>;
export const AssignPublisherExclusionPresetToWebsiteDocument = gql`
    mutation assignPublisherExclusionPresetToWebsite($presetId: PwsID!, $websiteId: PwsID!) {
  assignPublisherExclusionPresetToWebsite(
    presetId: $presetId
    websiteId: $websiteId
  )
}
    `;
export type AssignPublisherExclusionPresetToWebsiteMutationFn = ApolloReactCommon.MutationFunction<AssignPublisherExclusionPresetToWebsiteMutation, AssignPublisherExclusionPresetToWebsiteMutationVariables>;

/**
 * __useAssignPublisherExclusionPresetToWebsiteMutation__
 *
 * To run a mutation, you first call `useAssignPublisherExclusionPresetToWebsiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignPublisherExclusionPresetToWebsiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignPublisherExclusionPresetToWebsiteMutation, { data, loading, error }] = useAssignPublisherExclusionPresetToWebsiteMutation({
 *   variables: {
 *      presetId: // value for 'presetId'
 *      websiteId: // value for 'websiteId'
 *   },
 * });
 */
export function useAssignPublisherExclusionPresetToWebsiteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AssignPublisherExclusionPresetToWebsiteMutation, AssignPublisherExclusionPresetToWebsiteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AssignPublisherExclusionPresetToWebsiteMutation, AssignPublisherExclusionPresetToWebsiteMutationVariables>(AssignPublisherExclusionPresetToWebsiteDocument, options);
      }
export type AssignPublisherExclusionPresetToWebsiteMutationHookResult = ReturnType<typeof useAssignPublisherExclusionPresetToWebsiteMutation>;
export type AssignPublisherExclusionPresetToWebsiteMutationResult = ApolloReactCommon.MutationResult<AssignPublisherExclusionPresetToWebsiteMutation>;
export type AssignPublisherExclusionPresetToWebsiteMutationOptions = ApolloReactCommon.BaseMutationOptions<AssignPublisherExclusionPresetToWebsiteMutation, AssignPublisherExclusionPresetToWebsiteMutationVariables>;
export const UnassignPublisherExclusionPresetFromWebsiteDocument = gql`
    mutation unassignPublisherExclusionPresetFromWebsite($presetId: PwsID!, $websiteId: PwsID!) {
  unassignPublisherExclusionPresetFromWebsite(
    presetId: $presetId
    websiteId: $websiteId
  )
}
    `;
export type UnassignPublisherExclusionPresetFromWebsiteMutationFn = ApolloReactCommon.MutationFunction<UnassignPublisherExclusionPresetFromWebsiteMutation, UnassignPublisherExclusionPresetFromWebsiteMutationVariables>;

/**
 * __useUnassignPublisherExclusionPresetFromWebsiteMutation__
 *
 * To run a mutation, you first call `useUnassignPublisherExclusionPresetFromWebsiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnassignPublisherExclusionPresetFromWebsiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unassignPublisherExclusionPresetFromWebsiteMutation, { data, loading, error }] = useUnassignPublisherExclusionPresetFromWebsiteMutation({
 *   variables: {
 *      presetId: // value for 'presetId'
 *      websiteId: // value for 'websiteId'
 *   },
 * });
 */
export function useUnassignPublisherExclusionPresetFromWebsiteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnassignPublisherExclusionPresetFromWebsiteMutation, UnassignPublisherExclusionPresetFromWebsiteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UnassignPublisherExclusionPresetFromWebsiteMutation, UnassignPublisherExclusionPresetFromWebsiteMutationVariables>(UnassignPublisherExclusionPresetFromWebsiteDocument, options);
      }
export type UnassignPublisherExclusionPresetFromWebsiteMutationHookResult = ReturnType<typeof useUnassignPublisherExclusionPresetFromWebsiteMutation>;
export type UnassignPublisherExclusionPresetFromWebsiteMutationResult = ApolloReactCommon.MutationResult<UnassignPublisherExclusionPresetFromWebsiteMutation>;
export type UnassignPublisherExclusionPresetFromWebsiteMutationOptions = ApolloReactCommon.BaseMutationOptions<UnassignPublisherExclusionPresetFromWebsiteMutation, UnassignPublisherExclusionPresetFromWebsiteMutationVariables>;
export const AssignExclusionPresetToCompanyDocument = gql`
    mutation assignExclusionPresetToCompany($presetId: PwsID!, $companyId: PwsID!) {
  assignExclusionPresetToCompany(presetId: $presetId, companyId: $companyId)
}
    `;
export type AssignExclusionPresetToCompanyMutationFn = ApolloReactCommon.MutationFunction<AssignExclusionPresetToCompanyMutation, AssignExclusionPresetToCompanyMutationVariables>;

/**
 * __useAssignExclusionPresetToCompanyMutation__
 *
 * To run a mutation, you first call `useAssignExclusionPresetToCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignExclusionPresetToCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignExclusionPresetToCompanyMutation, { data, loading, error }] = useAssignExclusionPresetToCompanyMutation({
 *   variables: {
 *      presetId: // value for 'presetId'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useAssignExclusionPresetToCompanyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AssignExclusionPresetToCompanyMutation, AssignExclusionPresetToCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AssignExclusionPresetToCompanyMutation, AssignExclusionPresetToCompanyMutationVariables>(AssignExclusionPresetToCompanyDocument, options);
      }
export type AssignExclusionPresetToCompanyMutationHookResult = ReturnType<typeof useAssignExclusionPresetToCompanyMutation>;
export type AssignExclusionPresetToCompanyMutationResult = ApolloReactCommon.MutationResult<AssignExclusionPresetToCompanyMutation>;
export type AssignExclusionPresetToCompanyMutationOptions = ApolloReactCommon.BaseMutationOptions<AssignExclusionPresetToCompanyMutation, AssignExclusionPresetToCompanyMutationVariables>;
export const UnassignExclusionPresetFromCompanyDocument = gql`
    mutation unassignExclusionPresetFromCompany($presetId: PwsID!, $companyId: PwsID!) {
  unassignExclusionPresetFromCompany(presetId: $presetId, companyId: $companyId)
}
    `;
export type UnassignExclusionPresetFromCompanyMutationFn = ApolloReactCommon.MutationFunction<UnassignExclusionPresetFromCompanyMutation, UnassignExclusionPresetFromCompanyMutationVariables>;

/**
 * __useUnassignExclusionPresetFromCompanyMutation__
 *
 * To run a mutation, you first call `useUnassignExclusionPresetFromCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnassignExclusionPresetFromCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unassignExclusionPresetFromCompanyMutation, { data, loading, error }] = useUnassignExclusionPresetFromCompanyMutation({
 *   variables: {
 *      presetId: // value for 'presetId'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useUnassignExclusionPresetFromCompanyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnassignExclusionPresetFromCompanyMutation, UnassignExclusionPresetFromCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UnassignExclusionPresetFromCompanyMutation, UnassignExclusionPresetFromCompanyMutationVariables>(UnassignExclusionPresetFromCompanyDocument, options);
      }
export type UnassignExclusionPresetFromCompanyMutationHookResult = ReturnType<typeof useUnassignExclusionPresetFromCompanyMutation>;
export type UnassignExclusionPresetFromCompanyMutationResult = ApolloReactCommon.MutationResult<UnassignExclusionPresetFromCompanyMutation>;
export type UnassignExclusionPresetFromCompanyMutationOptions = ApolloReactCommon.BaseMutationOptions<UnassignExclusionPresetFromCompanyMutation, UnassignExclusionPresetFromCompanyMutationVariables>;
export const ResellerPublisherTimeseriesDocument = gql`
    query resellerPublisherTimeseries($endDate: DateTime!, $startDate: DateTime!, $resellerId: PwsID, $slug: String, $granularity: GraphGranularity!, $filters: [CostDetailsFilter!]) {
  reseller(id: $resellerId, slug: $slug) {
    id
    publisherTimeseries(
      granularity: $granularity
      endDate: $endDate
      startDate: $startDate
      filters: $filters
    ) {
      ...PublisherTimeseries
    }
  }
}
    ${PublisherTimeseriesFragmentDoc}`;

/**
 * __useResellerPublisherTimeseriesQuery__
 *
 * To run a query within a React component, call `useResellerPublisherTimeseriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useResellerPublisherTimeseriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResellerPublisherTimeseriesQuery({
 *   variables: {
 *      endDate: // value for 'endDate'
 *      startDate: // value for 'startDate'
 *      resellerId: // value for 'resellerId'
 *      slug: // value for 'slug'
 *      granularity: // value for 'granularity'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useResellerPublisherTimeseriesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ResellerPublisherTimeseriesQuery, ResellerPublisherTimeseriesQueryVariables> & ({ variables: ResellerPublisherTimeseriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ResellerPublisherTimeseriesQuery, ResellerPublisherTimeseriesQueryVariables>(ResellerPublisherTimeseriesDocument, options);
      }
export function useResellerPublisherTimeseriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ResellerPublisherTimeseriesQuery, ResellerPublisherTimeseriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ResellerPublisherTimeseriesQuery, ResellerPublisherTimeseriesQueryVariables>(ResellerPublisherTimeseriesDocument, options);
        }
// @ts-ignore
export function useResellerPublisherTimeseriesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ResellerPublisherTimeseriesQuery, ResellerPublisherTimeseriesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ResellerPublisherTimeseriesQuery, ResellerPublisherTimeseriesQueryVariables>;
export function useResellerPublisherTimeseriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ResellerPublisherTimeseriesQuery, ResellerPublisherTimeseriesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ResellerPublisherTimeseriesQuery | undefined, ResellerPublisherTimeseriesQueryVariables>;
export function useResellerPublisherTimeseriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ResellerPublisherTimeseriesQuery, ResellerPublisherTimeseriesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ResellerPublisherTimeseriesQuery, ResellerPublisherTimeseriesQueryVariables>(ResellerPublisherTimeseriesDocument, options);
        }
export type ResellerPublisherTimeseriesQueryHookResult = ReturnType<typeof useResellerPublisherTimeseriesQuery>;
export type ResellerPublisherTimeseriesLazyQueryHookResult = ReturnType<typeof useResellerPublisherTimeseriesLazyQuery>;
export type ResellerPublisherTimeseriesSuspenseQueryHookResult = ReturnType<typeof useResellerPublisherTimeseriesSuspenseQuery>;
export type ResellerPublisherTimeseriesQueryResult = ApolloReactCommon.QueryResult<ResellerPublisherTimeseriesQuery, ResellerPublisherTimeseriesQueryVariables>;
export const ResellerPublisherPopulationStatsDocument = gql`
    query resellerPublisherPopulationStats($slug: String) {
  reseller(slug: $slug) {
    publisherPopulation {
      ...PublisherPopulation
    }
  }
}
    ${PublisherPopulationFragmentDoc}`;

/**
 * __useResellerPublisherPopulationStatsQuery__
 *
 * To run a query within a React component, call `useResellerPublisherPopulationStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useResellerPublisherPopulationStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResellerPublisherPopulationStatsQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useResellerPublisherPopulationStatsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ResellerPublisherPopulationStatsQuery, ResellerPublisherPopulationStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ResellerPublisherPopulationStatsQuery, ResellerPublisherPopulationStatsQueryVariables>(ResellerPublisherPopulationStatsDocument, options);
      }
export function useResellerPublisherPopulationStatsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ResellerPublisherPopulationStatsQuery, ResellerPublisherPopulationStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ResellerPublisherPopulationStatsQuery, ResellerPublisherPopulationStatsQueryVariables>(ResellerPublisherPopulationStatsDocument, options);
        }
// @ts-ignore
export function useResellerPublisherPopulationStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ResellerPublisherPopulationStatsQuery, ResellerPublisherPopulationStatsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ResellerPublisherPopulationStatsQuery, ResellerPublisherPopulationStatsQueryVariables>;
export function useResellerPublisherPopulationStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ResellerPublisherPopulationStatsQuery, ResellerPublisherPopulationStatsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ResellerPublisherPopulationStatsQuery | undefined, ResellerPublisherPopulationStatsQueryVariables>;
export function useResellerPublisherPopulationStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ResellerPublisherPopulationStatsQuery, ResellerPublisherPopulationStatsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ResellerPublisherPopulationStatsQuery, ResellerPublisherPopulationStatsQueryVariables>(ResellerPublisherPopulationStatsDocument, options);
        }
export type ResellerPublisherPopulationStatsQueryHookResult = ReturnType<typeof useResellerPublisherPopulationStatsQuery>;
export type ResellerPublisherPopulationStatsLazyQueryHookResult = ReturnType<typeof useResellerPublisherPopulationStatsLazyQuery>;
export type ResellerPublisherPopulationStatsSuspenseQueryHookResult = ReturnType<typeof useResellerPublisherPopulationStatsSuspenseQuery>;
export type ResellerPublisherPopulationStatsQueryResult = ApolloReactCommon.QueryResult<ResellerPublisherPopulationStatsQuery, ResellerPublisherPopulationStatsQueryVariables>;
export const ResellerAdvertiserTimeseriesDocument = gql`
    query resellerAdvertiserTimeseries($endDate: DateTime!, $startDate: DateTime!, $resellerId: PwsID, $slug: String, $granularity: GraphGranularity!, $filters: [CostDetailsFilter!]) {
  reseller(id: $resellerId, slug: $slug) {
    id
    advertiserTimeseries(
      granularity: $granularity
      endDate: $endDate
      startDate: $startDate
      filters: $filters
    ) {
      ...AdvertiserTimeseries
    }
  }
}
    ${AdvertiserTimeseriesFragmentDoc}`;

/**
 * __useResellerAdvertiserTimeseriesQuery__
 *
 * To run a query within a React component, call `useResellerAdvertiserTimeseriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useResellerAdvertiserTimeseriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResellerAdvertiserTimeseriesQuery({
 *   variables: {
 *      endDate: // value for 'endDate'
 *      startDate: // value for 'startDate'
 *      resellerId: // value for 'resellerId'
 *      slug: // value for 'slug'
 *      granularity: // value for 'granularity'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useResellerAdvertiserTimeseriesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ResellerAdvertiserTimeseriesQuery, ResellerAdvertiserTimeseriesQueryVariables> & ({ variables: ResellerAdvertiserTimeseriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ResellerAdvertiserTimeseriesQuery, ResellerAdvertiserTimeseriesQueryVariables>(ResellerAdvertiserTimeseriesDocument, options);
      }
export function useResellerAdvertiserTimeseriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ResellerAdvertiserTimeseriesQuery, ResellerAdvertiserTimeseriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ResellerAdvertiserTimeseriesQuery, ResellerAdvertiserTimeseriesQueryVariables>(ResellerAdvertiserTimeseriesDocument, options);
        }
// @ts-ignore
export function useResellerAdvertiserTimeseriesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ResellerAdvertiserTimeseriesQuery, ResellerAdvertiserTimeseriesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ResellerAdvertiserTimeseriesQuery, ResellerAdvertiserTimeseriesQueryVariables>;
export function useResellerAdvertiserTimeseriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ResellerAdvertiserTimeseriesQuery, ResellerAdvertiserTimeseriesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ResellerAdvertiserTimeseriesQuery | undefined, ResellerAdvertiserTimeseriesQueryVariables>;
export function useResellerAdvertiserTimeseriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ResellerAdvertiserTimeseriesQuery, ResellerAdvertiserTimeseriesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ResellerAdvertiserTimeseriesQuery, ResellerAdvertiserTimeseriesQueryVariables>(ResellerAdvertiserTimeseriesDocument, options);
        }
export type ResellerAdvertiserTimeseriesQueryHookResult = ReturnType<typeof useResellerAdvertiserTimeseriesQuery>;
export type ResellerAdvertiserTimeseriesLazyQueryHookResult = ReturnType<typeof useResellerAdvertiserTimeseriesLazyQuery>;
export type ResellerAdvertiserTimeseriesSuspenseQueryHookResult = ReturnType<typeof useResellerAdvertiserTimeseriesSuspenseQuery>;
export type ResellerAdvertiserTimeseriesQueryResult = ApolloReactCommon.QueryResult<ResellerAdvertiserTimeseriesQuery, ResellerAdvertiserTimeseriesQueryVariables>;
export const ResellerPublisherPerformanceStatsDocument = gql`
    query resellerPublisherPerformanceStats($endDate: DateTime!, $startDate: DateTime!, $resellerId: PwsID, $slug: String, $filters: [CostDetailsFilter!]) {
  reseller(id: $resellerId, slug: $slug) {
    id
    publisherPerformanceStats(
      endDate: $endDate
      startDate: $startDate
      filters: $filters
    ) {
      stats {
        ...PublisherPerformanceStatsParts
      }
      publishers {
        name
        slug
        stats {
          ...PublisherPerformanceStatsParts
        }
      }
      advertiserResellers {
        name
        stats {
          ...PublisherPerformanceStatsParts
        }
        advertisers {
          name
          stats {
            ...PublisherPerformanceStatsParts
          }
        }
      }
    }
  }
}
    ${PublisherPerformanceStatsPartsFragmentDoc}`;

/**
 * __useResellerPublisherPerformanceStatsQuery__
 *
 * To run a query within a React component, call `useResellerPublisherPerformanceStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useResellerPublisherPerformanceStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResellerPublisherPerformanceStatsQuery({
 *   variables: {
 *      endDate: // value for 'endDate'
 *      startDate: // value for 'startDate'
 *      resellerId: // value for 'resellerId'
 *      slug: // value for 'slug'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useResellerPublisherPerformanceStatsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ResellerPublisherPerformanceStatsQuery, ResellerPublisherPerformanceStatsQueryVariables> & ({ variables: ResellerPublisherPerformanceStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ResellerPublisherPerformanceStatsQuery, ResellerPublisherPerformanceStatsQueryVariables>(ResellerPublisherPerformanceStatsDocument, options);
      }
export function useResellerPublisherPerformanceStatsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ResellerPublisherPerformanceStatsQuery, ResellerPublisherPerformanceStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ResellerPublisherPerformanceStatsQuery, ResellerPublisherPerformanceStatsQueryVariables>(ResellerPublisherPerformanceStatsDocument, options);
        }
// @ts-ignore
export function useResellerPublisherPerformanceStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ResellerPublisherPerformanceStatsQuery, ResellerPublisherPerformanceStatsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ResellerPublisherPerformanceStatsQuery, ResellerPublisherPerformanceStatsQueryVariables>;
export function useResellerPublisherPerformanceStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ResellerPublisherPerformanceStatsQuery, ResellerPublisherPerformanceStatsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ResellerPublisherPerformanceStatsQuery | undefined, ResellerPublisherPerformanceStatsQueryVariables>;
export function useResellerPublisherPerformanceStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ResellerPublisherPerformanceStatsQuery, ResellerPublisherPerformanceStatsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ResellerPublisherPerformanceStatsQuery, ResellerPublisherPerformanceStatsQueryVariables>(ResellerPublisherPerformanceStatsDocument, options);
        }
export type ResellerPublisherPerformanceStatsQueryHookResult = ReturnType<typeof useResellerPublisherPerformanceStatsQuery>;
export type ResellerPublisherPerformanceStatsLazyQueryHookResult = ReturnType<typeof useResellerPublisherPerformanceStatsLazyQuery>;
export type ResellerPublisherPerformanceStatsSuspenseQueryHookResult = ReturnType<typeof useResellerPublisherPerformanceStatsSuspenseQuery>;
export type ResellerPublisherPerformanceStatsQueryResult = ApolloReactCommon.QueryResult<ResellerPublisherPerformanceStatsQuery, ResellerPublisherPerformanceStatsQueryVariables>;
export const ResellerAdvertiserPerformanceStatsDocument = gql`
    query resellerAdvertiserPerformanceStats($endDate: DateTime!, $startDate: DateTime!, $resellerId: PwsID, $slug: String, $filters: [CostDetailsFilter!]) {
  reseller(id: $resellerId, slug: $slug) {
    id
    advertiserPerformanceStats(
      endDate: $endDate
      startDate: $startDate
      filters: $filters
    ) {
      stats {
        ...AdvertiserPerformanceStatsParts
      }
      publisherResellers {
        name
        stats {
          ...AdvertiserPerformanceStatsParts
        }
        publishers {
          name
          stats {
            ...AdvertiserPerformanceStatsParts
          }
        }
      }
      advertisers {
        id
        slug
        name
        stats {
          ...AdvertiserPerformanceStatsParts
        }
        campaigns {
          id
          name
          status
          stats {
            ...AdvertiserPerformanceStatsParts
          }
        }
      }
    }
  }
}
    ${AdvertiserPerformanceStatsPartsFragmentDoc}`;

/**
 * __useResellerAdvertiserPerformanceStatsQuery__
 *
 * To run a query within a React component, call `useResellerAdvertiserPerformanceStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useResellerAdvertiserPerformanceStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResellerAdvertiserPerformanceStatsQuery({
 *   variables: {
 *      endDate: // value for 'endDate'
 *      startDate: // value for 'startDate'
 *      resellerId: // value for 'resellerId'
 *      slug: // value for 'slug'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useResellerAdvertiserPerformanceStatsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ResellerAdvertiserPerformanceStatsQuery, ResellerAdvertiserPerformanceStatsQueryVariables> & ({ variables: ResellerAdvertiserPerformanceStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ResellerAdvertiserPerformanceStatsQuery, ResellerAdvertiserPerformanceStatsQueryVariables>(ResellerAdvertiserPerformanceStatsDocument, options);
      }
export function useResellerAdvertiserPerformanceStatsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ResellerAdvertiserPerformanceStatsQuery, ResellerAdvertiserPerformanceStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ResellerAdvertiserPerformanceStatsQuery, ResellerAdvertiserPerformanceStatsQueryVariables>(ResellerAdvertiserPerformanceStatsDocument, options);
        }
// @ts-ignore
export function useResellerAdvertiserPerformanceStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ResellerAdvertiserPerformanceStatsQuery, ResellerAdvertiserPerformanceStatsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ResellerAdvertiserPerformanceStatsQuery, ResellerAdvertiserPerformanceStatsQueryVariables>;
export function useResellerAdvertiserPerformanceStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ResellerAdvertiserPerformanceStatsQuery, ResellerAdvertiserPerformanceStatsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ResellerAdvertiserPerformanceStatsQuery | undefined, ResellerAdvertiserPerformanceStatsQueryVariables>;
export function useResellerAdvertiserPerformanceStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ResellerAdvertiserPerformanceStatsQuery, ResellerAdvertiserPerformanceStatsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ResellerAdvertiserPerformanceStatsQuery, ResellerAdvertiserPerformanceStatsQueryVariables>(ResellerAdvertiserPerformanceStatsDocument, options);
        }
export type ResellerAdvertiserPerformanceStatsQueryHookResult = ReturnType<typeof useResellerAdvertiserPerformanceStatsQuery>;
export type ResellerAdvertiserPerformanceStatsLazyQueryHookResult = ReturnType<typeof useResellerAdvertiserPerformanceStatsLazyQuery>;
export type ResellerAdvertiserPerformanceStatsSuspenseQueryHookResult = ReturnType<typeof useResellerAdvertiserPerformanceStatsSuspenseQuery>;
export type ResellerAdvertiserPerformanceStatsQueryResult = ApolloReactCommon.QueryResult<ResellerAdvertiserPerformanceStatsQuery, ResellerAdvertiserPerformanceStatsQueryVariables>;
export const AdGroupsFromAllPwsAccountsDocument = gql`
    query adGroupsFromAllPwsAccounts($id: PwsID!, $endDate: DateTime!, $startDate: DateTime!) {
  reseller(id: $id) {
    id
    advertiserPerformanceStats(endDate: $endDate, startDate: $startDate) {
      stats {
        cpm
      }
    }
    accounts(status: Enabled) {
      id
      firstName
      lastName
      advertisers {
        ...AccountAdvertiserParts
      }
    }
  }
}
    ${AccountAdvertiserPartsFragmentDoc}`;

/**
 * __useAdGroupsFromAllPwsAccountsQuery__
 *
 * To run a query within a React component, call `useAdGroupsFromAllPwsAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdGroupsFromAllPwsAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdGroupsFromAllPwsAccountsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      endDate: // value for 'endDate'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useAdGroupsFromAllPwsAccountsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdGroupsFromAllPwsAccountsQuery, AdGroupsFromAllPwsAccountsQueryVariables> & ({ variables: AdGroupsFromAllPwsAccountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdGroupsFromAllPwsAccountsQuery, AdGroupsFromAllPwsAccountsQueryVariables>(AdGroupsFromAllPwsAccountsDocument, options);
      }
export function useAdGroupsFromAllPwsAccountsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdGroupsFromAllPwsAccountsQuery, AdGroupsFromAllPwsAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdGroupsFromAllPwsAccountsQuery, AdGroupsFromAllPwsAccountsQueryVariables>(AdGroupsFromAllPwsAccountsDocument, options);
        }
// @ts-ignore
export function useAdGroupsFromAllPwsAccountsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdGroupsFromAllPwsAccountsQuery, AdGroupsFromAllPwsAccountsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdGroupsFromAllPwsAccountsQuery, AdGroupsFromAllPwsAccountsQueryVariables>;
export function useAdGroupsFromAllPwsAccountsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdGroupsFromAllPwsAccountsQuery, AdGroupsFromAllPwsAccountsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdGroupsFromAllPwsAccountsQuery | undefined, AdGroupsFromAllPwsAccountsQueryVariables>;
export function useAdGroupsFromAllPwsAccountsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdGroupsFromAllPwsAccountsQuery, AdGroupsFromAllPwsAccountsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdGroupsFromAllPwsAccountsQuery, AdGroupsFromAllPwsAccountsQueryVariables>(AdGroupsFromAllPwsAccountsDocument, options);
        }
export type AdGroupsFromAllPwsAccountsQueryHookResult = ReturnType<typeof useAdGroupsFromAllPwsAccountsQuery>;
export type AdGroupsFromAllPwsAccountsLazyQueryHookResult = ReturnType<typeof useAdGroupsFromAllPwsAccountsLazyQuery>;
export type AdGroupsFromAllPwsAccountsSuspenseQueryHookResult = ReturnType<typeof useAdGroupsFromAllPwsAccountsSuspenseQuery>;
export type AdGroupsFromAllPwsAccountsQueryResult = ApolloReactCommon.QueryResult<AdGroupsFromAllPwsAccountsQuery, AdGroupsFromAllPwsAccountsQueryVariables>;
export const PriorityListSettingsDocument = gql`
    query priorityListSettings($resellerSlug: String!) {
  reseller(slug: $resellerSlug) {
    priorities {
      id
      name
      value
      isDefault
      isDeletable
      isPowerspaceDefault
    }
  }
}
    `;

/**
 * __usePriorityListSettingsQuery__
 *
 * To run a query within a React component, call `usePriorityListSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePriorityListSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePriorityListSettingsQuery({
 *   variables: {
 *      resellerSlug: // value for 'resellerSlug'
 *   },
 * });
 */
export function usePriorityListSettingsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PriorityListSettingsQuery, PriorityListSettingsQueryVariables> & ({ variables: PriorityListSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PriorityListSettingsQuery, PriorityListSettingsQueryVariables>(PriorityListSettingsDocument, options);
      }
export function usePriorityListSettingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PriorityListSettingsQuery, PriorityListSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PriorityListSettingsQuery, PriorityListSettingsQueryVariables>(PriorityListSettingsDocument, options);
        }
// @ts-ignore
export function usePriorityListSettingsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PriorityListSettingsQuery, PriorityListSettingsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PriorityListSettingsQuery, PriorityListSettingsQueryVariables>;
export function usePriorityListSettingsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PriorityListSettingsQuery, PriorityListSettingsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PriorityListSettingsQuery | undefined, PriorityListSettingsQueryVariables>;
export function usePriorityListSettingsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PriorityListSettingsQuery, PriorityListSettingsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PriorityListSettingsQuery, PriorityListSettingsQueryVariables>(PriorityListSettingsDocument, options);
        }
export type PriorityListSettingsQueryHookResult = ReturnType<typeof usePriorityListSettingsQuery>;
export type PriorityListSettingsLazyQueryHookResult = ReturnType<typeof usePriorityListSettingsLazyQuery>;
export type PriorityListSettingsSuspenseQueryHookResult = ReturnType<typeof usePriorityListSettingsSuspenseQuery>;
export type PriorityListSettingsQueryResult = ApolloReactCommon.QueryResult<PriorityListSettingsQuery, PriorityListSettingsQueryVariables>;
export const UpdateResellerPrioritiesDocument = gql`
    mutation updateResellerPriorities($resellerId: PwsID!, $priorities: [AdPriorityInput!]!) {
  updateResellerPriorities(resellerId: $resellerId, priorities: $priorities)
}
    `;
export type UpdateResellerPrioritiesMutationFn = ApolloReactCommon.MutationFunction<UpdateResellerPrioritiesMutation, UpdateResellerPrioritiesMutationVariables>;

/**
 * __useUpdateResellerPrioritiesMutation__
 *
 * To run a mutation, you first call `useUpdateResellerPrioritiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateResellerPrioritiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateResellerPrioritiesMutation, { data, loading, error }] = useUpdateResellerPrioritiesMutation({
 *   variables: {
 *      resellerId: // value for 'resellerId'
 *      priorities: // value for 'priorities'
 *   },
 * });
 */
export function useUpdateResellerPrioritiesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateResellerPrioritiesMutation, UpdateResellerPrioritiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateResellerPrioritiesMutation, UpdateResellerPrioritiesMutationVariables>(UpdateResellerPrioritiesDocument, options);
      }
export type UpdateResellerPrioritiesMutationHookResult = ReturnType<typeof useUpdateResellerPrioritiesMutation>;
export type UpdateResellerPrioritiesMutationResult = ApolloReactCommon.MutationResult<UpdateResellerPrioritiesMutation>;
export type UpdateResellerPrioritiesMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateResellerPrioritiesMutation, UpdateResellerPrioritiesMutationVariables>;
export const UpdateResellerBannerSizesDocument = gql`
    mutation updateResellerBannerSizes($resellerId: PwsID!, $bannerSizes: [SizeInput!]!) {
  updateResellerBannerSizes(resellerId: $resellerId, bannerSizes: $bannerSizes) {
    id
    bannerSizes {
      width
      height
    }
  }
}
    `;
export type UpdateResellerBannerSizesMutationFn = ApolloReactCommon.MutationFunction<UpdateResellerBannerSizesMutation, UpdateResellerBannerSizesMutationVariables>;

/**
 * __useUpdateResellerBannerSizesMutation__
 *
 * To run a mutation, you first call `useUpdateResellerBannerSizesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateResellerBannerSizesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateResellerBannerSizesMutation, { data, loading, error }] = useUpdateResellerBannerSizesMutation({
 *   variables: {
 *      resellerId: // value for 'resellerId'
 *      bannerSizes: // value for 'bannerSizes'
 *   },
 * });
 */
export function useUpdateResellerBannerSizesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateResellerBannerSizesMutation, UpdateResellerBannerSizesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateResellerBannerSizesMutation, UpdateResellerBannerSizesMutationVariables>(UpdateResellerBannerSizesDocument, options);
      }
export type UpdateResellerBannerSizesMutationHookResult = ReturnType<typeof useUpdateResellerBannerSizesMutation>;
export type UpdateResellerBannerSizesMutationResult = ApolloReactCommon.MutationResult<UpdateResellerBannerSizesMutation>;
export type UpdateResellerBannerSizesMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateResellerBannerSizesMutation, UpdateResellerBannerSizesMutationVariables>;
export const ResellerBlacklistsDocument = gql`
    query resellerBlacklists($slug: String!) {
  reseller(slug: $slug) {
    id
    advertiserExclusions {
      ...AdvertiserExclusionItemParts
    }
    campaignExclusions {
      ...CampaignExclusionItemParts
    }
    iabExclusions {
      ...IabExclusionItemParts
    }
    domainExclusions {
      ...DomainExclusionItemParts
    }
  }
}
    ${AdvertiserExclusionItemPartsFragmentDoc}
${CampaignExclusionItemPartsFragmentDoc}
${IabExclusionItemPartsFragmentDoc}
${DomainExclusionItemPartsFragmentDoc}`;

/**
 * __useResellerBlacklistsQuery__
 *
 * To run a query within a React component, call `useResellerBlacklistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useResellerBlacklistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResellerBlacklistsQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useResellerBlacklistsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ResellerBlacklistsQuery, ResellerBlacklistsQueryVariables> & ({ variables: ResellerBlacklistsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ResellerBlacklistsQuery, ResellerBlacklistsQueryVariables>(ResellerBlacklistsDocument, options);
      }
export function useResellerBlacklistsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ResellerBlacklistsQuery, ResellerBlacklistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ResellerBlacklistsQuery, ResellerBlacklistsQueryVariables>(ResellerBlacklistsDocument, options);
        }
// @ts-ignore
export function useResellerBlacklistsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ResellerBlacklistsQuery, ResellerBlacklistsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ResellerBlacklistsQuery, ResellerBlacklistsQueryVariables>;
export function useResellerBlacklistsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ResellerBlacklistsQuery, ResellerBlacklistsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ResellerBlacklistsQuery | undefined, ResellerBlacklistsQueryVariables>;
export function useResellerBlacklistsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ResellerBlacklistsQuery, ResellerBlacklistsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ResellerBlacklistsQuery, ResellerBlacklistsQueryVariables>(ResellerBlacklistsDocument, options);
        }
export type ResellerBlacklistsQueryHookResult = ReturnType<typeof useResellerBlacklistsQuery>;
export type ResellerBlacklistsLazyQueryHookResult = ReturnType<typeof useResellerBlacklistsLazyQuery>;
export type ResellerBlacklistsSuspenseQueryHookResult = ReturnType<typeof useResellerBlacklistsSuspenseQuery>;
export type ResellerBlacklistsQueryResult = ApolloReactCommon.QueryResult<ResellerBlacklistsQuery, ResellerBlacklistsQueryVariables>;
export const UpdateResellerAdvertiserExclusionsDocument = gql`
    mutation updateResellerAdvertiserExclusions($resellerId: PwsID!, $advertiserExclusions: [PwsID!]!) {
  updateResellerAdvertiserExclusions(
    resellerId: $resellerId
    advertiserExclusions: $advertiserExclusions
  )
}
    `;
export type UpdateResellerAdvertiserExclusionsMutationFn = ApolloReactCommon.MutationFunction<UpdateResellerAdvertiserExclusionsMutation, UpdateResellerAdvertiserExclusionsMutationVariables>;

/**
 * __useUpdateResellerAdvertiserExclusionsMutation__
 *
 * To run a mutation, you first call `useUpdateResellerAdvertiserExclusionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateResellerAdvertiserExclusionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateResellerAdvertiserExclusionsMutation, { data, loading, error }] = useUpdateResellerAdvertiserExclusionsMutation({
 *   variables: {
 *      resellerId: // value for 'resellerId'
 *      advertiserExclusions: // value for 'advertiserExclusions'
 *   },
 * });
 */
export function useUpdateResellerAdvertiserExclusionsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateResellerAdvertiserExclusionsMutation, UpdateResellerAdvertiserExclusionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateResellerAdvertiserExclusionsMutation, UpdateResellerAdvertiserExclusionsMutationVariables>(UpdateResellerAdvertiserExclusionsDocument, options);
      }
export type UpdateResellerAdvertiserExclusionsMutationHookResult = ReturnType<typeof useUpdateResellerAdvertiserExclusionsMutation>;
export type UpdateResellerAdvertiserExclusionsMutationResult = ApolloReactCommon.MutationResult<UpdateResellerAdvertiserExclusionsMutation>;
export type UpdateResellerAdvertiserExclusionsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateResellerAdvertiserExclusionsMutation, UpdateResellerAdvertiserExclusionsMutationVariables>;
export const UpdateResellerCampaignExclusionsDocument = gql`
    mutation updateResellerCampaignExclusions($resellerId: PwsID!, $campaignExclusions: [PwsID!]!) {
  updateResellerCampaignExclusions(
    resellerId: $resellerId
    campaignExclusions: $campaignExclusions
  )
}
    `;
export type UpdateResellerCampaignExclusionsMutationFn = ApolloReactCommon.MutationFunction<UpdateResellerCampaignExclusionsMutation, UpdateResellerCampaignExclusionsMutationVariables>;

/**
 * __useUpdateResellerCampaignExclusionsMutation__
 *
 * To run a mutation, you first call `useUpdateResellerCampaignExclusionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateResellerCampaignExclusionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateResellerCampaignExclusionsMutation, { data, loading, error }] = useUpdateResellerCampaignExclusionsMutation({
 *   variables: {
 *      resellerId: // value for 'resellerId'
 *      campaignExclusions: // value for 'campaignExclusions'
 *   },
 * });
 */
export function useUpdateResellerCampaignExclusionsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateResellerCampaignExclusionsMutation, UpdateResellerCampaignExclusionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateResellerCampaignExclusionsMutation, UpdateResellerCampaignExclusionsMutationVariables>(UpdateResellerCampaignExclusionsDocument, options);
      }
export type UpdateResellerCampaignExclusionsMutationHookResult = ReturnType<typeof useUpdateResellerCampaignExclusionsMutation>;
export type UpdateResellerCampaignExclusionsMutationResult = ApolloReactCommon.MutationResult<UpdateResellerCampaignExclusionsMutation>;
export type UpdateResellerCampaignExclusionsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateResellerCampaignExclusionsMutation, UpdateResellerCampaignExclusionsMutationVariables>;
export const UpdateResellerIabExclusionsDocument = gql`
    mutation updateResellerIabExclusions($resellerId: PwsID!, $iabExclusions: [IAB!]!) {
  updateResellerIabExclusions(
    resellerId: $resellerId
    iabExclusions: $iabExclusions
  )
}
    `;
export type UpdateResellerIabExclusionsMutationFn = ApolloReactCommon.MutationFunction<UpdateResellerIabExclusionsMutation, UpdateResellerIabExclusionsMutationVariables>;

/**
 * __useUpdateResellerIabExclusionsMutation__
 *
 * To run a mutation, you first call `useUpdateResellerIabExclusionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateResellerIabExclusionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateResellerIabExclusionsMutation, { data, loading, error }] = useUpdateResellerIabExclusionsMutation({
 *   variables: {
 *      resellerId: // value for 'resellerId'
 *      iabExclusions: // value for 'iabExclusions'
 *   },
 * });
 */
export function useUpdateResellerIabExclusionsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateResellerIabExclusionsMutation, UpdateResellerIabExclusionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateResellerIabExclusionsMutation, UpdateResellerIabExclusionsMutationVariables>(UpdateResellerIabExclusionsDocument, options);
      }
export type UpdateResellerIabExclusionsMutationHookResult = ReturnType<typeof useUpdateResellerIabExclusionsMutation>;
export type UpdateResellerIabExclusionsMutationResult = ApolloReactCommon.MutationResult<UpdateResellerIabExclusionsMutation>;
export type UpdateResellerIabExclusionsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateResellerIabExclusionsMutation, UpdateResellerIabExclusionsMutationVariables>;
export const UpdateResellerDomainExclusionsDocument = gql`
    mutation updateResellerDomainExclusions($resellerId: PwsID!, $domainExclusions: [LimitedString2!]!) {
  updateResellerDomainExclusions(
    resellerId: $resellerId
    domainExclusions: $domainExclusions
  )
}
    `;
export type UpdateResellerDomainExclusionsMutationFn = ApolloReactCommon.MutationFunction<UpdateResellerDomainExclusionsMutation, UpdateResellerDomainExclusionsMutationVariables>;

/**
 * __useUpdateResellerDomainExclusionsMutation__
 *
 * To run a mutation, you first call `useUpdateResellerDomainExclusionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateResellerDomainExclusionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateResellerDomainExclusionsMutation, { data, loading, error }] = useUpdateResellerDomainExclusionsMutation({
 *   variables: {
 *      resellerId: // value for 'resellerId'
 *      domainExclusions: // value for 'domainExclusions'
 *   },
 * });
 */
export function useUpdateResellerDomainExclusionsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateResellerDomainExclusionsMutation, UpdateResellerDomainExclusionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateResellerDomainExclusionsMutation, UpdateResellerDomainExclusionsMutationVariables>(UpdateResellerDomainExclusionsDocument, options);
      }
export type UpdateResellerDomainExclusionsMutationHookResult = ReturnType<typeof useUpdateResellerDomainExclusionsMutation>;
export type UpdateResellerDomainExclusionsMutationResult = ApolloReactCommon.MutationResult<UpdateResellerDomainExclusionsMutation>;
export type UpdateResellerDomainExclusionsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateResellerDomainExclusionsMutation, UpdateResellerDomainExclusionsMutationVariables>;
export const ResellerSettingsDocument = gql`
    query resellerSettings($id: PwsID!) {
  reseller(id: $id) {
    id
    settings {
      accountManagerId
      salesManagerId
    }
  }
}
    `;

/**
 * __useResellerSettingsQuery__
 *
 * To run a query within a React component, call `useResellerSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useResellerSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResellerSettingsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResellerSettingsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ResellerSettingsQuery, ResellerSettingsQueryVariables> & ({ variables: ResellerSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ResellerSettingsQuery, ResellerSettingsQueryVariables>(ResellerSettingsDocument, options);
      }
export function useResellerSettingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ResellerSettingsQuery, ResellerSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ResellerSettingsQuery, ResellerSettingsQueryVariables>(ResellerSettingsDocument, options);
        }
// @ts-ignore
export function useResellerSettingsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ResellerSettingsQuery, ResellerSettingsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ResellerSettingsQuery, ResellerSettingsQueryVariables>;
export function useResellerSettingsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ResellerSettingsQuery, ResellerSettingsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ResellerSettingsQuery | undefined, ResellerSettingsQueryVariables>;
export function useResellerSettingsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ResellerSettingsQuery, ResellerSettingsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ResellerSettingsQuery, ResellerSettingsQueryVariables>(ResellerSettingsDocument, options);
        }
export type ResellerSettingsQueryHookResult = ReturnType<typeof useResellerSettingsQuery>;
export type ResellerSettingsLazyQueryHookResult = ReturnType<typeof useResellerSettingsLazyQuery>;
export type ResellerSettingsSuspenseQueryHookResult = ReturnType<typeof useResellerSettingsSuspenseQuery>;
export type ResellerSettingsQueryResult = ApolloReactCommon.QueryResult<ResellerSettingsQuery, ResellerSettingsQueryVariables>;
export const UpdateResellerSettingsDocument = gql`
    mutation updateResellerSettings($resellerId: PwsID!, $settings: ResellerSettingsInput!) {
  updateResellerSettings(resellerId: $resellerId, settings: $settings) {
    accountManagerId
    salesManagerId
  }
}
    `;
export type UpdateResellerSettingsMutationFn = ApolloReactCommon.MutationFunction<UpdateResellerSettingsMutation, UpdateResellerSettingsMutationVariables>;

/**
 * __useUpdateResellerSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateResellerSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateResellerSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateResellerSettingsMutation, { data, loading, error }] = useUpdateResellerSettingsMutation({
 *   variables: {
 *      resellerId: // value for 'resellerId'
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useUpdateResellerSettingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateResellerSettingsMutation, UpdateResellerSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateResellerSettingsMutation, UpdateResellerSettingsMutationVariables>(UpdateResellerSettingsDocument, options);
      }
export type UpdateResellerSettingsMutationHookResult = ReturnType<typeof useUpdateResellerSettingsMutation>;
export type UpdateResellerSettingsMutationResult = ApolloReactCommon.MutationResult<UpdateResellerSettingsMutation>;
export type UpdateResellerSettingsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateResellerSettingsMutation, UpdateResellerSettingsMutationVariables>;
export const SearchSentEmailsDocument = gql`
    query searchSentEmails($searchQuery: SentEmailSearchQuery!, $pagination: Pagination) {
  searchSentEmails(searchQuery: $searchQuery, pagination: $pagination) {
    ...SentEmailParts
  }
}
    ${SentEmailPartsFragmentDoc}`;

/**
 * __useSearchSentEmailsQuery__
 *
 * To run a query within a React component, call `useSearchSentEmailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchSentEmailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchSentEmailsQuery({
 *   variables: {
 *      searchQuery: // value for 'searchQuery'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useSearchSentEmailsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchSentEmailsQuery, SearchSentEmailsQueryVariables> & ({ variables: SearchSentEmailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchSentEmailsQuery, SearchSentEmailsQueryVariables>(SearchSentEmailsDocument, options);
      }
export function useSearchSentEmailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchSentEmailsQuery, SearchSentEmailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchSentEmailsQuery, SearchSentEmailsQueryVariables>(SearchSentEmailsDocument, options);
        }
// @ts-ignore
export function useSearchSentEmailsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SearchSentEmailsQuery, SearchSentEmailsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SearchSentEmailsQuery, SearchSentEmailsQueryVariables>;
export function useSearchSentEmailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchSentEmailsQuery, SearchSentEmailsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SearchSentEmailsQuery | undefined, SearchSentEmailsQueryVariables>;
export function useSearchSentEmailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchSentEmailsQuery, SearchSentEmailsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SearchSentEmailsQuery, SearchSentEmailsQueryVariables>(SearchSentEmailsDocument, options);
        }
export type SearchSentEmailsQueryHookResult = ReturnType<typeof useSearchSentEmailsQuery>;
export type SearchSentEmailsLazyQueryHookResult = ReturnType<typeof useSearchSentEmailsLazyQuery>;
export type SearchSentEmailsSuspenseQueryHookResult = ReturnType<typeof useSearchSentEmailsSuspenseQuery>;
export type SearchSentEmailsQueryResult = ApolloReactCommon.QueryResult<SearchSentEmailsQuery, SearchSentEmailsQueryVariables>;
export const SidebarPublisherDocument = gql`
    query sidebarPublisher($companyId: PwsID!, $status: [Status!], $pagination: Pagination!) {
  searchWebsites(
    searchQuery: {companyId: $companyId, status: $status}
    pagination: $pagination
  ) {
    id
    name
    status
    subItems: positions(status: $status) {
      id
      name
      status
    }
  }
}
    `;

/**
 * __useSidebarPublisherQuery__
 *
 * To run a query within a React component, call `useSidebarPublisherQuery` and pass it any options that fit your needs.
 * When your component renders, `useSidebarPublisherQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSidebarPublisherQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      status: // value for 'status'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useSidebarPublisherQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SidebarPublisherQuery, SidebarPublisherQueryVariables> & ({ variables: SidebarPublisherQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SidebarPublisherQuery, SidebarPublisherQueryVariables>(SidebarPublisherDocument, options);
      }
export function useSidebarPublisherLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SidebarPublisherQuery, SidebarPublisherQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SidebarPublisherQuery, SidebarPublisherQueryVariables>(SidebarPublisherDocument, options);
        }
// @ts-ignore
export function useSidebarPublisherSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SidebarPublisherQuery, SidebarPublisherQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SidebarPublisherQuery, SidebarPublisherQueryVariables>;
export function useSidebarPublisherSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SidebarPublisherQuery, SidebarPublisherQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SidebarPublisherQuery | undefined, SidebarPublisherQueryVariables>;
export function useSidebarPublisherSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SidebarPublisherQuery, SidebarPublisherQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SidebarPublisherQuery, SidebarPublisherQueryVariables>(SidebarPublisherDocument, options);
        }
export type SidebarPublisherQueryHookResult = ReturnType<typeof useSidebarPublisherQuery>;
export type SidebarPublisherLazyQueryHookResult = ReturnType<typeof useSidebarPublisherLazyQuery>;
export type SidebarPublisherSuspenseQueryHookResult = ReturnType<typeof useSidebarPublisherSuspenseQuery>;
export type SidebarPublisherQueryResult = ApolloReactCommon.QueryResult<SidebarPublisherQuery, SidebarPublisherQueryVariables>;
export const SidebarAdvertiserDocument = gql`
    query sidebarAdvertiser($companyId: PwsID!, $campaignStatus: [Status!], $adGroupStatus: [AdGroupStatus!], $pagination: Pagination!) {
  searchCampaigns(
    searchQuery: {companyId: $companyId, status: $campaignStatus}
    pagination: $pagination
  ) {
    id
    name
    status
    subItems: adGroups(status: $adGroupStatus) {
      id
      name
      status
    }
  }
}
    `;

/**
 * __useSidebarAdvertiserQuery__
 *
 * To run a query within a React component, call `useSidebarAdvertiserQuery` and pass it any options that fit your needs.
 * When your component renders, `useSidebarAdvertiserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSidebarAdvertiserQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      campaignStatus: // value for 'campaignStatus'
 *      adGroupStatus: // value for 'adGroupStatus'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useSidebarAdvertiserQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SidebarAdvertiserQuery, SidebarAdvertiserQueryVariables> & ({ variables: SidebarAdvertiserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SidebarAdvertiserQuery, SidebarAdvertiserQueryVariables>(SidebarAdvertiserDocument, options);
      }
export function useSidebarAdvertiserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SidebarAdvertiserQuery, SidebarAdvertiserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SidebarAdvertiserQuery, SidebarAdvertiserQueryVariables>(SidebarAdvertiserDocument, options);
        }
// @ts-ignore
export function useSidebarAdvertiserSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SidebarAdvertiserQuery, SidebarAdvertiserQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SidebarAdvertiserQuery, SidebarAdvertiserQueryVariables>;
export function useSidebarAdvertiserSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SidebarAdvertiserQuery, SidebarAdvertiserQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SidebarAdvertiserQuery | undefined, SidebarAdvertiserQueryVariables>;
export function useSidebarAdvertiserSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SidebarAdvertiserQuery, SidebarAdvertiserQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SidebarAdvertiserQuery, SidebarAdvertiserQueryVariables>(SidebarAdvertiserDocument, options);
        }
export type SidebarAdvertiserQueryHookResult = ReturnType<typeof useSidebarAdvertiserQuery>;
export type SidebarAdvertiserLazyQueryHookResult = ReturnType<typeof useSidebarAdvertiserLazyQuery>;
export type SidebarAdvertiserSuspenseQueryHookResult = ReturnType<typeof useSidebarAdvertiserSuspenseQuery>;
export type SidebarAdvertiserQueryResult = ApolloReactCommon.QueryResult<SidebarAdvertiserQuery, SidebarAdvertiserQueryVariables>;
export const SidebarTradingDeskDocument = gql`
    query sidebarTradingDesk($companyId: PwsID!, $campaignStatus: [Status!], $adGroupStatus: [AdGroupStatus!], $pagination: Pagination!) {
  searchProgrammaticCampaigns(
    searchQuery: {tradingDeskId: $companyId, status: $campaignStatus}
    pagination: $pagination
  ) {
    id
    name
    status
    subItems: inventory(status: $adGroupStatus) {
      id
      name
      status
    }
  }
}
    `;

/**
 * __useSidebarTradingDeskQuery__
 *
 * To run a query within a React component, call `useSidebarTradingDeskQuery` and pass it any options that fit your needs.
 * When your component renders, `useSidebarTradingDeskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSidebarTradingDeskQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      campaignStatus: // value for 'campaignStatus'
 *      adGroupStatus: // value for 'adGroupStatus'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useSidebarTradingDeskQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SidebarTradingDeskQuery, SidebarTradingDeskQueryVariables> & ({ variables: SidebarTradingDeskQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SidebarTradingDeskQuery, SidebarTradingDeskQueryVariables>(SidebarTradingDeskDocument, options);
      }
export function useSidebarTradingDeskLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SidebarTradingDeskQuery, SidebarTradingDeskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SidebarTradingDeskQuery, SidebarTradingDeskQueryVariables>(SidebarTradingDeskDocument, options);
        }
// @ts-ignore
export function useSidebarTradingDeskSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SidebarTradingDeskQuery, SidebarTradingDeskQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SidebarTradingDeskQuery, SidebarTradingDeskQueryVariables>;
export function useSidebarTradingDeskSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SidebarTradingDeskQuery, SidebarTradingDeskQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SidebarTradingDeskQuery | undefined, SidebarTradingDeskQueryVariables>;
export function useSidebarTradingDeskSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SidebarTradingDeskQuery, SidebarTradingDeskQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SidebarTradingDeskQuery, SidebarTradingDeskQueryVariables>(SidebarTradingDeskDocument, options);
        }
export type SidebarTradingDeskQueryHookResult = ReturnType<typeof useSidebarTradingDeskQuery>;
export type SidebarTradingDeskLazyQueryHookResult = ReturnType<typeof useSidebarTradingDeskLazyQuery>;
export type SidebarTradingDeskSuspenseQueryHookResult = ReturnType<typeof useSidebarTradingDeskSuspenseQuery>;
export type SidebarTradingDeskQueryResult = ApolloReactCommon.QueryResult<SidebarTradingDeskQuery, SidebarTradingDeskQueryVariables>;
export const SidebarAgencyDocument = gql`
    query sidebarAgency($agencyId: String!, $status: [Status!], $pagination: Pagination!) {
  searchCompanies(
    searchQuery: {agencyId: $agencyId, status: $status}
    pagination: $pagination
  ) {
    id
    slug
    name
    status
  }
}
    `;

/**
 * __useSidebarAgencyQuery__
 *
 * To run a query within a React component, call `useSidebarAgencyQuery` and pass it any options that fit your needs.
 * When your component renders, `useSidebarAgencyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSidebarAgencyQuery({
 *   variables: {
 *      agencyId: // value for 'agencyId'
 *      status: // value for 'status'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useSidebarAgencyQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SidebarAgencyQuery, SidebarAgencyQueryVariables> & ({ variables: SidebarAgencyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SidebarAgencyQuery, SidebarAgencyQueryVariables>(SidebarAgencyDocument, options);
      }
export function useSidebarAgencyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SidebarAgencyQuery, SidebarAgencyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SidebarAgencyQuery, SidebarAgencyQueryVariables>(SidebarAgencyDocument, options);
        }
// @ts-ignore
export function useSidebarAgencySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SidebarAgencyQuery, SidebarAgencyQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SidebarAgencyQuery, SidebarAgencyQueryVariables>;
export function useSidebarAgencySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SidebarAgencyQuery, SidebarAgencyQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SidebarAgencyQuery | undefined, SidebarAgencyQueryVariables>;
export function useSidebarAgencySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SidebarAgencyQuery, SidebarAgencyQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SidebarAgencyQuery, SidebarAgencyQueryVariables>(SidebarAgencyDocument, options);
        }
export type SidebarAgencyQueryHookResult = ReturnType<typeof useSidebarAgencyQuery>;
export type SidebarAgencyLazyQueryHookResult = ReturnType<typeof useSidebarAgencyLazyQuery>;
export type SidebarAgencySuspenseQueryHookResult = ReturnType<typeof useSidebarAgencySuspenseQuery>;
export type SidebarAgencyQueryResult = ApolloReactCommon.QueryResult<SidebarAgencyQuery, SidebarAgencyQueryVariables>;
export const TradingDeskTimeseriesDocument = gql`
    query tradingDeskTimeseries($endDate: DateTime!, $startDate: DateTime!, $tradingDeskId: PwsID, $slug: String, $granularity: GraphGranularity!) {
  tradingDesk(id: $tradingDeskId, slug: $slug) {
    id
    timeseries(granularity: $granularity, endDate: $endDate, startDate: $startDate) {
      ...AdvertiserTimeseries
    }
  }
}
    ${AdvertiserTimeseriesFragmentDoc}`;

/**
 * __useTradingDeskTimeseriesQuery__
 *
 * To run a query within a React component, call `useTradingDeskTimeseriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTradingDeskTimeseriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTradingDeskTimeseriesQuery({
 *   variables: {
 *      endDate: // value for 'endDate'
 *      startDate: // value for 'startDate'
 *      tradingDeskId: // value for 'tradingDeskId'
 *      slug: // value for 'slug'
 *      granularity: // value for 'granularity'
 *   },
 * });
 */
export function useTradingDeskTimeseriesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TradingDeskTimeseriesQuery, TradingDeskTimeseriesQueryVariables> & ({ variables: TradingDeskTimeseriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TradingDeskTimeseriesQuery, TradingDeskTimeseriesQueryVariables>(TradingDeskTimeseriesDocument, options);
      }
export function useTradingDeskTimeseriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TradingDeskTimeseriesQuery, TradingDeskTimeseriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TradingDeskTimeseriesQuery, TradingDeskTimeseriesQueryVariables>(TradingDeskTimeseriesDocument, options);
        }
// @ts-ignore
export function useTradingDeskTimeseriesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TradingDeskTimeseriesQuery, TradingDeskTimeseriesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TradingDeskTimeseriesQuery, TradingDeskTimeseriesQueryVariables>;
export function useTradingDeskTimeseriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TradingDeskTimeseriesQuery, TradingDeskTimeseriesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TradingDeskTimeseriesQuery | undefined, TradingDeskTimeseriesQueryVariables>;
export function useTradingDeskTimeseriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TradingDeskTimeseriesQuery, TradingDeskTimeseriesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TradingDeskTimeseriesQuery, TradingDeskTimeseriesQueryVariables>(TradingDeskTimeseriesDocument, options);
        }
export type TradingDeskTimeseriesQueryHookResult = ReturnType<typeof useTradingDeskTimeseriesQuery>;
export type TradingDeskTimeseriesLazyQueryHookResult = ReturnType<typeof useTradingDeskTimeseriesLazyQuery>;
export type TradingDeskTimeseriesSuspenseQueryHookResult = ReturnType<typeof useTradingDeskTimeseriesSuspenseQuery>;
export type TradingDeskTimeseriesQueryResult = ApolloReactCommon.QueryResult<TradingDeskTimeseriesQuery, TradingDeskTimeseriesQueryVariables>;
export const TradingDeskPerformanceStatsDocument = gql`
    query tradingDeskPerformanceStats($endDate: DateTime!, $startDate: DateTime!, $tradingDeskId: PwsID, $slug: String) {
  tradingDesk(id: $tradingDeskId, slug: $slug) {
    id
    performanceStats(endDate: $endDate, startDate: $startDate) {
      stats {
        ...AdvertiserPerformanceStatsParts
      }
      publisherResellers {
        name
        stats {
          ...AdvertiserPerformanceStatsParts
        }
        publishers {
          name
          stats {
            ...AdvertiserPerformanceStatsParts
          }
          websites {
            name
            stats {
              ...AdvertiserPerformanceStatsParts
            }
            positions {
              name
              stats {
                ...AdvertiserPerformanceStatsParts
              }
            }
          }
        }
      }
    }
  }
}
    ${AdvertiserPerformanceStatsPartsFragmentDoc}`;

/**
 * __useTradingDeskPerformanceStatsQuery__
 *
 * To run a query within a React component, call `useTradingDeskPerformanceStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTradingDeskPerformanceStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTradingDeskPerformanceStatsQuery({
 *   variables: {
 *      endDate: // value for 'endDate'
 *      startDate: // value for 'startDate'
 *      tradingDeskId: // value for 'tradingDeskId'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useTradingDeskPerformanceStatsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TradingDeskPerformanceStatsQuery, TradingDeskPerformanceStatsQueryVariables> & ({ variables: TradingDeskPerformanceStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TradingDeskPerformanceStatsQuery, TradingDeskPerformanceStatsQueryVariables>(TradingDeskPerformanceStatsDocument, options);
      }
export function useTradingDeskPerformanceStatsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TradingDeskPerformanceStatsQuery, TradingDeskPerformanceStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TradingDeskPerformanceStatsQuery, TradingDeskPerformanceStatsQueryVariables>(TradingDeskPerformanceStatsDocument, options);
        }
// @ts-ignore
export function useTradingDeskPerformanceStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TradingDeskPerformanceStatsQuery, TradingDeskPerformanceStatsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TradingDeskPerformanceStatsQuery, TradingDeskPerformanceStatsQueryVariables>;
export function useTradingDeskPerformanceStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TradingDeskPerformanceStatsQuery, TradingDeskPerformanceStatsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TradingDeskPerformanceStatsQuery | undefined, TradingDeskPerformanceStatsQueryVariables>;
export function useTradingDeskPerformanceStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TradingDeskPerformanceStatsQuery, TradingDeskPerformanceStatsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TradingDeskPerformanceStatsQuery, TradingDeskPerformanceStatsQueryVariables>(TradingDeskPerformanceStatsDocument, options);
        }
export type TradingDeskPerformanceStatsQueryHookResult = ReturnType<typeof useTradingDeskPerformanceStatsQuery>;
export type TradingDeskPerformanceStatsLazyQueryHookResult = ReturnType<typeof useTradingDeskPerformanceStatsLazyQuery>;
export type TradingDeskPerformanceStatsSuspenseQueryHookResult = ReturnType<typeof useTradingDeskPerformanceStatsSuspenseQuery>;
export type TradingDeskPerformanceStatsQueryResult = ApolloReactCommon.QueryResult<TradingDeskPerformanceStatsQuery, TradingDeskPerformanceStatsQueryVariables>;
export const TradingDeskDocument = gql`
    query tradingDesk($id: PwsID, $slug: String) {
  tradingDesk(id: $id, slug: $slug) {
    ...TradingDeskParts
  }
}
    ${TradingDeskPartsFragmentDoc}`;

/**
 * __useTradingDeskQuery__
 *
 * To run a query within a React component, call `useTradingDeskQuery` and pass it any options that fit your needs.
 * When your component renders, `useTradingDeskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTradingDeskQuery({
 *   variables: {
 *      id: // value for 'id'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useTradingDeskQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TradingDeskQuery, TradingDeskQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TradingDeskQuery, TradingDeskQueryVariables>(TradingDeskDocument, options);
      }
export function useTradingDeskLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TradingDeskQuery, TradingDeskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TradingDeskQuery, TradingDeskQueryVariables>(TradingDeskDocument, options);
        }
// @ts-ignore
export function useTradingDeskSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TradingDeskQuery, TradingDeskQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TradingDeskQuery, TradingDeskQueryVariables>;
export function useTradingDeskSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TradingDeskQuery, TradingDeskQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TradingDeskQuery | undefined, TradingDeskQueryVariables>;
export function useTradingDeskSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TradingDeskQuery, TradingDeskQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TradingDeskQuery, TradingDeskQueryVariables>(TradingDeskDocument, options);
        }
export type TradingDeskQueryHookResult = ReturnType<typeof useTradingDeskQuery>;
export type TradingDeskLazyQueryHookResult = ReturnType<typeof useTradingDeskLazyQuery>;
export type TradingDeskSuspenseQueryHookResult = ReturnType<typeof useTradingDeskSuspenseQuery>;
export type TradingDeskQueryResult = ApolloReactCommon.QueryResult<TradingDeskQuery, TradingDeskQueryVariables>;
export const AuthDocument = gql`
    query auth {
  me {
    ...UserParts
  }
}
    ${UserPartsFragmentDoc}`;

/**
 * __useAuthQuery__
 *
 * To run a query within a React component, call `useAuthQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthQuery({
 *   variables: {
 *   },
 * });
 */
export function useAuthQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AuthQuery, AuthQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AuthQuery, AuthQueryVariables>(AuthDocument, options);
      }
export function useAuthLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AuthQuery, AuthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AuthQuery, AuthQueryVariables>(AuthDocument, options);
        }
// @ts-ignore
export function useAuthSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AuthQuery, AuthQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AuthQuery, AuthQueryVariables>;
export function useAuthSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AuthQuery, AuthQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AuthQuery | undefined, AuthQueryVariables>;
export function useAuthSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AuthQuery, AuthQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AuthQuery, AuthQueryVariables>(AuthDocument, options);
        }
export type AuthQueryHookResult = ReturnType<typeof useAuthQuery>;
export type AuthLazyQueryHookResult = ReturnType<typeof useAuthLazyQuery>;
export type AuthSuspenseQueryHookResult = ReturnType<typeof useAuthSuspenseQuery>;
export type AuthQueryResult = ApolloReactCommon.QueryResult<AuthQuery, AuthQueryVariables>;
export const GetUserDocument = gql`
    query getUser($id: PwsID) {
  user(id: $id) {
    id
    marketId
    role
    lastName
    firstName
    email
    status
    lastName
    title
    mobile
    createdAt
    companyId
    accessType
    language
    isPrimaryContact
  }
}
    `;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
// @ts-ignore
export function useGetUserSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetUserQuery, GetUserQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetUserQuery, GetUserQueryVariables>;
export function useGetUserSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUserQuery, GetUserQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetUserQuery | undefined, GetUserQueryVariables>;
export function useGetUserSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserSuspenseQueryHookResult = ReturnType<typeof useGetUserSuspenseQuery>;
export type GetUserQueryResult = ApolloReactCommon.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const AuthWithCompanyDocument = gql`
    query authWithCompany($slug: String!) {
  me {
    ...UserParts
  }
  company(slug: $slug) {
    ...CompanyParts
  }
}
    ${UserPartsFragmentDoc}
${CompanyPartsFragmentDoc}`;

/**
 * __useAuthWithCompanyQuery__
 *
 * To run a query within a React component, call `useAuthWithCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthWithCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthWithCompanyQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useAuthWithCompanyQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AuthWithCompanyQuery, AuthWithCompanyQueryVariables> & ({ variables: AuthWithCompanyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AuthWithCompanyQuery, AuthWithCompanyQueryVariables>(AuthWithCompanyDocument, options);
      }
export function useAuthWithCompanyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AuthWithCompanyQuery, AuthWithCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AuthWithCompanyQuery, AuthWithCompanyQueryVariables>(AuthWithCompanyDocument, options);
        }
// @ts-ignore
export function useAuthWithCompanySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AuthWithCompanyQuery, AuthWithCompanyQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AuthWithCompanyQuery, AuthWithCompanyQueryVariables>;
export function useAuthWithCompanySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AuthWithCompanyQuery, AuthWithCompanyQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AuthWithCompanyQuery | undefined, AuthWithCompanyQueryVariables>;
export function useAuthWithCompanySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AuthWithCompanyQuery, AuthWithCompanyQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AuthWithCompanyQuery, AuthWithCompanyQueryVariables>(AuthWithCompanyDocument, options);
        }
export type AuthWithCompanyQueryHookResult = ReturnType<typeof useAuthWithCompanyQuery>;
export type AuthWithCompanyLazyQueryHookResult = ReturnType<typeof useAuthWithCompanyLazyQuery>;
export type AuthWithCompanySuspenseQueryHookResult = ReturnType<typeof useAuthWithCompanySuspenseQuery>;
export type AuthWithCompanyQueryResult = ApolloReactCommon.QueryResult<AuthWithCompanyQuery, AuthWithCompanyQueryVariables>;
export const LoginDocument = gql`
    mutation login($email: String!, $password: String!, $rememberMe: Boolean) {
  login(email: $email, password: $password, rememberMe: $rememberMe) {
    token
    slug
  }
}
    `;
export type LoginMutationFn = ApolloReactCommon.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      rememberMe: // value for 'rememberMe'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = ApolloReactCommon.MutationResult<LoginMutation>;
export type LoginMutationOptions = ApolloReactCommon.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const LoginWithGoogleDocument = gql`
    mutation loginWithGoogle($idToken: String!, $rememberMe: Boolean) {
  loginWithGoogle(idToken: $idToken, rememberMe: $rememberMe) {
    token
    slug
  }
}
    `;
export type LoginWithGoogleMutationFn = ApolloReactCommon.MutationFunction<LoginWithGoogleMutation, LoginWithGoogleMutationVariables>;

/**
 * __useLoginWithGoogleMutation__
 *
 * To run a mutation, you first call `useLoginWithGoogleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginWithGoogleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginWithGoogleMutation, { data, loading, error }] = useLoginWithGoogleMutation({
 *   variables: {
 *      idToken: // value for 'idToken'
 *      rememberMe: // value for 'rememberMe'
 *   },
 * });
 */
export function useLoginWithGoogleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LoginWithGoogleMutation, LoginWithGoogleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<LoginWithGoogleMutation, LoginWithGoogleMutationVariables>(LoginWithGoogleDocument, options);
      }
export type LoginWithGoogleMutationHookResult = ReturnType<typeof useLoginWithGoogleMutation>;
export type LoginWithGoogleMutationResult = ApolloReactCommon.MutationResult<LoginWithGoogleMutation>;
export type LoginWithGoogleMutationOptions = ApolloReactCommon.BaseMutationOptions<LoginWithGoogleMutation, LoginWithGoogleMutationVariables>;
export const AskResetUserPasswordDocument = gql`
    mutation askResetUserPassword($email: String!) {
  askResetUserPassword(email: $email)
}
    `;
export type AskResetUserPasswordMutationFn = ApolloReactCommon.MutationFunction<AskResetUserPasswordMutation, AskResetUserPasswordMutationVariables>;

/**
 * __useAskResetUserPasswordMutation__
 *
 * To run a mutation, you first call `useAskResetUserPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAskResetUserPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [askResetUserPasswordMutation, { data, loading, error }] = useAskResetUserPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useAskResetUserPasswordMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AskResetUserPasswordMutation, AskResetUserPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AskResetUserPasswordMutation, AskResetUserPasswordMutationVariables>(AskResetUserPasswordDocument, options);
      }
export type AskResetUserPasswordMutationHookResult = ReturnType<typeof useAskResetUserPasswordMutation>;
export type AskResetUserPasswordMutationResult = ApolloReactCommon.MutationResult<AskResetUserPasswordMutation>;
export type AskResetUserPasswordMutationOptions = ApolloReactCommon.BaseMutationOptions<AskResetUserPasswordMutation, AskResetUserPasswordMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation resetPassword($newPassword: String!, $resetToken: String!) {
  resetPassword(newPassword: $newPassword, resetToken: $resetToken)
}
    `;
export type ResetPasswordMutationFn = ApolloReactCommon.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      newPassword: // value for 'newPassword'
 *      resetToken: // value for 'resetToken'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = ApolloReactCommon.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = ApolloReactCommon.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const DeleteUserDocument = gql`
    mutation deleteUser($id: PwsID!) {
  deleteUser(id: $id)
}
    `;
export type DeleteUserMutationFn = ApolloReactCommon.MutationFunction<DeleteUserMutation, DeleteUserMutationVariables>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteUserMutation, DeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, options);
      }
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = ApolloReactCommon.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>;
export const UpdateUserPasswordDocument = gql`
    mutation updateUserPassword($password: Password!, $user: UserInput!) {
  updateUserPassword(newPassword: $password, user: $user)
}
    `;
export type UpdateUserPasswordMutationFn = ApolloReactCommon.MutationFunction<UpdateUserPasswordMutation, UpdateUserPasswordMutationVariables>;

/**
 * __useUpdateUserPasswordMutation__
 *
 * To run a mutation, you first call `useUpdateUserPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserPasswordMutation, { data, loading, error }] = useUpdateUserPasswordMutation({
 *   variables: {
 *      password: // value for 'password'
 *      user: // value for 'user'
 *   },
 * });
 */
export function useUpdateUserPasswordMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserPasswordMutation, UpdateUserPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateUserPasswordMutation, UpdateUserPasswordMutationVariables>(UpdateUserPasswordDocument, options);
      }
export type UpdateUserPasswordMutationHookResult = ReturnType<typeof useUpdateUserPasswordMutation>;
export type UpdateUserPasswordMutationResult = ApolloReactCommon.MutationResult<UpdateUserPasswordMutation>;
export type UpdateUserPasswordMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateUserPasswordMutation, UpdateUserPasswordMutationVariables>;
export const UpdateUserDocument = gql`
    mutation updateUser($user: UserInput!) {
  updateUser(user: $user) {
    ...UserParts
    accessType
  }
}
    ${UserPartsFragmentDoc}`;
export type UpdateUserMutationFn = ApolloReactCommon.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      user: // value for 'user'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = ApolloReactCommon.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const CreateUserDocument = gql`
    mutation createUser($newUser: UserCreateInput!) {
  createUser(newUser: $newUser) {
    ...UserParts
    accessType
  }
}
    ${UserPartsFragmentDoc}`;
export type CreateUserMutationFn = ApolloReactCommon.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      newUser: // value for 'newUser'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = ApolloReactCommon.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const InviteUserDocument = gql`
    mutation inviteUser($newUser: UserInviteInput!) {
  inviteUser(newUser: $newUser) {
    ...UserParts
    accessType
  }
}
    ${UserPartsFragmentDoc}`;
export type InviteUserMutationFn = ApolloReactCommon.MutationFunction<InviteUserMutation, InviteUserMutationVariables>;

/**
 * __useInviteUserMutation__
 *
 * To run a mutation, you first call `useInviteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteUserMutation, { data, loading, error }] = useInviteUserMutation({
 *   variables: {
 *      newUser: // value for 'newUser'
 *   },
 * });
 */
export function useInviteUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<InviteUserMutation, InviteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<InviteUserMutation, InviteUserMutationVariables>(InviteUserDocument, options);
      }
export type InviteUserMutationHookResult = ReturnType<typeof useInviteUserMutation>;
export type InviteUserMutationResult = ApolloReactCommon.MutationResult<InviteUserMutation>;
export type InviteUserMutationOptions = ApolloReactCommon.BaseMutationOptions<InviteUserMutation, InviteUserMutationVariables>;
export const AcceptInviteDocument = gql`
    mutation acceptInvite($acceptInvite: AcceptInviteInput!) {
  acceptInvite(acceptInvite: $acceptInvite)
}
    `;
export type AcceptInviteMutationFn = ApolloReactCommon.MutationFunction<AcceptInviteMutation, AcceptInviteMutationVariables>;

/**
 * __useAcceptInviteMutation__
 *
 * To run a mutation, you first call `useAcceptInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptInviteMutation, { data, loading, error }] = useAcceptInviteMutation({
 *   variables: {
 *      acceptInvite: // value for 'acceptInvite'
 *   },
 * });
 */
export function useAcceptInviteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AcceptInviteMutation, AcceptInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AcceptInviteMutation, AcceptInviteMutationVariables>(AcceptInviteDocument, options);
      }
export type AcceptInviteMutationHookResult = ReturnType<typeof useAcceptInviteMutation>;
export type AcceptInviteMutationResult = ApolloReactCommon.MutationResult<AcceptInviteMutation>;
export type AcceptInviteMutationOptions = ApolloReactCommon.BaseMutationOptions<AcceptInviteMutation, AcceptInviteMutationVariables>;
export const StartImpersonationDocument = gql`
    mutation startImpersonation($userId: PwsID!) {
  startImpersonation(userId: $userId) {
    token
    slug
    expiresAt
    actorId
    targetUserId
  }
}
    `;
export type StartImpersonationMutationFn = ApolloReactCommon.MutationFunction<StartImpersonationMutation, StartImpersonationMutationVariables>;

/**
 * __useStartImpersonationMutation__
 *
 * To run a mutation, you first call `useStartImpersonationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartImpersonationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startImpersonationMutation, { data, loading, error }] = useStartImpersonationMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useStartImpersonationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<StartImpersonationMutation, StartImpersonationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<StartImpersonationMutation, StartImpersonationMutationVariables>(StartImpersonationDocument, options);
      }
export type StartImpersonationMutationHookResult = ReturnType<typeof useStartImpersonationMutation>;
export type StartImpersonationMutationResult = ApolloReactCommon.MutationResult<StartImpersonationMutation>;
export type StartImpersonationMutationOptions = ApolloReactCommon.BaseMutationOptions<StartImpersonationMutation, StartImpersonationMutationVariables>;
export const SearchUsersLiteDocument = gql`
    query searchUsersLite($pagination: Pagination!, $searchQuery: UserSearchQuery!) {
  searchUsers(pagination: $pagination, searchQuery: $searchQuery) {
    id
    firstName
    lastName
  }
}
    `;

/**
 * __useSearchUsersLiteQuery__
 *
 * To run a query within a React component, call `useSearchUsersLiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchUsersLiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchUsersLiteQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function useSearchUsersLiteQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchUsersLiteQuery, SearchUsersLiteQueryVariables> & ({ variables: SearchUsersLiteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchUsersLiteQuery, SearchUsersLiteQueryVariables>(SearchUsersLiteDocument, options);
      }
export function useSearchUsersLiteLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchUsersLiteQuery, SearchUsersLiteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchUsersLiteQuery, SearchUsersLiteQueryVariables>(SearchUsersLiteDocument, options);
        }
// @ts-ignore
export function useSearchUsersLiteSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SearchUsersLiteQuery, SearchUsersLiteQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SearchUsersLiteQuery, SearchUsersLiteQueryVariables>;
export function useSearchUsersLiteSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchUsersLiteQuery, SearchUsersLiteQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SearchUsersLiteQuery | undefined, SearchUsersLiteQueryVariables>;
export function useSearchUsersLiteSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchUsersLiteQuery, SearchUsersLiteQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SearchUsersLiteQuery, SearchUsersLiteQueryVariables>(SearchUsersLiteDocument, options);
        }
export type SearchUsersLiteQueryHookResult = ReturnType<typeof useSearchUsersLiteQuery>;
export type SearchUsersLiteLazyQueryHookResult = ReturnType<typeof useSearchUsersLiteLazyQuery>;
export type SearchUsersLiteSuspenseQueryHookResult = ReturnType<typeof useSearchUsersLiteSuspenseQuery>;
export type SearchUsersLiteQueryResult = ApolloReactCommon.QueryResult<SearchUsersLiteQuery, SearchUsersLiteQueryVariables>;
export const SearchUsersDocument = gql`
    query searchUsers($pagination: Pagination!, $searchQuery: UserSearchQuery!) {
  searchUsers(pagination: $pagination, searchQuery: $searchQuery) {
    id
    firstName
    lastName
    company {
      id
      name
      slug
      type
    }
    email
    status
    accessType
  }
}
    `;

/**
 * __useSearchUsersQuery__
 *
 * To run a query within a React component, call `useSearchUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchUsersQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function useSearchUsersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchUsersQuery, SearchUsersQueryVariables> & ({ variables: SearchUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchUsersQuery, SearchUsersQueryVariables>(SearchUsersDocument, options);
      }
export function useSearchUsersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchUsersQuery, SearchUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchUsersQuery, SearchUsersQueryVariables>(SearchUsersDocument, options);
        }
// @ts-ignore
export function useSearchUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SearchUsersQuery, SearchUsersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SearchUsersQuery, SearchUsersQueryVariables>;
export function useSearchUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchUsersQuery, SearchUsersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SearchUsersQuery | undefined, SearchUsersQueryVariables>;
export function useSearchUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchUsersQuery, SearchUsersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SearchUsersQuery, SearchUsersQueryVariables>(SearchUsersDocument, options);
        }
export type SearchUsersQueryHookResult = ReturnType<typeof useSearchUsersQuery>;
export type SearchUsersLazyQueryHookResult = ReturnType<typeof useSearchUsersLazyQuery>;
export type SearchUsersSuspenseQueryHookResult = ReturnType<typeof useSearchUsersSuspenseQuery>;
export type SearchUsersQueryResult = ApolloReactCommon.QueryResult<SearchUsersQuery, SearchUsersQueryVariables>;
export const EnabledPowerspaceUsersDocument = gql`
    query enabledPowerspaceUsers {
  users: searchUsers(searchQuery: {companyId: 1, status: Enabled}) {
    id
    firstName
    lastName
    email
    status
  }
}
    `;

/**
 * __useEnabledPowerspaceUsersQuery__
 *
 * To run a query within a React component, call `useEnabledPowerspaceUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnabledPowerspaceUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnabledPowerspaceUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useEnabledPowerspaceUsersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EnabledPowerspaceUsersQuery, EnabledPowerspaceUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EnabledPowerspaceUsersQuery, EnabledPowerspaceUsersQueryVariables>(EnabledPowerspaceUsersDocument, options);
      }
export function useEnabledPowerspaceUsersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EnabledPowerspaceUsersQuery, EnabledPowerspaceUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EnabledPowerspaceUsersQuery, EnabledPowerspaceUsersQueryVariables>(EnabledPowerspaceUsersDocument, options);
        }
// @ts-ignore
export function useEnabledPowerspaceUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EnabledPowerspaceUsersQuery, EnabledPowerspaceUsersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EnabledPowerspaceUsersQuery, EnabledPowerspaceUsersQueryVariables>;
export function useEnabledPowerspaceUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EnabledPowerspaceUsersQuery, EnabledPowerspaceUsersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EnabledPowerspaceUsersQuery | undefined, EnabledPowerspaceUsersQueryVariables>;
export function useEnabledPowerspaceUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EnabledPowerspaceUsersQuery, EnabledPowerspaceUsersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EnabledPowerspaceUsersQuery, EnabledPowerspaceUsersQueryVariables>(EnabledPowerspaceUsersDocument, options);
        }
export type EnabledPowerspaceUsersQueryHookResult = ReturnType<typeof useEnabledPowerspaceUsersQuery>;
export type EnabledPowerspaceUsersLazyQueryHookResult = ReturnType<typeof useEnabledPowerspaceUsersLazyQuery>;
export type EnabledPowerspaceUsersSuspenseQueryHookResult = ReturnType<typeof useEnabledPowerspaceUsersSuspenseQuery>;
export type EnabledPowerspaceUsersQueryResult = ApolloReactCommon.QueryResult<EnabledPowerspaceUsersQuery, EnabledPowerspaceUsersQueryVariables>;
export const PasswordSettingsDocument = gql`
    query passwordSettings {
  passwordSettings {
    minLength
    maxLength
    requireLowercase
    requireUppercase
    requireNumber
    requireSpecial
  }
}
    `;

/**
 * __usePasswordSettingsQuery__
 *
 * To run a query within a React component, call `usePasswordSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePasswordSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePasswordSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePasswordSettingsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PasswordSettingsQuery, PasswordSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PasswordSettingsQuery, PasswordSettingsQueryVariables>(PasswordSettingsDocument, options);
      }
export function usePasswordSettingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PasswordSettingsQuery, PasswordSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PasswordSettingsQuery, PasswordSettingsQueryVariables>(PasswordSettingsDocument, options);
        }
// @ts-ignore
export function usePasswordSettingsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PasswordSettingsQuery, PasswordSettingsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PasswordSettingsQuery, PasswordSettingsQueryVariables>;
export function usePasswordSettingsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PasswordSettingsQuery, PasswordSettingsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PasswordSettingsQuery | undefined, PasswordSettingsQueryVariables>;
export function usePasswordSettingsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PasswordSettingsQuery, PasswordSettingsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PasswordSettingsQuery, PasswordSettingsQueryVariables>(PasswordSettingsDocument, options);
        }
export type PasswordSettingsQueryHookResult = ReturnType<typeof usePasswordSettingsQuery>;
export type PasswordSettingsLazyQueryHookResult = ReturnType<typeof usePasswordSettingsLazyQuery>;
export type PasswordSettingsSuspenseQueryHookResult = ReturnType<typeof usePasswordSettingsSuspenseQuery>;
export type PasswordSettingsQueryResult = ApolloReactCommon.QueryResult<PasswordSettingsQuery, PasswordSettingsQueryVariables>;
export const UserExistsDocument = gql`
    query userExists($email: String!) {
  userExists(email: $email)
}
    `;

/**
 * __useUserExistsQuery__
 *
 * To run a query within a React component, call `useUserExistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserExistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserExistsQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useUserExistsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UserExistsQuery, UserExistsQueryVariables> & ({ variables: UserExistsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserExistsQuery, UserExistsQueryVariables>(UserExistsDocument, options);
      }
export function useUserExistsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserExistsQuery, UserExistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserExistsQuery, UserExistsQueryVariables>(UserExistsDocument, options);
        }
// @ts-ignore
export function useUserExistsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UserExistsQuery, UserExistsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserExistsQuery, UserExistsQueryVariables>;
export function useUserExistsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserExistsQuery, UserExistsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserExistsQuery | undefined, UserExistsQueryVariables>;
export function useUserExistsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserExistsQuery, UserExistsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UserExistsQuery, UserExistsQueryVariables>(UserExistsDocument, options);
        }
export type UserExistsQueryHookResult = ReturnType<typeof useUserExistsQuery>;
export type UserExistsLazyQueryHookResult = ReturnType<typeof useUserExistsLazyQuery>;
export type UserExistsSuspenseQueryHookResult = ReturnType<typeof useUserExistsSuspenseQuery>;
export type UserExistsQueryResult = ApolloReactCommon.QueryResult<UserExistsQuery, UserExistsQueryVariables>;
export const WebsiteNameDocument = gql`
    query websiteName($id: PwsID!) {
  website(id: $id) {
    id
    name
  }
}
    `;

/**
 * __useWebsiteNameQuery__
 *
 * To run a query within a React component, call `useWebsiteNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebsiteNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebsiteNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWebsiteNameQuery(baseOptions: ApolloReactHooks.QueryHookOptions<WebsiteNameQuery, WebsiteNameQueryVariables> & ({ variables: WebsiteNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WebsiteNameQuery, WebsiteNameQueryVariables>(WebsiteNameDocument, options);
      }
export function useWebsiteNameLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WebsiteNameQuery, WebsiteNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WebsiteNameQuery, WebsiteNameQueryVariables>(WebsiteNameDocument, options);
        }
// @ts-ignore
export function useWebsiteNameSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<WebsiteNameQuery, WebsiteNameQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WebsiteNameQuery, WebsiteNameQueryVariables>;
export function useWebsiteNameSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WebsiteNameQuery, WebsiteNameQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WebsiteNameQuery | undefined, WebsiteNameQueryVariables>;
export function useWebsiteNameSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WebsiteNameQuery, WebsiteNameQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<WebsiteNameQuery, WebsiteNameQueryVariables>(WebsiteNameDocument, options);
        }
export type WebsiteNameQueryHookResult = ReturnType<typeof useWebsiteNameQuery>;
export type WebsiteNameLazyQueryHookResult = ReturnType<typeof useWebsiteNameLazyQuery>;
export type WebsiteNameSuspenseQueryHookResult = ReturnType<typeof useWebsiteNameSuspenseQuery>;
export type WebsiteNameQueryResult = ApolloReactCommon.QueryResult<WebsiteNameQuery, WebsiteNameQueryVariables>;
export const ResellerWebsitesDocument = gql`
    query resellerWebsites($companyId: PwsID!) {
  searchWebsites(searchQuery: {companyId: $companyId}) {
    ...WebsiteParts
  }
}
    ${WebsitePartsFragmentDoc}`;

/**
 * __useResellerWebsitesQuery__
 *
 * To run a query within a React component, call `useResellerWebsitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useResellerWebsitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResellerWebsitesQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useResellerWebsitesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ResellerWebsitesQuery, ResellerWebsitesQueryVariables> & ({ variables: ResellerWebsitesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ResellerWebsitesQuery, ResellerWebsitesQueryVariables>(ResellerWebsitesDocument, options);
      }
export function useResellerWebsitesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ResellerWebsitesQuery, ResellerWebsitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ResellerWebsitesQuery, ResellerWebsitesQueryVariables>(ResellerWebsitesDocument, options);
        }
// @ts-ignore
export function useResellerWebsitesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ResellerWebsitesQuery, ResellerWebsitesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ResellerWebsitesQuery, ResellerWebsitesQueryVariables>;
export function useResellerWebsitesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ResellerWebsitesQuery, ResellerWebsitesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ResellerWebsitesQuery | undefined, ResellerWebsitesQueryVariables>;
export function useResellerWebsitesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ResellerWebsitesQuery, ResellerWebsitesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ResellerWebsitesQuery, ResellerWebsitesQueryVariables>(ResellerWebsitesDocument, options);
        }
export type ResellerWebsitesQueryHookResult = ReturnType<typeof useResellerWebsitesQuery>;
export type ResellerWebsitesLazyQueryHookResult = ReturnType<typeof useResellerWebsitesLazyQuery>;
export type ResellerWebsitesSuspenseQueryHookResult = ReturnType<typeof useResellerWebsitesSuspenseQuery>;
export type ResellerWebsitesQueryResult = ApolloReactCommon.QueryResult<ResellerWebsitesQuery, ResellerWebsitesQueryVariables>;
export const PublisherWebsitesDocument = gql`
    query publisherWebsites($companyId: PwsID!) {
  searchWebsites(searchQuery: {companyId: $companyId}) {
    ...WebsiteParts
  }
}
    ${WebsitePartsFragmentDoc}`;

/**
 * __usePublisherWebsitesQuery__
 *
 * To run a query within a React component, call `usePublisherWebsitesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublisherWebsitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublisherWebsitesQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function usePublisherWebsitesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PublisherWebsitesQuery, PublisherWebsitesQueryVariables> & ({ variables: PublisherWebsitesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PublisherWebsitesQuery, PublisherWebsitesQueryVariables>(PublisherWebsitesDocument, options);
      }
export function usePublisherWebsitesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PublisherWebsitesQuery, PublisherWebsitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PublisherWebsitesQuery, PublisherWebsitesQueryVariables>(PublisherWebsitesDocument, options);
        }
// @ts-ignore
export function usePublisherWebsitesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PublisherWebsitesQuery, PublisherWebsitesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PublisherWebsitesQuery, PublisherWebsitesQueryVariables>;
export function usePublisherWebsitesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PublisherWebsitesQuery, PublisherWebsitesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PublisherWebsitesQuery | undefined, PublisherWebsitesQueryVariables>;
export function usePublisherWebsitesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PublisherWebsitesQuery, PublisherWebsitesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PublisherWebsitesQuery, PublisherWebsitesQueryVariables>(PublisherWebsitesDocument, options);
        }
export type PublisherWebsitesQueryHookResult = ReturnType<typeof usePublisherWebsitesQuery>;
export type PublisherWebsitesLazyQueryHookResult = ReturnType<typeof usePublisherWebsitesLazyQuery>;
export type PublisherWebsitesSuspenseQueryHookResult = ReturnType<typeof usePublisherWebsitesSuspenseQuery>;
export type PublisherWebsitesQueryResult = ApolloReactCommon.QueryResult<PublisherWebsitesQuery, PublisherWebsitesQueryVariables>;
export const WebsiteDocument = gql`
    query website($id: PwsID!) {
  website(id: $id) {
    ...WebsiteParts
  }
}
    ${WebsitePartsFragmentDoc}`;

/**
 * __useWebsiteQuery__
 *
 * To run a query within a React component, call `useWebsiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebsiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebsiteQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWebsiteQuery(baseOptions: ApolloReactHooks.QueryHookOptions<WebsiteQuery, WebsiteQueryVariables> & ({ variables: WebsiteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WebsiteQuery, WebsiteQueryVariables>(WebsiteDocument, options);
      }
export function useWebsiteLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WebsiteQuery, WebsiteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WebsiteQuery, WebsiteQueryVariables>(WebsiteDocument, options);
        }
// @ts-ignore
export function useWebsiteSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<WebsiteQuery, WebsiteQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WebsiteQuery, WebsiteQueryVariables>;
export function useWebsiteSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WebsiteQuery, WebsiteQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WebsiteQuery | undefined, WebsiteQueryVariables>;
export function useWebsiteSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WebsiteQuery, WebsiteQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<WebsiteQuery, WebsiteQueryVariables>(WebsiteDocument, options);
        }
export type WebsiteQueryHookResult = ReturnType<typeof useWebsiteQuery>;
export type WebsiteLazyQueryHookResult = ReturnType<typeof useWebsiteLazyQuery>;
export type WebsiteSuspenseQueryHookResult = ReturnType<typeof useWebsiteSuspenseQuery>;
export type WebsiteQueryResult = ApolloReactCommon.QueryResult<WebsiteQuery, WebsiteQueryVariables>;
export const WebsiteWithExclusionsOnlyDocument = gql`
    query websiteWithExclusionsOnly($id: PwsID!) {
  website(id: $id) {
    ...WebsiteParts
    recommendedIabCategory {
      iabCategory
      iabTiers {
        iabId
        type
        tier1Name
        tier2Name
        tier3Name
      }
    }
    advertiserExclusions {
      ...AdvertiserExclusionItemParts
    }
    campaignExclusions {
      ...CampaignExclusionItemParts
    }
    iabExclusions {
      ...IabExclusionItemParts
    }
    domainExclusions {
      ...DomainExclusionItemParts
    }
  }
}
    ${WebsitePartsFragmentDoc}
${AdvertiserExclusionItemPartsFragmentDoc}
${CampaignExclusionItemPartsFragmentDoc}
${IabExclusionItemPartsFragmentDoc}
${DomainExclusionItemPartsFragmentDoc}`;

/**
 * __useWebsiteWithExclusionsOnlyQuery__
 *
 * To run a query within a React component, call `useWebsiteWithExclusionsOnlyQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebsiteWithExclusionsOnlyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebsiteWithExclusionsOnlyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWebsiteWithExclusionsOnlyQuery(baseOptions: ApolloReactHooks.QueryHookOptions<WebsiteWithExclusionsOnlyQuery, WebsiteWithExclusionsOnlyQueryVariables> & ({ variables: WebsiteWithExclusionsOnlyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WebsiteWithExclusionsOnlyQuery, WebsiteWithExclusionsOnlyQueryVariables>(WebsiteWithExclusionsOnlyDocument, options);
      }
export function useWebsiteWithExclusionsOnlyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WebsiteWithExclusionsOnlyQuery, WebsiteWithExclusionsOnlyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WebsiteWithExclusionsOnlyQuery, WebsiteWithExclusionsOnlyQueryVariables>(WebsiteWithExclusionsOnlyDocument, options);
        }
// @ts-ignore
export function useWebsiteWithExclusionsOnlySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<WebsiteWithExclusionsOnlyQuery, WebsiteWithExclusionsOnlyQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WebsiteWithExclusionsOnlyQuery, WebsiteWithExclusionsOnlyQueryVariables>;
export function useWebsiteWithExclusionsOnlySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WebsiteWithExclusionsOnlyQuery, WebsiteWithExclusionsOnlyQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WebsiteWithExclusionsOnlyQuery | undefined, WebsiteWithExclusionsOnlyQueryVariables>;
export function useWebsiteWithExclusionsOnlySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WebsiteWithExclusionsOnlyQuery, WebsiteWithExclusionsOnlyQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<WebsiteWithExclusionsOnlyQuery, WebsiteWithExclusionsOnlyQueryVariables>(WebsiteWithExclusionsOnlyDocument, options);
        }
export type WebsiteWithExclusionsOnlyQueryHookResult = ReturnType<typeof useWebsiteWithExclusionsOnlyQuery>;
export type WebsiteWithExclusionsOnlyLazyQueryHookResult = ReturnType<typeof useWebsiteWithExclusionsOnlyLazyQuery>;
export type WebsiteWithExclusionsOnlySuspenseQueryHookResult = ReturnType<typeof useWebsiteWithExclusionsOnlySuspenseQuery>;
export type WebsiteWithExclusionsOnlyQueryResult = ApolloReactCommon.QueryResult<WebsiteWithExclusionsOnlyQuery, WebsiteWithExclusionsOnlyQueryVariables>;
export const WebsiteParentBlacklistDocument = gql`
    query websiteParentBlacklist($id: PwsID!) {
  website(id: $id) {
    publisher {
      reseller {
        advertiserExclusions {
          ...AdvertiserExclusionItemParts
        }
        campaignExclusions {
          ...CampaignExclusionItemParts
        }
        iabExclusions {
          ...IabExclusionItemParts
        }
        domainExclusions {
          ...DomainExclusionItemParts
        }
      }
      advertiserExclusions {
        ...AdvertiserExclusionItemParts
      }
      campaignExclusions {
        ...CampaignExclusionItemParts
      }
      iabExclusions {
        ...IabExclusionItemParts
      }
      domainExclusions {
        ...DomainExclusionItemParts
      }
    }
  }
}
    ${AdvertiserExclusionItemPartsFragmentDoc}
${CampaignExclusionItemPartsFragmentDoc}
${IabExclusionItemPartsFragmentDoc}
${DomainExclusionItemPartsFragmentDoc}`;

/**
 * __useWebsiteParentBlacklistQuery__
 *
 * To run a query within a React component, call `useWebsiteParentBlacklistQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebsiteParentBlacklistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebsiteParentBlacklistQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWebsiteParentBlacklistQuery(baseOptions: ApolloReactHooks.QueryHookOptions<WebsiteParentBlacklistQuery, WebsiteParentBlacklistQueryVariables> & ({ variables: WebsiteParentBlacklistQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WebsiteParentBlacklistQuery, WebsiteParentBlacklistQueryVariables>(WebsiteParentBlacklistDocument, options);
      }
export function useWebsiteParentBlacklistLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WebsiteParentBlacklistQuery, WebsiteParentBlacklistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WebsiteParentBlacklistQuery, WebsiteParentBlacklistQueryVariables>(WebsiteParentBlacklistDocument, options);
        }
// @ts-ignore
export function useWebsiteParentBlacklistSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<WebsiteParentBlacklistQuery, WebsiteParentBlacklistQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WebsiteParentBlacklistQuery, WebsiteParentBlacklistQueryVariables>;
export function useWebsiteParentBlacklistSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WebsiteParentBlacklistQuery, WebsiteParentBlacklistQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WebsiteParentBlacklistQuery | undefined, WebsiteParentBlacklistQueryVariables>;
export function useWebsiteParentBlacklistSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WebsiteParentBlacklistQuery, WebsiteParentBlacklistQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<WebsiteParentBlacklistQuery, WebsiteParentBlacklistQueryVariables>(WebsiteParentBlacklistDocument, options);
        }
export type WebsiteParentBlacklistQueryHookResult = ReturnType<typeof useWebsiteParentBlacklistQuery>;
export type WebsiteParentBlacklistLazyQueryHookResult = ReturnType<typeof useWebsiteParentBlacklistLazyQuery>;
export type WebsiteParentBlacklistSuspenseQueryHookResult = ReturnType<typeof useWebsiteParentBlacklistSuspenseQuery>;
export type WebsiteParentBlacklistQueryResult = ApolloReactCommon.QueryResult<WebsiteParentBlacklistQuery, WebsiteParentBlacklistQueryVariables>;
export const SearchWebsiteForPositionWizzardDocument = gql`
    query searchWebsiteForPositionWizzard($pagination: Pagination!, $searchQuery: WebsiteSearchQuery!) {
  searchWebsites(pagination: $pagination, searchQuery: $searchQuery) {
    id
    name
  }
}
    `;

/**
 * __useSearchWebsiteForPositionWizzardQuery__
 *
 * To run a query within a React component, call `useSearchWebsiteForPositionWizzardQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchWebsiteForPositionWizzardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchWebsiteForPositionWizzardQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function useSearchWebsiteForPositionWizzardQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchWebsiteForPositionWizzardQuery, SearchWebsiteForPositionWizzardQueryVariables> & ({ variables: SearchWebsiteForPositionWizzardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchWebsiteForPositionWizzardQuery, SearchWebsiteForPositionWizzardQueryVariables>(SearchWebsiteForPositionWizzardDocument, options);
      }
export function useSearchWebsiteForPositionWizzardLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchWebsiteForPositionWizzardQuery, SearchWebsiteForPositionWizzardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchWebsiteForPositionWizzardQuery, SearchWebsiteForPositionWizzardQueryVariables>(SearchWebsiteForPositionWizzardDocument, options);
        }
// @ts-ignore
export function useSearchWebsiteForPositionWizzardSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SearchWebsiteForPositionWizzardQuery, SearchWebsiteForPositionWizzardQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SearchWebsiteForPositionWizzardQuery, SearchWebsiteForPositionWizzardQueryVariables>;
export function useSearchWebsiteForPositionWizzardSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchWebsiteForPositionWizzardQuery, SearchWebsiteForPositionWizzardQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SearchWebsiteForPositionWizzardQuery | undefined, SearchWebsiteForPositionWizzardQueryVariables>;
export function useSearchWebsiteForPositionWizzardSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchWebsiteForPositionWizzardQuery, SearchWebsiteForPositionWizzardQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SearchWebsiteForPositionWizzardQuery, SearchWebsiteForPositionWizzardQueryVariables>(SearchWebsiteForPositionWizzardDocument, options);
        }
export type SearchWebsiteForPositionWizzardQueryHookResult = ReturnType<typeof useSearchWebsiteForPositionWizzardQuery>;
export type SearchWebsiteForPositionWizzardLazyQueryHookResult = ReturnType<typeof useSearchWebsiteForPositionWizzardLazyQuery>;
export type SearchWebsiteForPositionWizzardSuspenseQueryHookResult = ReturnType<typeof useSearchWebsiteForPositionWizzardSuspenseQuery>;
export type SearchWebsiteForPositionWizzardQueryResult = ApolloReactCommon.QueryResult<SearchWebsiteForPositionWizzardQuery, SearchWebsiteForPositionWizzardQueryVariables>;
export const SearchWebsitesForDashboardDocument = gql`
    query searchWebsitesForDashboard($pagination: Pagination!, $searchQuery: WebsiteSearchQuery!) {
  searchWebsites(pagination: $pagination, searchQuery: $searchQuery) {
    id
    name
    publisher {
      id
      slug
      genericName
      reseller {
        genericName
      }
    }
    positions {
      name
      nbZone
      channelType
    }
    iabCategory
    status
  }
}
    `;

/**
 * __useSearchWebsitesForDashboardQuery__
 *
 * To run a query within a React component, call `useSearchWebsitesForDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchWebsitesForDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchWebsitesForDashboardQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function useSearchWebsitesForDashboardQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchWebsitesForDashboardQuery, SearchWebsitesForDashboardQueryVariables> & ({ variables: SearchWebsitesForDashboardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchWebsitesForDashboardQuery, SearchWebsitesForDashboardQueryVariables>(SearchWebsitesForDashboardDocument, options);
      }
export function useSearchWebsitesForDashboardLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchWebsitesForDashboardQuery, SearchWebsitesForDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchWebsitesForDashboardQuery, SearchWebsitesForDashboardQueryVariables>(SearchWebsitesForDashboardDocument, options);
        }
// @ts-ignore
export function useSearchWebsitesForDashboardSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SearchWebsitesForDashboardQuery, SearchWebsitesForDashboardQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SearchWebsitesForDashboardQuery, SearchWebsitesForDashboardQueryVariables>;
export function useSearchWebsitesForDashboardSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchWebsitesForDashboardQuery, SearchWebsitesForDashboardQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SearchWebsitesForDashboardQuery | undefined, SearchWebsitesForDashboardQueryVariables>;
export function useSearchWebsitesForDashboardSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchWebsitesForDashboardQuery, SearchWebsitesForDashboardQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SearchWebsitesForDashboardQuery, SearchWebsitesForDashboardQueryVariables>(SearchWebsitesForDashboardDocument, options);
        }
export type SearchWebsitesForDashboardQueryHookResult = ReturnType<typeof useSearchWebsitesForDashboardQuery>;
export type SearchWebsitesForDashboardLazyQueryHookResult = ReturnType<typeof useSearchWebsitesForDashboardLazyQuery>;
export type SearchWebsitesForDashboardSuspenseQueryHookResult = ReturnType<typeof useSearchWebsitesForDashboardSuspenseQuery>;
export type SearchWebsitesForDashboardQueryResult = ApolloReactCommon.QueryResult<SearchWebsitesForDashboardQuery, SearchWebsitesForDashboardQueryVariables>;
export const WebsiteTimeseriesDocument = gql`
    query websiteTimeseries($endDate: DateTime!, $startDate: DateTime!, $websiteId: PwsID!, $granularity: GraphGranularity!, $filters: [CostDetailsFilter!]) {
  website(id: $websiteId) {
    id
    timeseries(
      granularity: $granularity
      endDate: $endDate
      startDate: $startDate
      filters: $filters
    ) {
      ...PublisherTimeseries
    }
  }
}
    ${PublisherTimeseriesFragmentDoc}`;

/**
 * __useWebsiteTimeseriesQuery__
 *
 * To run a query within a React component, call `useWebsiteTimeseriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebsiteTimeseriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebsiteTimeseriesQuery({
 *   variables: {
 *      endDate: // value for 'endDate'
 *      startDate: // value for 'startDate'
 *      websiteId: // value for 'websiteId'
 *      granularity: // value for 'granularity'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useWebsiteTimeseriesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<WebsiteTimeseriesQuery, WebsiteTimeseriesQueryVariables> & ({ variables: WebsiteTimeseriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WebsiteTimeseriesQuery, WebsiteTimeseriesQueryVariables>(WebsiteTimeseriesDocument, options);
      }
export function useWebsiteTimeseriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WebsiteTimeseriesQuery, WebsiteTimeseriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WebsiteTimeseriesQuery, WebsiteTimeseriesQueryVariables>(WebsiteTimeseriesDocument, options);
        }
// @ts-ignore
export function useWebsiteTimeseriesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<WebsiteTimeseriesQuery, WebsiteTimeseriesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WebsiteTimeseriesQuery, WebsiteTimeseriesQueryVariables>;
export function useWebsiteTimeseriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WebsiteTimeseriesQuery, WebsiteTimeseriesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WebsiteTimeseriesQuery | undefined, WebsiteTimeseriesQueryVariables>;
export function useWebsiteTimeseriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WebsiteTimeseriesQuery, WebsiteTimeseriesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<WebsiteTimeseriesQuery, WebsiteTimeseriesQueryVariables>(WebsiteTimeseriesDocument, options);
        }
export type WebsiteTimeseriesQueryHookResult = ReturnType<typeof useWebsiteTimeseriesQuery>;
export type WebsiteTimeseriesLazyQueryHookResult = ReturnType<typeof useWebsiteTimeseriesLazyQuery>;
export type WebsiteTimeseriesSuspenseQueryHookResult = ReturnType<typeof useWebsiteTimeseriesSuspenseQuery>;
export type WebsiteTimeseriesQueryResult = ApolloReactCommon.QueryResult<WebsiteTimeseriesQuery, WebsiteTimeseriesQueryVariables>;
export const WebsitePerformanceStatsDocument = gql`
    query websitePerformanceStats($endDate: DateTime!, $startDate: DateTime!, $websiteId: PwsID!, $filters: [CostDetailsFilter!]) {
  website(id: $websiteId) {
    id
    performanceStats(endDate: $endDate, startDate: $startDate, filters: $filters) {
      stats {
        ...PublisherPerformanceStatsParts
      }
      advertiserResellers {
        name
        stats {
          ...PublisherPerformanceStatsParts
        }
        advertisers {
          slug
          campaigns {
            name
            stats {
              ...PublisherPerformanceStatsParts
            }
          }
        }
      }
      positions {
        id
        name
        channelType
        status
        stats {
          ...PublisherPerformanceStatsParts
        }
      }
    }
  }
}
    ${PublisherPerformanceStatsPartsFragmentDoc}`;

/**
 * __useWebsitePerformanceStatsQuery__
 *
 * To run a query within a React component, call `useWebsitePerformanceStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebsitePerformanceStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebsitePerformanceStatsQuery({
 *   variables: {
 *      endDate: // value for 'endDate'
 *      startDate: // value for 'startDate'
 *      websiteId: // value for 'websiteId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useWebsitePerformanceStatsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<WebsitePerformanceStatsQuery, WebsitePerformanceStatsQueryVariables> & ({ variables: WebsitePerformanceStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WebsitePerformanceStatsQuery, WebsitePerformanceStatsQueryVariables>(WebsitePerformanceStatsDocument, options);
      }
export function useWebsitePerformanceStatsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WebsitePerformanceStatsQuery, WebsitePerformanceStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WebsitePerformanceStatsQuery, WebsitePerformanceStatsQueryVariables>(WebsitePerformanceStatsDocument, options);
        }
// @ts-ignore
export function useWebsitePerformanceStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<WebsitePerformanceStatsQuery, WebsitePerformanceStatsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WebsitePerformanceStatsQuery, WebsitePerformanceStatsQueryVariables>;
export function useWebsitePerformanceStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WebsitePerformanceStatsQuery, WebsitePerformanceStatsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WebsitePerformanceStatsQuery | undefined, WebsitePerformanceStatsQueryVariables>;
export function useWebsitePerformanceStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WebsitePerformanceStatsQuery, WebsitePerformanceStatsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<WebsitePerformanceStatsQuery, WebsitePerformanceStatsQueryVariables>(WebsitePerformanceStatsDocument, options);
        }
export type WebsitePerformanceStatsQueryHookResult = ReturnType<typeof useWebsitePerformanceStatsQuery>;
export type WebsitePerformanceStatsLazyQueryHookResult = ReturnType<typeof useWebsitePerformanceStatsLazyQuery>;
export type WebsitePerformanceStatsSuspenseQueryHookResult = ReturnType<typeof useWebsitePerformanceStatsSuspenseQuery>;
export type WebsitePerformanceStatsQueryResult = ApolloReactCommon.QueryResult<WebsitePerformanceStatsQuery, WebsitePerformanceStatsQueryVariables>;
export const WebsitePopulationStatsDocument = gql`
    query websitePopulationStats($id: PwsID!) {
  website(id: $id) {
    population {
      ...PublisherPopulation
    }
  }
}
    ${PublisherPopulationFragmentDoc}`;

/**
 * __useWebsitePopulationStatsQuery__
 *
 * To run a query within a React component, call `useWebsitePopulationStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebsitePopulationStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebsitePopulationStatsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWebsitePopulationStatsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<WebsitePopulationStatsQuery, WebsitePopulationStatsQueryVariables> & ({ variables: WebsitePopulationStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WebsitePopulationStatsQuery, WebsitePopulationStatsQueryVariables>(WebsitePopulationStatsDocument, options);
      }
export function useWebsitePopulationStatsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WebsitePopulationStatsQuery, WebsitePopulationStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WebsitePopulationStatsQuery, WebsitePopulationStatsQueryVariables>(WebsitePopulationStatsDocument, options);
        }
// @ts-ignore
export function useWebsitePopulationStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<WebsitePopulationStatsQuery, WebsitePopulationStatsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WebsitePopulationStatsQuery, WebsitePopulationStatsQueryVariables>;
export function useWebsitePopulationStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WebsitePopulationStatsQuery, WebsitePopulationStatsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WebsitePopulationStatsQuery | undefined, WebsitePopulationStatsQueryVariables>;
export function useWebsitePopulationStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WebsitePopulationStatsQuery, WebsitePopulationStatsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<WebsitePopulationStatsQuery, WebsitePopulationStatsQueryVariables>(WebsitePopulationStatsDocument, options);
        }
export type WebsitePopulationStatsQueryHookResult = ReturnType<typeof useWebsitePopulationStatsQuery>;
export type WebsitePopulationStatsLazyQueryHookResult = ReturnType<typeof useWebsitePopulationStatsLazyQuery>;
export type WebsitePopulationStatsSuspenseQueryHookResult = ReturnType<typeof useWebsitePopulationStatsSuspenseQuery>;
export type WebsitePopulationStatsQueryResult = ApolloReactCommon.QueryResult<WebsitePopulationStatsQuery, WebsitePopulationStatsQueryVariables>;
export const UpdateWebsiteDocument = gql`
    mutation updateWebsite($website: WebsiteInput!) {
  updateWebsite(website: $website) {
    ...WebsiteParts
  }
}
    ${WebsitePartsFragmentDoc}`;
export type UpdateWebsiteMutationFn = ApolloReactCommon.MutationFunction<UpdateWebsiteMutation, UpdateWebsiteMutationVariables>;

/**
 * __useUpdateWebsiteMutation__
 *
 * To run a mutation, you first call `useUpdateWebsiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWebsiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWebsiteMutation, { data, loading, error }] = useUpdateWebsiteMutation({
 *   variables: {
 *      website: // value for 'website'
 *   },
 * });
 */
export function useUpdateWebsiteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateWebsiteMutation, UpdateWebsiteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateWebsiteMutation, UpdateWebsiteMutationVariables>(UpdateWebsiteDocument, options);
      }
export type UpdateWebsiteMutationHookResult = ReturnType<typeof useUpdateWebsiteMutation>;
export type UpdateWebsiteMutationResult = ApolloReactCommon.MutationResult<UpdateWebsiteMutation>;
export type UpdateWebsiteMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateWebsiteMutation, UpdateWebsiteMutationVariables>;
export const ArchiveWebsiteDocument = gql`
    mutation archiveWebsite($websiteId: PwsID!) {
  archiveWebsite(websiteId: $websiteId)
}
    `;
export type ArchiveWebsiteMutationFn = ApolloReactCommon.MutationFunction<ArchiveWebsiteMutation, ArchiveWebsiteMutationVariables>;

/**
 * __useArchiveWebsiteMutation__
 *
 * To run a mutation, you first call `useArchiveWebsiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveWebsiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveWebsiteMutation, { data, loading, error }] = useArchiveWebsiteMutation({
 *   variables: {
 *      websiteId: // value for 'websiteId'
 *   },
 * });
 */
export function useArchiveWebsiteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ArchiveWebsiteMutation, ArchiveWebsiteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ArchiveWebsiteMutation, ArchiveWebsiteMutationVariables>(ArchiveWebsiteDocument, options);
      }
export type ArchiveWebsiteMutationHookResult = ReturnType<typeof useArchiveWebsiteMutation>;
export type ArchiveWebsiteMutationResult = ApolloReactCommon.MutationResult<ArchiveWebsiteMutation>;
export type ArchiveWebsiteMutationOptions = ApolloReactCommon.BaseMutationOptions<ArchiveWebsiteMutation, ArchiveWebsiteMutationVariables>;
export const WebsiteHasPositionsDocument = gql`
    query websiteHasPositions($websiteId: PwsID!) {
  website(id: $websiteId) {
    id
    positions {
      id
    }
  }
}
    `;

/**
 * __useWebsiteHasPositionsQuery__
 *
 * To run a query within a React component, call `useWebsiteHasPositionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebsiteHasPositionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebsiteHasPositionsQuery({
 *   variables: {
 *      websiteId: // value for 'websiteId'
 *   },
 * });
 */
export function useWebsiteHasPositionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<WebsiteHasPositionsQuery, WebsiteHasPositionsQueryVariables> & ({ variables: WebsiteHasPositionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WebsiteHasPositionsQuery, WebsiteHasPositionsQueryVariables>(WebsiteHasPositionsDocument, options);
      }
export function useWebsiteHasPositionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WebsiteHasPositionsQuery, WebsiteHasPositionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WebsiteHasPositionsQuery, WebsiteHasPositionsQueryVariables>(WebsiteHasPositionsDocument, options);
        }
// @ts-ignore
export function useWebsiteHasPositionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<WebsiteHasPositionsQuery, WebsiteHasPositionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WebsiteHasPositionsQuery, WebsiteHasPositionsQueryVariables>;
export function useWebsiteHasPositionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WebsiteHasPositionsQuery, WebsiteHasPositionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WebsiteHasPositionsQuery | undefined, WebsiteHasPositionsQueryVariables>;
export function useWebsiteHasPositionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WebsiteHasPositionsQuery, WebsiteHasPositionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<WebsiteHasPositionsQuery, WebsiteHasPositionsQueryVariables>(WebsiteHasPositionsDocument, options);
        }
export type WebsiteHasPositionsQueryHookResult = ReturnType<typeof useWebsiteHasPositionsQuery>;
export type WebsiteHasPositionsLazyQueryHookResult = ReturnType<typeof useWebsiteHasPositionsLazyQuery>;
export type WebsiteHasPositionsSuspenseQueryHookResult = ReturnType<typeof useWebsiteHasPositionsSuspenseQuery>;
export type WebsiteHasPositionsQueryResult = ApolloReactCommon.QueryResult<WebsiteHasPositionsQuery, WebsiteHasPositionsQueryVariables>;
export const UpdateWebsiteAdvertiserExclusionsDocument = gql`
    mutation updateWebsiteAdvertiserExclusions($websiteId: PwsID!, $advertiserExclusions: [PwsID!]!) {
  updateWebsiteAdvertiserExclusions(
    websiteId: $websiteId
    advertiserExclusions: $advertiserExclusions
  )
}
    `;
export type UpdateWebsiteAdvertiserExclusionsMutationFn = ApolloReactCommon.MutationFunction<UpdateWebsiteAdvertiserExclusionsMutation, UpdateWebsiteAdvertiserExclusionsMutationVariables>;

/**
 * __useUpdateWebsiteAdvertiserExclusionsMutation__
 *
 * To run a mutation, you first call `useUpdateWebsiteAdvertiserExclusionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWebsiteAdvertiserExclusionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWebsiteAdvertiserExclusionsMutation, { data, loading, error }] = useUpdateWebsiteAdvertiserExclusionsMutation({
 *   variables: {
 *      websiteId: // value for 'websiteId'
 *      advertiserExclusions: // value for 'advertiserExclusions'
 *   },
 * });
 */
export function useUpdateWebsiteAdvertiserExclusionsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateWebsiteAdvertiserExclusionsMutation, UpdateWebsiteAdvertiserExclusionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateWebsiteAdvertiserExclusionsMutation, UpdateWebsiteAdvertiserExclusionsMutationVariables>(UpdateWebsiteAdvertiserExclusionsDocument, options);
      }
export type UpdateWebsiteAdvertiserExclusionsMutationHookResult = ReturnType<typeof useUpdateWebsiteAdvertiserExclusionsMutation>;
export type UpdateWebsiteAdvertiserExclusionsMutationResult = ApolloReactCommon.MutationResult<UpdateWebsiteAdvertiserExclusionsMutation>;
export type UpdateWebsiteAdvertiserExclusionsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateWebsiteAdvertiserExclusionsMutation, UpdateWebsiteAdvertiserExclusionsMutationVariables>;
export const UpdateWebsiteCampaignExclusionsDocument = gql`
    mutation updateWebsiteCampaignExclusions($websiteId: PwsID!, $campaignExclusions: [PwsID!]!) {
  updateWebsiteCampaignExclusions(
    websiteId: $websiteId
    campaignExclusions: $campaignExclusions
  )
}
    `;
export type UpdateWebsiteCampaignExclusionsMutationFn = ApolloReactCommon.MutationFunction<UpdateWebsiteCampaignExclusionsMutation, UpdateWebsiteCampaignExclusionsMutationVariables>;

/**
 * __useUpdateWebsiteCampaignExclusionsMutation__
 *
 * To run a mutation, you first call `useUpdateWebsiteCampaignExclusionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWebsiteCampaignExclusionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWebsiteCampaignExclusionsMutation, { data, loading, error }] = useUpdateWebsiteCampaignExclusionsMutation({
 *   variables: {
 *      websiteId: // value for 'websiteId'
 *      campaignExclusions: // value for 'campaignExclusions'
 *   },
 * });
 */
export function useUpdateWebsiteCampaignExclusionsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateWebsiteCampaignExclusionsMutation, UpdateWebsiteCampaignExclusionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateWebsiteCampaignExclusionsMutation, UpdateWebsiteCampaignExclusionsMutationVariables>(UpdateWebsiteCampaignExclusionsDocument, options);
      }
export type UpdateWebsiteCampaignExclusionsMutationHookResult = ReturnType<typeof useUpdateWebsiteCampaignExclusionsMutation>;
export type UpdateWebsiteCampaignExclusionsMutationResult = ApolloReactCommon.MutationResult<UpdateWebsiteCampaignExclusionsMutation>;
export type UpdateWebsiteCampaignExclusionsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateWebsiteCampaignExclusionsMutation, UpdateWebsiteCampaignExclusionsMutationVariables>;
export const UpdateWebsiteIabExclusionsDocument = gql`
    mutation updateWebsiteIabExclusions($websiteId: PwsID!, $iabExclusions: [IAB!]!) {
  updateWebsiteIabExclusions(websiteId: $websiteId, iabExclusions: $iabExclusions)
}
    `;
export type UpdateWebsiteIabExclusionsMutationFn = ApolloReactCommon.MutationFunction<UpdateWebsiteIabExclusionsMutation, UpdateWebsiteIabExclusionsMutationVariables>;

/**
 * __useUpdateWebsiteIabExclusionsMutation__
 *
 * To run a mutation, you first call `useUpdateWebsiteIabExclusionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWebsiteIabExclusionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWebsiteIabExclusionsMutation, { data, loading, error }] = useUpdateWebsiteIabExclusionsMutation({
 *   variables: {
 *      websiteId: // value for 'websiteId'
 *      iabExclusions: // value for 'iabExclusions'
 *   },
 * });
 */
export function useUpdateWebsiteIabExclusionsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateWebsiteIabExclusionsMutation, UpdateWebsiteIabExclusionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateWebsiteIabExclusionsMutation, UpdateWebsiteIabExclusionsMutationVariables>(UpdateWebsiteIabExclusionsDocument, options);
      }
export type UpdateWebsiteIabExclusionsMutationHookResult = ReturnType<typeof useUpdateWebsiteIabExclusionsMutation>;
export type UpdateWebsiteIabExclusionsMutationResult = ApolloReactCommon.MutationResult<UpdateWebsiteIabExclusionsMutation>;
export type UpdateWebsiteIabExclusionsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateWebsiteIabExclusionsMutation, UpdateWebsiteIabExclusionsMutationVariables>;
export const UpdateWebsiteDomainExclusionsDocument = gql`
    mutation updateWebsiteDomainExclusions($websiteId: PwsID!, $domainExclusions: [LimitedString3!]!) {
  updateWebsiteDomainExclusions(
    websiteId: $websiteId
    domainExclusions: $domainExclusions
  )
}
    `;
export type UpdateWebsiteDomainExclusionsMutationFn = ApolloReactCommon.MutationFunction<UpdateWebsiteDomainExclusionsMutation, UpdateWebsiteDomainExclusionsMutationVariables>;

/**
 * __useUpdateWebsiteDomainExclusionsMutation__
 *
 * To run a mutation, you first call `useUpdateWebsiteDomainExclusionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWebsiteDomainExclusionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWebsiteDomainExclusionsMutation, { data, loading, error }] = useUpdateWebsiteDomainExclusionsMutation({
 *   variables: {
 *      websiteId: // value for 'websiteId'
 *      domainExclusions: // value for 'domainExclusions'
 *   },
 * });
 */
export function useUpdateWebsiteDomainExclusionsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateWebsiteDomainExclusionsMutation, UpdateWebsiteDomainExclusionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateWebsiteDomainExclusionsMutation, UpdateWebsiteDomainExclusionsMutationVariables>(UpdateWebsiteDomainExclusionsDocument, options);
      }
export type UpdateWebsiteDomainExclusionsMutationHookResult = ReturnType<typeof useUpdateWebsiteDomainExclusionsMutation>;
export type UpdateWebsiteDomainExclusionsMutationResult = ApolloReactCommon.MutationResult<UpdateWebsiteDomainExclusionsMutation>;
export type UpdateWebsiteDomainExclusionsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateWebsiteDomainExclusionsMutation, UpdateWebsiteDomainExclusionsMutationVariables>;
export const CreateWebsiteDocument = gql`
    mutation createWebsite($website: WebsiteCreateInput!) {
  createWebsite(newWebsite: $website) {
    ...WebsiteParts
  }
}
    ${WebsitePartsFragmentDoc}`;
export type CreateWebsiteMutationFn = ApolloReactCommon.MutationFunction<CreateWebsiteMutation, CreateWebsiteMutationVariables>;

/**
 * __useCreateWebsiteMutation__
 *
 * To run a mutation, you first call `useCreateWebsiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWebsiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWebsiteMutation, { data, loading, error }] = useCreateWebsiteMutation({
 *   variables: {
 *      website: // value for 'website'
 *   },
 * });
 */
export function useCreateWebsiteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateWebsiteMutation, CreateWebsiteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateWebsiteMutation, CreateWebsiteMutationVariables>(CreateWebsiteDocument, options);
      }
export type CreateWebsiteMutationHookResult = ReturnType<typeof useCreateWebsiteMutation>;
export type CreateWebsiteMutationResult = ApolloReactCommon.MutationResult<CreateWebsiteMutation>;
export type CreateWebsiteMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateWebsiteMutation, CreateWebsiteMutationVariables>;